import { useConnectionStore } from '@/stores/connectionStore';

// given the following array of english phrases, translate them into colloquial Spanish for use in a chess app and only return the translated Spanish in an array

// This is a json array of English words. Please translate them into collequial language for use in a chess app. The result should be a new json array with each array entry being an object where the English word is the "en" element and the Spanish word is the "es” element, French in the "fr" element, German in the "de" element, Italian in the "it" element, Portuguese in the "pt" and Swedish in the "sv"


var stringMap = null
var languageInUse = "en"

// *******************************************************************************

const strings = [
    {
        "en": "All",
        "es": "Todos",
        "de": "Alle",
        "fr": "Tous",
        "it": "Tutti",
        "pt": "Todos",
        "sv": "Alla"
    },
    {
        "en": "Includes every puzzle",
        "es": "Incluye todos los puzzles",
        "de": "Enthält alle Rätsel",
        "fr": "Comprend tous les problèmes",
        "it": "Include tutti i puzzle",
        "pt": "Inclui todos os problemas",
        "sv": "Inkluderar alla pussel"
    },
    {
        "en": "Advantage",
        "es": "Ventaja",
        "de": "Vorteil",
        "fr": "Avantage",
        "it": "Vantaggio",
        "pt": "Vantagem",
        "sv": "Fördel"
    },
    {
        "en": "Seize your chance to get a decisive advantage. (200cp <= eval <= 600cp)",
        "es": "Aprovecha la oportunidad para obtener una ventaja decisiva. (200cp <= eval <= 600cp)",
        "de": "Nutze die Chance auf einen entscheidenden Vorteil. (200cp <= Bewertung <= 600cp)",
        "fr": "Saisissez la chance d'obtenir un avantage décisif. (200 cp <= éval <= 600 cp)",
        "it": "Cogli l'occasione per ottenere un vantaggio decisivo. (200cp <= eval <= 600cp)",
        "pt": "Aproveite a chance de obter uma vantagem decisiva. (200cp <= aval. <= 600cp)",
        "sv": "Ta chansen att få en avgörande fördel. (200cp <= eval <= 600cp)"
    },
    {
        "en": "Endgame",
        "es": "Final",
        "de": "Endspiel",
        "fr": "Finale",
        "it": "Finale",
        "pt": "Final",
        "sv": "Slutspel"
    },
    {
        "en": "A tactic during the last phase of the game.",
        "es": "Una táctica durante la fase final del juego.",
        "de": "Eine Taktik in der letzten Phase des Spiels.",
        "fr": "Une tactique durant la dernière phase de la partie.",
        "it": "Una tattica durante l'ultima fase della partita.",
        "pt": "Uma tática na fase final do jogo.",
        "sv": "Ett taktiskt tema i spelets sista fas."
    },
    {
        "en": "2 move puzzle",
        "es": "Problema de 2 jugadas",
        "de": "2-Züge-Rätsel",
        "fr": "Problème en 2 coups",
        "it": "Puzzle in 2 mosse",
        "pt": "Problema de 2 lances",
        "sv": "Pussel på 2 drag"
    },
    {
        "en": "Two moves to win.",
        "es": "Dos jugadas para ganar.",
        "de": "Zwei Züge zum Gewinn.",
        "fr": "Deux coups pour gagner.",
        "it": "Due mosse per vincere.",
        "pt": "Dois lances para vencer.",
        "sv": "Två drag till vinst."
    },
    {
        "en": "Middlegame",
        "es": "Mediados de juego",
        "de": "Mittelspiel",
        "fr": "Milieu de partie",
        "it": "Mediogioco",
        "pt": "Médio-jogo",
        "sv": "Mittspel"
    },
    {
        "en": "A tactic during the second phase of the game.",
        "es": "Una táctica durante la segunda fase del juego.",
        "de": "Eine Taktik in der zweiten Spielphase.",
        "fr": "Une tactique pendant le milieu de la partie.",
        "it": "Una tattica durante la fase centrale della partita.",
        "pt": "Uma tática na segunda fase do jogo.",
        "sv": "Ett taktiskt tema i spelets mittersta fas."
    },
    {
        "en": "Advanced pawn",
        "es": "Peón avanzado",
        "de": "Vorgezogener Bauer",
        "fr": "Pion avancé",
        "it": "Pedone avanzato",
        "pt": "Peão avançado",
        "sv": "Avancerad bonde"
    },
    {
        "en": "One of your pawns is deep into the opponent position, maybe threatening to promote.",
        "es": "Uno de tus peones está muy avanzado en la posición rival, quizá amenazando con coronar.",
        "de": "Einer deiner Bauern steht tief in der gegnerischen Stellung und droht vielleicht zu promoten.",
        "fr": "Un de vos pions est profondément dans le camp adverse, peut-être menaçant de promouvoir.",
        "it": "Uno dei tuoi pedoni è profondamente nella posizione avversaria, magari minaccia la promozione.",
        "pt": "Um dos seus peões está avançado na posição do oponente, possivelmente ameaçando promoção.",
        "sv": "En av dina bönder är djupt inne i motståndarens ställning och hotar kanske att promovera."
    },
    {
        "en": "Crushing",
        "es": "Aplastante",
        "de": "Erdrückend",
        "fr": "Accablant",
        "it": "Schiacciante",
        "pt": "Avassalador",
        "sv": "Knockout"
    },
    {
        "en": "Spot the opponent blunder to obtain a crushing advantage. (eval >= 600cp)",
        "es": "Encuentra el error del rival para obtener una ventaja aplastante. (eval >= 600cp)",
        "de": "Finde den gegnerischen Fehler, um einen erdrückenden Vorteil zu erlangen. (Bewertung >= 600cp)",
        "fr": "Repérez l'erreur de l'adversaire pour obtenir un avantage décisif. (éval >= 600 cp)",
        "it": "Individua l'errore dell'avversario per ottenere un vantaggio schiacciante. (eval >= 600cp)",
        "pt": "Detecte o erro do oponente para obter uma vantagem avassaladora. (aval. >= 600cp)",
        "sv": "Hitta motståndarens miss och få en förkrossande fördel. (eval >= 600cp)"
    },
    {
        "en": "Trapped piece",
        "es": "Pieza atrapada",
        "de": "Eingeschlossene Figur",
        "fr": "Pièce piégée",
        "it": "Pezzo intrappolato",
        "pt": "Peça presa",
        "sv": "Inlåst pjäs"
    },
    {
        "en": "A piece is unable to escape capture as it has limited moves.",
        "es": "Una pieza no puede escapar de la captura porque tiene movimientos muy limitados.",
        "de": "Eine Figur kann nicht entkommen, weil ihre Zugmöglichkeiten stark eingeschränkt sind.",
        "fr": "Une pièce ne peut pas échapper à la capture car elle a peu de cases disponibles.",
        "it": "Un pezzo non può sfuggire alla cattura perché ha mosse limitate.",
        "pt": "Uma peça não consegue escapar da captura por ter movimentos limitados.",
        "sv": "En pjäs kan inte undkomma och har mycket begränsade dragmöjligheter."
    },
    {
        "en": "Pin",
        "es": "Clavada",
        "de": "Gabel \/ Fesselung",
        "fr": "Clouage",
        "it": "Inchiodamento",
        "pt": "Cravada",
        "sv": "Pin"
    },
    {
        "en": "A tactic involving pins, where a piece is unable to move without revealing an attack on a higher value piece.",
        "es": "Una táctica que involucra clavadas: una pieza no puede moverse sin descubrir un ataque a una pieza de mayor valor.",
        "de": "Taktik mit Fesselungen: Eine Figur kann nicht ziehen, ohne einen Angriff auf eine wertvollere Figur freizulegen.",
        "fr": "Tactique de clouage : une pièce ne peut bouger sans révéler une attaque sur une pièce plus importante.",
        "it": "Una tattica che coinvolge l'inchiodamento, quando un pezzo non può muovere senza scoprire un attacco su un pezzo di maggior valore.",
        "pt": "Uma tática envolvendo cravadas, onde mover uma peça revela um ataque a uma peça de maior valor.",
        "sv": "En taktik med pinnar där en pjäs inte kan flytta utan att avslöja en attack mot en viktigare pjäs."
    },
    {
        "en": "Hanging piece",
        "es": "Pieza colgando",
        "de": "Ungedeckte Figur",
        "fr": "Pièce pendante",
        "it": "Pezzo scoperto",
        "pt": "Peça pendurada",
        "sv": "Hängande pjäs"
    },
    {
        "en": "A tactic involving an opponent piece being undefended or insufficiently defended and free to capture.",
        "es": "Táctica que aprovecha una pieza rival sin suficiente defensa y libre para capturar.",
        "de": "Taktik bei einer ungeschützten oder schlecht geschützten gegnerischen Figur, die einfach zu schlagen ist.",
        "fr": "Tactique où une pièce adverse est non protégée ou insuffisamment défendue et peut être capturée.",
        "it": "Una tattica che sfrutta un pezzo avversario non difeso o insufficientemente difeso, libero da catturare.",
        "pt": "Tática em que uma peça adversária está sem defesa ou mal defendida e pode ser capturada.",
        "sv": "En taktik där en motståndarpjäs är odefenderad eller svagt försvarad och kan tas gratis."
    },
    {
        "en": "Opening",
        "es": "Apertura",
        "de": "Eröffnung",
        "fr": "Ouverture",
        "it": "Apertura",
        "pt": "Abertura",
        "sv": "Öppning"
    },
    {
        "en": "A tactic during the first phase of the game.",
        "es": "Una táctica durante la primera fase del juego.",
        "de": "Eine Taktik in der Eröffnungsphase.",
        "fr": "Une tactique durant la phase d'ouverture.",
        "it": "Una tattica nella fase iniziale della partita.",
        "pt": "Uma tática na primeira fase do jogo.",
        "sv": "Ett taktiskt tema i spelets första fas."
    },
    {
        "en": "Discovered attack",
        "es": "Ataque descubierto",
        "de": "Entdeckter Angriff",
        "fr": "Attaque découverte",
        "it": "Attacco scoperto",
        "pt": "Ataque descoberto",
        "sv": "Upptäckt attack"
    },
    {
        "en": "Moving a piece that previously blocked an attack by another long range piece, such as a knight out of the way of a rook.",
        "es": "Mover una pieza que bloqueaba el ataque de otra de largo alcance, por ejemplo despejar un caballo para liberar a una torre.",
        "de": "Das Bewegen einer Figur, die zuvor einen Angriff eines Langreichweiters (z. B. Turm oder Läufer) blockiert hat.",
        "fr": "Déplacer une pièce qui bloquait auparavant l'attaque d'une pièce longue portée (ex. déplacer un cavalier pour libérer une tour).",
        "it": "Muovere un pezzo che precedentemente bloccava l'attacco di un'altra arma a lunga gittata, ad esempio liberare un cavallo dalla linea di una torre.",
        "pt": "Mover uma peça que bloqueava o ataque de outra peça de longo alcance, liberando esse ataque.",
        "sv": "Att flytta en pjäs som tidigare blockerade en attack från ett långdistansstycke, t.ex. att undanröja en springare från en tornlinje."
    },
    {
        "en": "1 move puzzle",
        "es": "Problema de 1 jugada",
        "de": "1-Zug-Rätsel",
        "fr": "Problème en 1 coup",
        "it": "Puzzle in 1 mossa",
        "pt": "Problema de 1 lance",
        "sv": "Pussel på 1 drag"
    },
    {
        "en": "A puzzle that is only one move long.",
        "es": "Un problema que se resuelve con una sola jugada.",
        "de": "Ein Rätsel, das nur einen Zug erfordert.",
        "fr": "Un problème qui ne dure qu'un seul coup.",
        "it": "Un puzzle che richiede solo una mossa.",
        "pt": "Um problema que envolve apenas um lance.",
        "sv": "Ett pussel som löses med ett enda drag."
    },
    {
        "en": "Fork",
        "es": "Bifurcación (tenedor)",
        "de": "Gabel",
        "fr": "Fourchette",
        "it": "Forchetta",
        "pt": "Garfo",
        "sv": "Gaffel"
    },
    {
        "en": "A move where the moved piece attacks two opponent pieces at once.",
        "es": "Una jugada que ataca dos piezas enemigas a la vez.",
        "de": "Ein Zug, bei dem eine Figur gleichzeitig zwei gegnerische Figuren angreift.",
        "fr": "Un coup où la pièce attaquante menace deux pièces adverses en même temps.",
        "it": "Una mossa in cui il pezzo attacca due pezzi avversari contemporaneamente.",
        "pt": "Um lance em que a peça atacante ataca duas peças do adversário ao mesmo tempo.",
        "sv": "Ett drag där den flyttade pjäsen attackerar två motståndar­pjäser samtidigt."
    },
    {
        "en": "3 move puzzle",
        "es": "Problema de 3 jugadas",
        "de": "3-Züge-Rätsel",
        "fr": "Problème en 3 coups",
        "it": "Puzzle in 3 mosse",
        "pt": "Problema de 3 lances",
        "sv": "Pussel på 3 drag"
    },
    {
        "en": "Three moves to win.",
        "es": "Tres jugadas para ganar.",
        "de": "Drei Züge zum Gewinn.",
        "fr": "Trois coups pour gagner.",
        "it": "Tre mosse per vincere.",
        "pt": "Três lances para vencer.",
        "sv": "Tre drag till vinst."
    },
    {
        "en": "4+ move puzzle",
        "es": "Problema de 4+ jugadas",
        "de": "4+ Züge-Rätsel",
        "fr": "Problème en 4 coups et plus",
        "it": "Puzzle di 4 o più mosse",
        "pt": "Problema de 4+ lances",
        "sv": "Pussel på 4+ drag"
    },
    {
        "en": "Four moves or more to win.",
        "es": "Cuatro jugadas o más para ganar.",
        "de": "Vier oder mehr Züge zum Gewinn.",
        "fr": "Quatre coups ou plus pour gagner.",
        "it": "Quattro o più mosse per vincere.",
        "pt": "Quatro lances ou mais para vencer.",
        "sv": "Fyra eller fler drag till vinst."
    },
    {
        "en": "Exposed king",
        "es": "Rey expuesto",
        "de": "Freier König",
        "fr": "Roi exposé",
        "it": "Re esposto",
        "pt": "Rei exposto",
        "sv": "Utsatt kung"
    },
    {
        "en": "A tactic involving a king with few defenders around it, often leading to checkmate.",
        "es": "Táctica que aprovecha un rey con pocos defensores, a menudo conduciendo al mate.",
        "de": "Taktik gegen einen König mit wenigen Verteidigern – oft mit Mattfolge.",
        "fr": "Tactique impliquant un roi avec peu de défenseurs, souvent conduisant au mat.",
        "it": "Una tattica che coinvolge un re con pochi difensori intorno, spesso sfocia in scacco matto.",
        "pt": "Tática envolvendo um rei com poucos defensores, frequentemente levando ao xeque-mate.",
        "sv": "En taktik där kungen har få försvarare runt sig, ofta leder till schackmatt."
    },
    {
        "en": "Skewer",
        "es": "Pinza (skewer)",
        "de": "Spieß",
        "fr": "Découverte forcée (skewer)",
        "it": "Spiedo",
        "pt": "Espeto (Skewer)",
        "sv": "Skewers (genomborrning)"
    },
    {
        "en": "A motif involving a high value piece being attacked, moving out the way, and allowing a lower value piece behind it to be captured or attacked, the inverse of a pin.",
        "es": "Motivo en el que una pieza de alto valor es atacada y al moverse deja otra pieza de menor valor para ser capturada; inverso de la clavada.",
        "de": "Motiv, bei dem eine höherwertige Figur angegriffen wird und ausweichen muss, so dass dahinter eine niedrigere Figur geschlagen oder angegriffen werden kann (Gegenteil der Fesselung).",
        "fr": "Motif où une pièce de grande valeur est attaquée et, en se déplaçant, expose une pièce de moindre valeur derrière elle à la capture (inverse du clouage).",
        "it": "Un motivo in cui un pezzo di alto valore è attaccato e, muovendosi, lascia dietro di sé un pezzo di valore inferiore catturabile o attaccabile; l'opposto dell'inchiodamento.",
        "pt": "Motivo em que uma peça de maior valor é atacada, se move e permite capturar ou atacar uma peça de menor valor atrás dela — o inverso da cravada.",
        "sv": "En mot­iv där en värdefull pjäs attackeras och flyttar så att en mindre pjäs bakom blir sårbar — motsatsen till pin."
    },
    {
        "en": "Kingside attack",
        "es": "Ataque al flanco de rey",
        "de": "Königsflügel-Angriff",
        "fr": "Attaque sur le roque côté roi",
        "it": "Attacco sul lato di re",
        "pt": "Ataque no flanco do rei",
        "sv": "Kungsangrepp"
    },
    {
        "en": "An attack of the opponent's king, after they castled on the king side.",
        "es": "Un ataque al rey rival tras enrocarse en el flanco de rey.",
        "de": "Angriff auf den gegnerischen König nach kurzzeitiger Rochade (Königsflügel).",
        "fr": "Attaque contre le roi adverse après qu'il ait roqué côté roi.",
        "it": "Un attacco al re avversario dopo che ha arroccato sul lato di re.",
        "pt": "Ataque ao rei adversário após este ter feito o roque no lado do rei.",
        "sv": "Ett angrepp mot motståndarens kung efter kort rockad."
    },
    {
        "en": "Rook endgame",
        "es": "Final de torres",
        "de": "Turmendspiel",
        "fr": "Finale de tours",
        "it": "Finale di torri",
        "pt": "Final de torre",
        "sv": "Torndspel"
    },
    {
        "en": "An endgame with only rooks and pawns.",
        "es": "Final con solo torres y peones.",
        "de": "Endspiel mit nur Türmen und Bauern.",
        "fr": "Finale composée uniquement de tours et de pions.",
        "it": "Un finale con solo torri e pedoni.",
        "pt": "Final com apenas torres e peões.",
        "sv": "Ett slutspel med bara torn och bönder."
    },
    {
        "en": "Mate",
        "es": "Mate",
        "de": "Matt",
        "fr": "Mat",
        "it": "Scacco matto",
        "pt": "Mate",
        "sv": "Matt"
    },
    {
        "en": "All checkmate puzzles combined",
        "es": "Todos los problemas de mate combinados",
        "de": "Alle Matt-Rätsel zusammengefasst",
        "fr": "Tous les problèmes de mat combinés",
        "it": "Tutti i puzzle di scacco matto combinati",
        "pt": "Todos os problemas de xeque-mate combinados",
        "sv": "Alla mattpussel samlade"
    },
    {
        "en": "1 move mate",
        "es": "Mate en 1",
        "de": "Matt in 1",
        "fr": "Mat en 1",
        "it": "Scacco matto in 1 mossa",
        "pt": "Mate em 1",
        "sv": "Matt på 1 drag"
    },
    {
        "en": "Checkmate in 1 move",
        "es": "Jaque mate en 1 jugada",
        "de": "Matt in 1 Zug",
        "fr": "Mat en 1 coup",
        "it": "Scacco matto in 1 mossa",
        "pt": "Xeque-mate em 1 lance",
        "sv": "Schackmatt på 1 drag"
    },
    {
        "en": "Defensive move",
        "es": "Jugada defensiva",
        "de": "Verteidigender Zug",
        "fr": "Coup défensif",
        "it": "Mossa difensiva",
        "pt": "Lance defensivo",
        "sv": "Defensivt drag"
    },
    {
        "en": "A precise move or sequence of moves that is needed to avoid losing material or another advantage.",
        "es": "Una jugada o secuencia precisa necesaria para evitar perder material u otra desventaja.",
        "de": "Ein gezielter Zug oder Zugfolgen, die nötig sind, um Materialverlust oder andere Nachteile zu vermeiden.",
        "fr": "Un coup ou une séquence précise nécessaire pour éviter de perdre du matériel ou un autre avantage.",
        "it": "Una mossa o sequenza precisa necessaria per evitare di perdere materiale o un altro vantaggio.",
        "pt": "Um lance ou sequência precisa necessária para evitar perda de material ou outra desvantagem.",
        "sv": "Ett precist drag eller dragföljd som krävs för att undvika materialförlust eller annan nackdel."
    },
    {
        "en": "Back rank mate",
        "es": "Mate en la última fila",
        "de": "Matt am Grundränge",
        "fr": "Mat sur la première rangée",
        "it": "Scacco matto sul retro",
        "pt": "Mate na última fileira",
        "sv": "Backranksmatt"
    },
    {
        "en": "Checkmate the king on the home rank, when it is trapped there by its own pieces.",
        "es": "Dar mate en la fila inicial cuando el rey está atrapado por sus propias piezas.",
        "de": "Matt am Grundränge, wenn der König durch eigene Figuren gefangen ist.",
        "fr": "Mat infligé sur la rangée de départ, quand le roi est piégé par ses propres pièces.",
        "it": "Scacco matto al re sulla traversa di fondo, quando è intrappolato dai propri pezzi.",
        "pt": "Xeque-mate ao rei na última fileira, quando está preso por suas próprias peças.",
        "sv": "Schackmatt på hemmaraden när kungen är fastlåst av egna pjäser."
    },
    {
        "en": "2 move mate",
        "es": "Mate en 2",
        "de": "Matt in 2",
        "fr": "Mat en 2",
        "it": "Scacco matto in 2 mosse",
        "pt": "Mate em 2",
        "sv": "Matt på 2 drag"
    },
    {
        "en": "Checkmate in 2 moves",
        "es": "Jaque mate en 2 jugadas",
        "de": "Matt in 2 Zügen",
        "fr": "Mat en 2 coups",
        "it": "Scacco matto in 2 mosse",
        "pt": "Xeque-mate em 2 lances",
        "sv": "Schackmatt på 2 drag"
    },
    {
        "en": "Equality",
        "es": "Igualdad",
        "de": "Ausgleich",
        "fr": "Égalité",
        "it": "Parità",
        "pt": "Igualdade",
        "sv": "Jämvikt"
    },
    {
        "en": "Come back from a losing position, and secure a draw or a balanced position. (eval >= 200cp)",
        "es": "Volver desde una posición perdedora y asegurar tablas o una posición equilibrada. (eval >= 200cp)",
        "de": "Aus einer verlorenen Stellung zurückkommen und ein Remis oder Gleichgewicht erreichen. (Bewertung >= 200cp)",
        "fr": "Revenir d'une position perdante et obtenir l'égalité ou une position équilibrée. (éval >= 200 cp)",
        "it": "Rimettersi da una posizione perdente e assicurare una patta o una posizione equilibrata. (eval >= 200cp)",
        "pt": "Recupere-se de uma posição perdida e garanta emparelhamento ou empate. (aval. >= 200cp)",
        "sv": "Återhämta sig från förlustställning och få remi eller balans. (eval >= 200cp)"
    },
    {
        "en": "Sacrifice",
        "es": "Sacrificio",
        "de": "Opfer",
        "fr": "Sacrifice",
        "it": "Sacrificio",
        "pt": "Sacrifício",
        "sv": "Offring"
    },
    {
        "en": "A tactic involving giving up material in the short-term, to gain an advantage again after a forced sequence of moves.",
        "es": "Táctica que consiste en ceder material a corto plazo para obtener ventaja después de una secuencia forzada.",
        "de": "Taktik, bei der Material kurzfristig gegeben wird, um danach durch erzwungene Züge Vorteil zu erlangen.",
        "fr": "Tactique consistant à céder du matériel à court terme pour obtenir un avantage après une suite forcée.",
        "it": "Una tattica che prevede di perdere materiale a breve termine per ottenere un vantaggio dopo una sequenza forzata.",
        "pt": "Tática que consiste em ceder material no curto prazo para obter vantagem após uma sequência forçada.",
        "sv": "En taktik där man ger upp material på kort sikt för att få fördel efter en tvingande följd."
    },
    {
        "en": "Pawn endgame",
        "es": "Final de peones",
        "de": "Bauernendspiel",
        "fr": "Finale de pions",
        "it": "Finale di pedoni",
        "pt": "Final de peões",
        "sv": "Bondslutspel"
    },
    {
        "en": "An endgame with only pawns.",
        "es": "Final con solo peones.",
        "de": "Endspiel mit nur Bauern.",
        "fr": "Finale composée uniquement de pions.",
        "it": "Un finale con solo pedoni.",
        "pt": "Final com apenas peões.",
        "sv": "Ett slutspel med bara bönder."
    },
    {
        "en": "Intermezzo",
        "es": "Intermedio (Zwischenzug)",
        "de": "Intermezzo (Zwischzug)",
        "fr": "Intermezzo (Zwischenzug)",
        "it": "Intermezzo",
        "pt": "Intermezzo (Zwischenzug)",
        "sv": "Intermezzo (mellandrag)"
    },
    {
        "en": "Instead of playing the expected move, first interpose another move posing an immediate threat that the opponent must answer. Also known as 'Zwischenzug' or 'In between'.",
        "es": "En lugar de jugar lo esperado, interponer primero una jugada que plantee una amenaza inmediata que el rival deba responder. También conocido como 'Zwischenzug' o 'movida intermedia'.",
        "de": "Statt des erwarteten Zugs wird zuerst ein Zwischenzug gespielt, der eine sofortige Drohung stellt und beantwortet werden muss. Auch 'Zwischenzug' genannt.",
        "fr": "Au lieu du coup attendu, intercaler d'abord un coup qui pose une menace immédiate à laquelle l'adversaire doit répondre. Aussi appelé 'Zwischenzug'.",
        "it": "Invece di giocare la mossa attesa, si inserisce prima una mossa che crea una minaccia immediata a cui l'avversario deve rispondere. Conosciuto anche come 'Zwischenzug' o 'mossa intermedia'.",
        "pt": "Ao invés de jogar o lance esperado, interponha primeiro um lance que gera uma ameaça imediata que o adversário precisa responder. Também chamado 'Zwischenzug' ou 'entre-lance'.",
        "sv": "Istället för det väntade draget gör man ett mellan­drag som ställer ett omedelbart hot som motståndaren måste svara på. Kallas även 'zwischenzug'."
    },
    {
        "en": "Deflection",
        "es": "Desviación",
        "de": "Ablenkung",
        "fr": "Déviation",
        "it": "Deflessione",
        "pt": "Desvio",
        "sv": "Avledningsdrag"
    },
    {
        "en": "A move that distracts an opponent piece from another duty that it performs, such as guarding a key square. Sometimes also called 'overloading'.",
        "es": "Una jugada que distrae una pieza rival de otra tarea, como defender una casilla clave. A veces llamada 'sobrecarga'.",
        "de": "Ein Zug, der eine gegnerische Figur von ihrer Aufgabe (z. B. dem Bewachen eines wichtigen Felds) ablenkt. Manchmal auch 'Überlastung' genannt.",
        "fr": "Un coup qui détourne une pièce adverse d'une autre tâche (ex. garder une case clé). Parfois appelé 'surcharge'.",
        "it": "Una mossa che distrae un pezzo avversario da un altro compito, come difendere una casa chiave. Talvolta chiamata anche 'sovraccarico'.",
        "pt": "Um lance que desvia a peça adversária de outra função, como defender uma casa-chave. Às vezes também chamado de 'sobrecarregamento'.",
        "sv": "Ett drag som avleder en motståndarpjäs från dess uppgift, t.ex. att bevaka en viktig ruta. Kallas ibland överbelastning."
    },
    {
        "en": "X-Ray attack",
        "es": "Ataque por rayos (X-Ray)",
        "de": "X-Ray-Angriff",
        "fr": "Attaque en rayon X",
        "it": "Attacco a raggi X",
        "pt": "Ataque por raio X",
        "sv": "Röntgenattack"
    },
    {
        "en": "A piece attacks or defends a square, through an enemy piece.",
        "es": "Una pieza ataca o defiende una casilla a través de una pieza enemiga.",
        "de": "Eine Figur greift oder verteidigt ein Feld durch eine gegnerische Figur hindurch.",
        "fr": "Une pièce attaque ou défend une case 'à travers' une pièce ennemie.",
        "it": "Un pezzo attacca o difende una casa attraverso un pezzo nemico interposto.",
        "pt": "Uma peça ataca ou defende uma casa através de uma peça inimiga (ataque 'raio X').",
        "sv": "En pjäs attackerar eller försvarar en ruta genom en motståndarpjäs."
    },
    {
        "en": "Capture the defender",
        "es": "Capturar al defensor",
        "de": "Den Verteidiger schlagen",
        "fr": "Capture du défenseur",
        "it": "Cattura il difensore",
        "pt": "Capturar o defensor",
        "sv": "Ta bort försvararen"
    },
    {
        "en": "Removing a piece that is critical to defence of another piece, allowing the now undefended piece to be captured on a following move.",
        "es": "Eliminar una pieza clave en la defensa de otra, permitiendo capturar la pieza ahora desprotegida en la jugada siguiente.",
        "de": "Eine Figur entfernen, die eine andere verteidigt, sodass diese anschließend ungeschützt geschlagen werden kann.",
        "fr": "Enlever une pièce cruciale à la défense d'une autre, permettant de capturer celle-ci ensuite.",
        "it": "Eliminare un pezzo cruciale per la difesa di un altro pezzo, permettendo che il pezzo ora non difeso venga catturato alla mossa successiva.",
        "pt": "Remover uma peça crítica para a defesa de outra, permitindo capturar a peça agora indefesa no próximo lance.",
        "sv": "Ta bort en pjäs som skyddar en annan, så att den nu odefenderade pjäsen kan tas nästa drag."
    },
    {
        "en": "Queen endgame",
        "es": "Final de damas",
        "de": "Damenendspiel",
        "fr": "Finale de dames",
        "it": "Finale di regine",
        "pt": "Final de dama",
        "sv": "Damslutspel"
    },
    {
        "en": "An endgame with only queens and pawns.",
        "es": "Final con solo damas y peones.",
        "de": "Endspiel mit Damen und Bauern.",
        "fr": "Finale composée uniquement de dames et de pions.",
        "it": "Un finale con solo regine e pedoni.",
        "pt": "Final com apenas damas e peões.",
        "sv": "Ett slutspel med bara damer och bönder."
    },
    {
        "en": "Attraction",
        "es": "Atracción",
        "de": "Anlocken",
        "fr": "Attraction",
        "it": "Attrazione",
        "pt": "Atração",
        "sv": "Lockning"
    },
    {
        "en": "An exchange or sacrifice encouraging or forcing an opponent piece to a square that allows a follow-up tactic.",
        "es": "Un cambio o sacrificio que obliga o incita a una pieza rival a ir a una casilla que permite una táctica posterior.",
        "de": "Tausch oder Opfer, das eine gegnerische Figur auf ein bestimmtes Feld lockt oder zwingt und so Folge-Taktiken ermöglicht.",
        "fr": "Échange ou sacrifice visant à forcer une pièce adverse vers une case permettant une tactique suivante.",
        "it": "Uno scambio o sacrificio che costringe o incoraggia un pezzo avversario a una casa che permette una tattica successiva.",
        "pt": "Uma troca ou sacrifício que força ou incentiva uma peça adversária a ocupar uma casa que possibilita uma tática posterior.",
        "sv": "Ett byte eller offer som tvingar eller lockar en motståndarpjäs till en ruta där en följdtaktik blir möjlig."
    },
    {
        "en": "Quiet move",
        "es": "Jugada tranquila",
        "de": "Leiser Zug",
        "fr": "Coup silencieux",
        "it": "Mossa tranquilla",
        "pt": "Lance silencioso",
        "sv": "Tyst drag"
    },
    {
        "en": "A move that does not make a check or capture, but does prepare an unavoidable threat for a later move.",
        "es": "Una jugada que no da jaque ni captura, pero prepara una amenaza ineludible para más adelante.",
        "de": "Ein Zug ohne Schlag oder Schach, der aber eine kaum abwehrbare Drohung vorbereitet.",
        "fr": "Un coup qui ne donne ni échec ni capture, mais prépare une menace irrésistible.",
        "it": "Una mossa che non dà scacco né cattura, ma prepara una minaccia inevitabile per mosse successive.",
        "pt": "Lance que não faz xeque nem captura, mas prepara uma ameaça inevitável para mais tarde.",
        "sv": "Ett drag som varken ger schack eller tar pjäs, men förbereder ett oundvikligt hot senare."
    },
    {
        "en": "Knight endgame",
        "es": "Final de caballos",
        "de": "Springerendspiel",
        "fr": "Finale de cavaliers",
        "it": "Finale di cavalli",
        "pt": "Final de cavalo",
        "sv": "Springarslutspel"
    },
    {
        "en": "An endgame with only knights and pawns.",
        "es": "Final con solo caballos y peones.",
        "de": "Endspiel mit Springern und Bauern.",
        "fr": "Finale composée uniquement de cavaliers et de pions.",
        "it": "Un finale con solo cavalli e pedoni.",
        "pt": "Final com apenas cavalos e peões.",
        "sv": "Ett slutspel med bara springare och bönder."
    },
    {
        "en": "3 move mate",
        "es": "Mate en 3",
        "de": "Matt in 3",
        "fr": "Mat en 3",
        "it": "Scacco matto in 3 mosse",
        "pt": "Mate em 3",
        "sv": "Matt på 3 drag"
    },
    {
        "en": "Checkmate in 3 moves",
        "es": "Jaque mate en 3 jugadas",
        "de": "Matt in 3 Zügen",
        "fr": "Mat en 3 coups",
        "it": "Scacco matto in 3 mosse",
        "pt": "Xeque-mate em 3 lances",
        "sv": "Schackmatt på 3 drag"
    },
    {
        "en": "Clearance",
        "es": "Despeje",
        "de": "Freimachen",
        "fr": "Dégagement",
        "it": "Sgombro",
        "pt": "Liberação",
        "sv": "Rensningsdrag"
    },
    {
        "en": "A move, often with tempo, that clears a square, file or diagonal for a follow-up tactical idea.",
        "es": "Una jugada, a menudo con tempo, que despeja una casilla, columna o diagonal para una idea táctica posterior.",
        "de": "Ein Zug (oft mit Tempo), der ein Feld, eine Linie oder Diagonale räumt, um Platz für eine Folgetaktik zu schaffen.",
        "fr": "Un coup, souvent avec un gain de tempo, qui libère une case, colonne ou diagonale pour une tactique ultérieure.",
        "it": "Una mossa, spesso con tempo, che libera una casa, una colonna o una diagonale per un'idea tattica successiva.",
        "pt": "Um lance, muitas vezes ganhando tempo, que libera uma casa, coluna ou diagonal para uma ideia tática subsequente.",
        "sv": "Ett drag, ofta med tempo, som frigör en ruta, fil eller diagonal för en efterföljande taktik."
    },
    {
        "en": "Bishop endgame",
        "es": "Final de alfiles",
        "de": "Läuferendspiel",
        "fr": "Finale de fous",
        "it": "Finale di alfieri",
        "pt": "Final de bispo",
        "sv": "Löpars slutspel"
    },
    {
        "en": "An endgame with only bishops and pawns.",
        "es": "Final con solo alfiles y peones.",
        "de": "Endspiel mit Läufern und Bauern.",
        "fr": "Finale composée uniquement de fous et de pions.",
        "it": "Un finale con solo alfieri e pedoni.",
        "pt": "Final com apenas bispos e peões.",
        "sv": "Ett slutspel med bara löpare och bönder."
    },
    {
        "en": "Promotion",
        "es": "Coronación",
        "de": "Bauernumwandlung",
        "fr": "Promotion",
        "it": "Promozione",
        "pt": "Promoção",
        "sv": "Promovering"
    },
    {
        "en": "Promote one of your pawns to a queen or minor piece.",
        "es": "Coronar uno de tus peones en dama u otra pieza menor.",
        "de": "Einen Bauern zur Dame oder einer Nebenfigur umwandeln.",
        "fr": "Promouvoir un pion en dame ou en pièce mineure.",
        "it": "Promuovere uno dei tuoi pedoni in una regina o in un pezzo minore.",
        "pt": "Promova um dos seus peões para dama ou peça menor.",
        "sv": "Förvandla en av dina bönder till en dam eller annan pjäs."
    },
    {
        "en": "Queen and Rook",
        "es": "Dama y torre",
        "de": "Dame und Turm",
        "fr": "Finale dame et tour",
        "it": "Regina e torre",
        "pt": "Dama e Torre",
        "sv": "Dam och Torn"
    },
    {
        "en": "An endgame with only queens, rooks and pawns.",
        "es": "Final con damas, torres y peones.",
        "de": "Endspiel mit Damen, Türmen und Bauern.",
        "fr": "Finale composée de dames, tours et pions.",
        "it": "Un finale con regine, torri e pedoni.",
        "pt": "Final com damas, torres e peões.",
        "sv": "Ett slutspel med damer, torn och bönder."
    },
    {
        "en": "Interference",
        "es": "Interferencia",
        "de": "Störung \/ Interferenz",
        "fr": "Interférence",
        "it": "Interferenza",
        "pt": "Interferência",
        "sv": "Interferens"
    },
    {
        "en": "Moving a piece between two opponent pieces to leave one or both opponent pieces undefended, such as a knight on a defended square between two rooks.",
        "es": "Colocar una pieza entre dos piezas enemigas para dejar una o ambas desprotegidas, por ejemplo un caballo en una casilla defendida entre dos torres.",
        "de": "Einen Stein zwischen zwei gegnerische Figuren stellen, um eine oder beide zu entblößen (z. B. Springer zwischen zwei Türmen).",
        "fr": "Placer une pièce entre deux pièces adverses pour laisser l'une ou les deux sans défense (ex. cavalier entre deux tours).",
        "it": "Inserire un pezzo tra due pezzi avversari per lasciare uno o entrambi non difesi, ad esempio un cavallo su una casa difesa tra due torri.",
        "pt": "Interpor uma peça entre duas peças adversárias para deixar uma ou ambas indefesas, por exemplo um cavalo entre duas torres.",
        "sv": "Att lägga en pjäs mellan två motståndar­pjäser för att göra en eller båda odefenderade, t.ex. en springare mellan två torn."
    },
    {
        "en": "Queenside attack",
        "es": "Ataque al flanco de dama",
        "de": "Damenflügel-Angriff",
        "fr": "Attaque sur le roque côté dame",
        "it": "Attacco sul lato di donna",
        "pt": "Ataque no flanco da dama",
        "sv": "Damsideangrepp"
    },
    {
        "en": "An attack of the opponent's king, after they castled on the queen side.",
        "es": "Un ataque al rey rival tras enrocarse en el flanco de dama.",
        "de": "Angriff auf den gegnerischen König nach langer Rochade (Damenflügel).",
        "fr": "Attaque contre le roi adverse après qu'il ait roqué côté dame.",
        "it": "Un attacco al re avversario dopo che ha arroccato sul lato di donna.",
        "pt": "Ataque ao rei adversário após este ter feito o roque no lado da dama.",
        "sv": "Ett angrepp mot kung efter lång rockad (damside)."
    },
    {
        "en": "Double check",
        "es": "Doble jaque",
        "de": "Doppelschach",
        "fr": "Double échec",
        "it": "Doppio scacco",
        "pt": "Duplo xeque",
        "sv": "Dubbel­schack"
    },
    {
        "en": "Checking with two pieces at once, as a result of a discovered attack where both the moving piece and the unveiled piece attack the opponent's king.",
        "es": "Jaque con dos piezas a la vez, resultado de un ataque descubierto donde la pieza que se mueve y la descubierta atacan al rey.",
        "de": "Zwei Figuren geben gleichzeitig Schach, oft durch einen entdeckten Angriff, bei dem sowohl die ziehende als auch die enthüllte Figur den König angreifen.",
        "fr": "Échec donné par deux pièces en même temps, souvent via une découverte où la pièce mouvante et la pièce dévoilée attaquent le roi.",
        "it": "Dare scacco con due pezzi contemporaneamente, risultato di un attacco scoperto in cui sia il pezzo mosso sia quello scoperto attaccano il re avversario.",
        "pt": "Xeque com duas peças ao mesmo tempo, geralmente por um ataque descoberto em que tanto a peça que se move quanto a revelada atacam o rei.",
        "sv": "Schack med två pjäser samtidigt, ofta som följd av ett upptäckt drag där både den flyttade och den avslöjade pjäsen ger schack."
    },
    {
        "en": "Smothered mate",
        "es": "Mate ahogado",
        "de": "Ersticktes Matt",
        "fr": "Mat étouffé",
        "it": "Matto soffocato",
        "pt": "Mate sufocado",
        "sv": "Kvävd matt"
    },
    {
        "en": "A checkmate delivered by a knight in which the mated king is unable to move because it is surrounded (or smothered) by its own pieces.",
        "es": "Un mate dado por un caballo en el que el rey no puede moverse porque está rodeado por sus propias piezas.",
        "de": "Mattsituation durch einen Springer, bei der der König wegen eigener Figuren keine Fluchtfelder hat.",
        "fr": "Mat donné par un cavalier alors que le roi est empêché de bouger par ses propres pièces.",
        "it": "Uno scacco matto dato da un cavallo in cui il re non può muoversi perché circondato (soffocato) dai propri pezzi.",
        "pt": "Xeque-mate aplicado por um cavalo em que o rei não pode se mover por estar cercado por suas próprias peças.",
        "sv": "En matt med springare där kungen inte kan flytta eftersom egna pjäser omger honom."
    },
    {
        "en": "Zugzwang",
        "es": "Zugzwang",
        "de": "Zugzwang",
        "fr": "Zugzwang",
        "it": "Zugzwang",
        "pt": "Zugzwang",
        "sv": "Zugzwang"
    },
    {
        "en": "The opponent is limited in the moves they can make, and all moves worsen their position.",
        "es": "El rival está obligado a mover y todas sus jugadas empeoran su posición.",
        "de": "Der Gegner ist in seinen Zügen so eingeschränkt, dass jeder Zug die Stellung verschlechtert.",
        "fr": "L'adversaire est obligé de jouer et tous ses coups détériorent sa position.",
        "it": "L'avversario è limitato nelle mosse possibili e tutte peggiorano la sua posizione.",
        "pt": "O oponente tem movimentos limitados e qualquer lance piora sua posição.",
        "sv": "Motståndaren har inga bra drag kvar — alla drag försämrar ställningen."
    },
    {
        "en": "En Passant",
        "es": "Al paso (en passant)",
        "de": "En-passant",
        "fr": "En passant",
        "it": "En passant",
        "pt": "En passant",
        "sv": "En passant"
    },
    {
        "en": "A tactic involving the en passant rule, where a pawn can capture an opponent pawn that has bypassed it using its initial two-square move.",
        "es": "Táctica que usa la regla de 'al paso', donde un peón puede capturar a otro que avanzó dos casillas en su primer movimiento.",
        "de": "Taktik mit der en-passant-Regel: Ein Bauer schlägt einen gegnerischen Bauern, der gerade zwei Felder gezogen hat.",
        "fr": "Tactique liée à la règle de l'en passant : un pion capture un pion adverse qui a avancé de deux cases.",
        "it": "Una tattica che sfrutta la regola dell'en passant, dove un pedone cattura un pedone avversario che lo ha oltrepassato con la mossa iniziale di due caselle.",
        "pt": "Tática envolvendo a regra en passant, onde um peão captura um adversário que avançou duas casas no lance inicial.",
        "sv": "En taktik med en passant-regeln: en bonde kan slå en motståndarbonde som gått två rutor från start."
    },
    {
        "en": "Castling",
        "es": "Enroque",
        "de": "Rochade",
        "fr": "Roque",
        "it": "Arrocco",
        "pt": "Roque",
        "sv": "Rockad"
    },
    {
        "en": "Bring the king to safety, and deploy the rook for attack.",
        "es": "Llevar el rey a salvo y desarrollar la torre para el ataque.",
        "de": "Den König in Sicherheit bringen und den Turm ins Spiel bringen.",
        "fr": "Mettre le roi en sécurité et activer la tour pour l'attaque.",
        "it": "Mettere il re al sicuro e attivare la torre per l'attacco.",
        "pt": "Colocar o rei em segurança e ativar a torre para ataque.",
        "sv": "För kungen i säkerhet och aktivera tornet för angrepp."
    },
    {
        "en": "Attacking f2 or f7",
        "es": "Atacar f2 o f7",
        "de": "Angriff auf f2 oder f7",
        "fr": "Attaque sur f2 ou f7",
        "it": "Attacco su f2 o f7",
        "pt": "Ataque a f2 ou f7",
        "sv": "Angrepp mot f2 eller f7"
    },
    {
        "en": "An attack focusing on the f2 or f7 pawn, such as in the fried liver opening.",
        "es": "Un ataque centrado en el peón f2 o f7, como en la apertura 'fried liver'.",
        "de": "Angriff auf den Bauern f2 oder f7, z. B. typisch im Fried-Liver-Angriff.",
        "fr": "Attaque ciblant le pion f2 ou f7, comme dans l'attaque 'fried liver'.",
        "it": "Un attacco che prende di mira il pedone f2 o f7, come nel Fried Liver.",
        "pt": "Ataque focado no peão f2 ou f7, como na abertura 'Fried Liver'.",
        "sv": "Angrepp inriktat på f2- eller f7-bonden, t.ex. i Fried Liver-varianten."
    },
    {
        "en": "4 move mate",
        "es": "Mate en 4",
        "de": "Matt in 4",
        "fr": "Mat en 4",
        "it": "Scacco matto in 4 mosse",
        "pt": "Mate em 4",
        "sv": "Matt på 4 drag"
    },
    {
        "en": "Checkmate in 4 moves",
        "es": "Jaque mate en 4 jugadas",
        "de": "Matt in 4 Zügen",
        "fr": "Mat en 4 coups",
        "it": "Scacco matto in 4 mosse",
        "pt": "Xeque-mate em 4 lances",
        "sv": "Schackmatt på 4 drag"
    },
    {
        "en": "5+ move mate",
        "es": "Mate en 5+",
        "de": "Matt in 5+ Zügen",
        "fr": "Mat en 5 coups et plus",
        "it": "Scacco matto in 5 o più mosse",
        "pt": "Mate em 5+ lances",
        "sv": "Matt på 5+ drag"
    },
    {
        "en": "Checkmate in 5 or more move",
        "es": "Jaque mate en 5 o más jugadas",
        "de": "Matt in 5 oder mehr Zügen",
        "fr": "Mat en 5 coups ou plus",
        "it": "Scacco matto in 5 o più mosse",
        "pt": "Xeque-mate em 5 ou mais lances",
        "sv": "Schackmatt på 5 eller fler drag"
    },
    {
        "en": "Underpromotion",
        "es": "Coronación menor",
        "de": "Unterverwandlung",
        "fr": "Sous-promotion",
        "it": "Sotto-promozione",
        "pt": "Subpromoção",
        "sv": "Underpromotion"
    },
    {
        "en": "Promotion to a knight, bishop, or rook.",
        "es": "Coronar a caballo, alfil o torre en lugar de dama.",
        "de": "Umwandlung in Springer, Läufer oder Turm (statt Dame).",
        "fr": "Promotion en cavalier, fou ou tour.",
        "it": "Promozione in cavallo, alfiere o torre.",
        "pt": "Promoção para cavalo, bispo ou torre.",
        "sv": "Promovera till springare, löpare eller torn istället för dam."
    },
    {
        "en": "Master games",
        "es": "Partidas de maestros",
        "de": "Meisterpartien",
        "fr": "Parties de maîtres",
        "it": "Partite di maestri",
        "pt": "Partidas de mestres",
        "sv": "Partier från stormästare"
    },
    {
        "en": "Puzzles from games played by titled players.",
        "es": "Puzzles extraídos de partidas jugadas por jugadores titulados.",
        "de": "Rätsel aus Partien von titulierten Spielern.",
        "fr": "Problèmes tirés de parties jouées par des joueurs titrés.",
        "it": "Puzzle tratti da partite giocate da giocatori titolati.",
        "pt": "Problemas retirados de partidas jogadas por jogadores titulados.",
        "sv": "Pussel från partier av titulerade spelare."
    },
    {
        "en": "Master vs Master games",
        "es": "Partidas maestro vs maestro",
        "de": "Meister vs Meister",
        "fr": "Parties maître vs maître",
        "it": "Partite maestro vs maestro",
        "pt": "Partidas Mestre vs Mestre",
        "sv": "Partier mellan stormästare"
    },
    {
        "en": "Puzzles from games between two titled players.",
        "es": "Puzzles de partidas entre dos jugadores titulados.",
        "de": "Rätsel aus Partien zwischen zwei Titelträgern.",
        "fr": "Problèmes issus de parties entre deux joueurs titrés.",
        "it": "Puzzle da partite tra due giocatori titolati.",
        "pt": "Problemas de partidas entre dois jogadores titulados.",
        "sv": "Pussel från partier mellan två titulerade spelare."
    },
    {
        "en": "Super GM games",
        "es": "Partidas de super-GMs",
        "de": "Super-GM-Partien",
        "fr": "Parties de super-GM",
        "it": "Partite dei super GM",
        "pt": "Partidas de Super-GMs",
        "sv": "Partier från super-GM"
    },
    {
        "en": "Puzzles from games played by the best players in the world.",
        "es": "Puzzles de partidas jugadas por los mejores jugadores del mundo.",
        "de": "Rätsel aus Partien der weltbesten Spieler.",
        "fr": "Problèmes tirés de parties des meilleurs joueurs mondiaux.",
        "it": "Puzzle da partite giocate dai migliori giocatori al mondo.",
        "pt": "Problemas de partidas jogadas pelos melhores jogadores do mundo.",
        "sv": "Pussel från världens starkaste spelare."
    },
    {
        "en": "Hook mate",
        "es": "Mate gancho",
        "de": "Hakenmatt",
        "fr": "Mat en crochet",
        "it": "Matto a uncino",
        "pt": "Mate gancho",
        "sv": "Hook-matt"
    },
    {
        "en": "Checkmate with a rook, knight, and pawn along with one enemy pawn to limit the enemy king's escape.",
        "es": "Mate con torre, caballo y peón, y un peón enemigo que limita la huida del rey rival.",
        "de": "Matt mit Turm, Springer und Bauer, wobei ein gegnerischer Bauer Fluchtfelder blockiert.",
        "fr": "Mat impliquant une tour, un cavalier et un pion, avec un pion adverse qui limite les cases d'évasion du roi.",
        "it": "Scacco matto con torre, cavallo e pedone supportati da un pedone nemico che limita le fughe del re.",
        "pt": "Xeque-mate com torre, cavalo e peão, usando também um peão inimigo para limitar a fuga do rei.",
        "sv": "Matt med torn, springare och bonde där en fiendebonde hjälper till att begränsa kungens utvägar."
    },
    {
        "en": "Anastasia's mate",
        "es": "Mate de Anastasia",
        "de": "Anastasias Matt",
        "fr": "Mat d'Anastasia",
        "it": "Matto di Anastasia",
        "pt": "Mate de Anastásia",
        "sv": "Anastasias matt"
    },
    {
        "en": "A knight and rook or queen team up to trap the opposing king between the side of the board and a friendly piece.",
        "es": "Caballo y torre o dama se combinan para atrapar al rey entre el borde del tablero y una pieza propia.",
        "de": "Mattbild, bei dem Springer und Turm\/Dame den König an die Brettseite und eine eigene Figur fesseln.",
        "fr": "Cavalier et tour (ou dame) s'associent pour coincer le roi adverse contre le bord et une pièce alliée.",
        "it": "Un cavallo e una torre (o regina) si combinano per intrappolare il re avversario tra il lato della scacchiera e un pezzo amico.",
        "pt": "Cavalo e torre\/dama combinam para encurralar o rei adversário entre a lateral do tabuleiro e uma peça própria.",
        "sv": "Springare och torn (eller dam) samarbetar för att fånga kungen vid brädets kant."
    },
    {
        "en": "Arabian mate",
        "es": "Mate árabe",
        "de": "Arabisches Matt",
        "fr": "Mat arabe",
        "it": "Matto arabo",
        "pt": "Mate árabe",
        "sv": "Arabisk matt"
    },
    {
        "en": "A knight and a rook team up to trap the opposing king on a corner of the board.",
        "es": "Caballo y torre se combinan para atrapar al rey en una esquina del tablero.",
        "de": "Mattbild mit Springer und Turm, das den König in einer Ecke fängt.",
        "fr": "Cavalier et tour coopèrent pour coincer le roi adverse dans un coin.",
        "it": "Un cavallo e una torre si combinano per intrappolare il re avversario in un angolo della scacchiera.",
        "pt": "Cavalo e torre combinam para encurralar o rei adversário num canto do tabuleiro.",
        "sv": "Springare och torn samarbetar för att mata i ett hörn."
    },
    {
        "en": "Dovetail mate",
        "es": "Mate Dovetail",
        "de": "Schwalbenschwanzmatt",
        "fr": "Mat en queue d'aronde",
        "it": "Matto a incastro",
        "pt": "Mate em encaixe",
        "sv": "Dovetail-matt"
    },
    {
        "en": "A queen delivers mate to an adjacent king, whose only two escape squares are obstructed by friendly pieces.",
        "es": "La dama da mate a un rey adyacente cuyas dos únicas casillas de escape están bloqueadas por piezas propias.",
        "de": "Dame setzt matt an einen König, dessen zwei Fluchtfelder von eigenen Figuren blockiert sind.",
        "fr": "Dame matant un roi adjacent dont les deux cases d'évasion sont bloquées par ses propres pièces.",
        "it": "La regina dà matto a un re adiacente, le cui uniche due vie di fuga sono bloccate da pezzi amici.",
        "pt": "A dama dá mate a um rei adjacente cujas duas casas de fuga estão obstruídas por peças próprias.",
        "sv": "Dam mattar en kung vars båda flyktrutor är blockerade av egna pjäser."
    },
    {
        "en": "Boden's mate",
        "es": "Mate de Boden",
        "de": "Bodens Matt",
        "fr": "Mat de Boden",
        "it": "Matto di Boden",
        "pt": "Mate de Boden",
        "sv": "Bodens matt"
    },
    {
        "en": "Two attacking bishops on criss-crossing diagonals deliver mate to a king obstructed by friendly pieces.",
        "es": "Dos alfiles atacantes en diagonales cruzadas dan mate a un rey bloqueado por piezas propias.",
        "de": "Zwei Läufer auf gekreuzten Diagonalen setzen matt, während eigene Figuren Fluchtfelder blockieren.",
        "fr": "Deux fous attaquants sur diagonales croisées donnent mat à un roi bloqué par ses propres pièces.",
        "it": "Due alfieri attaccanti su diagonali incrociate danno matto a un re ostruito dai propri pezzi.",
        "pt": "Dois bispos atacantes em diagonais cruzadas dão mate a um rei cujas rotas estão bloqueadas por peças próprias.",
        "sv": "Två löpare i korsande diagonaler levererar matt när kungens flyktrutor blockeras av egna pjäser."
    },
    {
        "en": "Double bishop mate",
        "es": "Mate de dos alfiles",
        "de": "Matt mit zwei Läufern",
        "fr": "Mat aux deux fous",
        "it": "Matto con due alfieri",
        "pt": "Mate de dois bispos",
        "sv": "Dubbel-löparmatt"
    },
    {
        "en": "Two attacking bishops on adjacent diagonals deliver mate to a king obstructed by friendly pieces.",
        "es": "Dos alfiles atacantes en diagonales adyacentes dan mate a un rey obstruido por piezas propias.",
        "de": "Zwei Läufer auf benachbarten Diagonalen bringen Matt, während eigene Figuren Fluchtfelder versperren.",
        "fr": "Deux fous sur diagonales adjacentes donnent mat à un roi empêché de fuir par ses pièces.",
        "it": "Due alfieri attaccanti su diagonali adiacenti danno matto a un re ostruito dai propri pezzi.",
        "pt": "Dois bispos atacantes em diagonais adjacentes dão mate a um rei obstruído por peças próprias.",
        "sv": "Två löpare på intilliggande diagonaler ger matt när egna pjäser hindrar kungen."
    },
    {
        "en": "Vukovic Mate",
        "es": "Mate de Vukovic",
        "de": "Vuković-Matt",
        "fr": "Mat de Vukovic",
        "it": "Matto di Vukovic",
        "pt": "Mate de Vukovic",
        "sv": "Vukovic-matt"
    },
    {
        "en": "Killbox Mate",
        "es": "Mate Killbox",
        "de": "Killbox-Matt",
        "fr": "Mat en killbox",
        "it": "Killbox Mate",
        "pt": "Mate 'killbox'",
        "sv": "Killbox-matt"
    },
    {
        "en": "A rook is next to the enemy king and supported by a queen that also blocks the king's escape squares. The rook and the queen catch the enemy king in a 3 by 3 'kill box'.",
        "es": "Una torre junto al rey enemigo, apoyada por la dama que bloquea las casillas de escape. Torre y dama atrapan al rey en una 'kill box' de 3x3.",
        "de": "Turm steht neben dem gegnerischen König, unterstützt von der Dame, die Fluchtfelder versperrt – König in einem 3x3 ‚Killbox‘ gefangen.",
        "fr": "Une tour près du roi adverse, soutenue par une dame qui bloque les cases d'évasion, forme une 'kill box' 3x3 pour mater le roi.",
        "it": "Una torre è accanto al re nemico e supportata da una regina che blocca anche le vie di fuga. Torre e regina intrappolano il re in una 'kill box' 3x3.",
        "pt": "Uma torre próxima ao rei inimigo apoiada por uma dama que bloqueia as casas de fuga. Torre e dama prendem o rei em uma 'caixa de morte' 3x3.",
        "sv": "Ett torn står bredvid fiendekungen och stöds av en dam som också stänger flyktrutorna — kungen fångas i en 3x3 'kill box'."
    },
    {
        "en": "Alekhine Defense",
        "es": "Defensa Alekhine",
        "de": "Alekhine-Verteidigung",
        "fr": "Défense Alekhine",
        "it": "Difesa Alekhine",
        "pt": "Defesa Alekhine",
        "sv": "Alekhineförsvaret"
    },
    {
        "en": "Benoni Defense",
        "es": "Defensa Benoni",
        "de": "Benoni-Verteidigung",
        "fr": "Défense Benoni",
        "it": "Difesa Benoni",
        "pt": "Defesa Benoni",
        "sv": "Benoni-försvaret"
    },
    {
        "en": "Bird Opening",
        "es": "Apertura Bird",
        "de": "Bird-Eröffnung",
        "fr": "Ouverture Bird",
        "it": "Apertura Bird",
        "pt": "Abertura Bird",
        "sv": "Bird-öppningen"
    },
    {
        "en": "Bishops Opening",
        "es": "Apertura de los alfiles",
        "de": "Läufer-Eröffnung",
        "fr": "Ouverture des fous",
        "it": "Apertura degli alfieri",
        "pt": "Abertura dos Bispos",
        "sv": "Löparöppningen"
    },
    {
        "en": "Blackmar-Diemer Gambit",
        "es": "Gambito Blackmar-Diemer",
        "de": "Blackmar-Diemer-Gambit",
        "fr": "Gambit Blackmar-Diemer",
        "it": "Gambetto Blackmar-Diemer",
        "pt": "Gambito Blackmar–Diemer",
        "sv": "Blackmar–Diemer-gambit"
    },
    {
        "en": "Caro-Kann Defense",
        "es": "Defensa Caro-Kann",
        "de": "Caro-Kann-Verteidigung",
        "fr": "Défense Caro-Kann",
        "it": "Difesa Caro-Kann",
        "pt": "Defesa Caro–Kann",
        "sv": "Caro–Kann-försvaret"
    },
    {
        "en": "Catalan Opening",
        "es": "Apertura Catalana",
        "de": "Katalanische Eröffnung",
        "fr": "Ouverture Catalane",
        "it": "Apertura Catalana",
        "pt": "Abertura Catalã",
        "sv": "Catalan-öppningen"
    },
    {
        "en": "Center Game",
        "es": "Juego del centro",
        "de": "Zentrumsspiel",
        "fr": "Jeu du Centre",
        "it": "Partita di centro",
        "pt": "Jogo do Centro",
        "sv": "Center Game"
    },
    {
        "en": "Danish Gambit",
        "es": "Gambito Danés",
        "de": "Dänisches Gambit",
        "fr": "Gambit danois",
        "it": "Gambetto Danese",
        "pt": "Gambito Dinamarquês",
        "sv": "Danska gambiten"
    },
    {
        "en": "Danish Gambit Accepted",
        "es": "Gambito Danés Aceptado",
        "de": "Dänisches Gambit angenommen",
        "fr": "Gambit danois accepté",
        "it": "Gambetto Danese accettato",
        "pt": "Gambito Dinamarquês Aceito",
        "sv": "Danska gambiten accepterad"
    },
    {
        "en": "Dutch Defense",
        "es": "Defensa Holandesa",
        "de": "Niederländische Verteidigung",
        "fr": "Défense Hollandaise",
        "it": "Difesa Olandese",
        "pt": "Defesa Holandesa",
        "sv": "Holländskt försvar"
    },
    {
        "en": "Elephant Gambit",
        "es": "Gambito Elefante",
        "de": "Elefanten-Gambit",
        "fr": "Gambit Éléphant",
        "it": "Gambetto Elephant",
        "pt": "Gambito Elefante",
        "sv": "Elefantgambit"
    },
    {
        "en": "English Defense",
        "es": "Defensa Inglesa",
        "de": "Englische Verteidigung",
        "fr": "Défense Anglaise",
        "it": "Difesa Inglese",
        "pt": "Defesa Inglesa",
        "sv": "Engelskt försvar"
    },
    {
        "en": "English Opening",
        "es": "Apertura Inglesa",
        "de": "Englische Eröffnung",
        "fr": "Ouverture anglaise",
        "it": "Apertura Inglese",
        "pt": "Abertura Inglesa",
        "sv": "Engelska öppningen"
    },
    {
        "en": "Englund Gambit",
        "es": "Gambito Englund",
        "de": "Englund-Gambit",
        "fr": "Gambit Englund",
        "it": "Gambetto Englund",
        "pt": "Gambito Englund",
        "sv": "Englund-gambit"
    },
    {
        "en": "Englund Gambit Complex",
        "es": "Complejo de Gambito Englund",
        "de": "Englund-Gambit-Komplex",
        "fr": "Complexe du gambit Englund",
        "it": "Complesso del Gambetto Englund",
        "pt": "Complexo do Gambito Englund",
        "sv": "Englund-gambitkomplexet"
    },
    {
        "en": "Englund Gambit Declined",
        "es": "Gambito Englund Rehusado",
        "de": "Englund-Gambit abgelehnt",
        "fr": "Gambit Englund refusé",
        "it": "Gambetto Englund rifiutato",
        "pt": "Gambito Englund Recusado",
        "sv": "Englund-gambit avvisad"
    },
    {
        "en": "Four Knights Game",
        "es": "Partida de los cuatro caballos",
        "de": "Vier-Springer-Spiel",
        "fr": "Partie des quatre cavaliers",
        "it": "Partita dei quattro cavalli",
        "pt": "Jogo dos Quatro Cavalos",
        "sv": "Fyra springares parti"
    },
    {
        "en": "French Defense",
        "es": "Defensa Francesa",
        "de": "Französische Verteidigung",
        "fr": "Défense Française",
        "it": "Difesa Francese",
        "pt": "Defesa Francesa",
        "sv": "Franskt försvar"
    },
    {
        "en": "Grob Opening",
        "es": "Apertura Grob",
        "de": "Grob-Eröffnung",
        "fr": "Ouverture Grob",
        "it": "Apertura Grob",
        "pt": "Abertura Grob",
        "sv": "Grob-öppningen"
    },
    {
        "en": "Grunfeld Defense",
        "es": "Defensa Grünfeld",
        "de": "Grünfeld-Verteidigung",
        "fr": "Défense Grünfeld",
        "it": "Difesa Grünfeld",
        "pt": "Defesa Grünfeld",
        "sv": "Grünfeldförsvaret"
    },
    {
        "en": "Horwitz Defense",
        "es": "Defensa Horwitz",
        "de": "Horwitz-Verteidigung",
        "fr": "Défense Horwitz",
        "it": "Difesa Horwitz",
        "pt": "Defesa Horwitz",
        "sv": "Horwitz-försvaret"
    },
    {
        "en": "Hungarian Opening",
        "es": "Apertura Húngara",
        "de": "Ungarische Eröffnung",
        "fr": "Ouverture Hongroise",
        "it": "Apertura Ungherese",
        "pt": "Abertura Húngara",
        "sv": "Ungerska öppningen"
    },
    {
        "en": "Indian Defense",
        "es": "Defensa India",
        "de": "Indische Verteidigung",
        "fr": "Défense Indienne",
        "it": "Difesa Indiana",
        "pt": "Defesa Indiana",
        "sv": "Indiskt försvar"
    },
    {
        "en": "Italian Game",
        "es": "Partida italiana",
        "de": "Italienisches Spiel",
        "fr": "Partie italienne",
        "it": "Partita Italiana",
        "pt": "Jogo Italiano",
        "sv": "Italienskt parti"
    },
    {
        "en": "Kings Gambit",
        "es": "Gambito de rey",
        "de": "Königs-Gambit",
        "fr": "Gambit du roi",
        "it": "Gambetto di Re",
        "pt": "Gambito do Rei",
        "sv": "Kungs­gambit"
    },
    {
        "en": "Kings Gambit Accepted",
        "es": "Gambito de rey aceptado",
        "de": "Königs-Gambit angenommen",
        "fr": "Gambit du roi accepté",
        "it": "Gambetto di Re accettato",
        "pt": "Gambito do Rei Aceito",
        "sv": "Kungs­gambit accepterad"
    },
    {
        "en": "Kings Gambit Declined",
        "es": "Gambito de rey rehusado",
        "de": "Königs-Gambit abgelehnt",
        "fr": "Gambit du roi refusé",
        "it": "Gambetto di Re rifiutato",
        "pt": "Gambito do Rei Recusado",
        "sv": "Kungs­gambit avvisad"
    },
    {
        "en": "Kings Indian Attack",
        "es": "Ataque Indio del Rey",
        "de": "Königsindischer Angriff",
        "fr": "Attaque indienne du roi",
        "it": "Attacco Indiano del Re",
        "pt": "Ataque Indiano do Rei",
        "sv": "Kunglig indisk attack"
    },
    {
        "en": "Kings Indian Defense",
        "es": "Defensa India del Rey",
        "de": "Königsindische Verteidigung",
        "fr": "Défense Est-Indienne",
        "it": "Difesa Indiana del Re",
        "pt": "Defesa Índia do Rei",
        "sv": "Kungens indiska försvar"
    },
    {
        "en": "Kings Knight Opening",
        "es": "Apertura del Caballo de Rey",
        "de": "Königsspringer-Eröffnung",
        "fr": "Ouverture du cavalier du roi",
        "it": "Apertura Cavallo del Re",
        "pt": "Abertura do Cavalo do Rei",
        "sv": "Kungens springs öppning"
    },
    {
        "en": "Kings Pawn Game",
        "es": "Juego de peón de rey",
        "de": "Königbauer-Spiel (e4)",
        "fr": "Partie du pion roi",
        "it": "Partita di pedone di re",
        "pt": "Jogo do Peão do Rei",
        "sv": "Kungsbondens parti"
    },
    {
        "en": "London System",
        "es": "Sistema Londres",
        "de": "London-System",
        "fr": "Système de Londres",
        "it": "Sistema Londra",
        "pt": "Sistema Londres",
        "sv": "London-systemet"
    },
    {
        "en": "Mieses Opening",
        "es": "Apertura Mieses",
        "de": "Mieses-Eröffnung",
        "fr": "Ouverture Mieses",
        "it": "Apertura Mieses",
        "pt": "Abertura Mieses",
        "sv": "Mieses-öppningen"
    },
    {
        "en": "Modern Defense",
        "es": "Defensa Moderna",
        "de": "Moderne Verteidigung",
        "fr": "Défense Moderne",
        "it": "Difesa Moderna",
        "pt": "Defesa Moderna",
        "sv": "Modernt försvar"
    },
    {
        "en": "Nimzo-Indian Defense",
        "es": "Defensa Nimzo-India",
        "de": "Nimzo-Indische Verteidigung",
        "fr": "Défense Nimzo-Indienne",
        "it": "Difesa Nimzo-Indiana",
        "pt": "Defesa Nimzo-Índia",
        "sv": "Nimzoindiskt försvar"
    },
    {
        "en": "Nimzo-Larsen Attack",
        "es": "Ataque Nimzo-Larsen",
        "de": "Nimzo-Larsen-Angriff",
        "fr": "Attaque Nimzo-Larsen",
        "it": "Attacco Nimzo-Larsen",
        "pt": "Ataque Nimzo–Larsen",
        "sv": "Nimzo–Larsen-attack"
    },
    {
        "en": "Nimzowitsch Defense",
        "es": "Defensa Nimzowitsch",
        "de": "Nimzowitsch-Verteidigung",
        "fr": "Défense Nimzowitsch",
        "it": "Difesa Nimzowitsch",
        "pt": "Defesa Nimzowitsch",
        "sv": "Nimzowitsch-försvaret"
    },
    {
        "en": "Old Indian Defense",
        "es": "Defensa India Antigua",
        "de": "Alte Indische Verteidigung",
        "fr": "Ancienne défense indienne",
        "it": "Vecchia Difesa Indiana",
        "pt": "Defesa Índia Antiga",
        "sv": "Gamla indiska försvaret"
    },
    {
        "en": "Owen Defense",
        "es": "Defensa Owen",
        "de": "Owen-Verteidigung",
        "fr": "Défense Owen",
        "it": "Difesa Owen",
        "pt": "Defesa Owen",
        "sv": "Owen-försvaret"
    },
    {
        "en": "Philidor Defense",
        "es": "Defensa Philidor",
        "de": "Philidor-Verteidigung",
        "fr": "Défense Philidor",
        "it": "Difesa Philidor",
        "pt": "Defesa Philidor",
        "sv": "Philidor-försvaret"
    },
    {
        "en": "Pirc Defense",
        "es": "Defensa Pirc",
        "de": "Pirc-Verteidigung",
        "fr": "Défense Pirc",
        "it": "Difesa Pirc",
        "pt": "Defesa Pirc",
        "sv": "Pirc-försvaret"
    },
    {
        "en": "Polish Opening",
        "es": "Apertura Polaca",
        "de": "Polnische Eröffnung",
        "fr": "Ouverture Polonaise",
        "it": "Apertura Polacca",
        "pt": "Abertura Polonesa",
        "sv": "Polska öppningen"
    },
    {
        "en": "Ponziani Opening",
        "es": "Apertura Ponziani",
        "de": "Ponziani-Eröffnung",
        "fr": "Ouverture Ponziani",
        "it": "Apertura Ponziani",
        "pt": "Abertura Ponziani",
        "sv": "Ponziani-öppningen"
    },
    {
        "en": "Queens Gambit Accepted",
        "es": "Gambito de dama aceptado",
        "de": "Damengambit angenommen",
        "fr": "Gambit dame accepté",
        "it": "Gambetto di Donna accettato",
        "pt": "Gambito da Dama Aceito",
        "sv": "Damen-gambit accepterad"
    },
    {
        "en": "Queens Gambit Declined",
        "es": "Gambito de dama rehusado",
        "de": "Damengambit abgelehnt",
        "fr": "Gambit dame refusé",
        "it": "Gambetto di Donna rifiutato",
        "pt": "Gambito da Dama Recusado",
        "sv": "Damen-gambit avvisad"
    },
    {
        "en": "Queens Indian Defense",
        "es": "Defensa India de Dama",
        "de": "Damenindische Verteidigung",
        "fr": "Défense Nimzo-Indienne (Indienne de la dame)",
        "it": "Difesa Indiana della Donna",
        "pt": "Defesa Índia da Dama",
        "sv": "Damenindiskt försvar"
    },
    {
        "en": "Queens Pawn Game",
        "es": "Juego de peón de dama",
        "de": "Dammbauern-Spiel (d4)",
        "fr": "Partie du pion dame",
        "it": "Partita di pedone di donna",
        "pt": "Jogo do Peão da Dama",
        "sv": "Dambondens parti"
    },
    {
        "en": "Rapport-Jobava System",
        "es": "Sistema Rapport-Jobava",
        "de": "Rapport-Jobava-System",
        "fr": "Système Rapport-Jobava",
        "it": "Sistema Rapport-Jobava",
        "pt": "Sistema Rapport–Jobava",
        "sv": "Rapport–Jobava-systemet"
    },
    {
        "en": "Rat Defense",
        "es": "Defensa Rat",
        "de": "Rat-Verteidigung",
        "fr": "Défense Rat",
        "it": "Difesa Rat",
        "pt": "Defesa Rato",
        "sv": "Råttförsvaret"
    },
    {
        "en": "Reti Opening",
        "es": "Apertura Réti",
        "de": "Réti-Eröffnung",
        "fr": "Ouverture Réti",
        "it": "Apertura Réti",
        "pt": "Abertura Réti",
        "sv": "Réti-öppningen"
    },
    {
        "en": "Russian Game",
        "es": "Partida Rusa",
        "de": "Russisches Spiel",
        "fr": "Partie Russe",
        "it": "Partita Russa",
        "pt": "Jogo Russo",
        "sv": "Ryskt parti"
    },
    {
        "en": "Ruy Lopez",
        "es": "Ruy López",
        "de": "Spanische Partie (Ruy Lopez)",
        "fr": "Ruy Lopez (Espagnole)",
        "it": "Spagnola (Ruy Lopez)",
        "pt": "Ruy Lopez",
        "sv": "Ruy Lopez"
    },
    {
        "en": "Scandinavian Defense",
        "es": "Defensa Escandinava",
        "de": "Skandinavische Verteidigung",
        "fr": "Défense Scandinave",
        "it": "Difesa Scandinava",
        "pt": "Defesa Escandinava",
        "sv": "Skandinaviskt försvar"
    },
    {
        "en": "Scotch Game",
        "es": "Partida escocesa",
        "de": "Schottische Partie",
        "fr": "Partie écossaise",
        "it": "Partita Scozzese",
        "pt": "Jogo Escocês",
        "sv": "Skotskt parti"
    },
    {
        "en": "Semi-Slav Defense",
        "es": "Defensa Semi-Eslava",
        "de": "Halbslawische Verteidigung",
        "fr": "Défense Semi-Slave",
        "it": "Difesa Semislav",
        "pt": "Defesa Semi-Eslava",
        "sv": "Semi-Slaviskt försvar"
    },
    {
        "en": "Sicilian Defense",
        "es": "Defensa Siciliana",
        "de": "Sizilianische Verteidigung",
        "fr": "Défense sicilienne",
        "it": "Difesa Siciliana",
        "pt": "Defesa Siciliana",
        "sv": "Sicilianskt försvar"
    },
    {
        "en": "Slav Defense",
        "es": "Defensa Eslava",
        "de": "Slawische Verteidigung",
        "fr": "Défense slave",
        "it": "Difesa Slavona",
        "pt": "Defesa Eslava",
        "sv": "Slaviskt försvar"
    },
    {
        "en": "Tarrasch Defense",
        "es": "Defensa Tarrasch",
        "de": "Tarrasch-Verteidigung",
        "fr": "Défense Tarrasch",
        "it": "Difesa Tarrasch",
        "pt": "Defesa Tarrasch",
        "sv": "Tarrasch-försvaret"
    },
    {
        "en": "Three Knights Opening",
        "es": "Apertura de los tres caballos",
        "de": "Drei-Springer-Eröffnung",
        "fr": "Ouverture des trois cavaliers",
        "it": "Apertura dei tre cavalli",
        "pt": "Abertura dos Três Cavalos",
        "sv": "Tre springares öppning"
    },
    {
        "en": "Trompowsky Attack",
        "es": "Ataque Trompowsky",
        "de": "Trompowsky-Angriff",
        "fr": "Attaque Trompowsky",
        "it": "Attacco Trompowsky",
        "pt": "Ataque Trompowsky",
        "sv": "Trompowsky-attacken"
    },
    {
        "en": "Van Geet Opening",
        "es": "Apertura Van Geet",
        "de": "Van-Geet-Eröffnung",
        "fr": "Ouverture Van Geet",
        "it": "Apertura Van Geet",
        "pt": "Abertura Van Geet",
        "sv": "Van Geet-öppningen"
    },
    {
        "en": "Vant Kruijs Opening",
        "es": "Apertura Van't Kruijs",
        "de": "Vant-Kruijs-Eröffnung",
        "fr": "Ouverture Vant Kruijs",
        "it": "Apertura Van't Kruijs",
        "pt": "Abertura Van't Kruijs",
        "sv": "Vant Kruijs-öppningen"
    },
    {
        "en": "Vienna Game",
        "es": "Partida de Viena",
        "de": "Wiener Partie",
        "fr": "Partie de Vienne",
        "it": "Partita di Vienna",
        "pt": "Jogo de Viena",
        "sv": "Wienerpartiet"
    },
    {
        "en": "Zukertort Opening",
        "es": "Apertura Zukertort",
        "de": "Zukertort-Eröffnung",
        "fr": "Ouverture Zukertort",
        "it": "Apertura Zukertort",
        "pt": "Abertura Zukertort",
        "sv": "Zukertort-öppningen"
    },
    {
        "en": "3 Pieces",
        "es": "3 piezas",
        "de": "3 Figuren",
        "fr": "3 pièces",
        "it": "3 pezzi",
        "pt": "3 Peças",
        "sv": "3 pjäser"
    },
    {
        "en": "Boards with 3 Pieces",
        "es": "Tableros con 3 piezas",
        "de": "Bretter mit 3 Figuren",
        "fr": "Plateaux avec 3 pièces",
        "it": "Scacchiere con 3 pezzi",
        "pt": "Tabuleiros com 3 peças",
        "sv": "Bräden med 3 pjäser"
    },
    {
        "en": "4 Pieces",
        "es": "4 piezas",
        "de": "4 Figuren",
        "fr": "4 pièces",
        "it": "4 pezzi",
        "pt": "4 Peças",
        "sv": "4 pjäser"
    },
    {
        "en": "Boards with 4 Pieces",
        "es": "Tableros con 4 piezas",
        "de": "Bretter mit 4 Figuren",
        "fr": "Plateaux avec 4 pièces",
        "it": "Scacchiere con 4 pezzi",
        "pt": "Tabuleiros com 4 peças",
        "sv": "Bräden med 4 pjäser"
    },
    {
        "en": "5 Pieces",
        "es": "5 piezas",
        "de": "5 Figuren",
        "fr": "5 pièces",
        "it": "5 pezzi",
        "pt": "5 Peças",
        "sv": "5 pjäser"
    },
    {
        "en": "Boards with 5 Pieces",
        "es": "Tableros con 5 piezas",
        "de": "Bretter mit 5 Figuren",
        "fr": "Plateaux avec 5 pièces",
        "it": "Scacchiere con 5 pezzi",
        "pt": "Tabuleiros com 5 peças",
        "sv": "Bräden med 5 pjäser"
    },
    {
        "en": "6 Pieces",
        "es": "6 piezas",
        "de": "6 Figuren",
        "fr": "6 pièces",
        "it": "6 pezzi",
        "pt": "6 Peças",
        "sv": "6 pjäser"
    },
    {
        "en": "Boards with 6 Pieces",
        "es": "Tableros con 6 piezas",
        "de": "Bretter mit 6 Figuren",
        "fr": "Plateaux avec 6 pièces",
        "it": "Scacchiere con 6 pezzi",
        "pt": "Tabuleiros com 6 peças",
        "sv": "Bräden med 6 pjäser"
    },
    {
        "en": "7 Pieces",
        "es": "7 piezas",
        "de": "7 Figuren",
        "fr": "7 pièces",
        "it": "7 pezzi",
        "pt": "7 Peças",
        "sv": "7 pjäser"
    },
    {
        "en": "Boards with 7 Pieces",
        "es": "Tableros con 7 piezas",
        "de": "Bretter mit 7 Figuren",
        "fr": "Plateaux avec 7 pièces",
        "it": "Scacchiere con 7 pezzi",
        "pt": "Tabuleiros com 7 peças",
        "sv": "Bräden med 7 pjäser"
    },
    {
        "en": "8 Pieces",
        "es": "8 piezas",
        "de": "8 Figuren",
        "fr": "8 pièces",
        "it": "8 pezzi",
        "pt": "8 Peças",
        "sv": "8 pjäser"
    },
    {
        "en": "Boards with 8 Pieces",
        "es": "Tableros con 8 piezas",
        "de": "Bretter mit 8 Figuren",
        "fr": "Plateaux avec 8 pièces",
        "it": "Scacchiere con 8 pezzi",
        "pt": "Tabuleiros com 8 peças",
        "sv": "Bräden med 8 pjäser"
    },
    {
        "en": "9 Pieces",
        "es": "9 piezas",
        "de": "9 Figuren",
        "fr": "9 pièces",
        "it": "9 pezzi",
        "pt": "9 Peças",
        "sv": "9 pjäser"
    },
    {
        "en": "Boards with 9 Pieces",
        "es": "Tableros con 9 piezas",
        "de": "Bretter mit 9 Figuren",
        "fr": "Plateaux avec 9 pièces",
        "it": "Scacchiere con 9 pezzi",
        "pt": "Tabuleiros com 9 peças",
        "sv": "Bräden med 9 pjäser"
    },
    {
        "en": "10 Pieces",
        "es": "10 piezas",
        "de": "10 Figuren",
        "fr": "10 pièces",
        "it": "10 pezzi",
        "pt": "10 Peças",
        "sv": "10 pjäser"
    },
    {
        "en": "Boards with 10 Pieces",
        "es": "Tableros con 10 piezas",
        "de": "Bretter mit 10 Figuren",
        "fr": "Plateaux avec 10 pièces",
        "it": "Scacchiere con 10 pezzi",
        "pt": "Tabuleiros com 10 peças",
        "sv": "Bräden med 10 pjäser"
    },
    {
        "en": "11 Pieces",
        "es": "11 piezas",
        "de": "11 Figuren",
        "fr": "11 pièces",
        "it": "11 pezzi",
        "pt": "11 Peças",
        "sv": "11 pjäser"
    },
    {
        "en": "Boards with 11 Pieces",
        "es": "Tableros con 11 piezas",
        "de": "Bretter mit 11 Figuren",
        "fr": "Plateaux avec 11 pièces",
        "it": "Scacchiere con 11 pezzi",
        "pt": "Tabuleiros com 11 peças",
        "sv": "Bräden med 11 pjäser"
    },
    {
        "en": "12 Pieces",
        "es": "12 piezas",
        "de": "12 Figuren",
        "fr": "12 pièces",
        "it": "12 pezzi",
        "pt": "12 Peças",
        "sv": "12 pjäser"
    },
    {
        "en": "Boards with 12 Pieces",
        "es": "Tableros con 12 piezas",
        "de": "Bretter mit 12 Figuren",
        "fr": "Plateaux avec 12 pièces",
        "it": "Scacchiere con 12 pezzi",
        "pt": "Tabuleiros com 12 peças",
        "sv": "Bräden med 12 pjäser"
    },
    {
        "en": "13 Pieces",
        "es": "13 piezas",
        "de": "13 Figuren",
        "fr": "13 pièces",
        "it": "13 pezzi",
        "pt": "13 Peças",
        "sv": "13 pjäser"
    },
    {
        "en": "Boards with 13 Pieces",
        "es": "Tableros con 13 piezas",
        "de": "Bretter mit 13 Figuren",
        "fr": "Plateaux avec 13 pièces",
        "it": "Scacchiere con 13 pezzi",
        "pt": "Tabuleiros com 13 peças",
        "sv": "Bräden med 13 pjäser"
    },
    {
        "en": "14 Pieces",
        "es": "14 piezas",
        "de": "14 Figuren",
        "fr": "14 pièces",
        "it": "14 pezzi",
        "pt": "14 Peças",
        "sv": "14 pjäser"
    },
    {
        "en": "Boards with 14 Pieces",
        "es": "Tableros con 14 piezas",
        "de": "Bretter mit 14 Figuren",
        "fr": "Plateaux avec 14 pièces",
        "it": "Scacchiere con 14 pezzi",
        "pt": "Tabuleiros com 14 peças",
        "sv": "Bräden med 14 pjäser"
    },
    {
        "en": "15 Pieces",
        "es": "15 piezas",
        "de": "15 Figuren",
        "fr": "15 pièces",
        "it": "15 pezzi",
        "pt": "15 Peças",
        "sv": "15 pjäser"
    },
    {
        "en": "Boards with 15 Pieces",
        "es": "Tableros con 15 piezas",
        "de": "Bretter mit 15 Figuren",
        "fr": "Plateaux avec 15 pièces",
        "it": "Scacchiere con 15 pezzi",
        "pt": "Tabuleiros com 15 peças",
        "sv": "Bräden med 15 pjäser"
    },
    {
        "en": "16 Pieces",
        "es": "16 piezas",
        "de": "16 Figuren",
        "fr": "16 pièces",
        "it": "16 pezzi",
        "pt": "16 Peças",
        "sv": "16 pjäser"
    },
    {
        "en": "Boards with 16 Pieces",
        "es": "Tableros con 16 piezas",
        "de": "Bretter mit 16 Figuren",
        "fr": "Plateaux avec 16 pièces",
        "it": "Scacchiere con 16 pezzi",
        "pt": "Tabuleiros com 16 peças",
        "sv": "Bräden med 16 pjäser"
    },
    {
        "en": "17 Pieces",
        "es": "17 piezas",
        "de": "17 Figuren",
        "fr": "17 pièces",
        "it": "17 pezzi",
        "pt": "17 Peças",
        "sv": "17 pjäser"
    },
    {
        "en": "Boards with 17 Pieces",
        "es": "Tableros con 17 piezas",
        "de": "Bretter mit 17 Figuren",
        "fr": "Plateaux avec 17 pièces",
        "it": "Scacchiere con 17 pezzi",
        "pt": "Tabuleiros com 17 peças",
        "sv": "Bräden med 17 pjäser"
    },
    {
        "en": "18 Pieces",
        "es": "18 piezas",
        "de": "18 Figuren",
        "fr": "18 pièces",
        "it": "18 pezzi",
        "pt": "18 Peças",
        "sv": "18 pjäser"
    },
    {
        "en": "Boards with 18 Pieces",
        "es": "Tableros con 18 piezas",
        "de": "Bretter mit 18 Figuren",
        "fr": "Plateaux avec 18 pièces",
        "it": "Scacchiere con 18 pezzi",
        "pt": "Tabuleiros com 18 peças",
        "sv": "Bräden med 18 pjäser"
    },
    {
        "en": "19 Pieces",
        "es": "19 piezas",
        "de": "19 Figuren",
        "fr": "19 pièces",
        "it": "19 pezzi",
        "pt": "19 Peças",
        "sv": "19 pjäser"
    },
    {
        "en": "Boards with 19 Pieces",
        "es": "Tableros con 19 piezas",
        "de": "Bretter mit 19 Figuren",
        "fr": "Plateaux avec 19 pièces",
        "it": "Scacchiere con 19 pezzi",
        "pt": "Tabuleiros com 19 peças",
        "sv": "Bräden med 19 pjäser"
    },
    {
        "en": "20 Pieces",
        "es": "20 piezas",
        "de": "20 Figuren",
        "fr": "20 pièces",
        "it": "20 pezzi",
        "pt": "20 Peças",
        "sv": "20 pjäser"
    },
    {
        "en": "Boards with 20 Pieces",
        "es": "Tableros con 20 piezas",
        "de": "Bretter mit 20 Figuren",
        "fr": "Plateaux avec 20 pièces",
        "it": "Scacchiere con 20 pezzi",
        "pt": "Tabuleiros com 20 peças",
        "sv": "Bräden med 20 pjäser"
    },
    {
        "en": "21 Pieces",
        "es": "21 piezas",
        "de": "21 Figuren",
        "fr": "21 pièces",
        "it": "21 pezzi",
        "pt": "21 Peças",
        "sv": "21 pjäser"
    },
    {
        "en": "Boards with 21 Pieces",
        "es": "Tableros con 21 piezas",
        "de": "Bretter mit 21 Figuren",
        "fr": "Plateaux avec 21 pièces",
        "it": "Scacchiere con 21 pezzi",
        "pt": "Tabuleiros com 21 peças",
        "sv": "Bräden med 21 pjäser"
    },
    {
        "en": "22 Pieces",
        "es": "22 piezas",
        "de": "22 Figuren",
        "fr": "22 pièces",
        "it": "22 pezzi",
        "pt": "22 Peças",
        "sv": "22 pjäser"
    },
    {
        "en": "Boards with 22 Pieces",
        "es": "Tableros con 22 piezas",
        "de": "Bretter mit 22 Figuren",
        "fr": "Plateaux avec 22 pièces",
        "it": "Scacchiere con 22 pezzi",
        "pt": "Tabuleiros com 22 peças",
        "sv": "Bräden med 22 pjäser"
    },
    {
        "en": "23 Pieces",
        "es": "23 piezas",
        "de": "23 Figuren",
        "fr": "23 pièces",
        "it": "23 pezzi",
        "pt": "23 Peças",
        "sv": "23 pjäser"
    },
    {
        "en": "Boards with 23 Pieces",
        "es": "Tableros con 23 piezas",
        "de": "Bretter mit 23 Figuren",
        "fr": "Plateaux avec 23 pièces",
        "it": "Scacchiere con 23 pezzi",
        "pt": "Tabuleiros com 23 peças",
        "sv": "Bräden med 23 pjäser"
    },
    {
        "en": "24 Pieces",
        "es": "24 piezas",
        "de": "24 Figuren",
        "fr": "24 pièces",
        "it": "24 pezzi",
        "pt": "24 Peças",
        "sv": "24 pjäser"
    },
    {
        "en": "Boards with 24 Pieces",
        "es": "Tableros con 24 piezas",
        "de": "Bretter mit 24 Figuren",
        "fr": "Plateaux avec 24 pièces",
        "it": "Scacchiere con 24 pezzi",
        "pt": "Tabuleiros com 24 peças",
        "sv": "Bräden med 24 pjäser"
    },
    {
        "en": "25 Pieces",
        "es": "25 piezas",
        "de": "25 Figuren",
        "fr": "25 pièces",
        "it": "25 pezzi",
        "pt": "25 Peças",
        "sv": "25 pjäser"
    },
    {
        "en": "Boards with 25 Pieces",
        "es": "Tableros con 25 piezas",
        "de": "Bretter mit 25 Figuren",
        "fr": "Plateaux avec 25 pièces",
        "it": "Scacchiere con 25 pezzi",
        "pt": "Tabuleiros com 25 peças",
        "sv": "Bräden med 25 pjäser"
    },
    {
        "en": "26 Pieces",
        "es": "26 piezas",
        "de": "26 Figuren",
        "fr": "26 pièces",
        "it": "26 pezzi",
        "pt": "26 Peças",
        "sv": "26 pjäser"
    },
    {
        "en": "Boards with 26 Pieces",
        "es": "Tableros con 26 piezas",
        "de": "Bretter mit 26 Figuren",
        "fr": "Plateaux avec 26 pièces",
        "it": "Scacchiere con 26 pezzi",
        "pt": "Tabuleiros com 26 peças",
        "sv": "Bräden med 26 pjäser"
    },
    {
        "en": "27 Pieces",
        "es": "27 piezas",
        "de": "27 Figuren",
        "fr": "27 pièces",
        "it": "27 pezzi",
        "pt": "27 Peças",
        "sv": "27 pjäser"
    },
    {
        "en": "Boards with 27 Pieces",
        "es": "Tableros con 27 piezas",
        "de": "Bretter mit 27 Figuren",
        "fr": "Plateaux avec 27 pièces",
        "it": "Scacchiere con 27 pezzi",
        "pt": "Tabuleiros com 27 peças",
        "sv": "Bräden med 27 pjäser"
    },
    {
        "en": "28 Pieces",
        "es": "28 piezas",
        "de": "28 Figuren",
        "fr": "28 pièces",
        "it": "28 pezzi",
        "pt": "28 Peças",
        "sv": "28 pjäser"
    },
    {
        "en": "Boards with 28 Pieces",
        "es": "Tableros con 28 piezas",
        "de": "Bretter mit 28 Figuren",
        "fr": "Plateaux avec 28 pièces",
        "it": "Scacchiere con 28 pezzi",
        "pt": "Tabuleiros com 28 peças",
        "sv": "Bräden med 28 pjäser"
    },
    {
        "en": "29 Pieces",
        "es": "29 piezas",
        "de": "29 Figuren",
        "fr": "29 pièces",
        "it": "29 pezzi",
        "pt": "29 Peças",
        "sv": "29 pjäser"
    },
    {
        "en": "Boards with 29 Pieces",
        "es": "Tableros con 29 piezas",
        "de": "Bretter mit 29 Figuren",
        "fr": "Plateaux avec 29 pièces",
        "it": "Scacchiere con 29 pezzi",
        "pt": "Tabuleiros com 29 peças",
        "sv": "Bräden med 29 pjäser"
    },
    {
        "en": "30 Pieces",
        "es": "30 piezas",
        "de": "30 Figuren",
        "fr": "30 pièces",
        "it": "30 pezzi",
        "pt": "30 Peças",
        "sv": "30 pjäser"
    },
    {
        "en": "Boards with 30 Pieces",
        "es": "Tableros con 30 piezas",
        "de": "Bretter mit 30 Figuren",
        "fr": "Plateaux avec 30 pièces",
        "it": "Scacchiere con 30 pezzi",
        "pt": "Tabuleiros com 30 peças",
        "sv": "Bräden med 30 pjäser"
    },
    {
        "en": "31 Pieces",
        "es": "31 piezas",
        "de": "31 Figuren",
        "fr": "31 pièces",
        "it": "31 pezzi",
        "pt": "31 Peças",
        "sv": "31 pjäser"
    },
    {
        "en": "Boards with 31 Pieces",
        "es": "Tableros con 31 piezas",
        "de": "Bretter mit 31 Figuren",
        "fr": "Plateaux avec 31 pièces",
        "it": "Scacchiere con 31 pezzi",
        "pt": "Tabuleiros com 31 peças",
        "sv": "Bräden med 31 pjäser"
    },
    {
        "en": "32 Pieces",
        "es": "32 piezas",
        "de": "32 Figuren",
        "fr": "32 pièces",
        "it": "32 pezzi",
        "pt": "32 Peças",
        "sv": "32 pjäser"
    },
    {
        "en": "Boards with 32 Pieces",
        "es": "Tableros con 32 piezas",
        "de": "Bretter mit 32 Figuren",
        "fr": "Plateaux avec 32 pièces",
        "it": "Scacchiere con 32 pezzi",
        "pt": "Tabuleiros com 32 peças",
        "sv": "Bräden med 32 pjäser"
    },
    {
        "en": "Do over",
        "es": "Volver a intentar",
        "de": "Nochmals versuchen",
        "fr": "Recommencer",
        "it": "Riprova",
        "pt": "Refazer",
        "sv": "Gör om"
    },
    {
        "en": "Puzzles you tried again.",
        "es": "Puzzles que intentaste de nuevo.",
        "de": "Rätsel, die du nochmal versucht hast.",
        "fr": "Problèmes que vous avez réessayés.",
        "it": "Puzzle che hai riprovato.",
        "pt": "Problemas que você tentou novamente.",
        "sv": "Pussel du försökte igen."
    },
    {
        "en": "New puzzles",
        "es": "Puzzles nuevos",
        "de": "Neue Rätsel",
        "fr": "Nouveaux problèmes",
        "it": "Nuovi puzzle",
        "pt": "Novos problemas",
        "sv": "Nya pussel"
    },
    {
        "en": "New or unpopular puzzles.",
        "es": "Puzzles nuevos o poco populares.",
        "de": "Neue oder wenig gespielte Rätsel.",
        "fr": "Problèmes nouveaux ou peu joués.",
        "it": "Puzzle nuovi o poco popolari.",
        "pt": "Problemas novos ou pouco populares.",
        "sv": "Nya eller ovanliga pussel."
    },
    {
        "en": "No Visualized Moves",
        "es": "Sin movimientos visualizados",
        "de": "Keine visualisierten Züge",
        "fr": "Pas de coups visualisés",
        "it": "Nessuna mossa visualizzata",
        "pt": "Sem lances visualizados",
        "sv": "Inga visualiserade drag"
    },
    {
        "en": "1 Opponent Move - 1 Half Move",
        "es": "1 jugada del rival - 1 medio movimiento",
        "de": "1 Gegnerzug – 1 Halber Zug",
        "fr": "1 coup de l'adversaire - 1 demi-coup",
        "it": "1 mossa avversaria - 1 mezza-mossa",
        "pt": "1 lance do oponente - 1 meio-movimento",
        "sv": "1 motståndardrag - 1 halvdrag"
    },
    {
        "en": "Move",
        "es": "Jugada",
        "de": "Zug",
        "fr": "Coup",
        "it": "Mossa",
        "pt": "Lance",
        "sv": "Drag"
    },
    {
        "en": "Moves",
        "es": "Jugadas",
        "de": "Züge",
        "fr": "Coups",
        "it": "Mosse",
        "pt": "Lances",
        "sv": "Drag"
    },
    {
        "en": "Seconds",
        "es": "Segundos",
        "de": "Sekunden",
        "fr": "Secondes",
        "it": "Secondi",
        "pt": "Segundos",
        "sv": "Sekunder"
    },
    {
        "en": "Puzzle Categories",
        "es": "Categorías de puzzles",
        "de": "Rätsel-Kategorien",
        "fr": "Catégories de problèmes",
        "it": "Categorie di puzzle",
        "pt": "Categorias de problemas",
        "sv": "Pusselkategorier"
    },
    {
        "en": "Puzzle Difficulty Rating",
        "es": "Dificultad del puzzle",
        "de": "Rätsel-Schwierigkeitsbewertung",
        "fr": "Indice de difficulté du problème",
        "it": "Valutazione difficoltà puzzle",
        "pt": "Avaliação de dificuldade do problema",
        "sv": "Pusselns svårighetsbetyg"
    },
    {
        "en": "# of Moves to Visualize",
        "es": "# de jugadas para visualizar",
        "de": "# Züge zum Visualisieren",
        "fr": "# de coups à visualiser",
        "it": "# di mosse da visualizzare",
        "pt": "# de lances para visualizar",
        "sv": "Antal drag att visualisera"
    },
    {
        "en": "Time Control",
        "es": "Control de tiempo",
        "de": "Bedenkzeit",
        "fr": "Contrôle du temps",
        "it": "Controllo del tempo",
        "pt": "Controle de tempo",
        "sv": "Tidskontroll"
    },
    {
        "en": "When Timer Starts",
        "es": "Cuándo empieza el temporizador",
        "de": "Wann der Timer startet",
        "fr": "Quand le chronomètre démarre",
        "it": "Quando parte il timer",
        "pt": "Quando o temporizador começa",
        "sv": "När timern startar"
    },
    {
        "en": "Blindfold Level",
        "es": "Nivel de ciegas",
        "de": "Blindschach-Level",
        "fr": "Niveau aveugle",
        "it": "Livello bendato",
        "pt": "Nível de blindfold",
        "sv": "Blindfold-nivå"
    },
    {
        "en": "Phases",
        "es": "Fases",
        "de": "Phasen",
        "fr": "Phases",
        "it": "Fasi",
        "pt": "Fases",
        "sv": "Faser"
    },
    {
        "en": "Motifs",
        "es": "Motivos",
        "de": "Motive",
        "fr": "Motifs",
        "it": "Motivi",
        "pt": "Motivos",
        "sv": "Motiv"
    },
    {
        "en": "Advanced",
        "es": "Avanzado",
        "de": "Fortgeschritten",
        "fr": "Avancé",
        "it": "Avanzato",
        "pt": "Avançado",
        "sv": "Avancerat"
    },
    {
        "en": "Mates",
        "es": "Mates",
        "de": "Matte",
        "fr": "Mats",
        "it": "Scacchi matto",
        "pt": "Mates",
        "sv": "Matt"
    },
    {
        "en": "Special Moves",
        "es": "Movimientos especiales",
        "de": "Sonderzüge",
        "fr": "Coups spéciaux",
        "it": "Mosse speciali",
        "pt": "Jogadas especiais",
        "sv": "Specialdrag"
    },
    {
        "en": "Goals",
        "es": "Objetivos",
        "de": "Ziele",
        "fr": "Objectifs",
        "it": "Obiettivi",
        "pt": "Objetivos",
        "sv": "Mål"
    },
    {
        "en": "Lengths",
        "es": "Duraciones",
        "de": "Längen",
        "fr": "Longueurs",
        "it": "Lunghezze",
        "pt": "Tamanhos",
        "sv": "Längder"
    },
    {
        "en": "Origin",
        "es": "Origen",
        "de": "Herkunft",
        "fr": "Origine",
        "it": "Origine",
        "pt": "Origem",
        "sv": "Ursprung"
    },
    {
        "en": "Piece Count",
        "es": "Número de piezas",
        "de": "Figurenanzahl",
        "fr": "Nombre de pièces",
        "it": "Conteggio pezzi",
        "pt": "Contagem de peças",
        "sv": "Antal pjäser"
    },
    {
        "en": "Category",
        "es": "Categoría",
        "de": "Kategorie",
        "fr": "Catégorie",
        "it": "Categoria",
        "pt": "Categoria",
        "sv": "Kategori"
    },
    {
        "en": "Rating",
        "es": "Valoración",
        "de": "Rating",
        "fr": "Cote",
        "it": "Valutazione",
        "pt": "Avaliação",
        "sv": "Betyg"
    },
    {
        "en": "Cancel",
        "es": "Cancelar",
        "de": "Abbrechen",
        "fr": "Annuler",
        "it": "Annulla",
        "pt": "Cancelar",
        "sv": "Avbryt"
    },
    {
        "en": "Ok",
        "es": "Vale",
        "fr": "D’accord",
        "de": "OK",
        "it": "Ok",
        "pt": "Beleza",
        "sv": "OK"
    },
    {
        "en": "Get-Next",
        "es": "Obtener siguiente",
        "de": "Nächstes holen",
        "fr": "Obtenir suivant",
        "it": "Prendi successivo",
        "pt": "Obter próximo",
        "sv": "Hämta nästa"
    },
    {
        "en": "Done",
        "es": "Listo",
        "de": "Fertig",
        "fr": "Terminé",
        "it": "Fatto",
        "pt": "Concluído",
        "sv": "Klar"
    },
    {
        "en": "Start",
        "es": "Iniciar",
        "de": "Start",
        "fr": "Démarrer",
        "it": "Avvia",
        "pt": "Iniciar",
        "sv": "Starta"
    },
    {
        "en": "Give-Up",
        "es": "Rendirse",
        "de": "Aufgeben",
        "fr": "Abandonner",
        "it": "Abbandona",
        "pt": "Desistir",
        "sv": "Ge upp"
    },
    {
        "en": "Explore",
        "es": "Explorar",
        "de": "Erkunden",
        "fr": "Explorer",
        "it": "Esplora",
        "pt": "Explorar",
        "sv": "Utforska"
    },
    {
        "en": "Review",
        "es": "Revisar",
        "de": "Überprüfen",
        "fr": "Revoir",
        "it": "Rivedi",
        "pt": "Revisar",
        "sv": "Granska"
    },
    {
        "en": "Animating Solution",
        "es": "Animando solución",
        "de": "Lösung wird animiert",
        "fr": "Animation de la solution",
        "it": "Animazione della soluzione",
        "pt": "Animando solução",
        "sv": "Spelar upp lösning"
    },
    {
        "en": "Getting Initial Score",
        "es": "Obteniendo puntuación inicial",
        "de": "Initiale Bewertung wird ermittelt",
        "fr": "Obtention du score initial",
        "it": "Calcolo punteggio iniziale",
        "pt": "Obtendo pontuação inicial",
        "sv": "Hämtar startpoäng"
    },
    {
        "en": "seconds",
        "es": "segundos",
        "de": "Sekunden",
        "fr": "secondes",
        "it": "secondi",
        "pt": "segundos",
        "sv": "sekunder"
    },
    {
        "en": "Out of Time",
        "es": "Se acabó el tiempo",
        "de": "Zeit abgelaufen",
        "fr": "Temps écoulé",
        "it": "Tempo scaduto",
        "pt": "Tempo esgotado",
        "sv": "Tidsutgång"
    },
    {
        "en": "Timer Waiting",
        "es": "Temporizador esperando",
        "de": "Timer wartet",
        "fr": "Chrono en attente",
        "it": "Timer in attesa",
        "pt": "Temporizador aguardando",
        "sv": "Timer väntar"
    },
    {
        "en": "Options",
        "es": "Opciones",
        "de": "Optionen",
        "fr": "Options",
        "it": "Opzioni",
        "pt": "Opções",
        "sv": "Alternativ"
    },
    {
        "en": "Puzzle Rating",
        "es": "Valoración del puzzle",
        "de": "Rätsel-Rating",
        "fr": "Cote du problème",
        "it": "Valutazione del puzzle",
        "pt": "Avaliação do problema",
        "sv": "Pusselbetyg"
    },
    {
        "en": "Starting Rating",
        "es": "Valoración inicial",
        "de": "Start-Rating",
        "fr": "Cote de départ",
        "it": "Punteggio iniziale",
        "pt": "Avaliação inicial",
        "sv": "Startbetyg"
    },
    {
        "en": "Puzzles will be randomly selected from this rating range",
        "es": "Los puzzles se seleccionarán aleatoriamente dentro de este rango de valoración",
        "de": "Rätsel werden zufällig aus diesem Ratingbereich ausgewählt",
        "fr": "Les problèmes seront choisis aléatoirement dans cette fourchette de cote",
        "it": "I puzzle saranno selezionati casualmente da questo intervallo di valutazione",
        "pt": "Os problemas serão selecionados aleatoriamente dentro desta faixa de avaliação",
        "sv": "Pussel väljs slumpmässigt inom detta betygsområde"
    },
    {
        "en": "Puzzles will start at this rating and drift up\/down based on success",
        "es": "Los puzzles empezarán en esta valoración y subirán\/bajarán según tu acierto",
        "de": "Rätsel starten bei diesem Rating und passen sich je nach Erfolg an",
        "fr": "Les problèmes démarreront à cette cote et varieront selon vos réussites",
        "it": "I puzzle partiranno da questa valutazione e varieranno su\/giù in base al successo",
        "pt": "Os problemas começarão nesta avaliação e flutuarão conforme seu desempenho",
        "sv": "Pussel startar på detta betyg och rör sig upp\/ner beroende på resultat"
    },
    {
        "en": "Count",
        "es": "Contar",
        "de": "Anzahl",
        "fr": "Compter",
        "it": "Conteggio",
        "pt": "Quantidade",
        "sv": "Antal"
    },
    {
        "en": "to",
        "es": "a",
        "de": "bis",
        "fr": "à",
        "it": "a",
        "pt": "a",
        "sv": "till"
    },
    {
        "en": "Note: Working Offline",
        "es": "Nota: trabajando sin conexión",
        "de": "Hinweis: Arbeite offline",
        "fr": "Note : travail hors ligne",
        "it": "Nota: si sta lavorando offline",
        "pt": "Obs.: Funcionando offline",
        "sv": "Observera: Arbetar offline"
    },
    {
        "en": "Note: if needed, change Options now",
        "es": "Nota: si es necesario, cambia las opciones ahora",
        "de": "Hinweis: Gegebenenfalls jetzt die Optionen ändern",
        "fr": "Note : si nécessaire, modifiez les options maintenant",
        "it": "Nota: se necessario, modifica ora le Opzioni",
        "pt": "Obs.: se necessário, altere as opções agora",
        "sv": "Obs: ändra gärna inställningar nu om det behövs"
    },
    {
        "en": "Current Option Values",
        "es": "Valores actuales de las opciones",
        "de": "Aktuelle Optionen",
        "fr": "Valeurs actuelles des options",
        "it": "Valori correnti delle opzioni",
        "pt": "Valores atuais das opções",
        "sv": "Aktuella inställningar"
    },
    {
        "en": "Hint Button Disabled - by Preferences",
        "es": "Botón de pista desactivado - según Preferencias",
        "de": "Hinweis-Button deaktiviert – nach Einstellungen",
        "fr": "Bouton indice désactivé - selon préférences",
        "it": "Pulsante suggerimento disabilitato - dalle preferenze",
        "pt": "Botão de dica desativado — nas preferências",
        "sv": "Tipsknapp avstängd - enligt inställningar"
    },
    {
        "en": "Target Rating: Stay within",
        "es": "Valoración objetivo: mantener dentro de",
        "de": "Ziel-Rating: Bleib innerhalb",
        "fr": "Cote cible : rester dans",
        "it": "Valutazione target: rimanere dentro",
        "pt": "Avaliação alvo: manter dentro de",
        "sv": "Målbetyg: Håll inom"
    },
    {
        "en": "Target Rating",
        "es": "Valoración objetivo",
        "de": "Ziel-Rating",
        "fr": "Cote cible",
        "it": "Valutazione target",
        "pt": "Avaliação alvo",
        "sv": "Målbetyg"
    },
    {
        "en": "Your Rating",
        "es": "Tu valoración",
        "de": "Dein Rating",
        "fr": "Votre cote",
        "it": "La tua valutazione",
        "pt": "Sua avaliação",
        "sv": "Ditt betyg"
    },
    {
        "en": "Hint",
        "es": "Pista",
        "de": "Hinweis",
        "fr": "Indice",
        "it": "Suggerimento",
        "pt": "Dica",
        "sv": "Tips"
    },
    {
        "en": "Reveal",
        "es": "Revelar",
        "de": "Aufdecken",
        "fr": "Révéler",
        "it": "Rivela",
        "pt": "Revelar",
        "sv": "Avslöja"
    },
    {
        "en": "Back",
        "es": "Atrás",
        "de": "Zurück",
        "fr": "Retour",
        "it": "Indietro",
        "pt": "Voltar",
        "sv": "Tillbaka"
    },
    {
        "en": "White",
        "es": "Blancas",
        "de": "Weiß",
        "fr": "Blanc",
        "it": "Bianco",
        "pt": "Brancas",
        "sv": "Vit"
    },
    {
        "en": "Black",
        "es": "Negras",
        "de": "Schwarz",
        "fr": "Noir",
        "it": "Nero",
        "pt": "Negras",
        "sv": "Svart"
    },
    {
        "en": "You",
        "es": "Tú",
        "de": "Du",
        "fr": "Vous",
        "it": "Tu",
        "pt": "Você",
        "sv": "Du"
    },
    {
        "en": "Play",
        "es": "Jugar",
        "de": "Spielen",
        "fr": "Jouer",
        "it": "Gioca",
        "pt": "Jogar",
        "sv": "Spela"
    },
    {
        "en": "Visualize # Moves",
        "es": "Visualizar # de jugadas",
        "de": "# Züge visualisieren",
        "fr": "Visualiser # coups",
        "it": "Visualizza # mosse",
        "pt": "Visualizar # de lances",
        "sv": "Visualisera # drag"
    },
    {
        "en": "Puzzles",
        "es": "Puzzles",
        "de": "Rätsel",
        "fr": "Problèmes",
        "it": "Puzzle",
        "pt": "Problemas",
        "sv": "Pussel"
    },
    {
        "en": "Puzzle Visualization",
        "es": "Visualización de puzzles",
        "de": "Rätsel-Visualisierung",
        "fr": "Visualisation de problèmes",
        "it": "Visualizzazione puzzle",
        "pt": "Visualização de problemas",
        "sv": "Pusselvisualisering"
    },
    {
        "en": "Timed Puzzles",
        "es": "Puzzles cronometrados",
        "de": "Zeitbegrenzte Rätsel",
        "fr": "Problèmes chronométrés",
        "it": "Puzzle a tempo",
        "pt": "Problemas cronometrados",
        "sv": "Tidsbegränsade pussel"
    },
    {
        "en": "Timed Visualized Puzzles",
        "es": "Puzzles visualizados cronometrados",
        "de": "Zeitbegrenzte visualisierte Rätsel",
        "fr": "Problèmes visualisés et chronométrés",
        "it": "Puzzle visualizzati a tempo",
        "pt": "Problemas visualizados cronometrados",
        "sv": "Tidsbegränsade visualiserade pussel"
    },
    {
        "en": "Blindfold Puzzles",
        "es": "Puzzles a ciegas",
        "de": "Blindschach-Rätsel",
        "fr": "Problèmes en aveugle",
        "it": "Puzzle bendati",
        "pt": "Problemas blindfold",
        "sv": "Blindfold-pussel"
    },
    {
        "en": "Sync Offline Attempts & Refresh",
        "es": "Sincronizar intentos offline y actualizar",
        "de": "Offline-Versuche synchronisieren & aktualisieren",
        "fr": "Synchroniser les tentatives hors ligne & actualiser",
        "it": "Sincronizza tentativi offline e aggiorna",
        "pt": "Sincronizar tentativas offline e atualizar",
        "sv": "Synka offlineförsök & uppdatera"
    },
    {
        "en": "Puzzles Available when Offline",
        "es": "Puzzles disponibles sin conexión",
        "de": "Offline verfügbare Rätsel",
        "fr": "Problèmes disponibles hors ligne",
        "it": "Puzzle disponibili offline",
        "pt": "Problemas disponíveis offline",
        "sv": "Pussel tillgängliga offline"
    },
    {
        "en": "Offline",
        "es": "Sin conexión",
        "de": "Offline",
        "fr": "Hors ligne",
        "it": "Offline",
        "pt": "Offline",
        "sv": "Offline"
    },
    {
        "en": "Switch to Online Puzzles",
        "es": "Cambiar a puzzles en línea",
        "de": "Zu Online-Rätseln wechseln",
        "fr": "Passer aux problèmes en ligne",
        "it": "Passa ai puzzle online",
        "pt": "Alternar para problemas online",
        "sv": "Byt till online-pussel"
    },
    {
        "en": "Download for Offline Play",
        "es": "Descargar para jugar sin conexión",
        "de": "Für Offline-Spiel herunterladen",
        "fr": "Télécharger pour jouer hors ligne",
        "it": "Scarica per giocare offline",
        "pt": "Baixar para jogar offline",
        "sv": "Ladda ner för offline-spel"
    },
    {
        "en": "Switch to Offline Puzzles",
        "es": "Cambiar a puzzles sin conexión",
        "de": "Zu Offline-Rätseln wechseln",
        "fr": "Passer aux problèmes hors ligne",
        "it": "Passa ai puzzle offline",
        "pt": "Alternar para problemas offline",
        "sv": "Byt till offline-pussel"
    },
    {
        "en": "Puzzle History & Download",
        "es": "Historial de puzzles y descarga",
        "de": "Rätselverlauf & Download",
        "fr": "Historique des problèmes & téléchargement",
        "it": "Cronologia puzzle e download",
        "pt": "Histórico de problemas e download",
        "sv": "Pusselhistorik & nedladdning"
    },
    {
        "en": "You'll now be shown puzzles from the downloaded offline collection",
        "es": "Ahora se te mostrarán puzzles de la colección descargada para offline",
        "de": "Du siehst jetzt Rätsel aus der heruntergeladenen Offline-Sammlung",
        "fr": "Vous verrez maintenant les problèmes de la collection téléchargée hors ligne",
        "it": "Ora ti saranno mostrati i puzzle dalla collezione scaricata offline",
        "pt": "Agora serão mostrados problemas da coleção baixada para offline",
        "sv": "Nu visas pussel från den nedladdade offline-samlingen"
    },
    {
        "en": "You're back to accessing puzzles from the millions of online puzzles",
        "es": "Has vuelto a acceder a puzzles de millones disponibles en línea",
        "de": "Du greifst wieder auf Millionen Online-Rätsel zu",
        "fr": "Vous revenez aux millions de problèmes en ligne",
        "it": "Sei tornato ad accedere ai milioni di puzzle online",
        "pt": "Você voltou a acessar problemas dentre milhões disponíveis online",
        "sv": "Du är tillbaka till pussel från miljoner online-pussel"
    },
    {
        "en": "This will be reflected on the menu and in the puzzle programs",
        "es": "Esto se reflejará en el menú y en los programas de puzzles",
        "de": "Das wird im Menü und in den Rätselprogrammen angezeigt",
        "fr": "Cela sera reflété dans le menu et les programmes de problèmes",
        "it": "Questo sarà riflesso nel menu e nei programmi dei puzzle",
        "pt": "Isto será refletido no menu e nos programas de problemas",
        "sv": "Detta syns i menyn och i pusselprogrammen"
    },
    {
        "en": "After First Move",
        "es": "Después de la primera jugada",
        "de": "Nach dem ersten Zug",
        "fr": "Après le premier coup",
        "it": "Dopo la prima mossa",
        "pt": "Após o primeiro lance",
        "sv": "Efter första draget"
    },
    {
        "en": "Immediately When Puzzle Shown",
        "es": "Inmediatamente al mostrar el puzzle",
        "de": "Sofort beim Anzeigen des Rätsels",
        "fr": "Immédiatement à l'affichage du problème",
        "it": "Immediatamente quando il puzzle viene mostrato",
        "pt": "Imediatamente ao mostrar o problema",
        "sv": "Omedelbart när pusslet visas"
    },
    {
        "en": "One Color Pieces",
        "es": "Piezas de un color",
        "de": "Einfarbige Figuren",
        "fr": "Pièces d'une seule couleur",
        "it": "Pezzi di un solo colore",
        "pt": "Peças de uma cor",
        "sv": "Enfärgade pjäser"
    },
    {
        "en": "Two Color Discs",
        "es": "Discos de dos colores",
        "de": "Zweifarbige Scheiben",
        "fr": "Disques deux couleurs",
        "it": "Dischi di due colori",
        "pt": "Discos de duas cores",
        "sv": "Tvåfärgade brickor"
    },
    {
        "en": "One Color Disc",
        "es": "Disco de un color",
        "de": "Einfarbige Scheibe",
        "fr": "Disque d'une seule couleur",
        "it": "Disco di un solo colore",
        "pt": "Disco de uma cor",
        "sv": "En enfärgad bricka"
    },
    {
        "en": "Empty Board",
        "es": "Tablero vacío",
        "de": "Leeres Brett",
        "fr": "Échiquier vide",
        "it": "Scacchiera vuota",
        "pt": "Tabuleiro vazio",
        "sv": "Tomt bräde"
    },
    {
        "en": "With Visualization",
        "es": "Con visualización",
        "de": "Mit Visualisierung",
        "fr": "Avec visualisation",
        "it": "Con visualizzazione",
        "pt": "Com visualização",
        "sv": "Med visualisering"
    },
    {
        "en": "Visualize",
        "es": "Visualizar",
        "de": "Visualisieren",
        "fr": "Visualiser",
        "it": "Visualizza",
        "pt": "Visualizar",
        "sv": "Visualisera"
    },
    {
        "en": "Starts",
        "es": "Comienza",
        "de": "Startet",
        "fr": "Commence",
        "it": "Inizia",
        "pt": "Inicia",
        "sv": "Startar"
    },
    {
        "en": "Timed",
        "es": "Cronometrado",
        "de": "Zeitgesteuert",
        "fr": "Chronométré",
        "it": "A tempo",
        "pt": "Cronometrado",
        "sv": "Tidsatt"
    },
    {
        "en": "Blindfold",
        "es": "A ciegas",
        "de": "Blindspiel",
        "fr": "Aveugle",
        "it": "Bendato",
        "pt": "Blindfold",
        "sv": "Blindfold"
    },
    {
        "en": "click 'From' square",
        "es": "clic en la casilla 'Desde'",
        "de": "auf das 'Von'-Feld klicken",
        "fr": "cliquez la case 'De'",
        "it": "clicca la casa 'Da'",
        "pt": "clique na casa 'De'",
        "sv": "klicka på 'Från'-rutan"
    },
    {
        "en": "Checkmate",
        "es": "Jaque mate",
        "de": "Schachmatt",
        "fr": "Échec et mat",
        "it": "Scacco matto",
        "pt": "Xeque-mate",
        "sv": "Schackmatt"
    },
    {
        "en": "Mate in 1",
        "es": "Mate en 1",
        "de": "Matt in 1",
        "fr": "Mat en 1",
        "it": "Matto in 1",
        "pt": "Mate em 1",
        "sv": "Matt på 1"
    },
    {
        "en": "Mate in",
        "es": "Mate en",
        "de": "Matt in",
        "fr": "Mat en",
        "it": "Matto in",
        "pt": "Mate em",
        "sv": "Matt på"
    },
    {
        "en": "by",
        "es": "por",
        "de": "durch",
        "fr": "par",
        "it": "da",
        "pt": "por",
        "sv": "av"
    },
    {
        "en": "Stalemate",
        "es": "Tablas por ahogado",
        "de": "Patt",
        "fr": "Pat",
        "it": "Patta (stallo)",
        "pt": "Afogado",
        "sv": "Pat"
    },
    {
        "en": "Draw",
        "es": "Tablas",
        "de": "Remis",
        "fr": "Nulle",
        "it": "Patta",
        "pt": "Empate",
        "sv": "Remi"
    },
    {
        "en": "Other",
        "es": "Otro",
        "de": "Andere",
        "fr": "Autre",
        "it": "Altro",
        "pt": "Outro",
        "sv": "Övrigt"
    },
    {
        "en": "unknown response from engine",
        "es": "respuesta desconocida del motor",
        "de": "unbekannte Antwort der Engine",
        "fr": "réponse inconnue du moteur",
        "it": "risposta sconosciuta dal motore",
        "pt": "resposta desconhecida do motor",
        "sv": "okänt svar från motorn"
    },
    {
        "en": "Rook",
        "es": "Torre",
        "de": "Turm",
        "fr": "Tour",
        "it": "Torre",
        "pt": "Torre",
        "sv": "Torn"
    },
    {
        "en": "Knight",
        "es": "Caballo",
        "de": "Springer",
        "fr": "Cavalier",
        "it": "Cavallo",
        "pt": "Cavalo",
        "sv": "Springare"
    },
    {
        "en": "Bishop",
        "es": "Alfil",
        "de": "Läufer",
        "fr": "Fou",
        "it": "Alfiere",
        "pt": "Bispo",
        "sv": "Löpare"
    },
    {
        "en": "Queen",
        "es": "Dama",
        "de": "Dame",
        "fr": "Dame",
        "it": "Regina",
        "pt": "Dama",
        "sv": "Dam"
    },
    {
        "en": "King",
        "es": "Rey",
        "de": "König",
        "fr": "Roi",
        "it": "Re",
        "pt": "Rei",
        "sv": "Kung"
    },
    {
        "en": "Pawn",
        "es": "Peón",
        "de": "Bauer",
        "fr": "Pion",
        "it": "Pedone",
        "pt": "Peão",
        "sv": "Bonde"
    },
    {
        "en": "Guards",
        "es": "Defensores",
        "de": "Bewacher",
        "fr": "Garde(s)",
        "it": "Difensori",
        "pt": "Defesas",
        "sv": "Försvarare"
    },
    {
        "en": "Click 'Start' to Begin",
        "es": "Pulsa 'Iniciar' para empezar",
        "de": "Klick auf 'Start' zum Beginnen",
        "fr": "Cliquez 'Démarrer' pour commencer",
        "it": "Clicca 'Avvia' per iniziare",
        "pt": "Clique em 'Iniciar' para começar",
        "sv": "Klicka 'Start' för att börja"
    },
    {
        "en": "Check",
        "es": "Jaque",
        "de": "Schach",
        "fr": "Échec",
        "it": "Scacco",
        "pt": "Cheque",
        "sv": "Schack"
    },
    {
        "en": "Next Move",
        "es": "Siguiente jugada",
        "de": "Nächster Zug",
        "fr": "Coup suivant",
        "it": "Mossa successiva",
        "pt": "Próximo lance",
        "sv": "Nästa drag"
    },
    {
        "en": "List",
        "es": "Lista",
        "de": "Liste",
        "fr": "Liste",
        "it": "Elenco",
        "pt": "Lista",
        "sv": "Lista"
    },
    {
        "en": "Hide",
        "es": "Ocultar",
        "de": "Verbergen",
        "fr": "Cacher",
        "it": "Nascondi",
        "pt": "Ocultar",
        "sv": "Dölj"
    },
    {
        "en": "Restart",
        "es": "Reiniciar",
        "de": "Neustart",
        "fr": "Redémarrer",
        "it": "Riavvia",
        "pt": "Reiniciar",
        "sv": "Starta om"
    },
    {
        "en": "Find Initial Guardings",
        "es": "Buscar defensas iniciales",
        "de": "Anfängliche Deckungen finden",
        "fr": "Trouver les gardes initiaux",
        "it": "Trova difese iniziali",
        "pt": "Encontrar defesas iniciais",
        "sv": "Hitta initiala bevakningar"
    },
    {
        "en": "Excellent",
        "es": "Excelente",
        "de": "Ausgezeichnet",
        "fr": "Excellent",
        "it": "Eccellente",
        "pt": "Excelente",
        "sv": "Utmärkt"
    },
    {
        "en": "Error",
        "es": "Error",
        "de": "Fehler",
        "fr": "Erreur",
        "it": "Errore",
        "pt": "Erro",
        "sv": "Fel"
    },
    {
        "en": "Errors",
        "es": "Errores",
        "de": "Fehler",
        "fr": "Erreurs",
        "it": "Errori",
        "pt": "Erros",
        "sv": "Fel"
    },
    {
        "en": "Click 'Get Next' to Begin",
        "es": "Pulsa 'Obtener siguiente' para empezar",
        "de": "Klick auf 'Nächstes holen' zum Starten",
        "fr": "Cliquez 'Obtenir suivant' pour commencer",
        "it": "Clicca 'Prendi successivo' per iniziare",
        "pt": "Clique em 'Obter próximo' para começar",
        "sv": "Klicka 'Hämta nästa' för att börja"
    },
    {
        "en": "Board Shows Your Answer",
        "es": "El tablero muestra tu respuesta",
        "de": "Brett zeigt deine Antwort",
        "fr": "L'échiquier montre votre réponse",
        "it": "La scacchiera mostra la tua risposta",
        "pt": "O tabuleiro mostra sua resposta",
        "sv": "Brädet visar ditt svar"
    },
    {
        "en": "Board Shows Actual Answer",
        "es": "El tablero muestra la respuesta real",
        "de": "Brett zeigt die tatsächliche Lösung",
        "fr": "L'échiquier montre la réponse réelle",
        "it": "La scacchiera mostra la risposta reale",
        "pt": "O tabuleiro mostra a resposta real",
        "sv": "Brädet visar det faktiska svaret"
    },
    {
        "en": "No Errors",
        "es": "Sin errores",
        "de": "Keine Fehler",
        "fr": "Aucune erreur",
        "it": "Nessun errore",
        "pt": "Sem erros",
        "sv": "Inga fel"
    },
    {
        "en": "Random Start",
        "es": "Inicio aleatorio",
        "de": "Zufälliger Start",
        "fr": "Départ aléatoire",
        "it": "Inizio casuale",
        "pt": "Início aleatório",
        "sv": "Slumpmässig start"
    },
    {
        "en": "Random Pieces",
        "es": "Piezas aleatorias",
        "de": "Zufällige Figuren",
        "fr": "Pièces aléatoires",
        "it": "Pezzi casuali",
        "pt": "Peças aleatórias",
        "sv": "Slumpmässiga pjäser"
    },
    {
        "en": "At Game Start",
        "es": "Al inicio de la partida",
        "de": "Zu Spielbeginn",
        "fr": "Au début de la partie",
        "it": "All'inizio della partita",
        "pt": "No início da partida",
        "sv": "Vid partiets start"
    },
    {
        "en": "Revert",
        "es": "Revertir",
        "de": "Zurücksetzen",
        "fr": "Revenir",
        "it": "Ripristina",
        "pt": "Reverter",
        "sv": "Återställ"
    },
    {
        "en": "Give Up",
        "es": "Rendirse",
        "de": "Aufgeben",
        "fr": "Abandonner",
        "it": "Mollare",
        "pt": "Desistir",
        "sv": "Ge upp"
    },
    {
        "en": "Tap the button for the first move",
        "es": "Pulsa el botón para la primera jugada",
        "de": "Tippe den Button für den ersten Zug",
        "fr": "Appuyez sur le bouton pour le premier coup",
        "it": "Tocca il pulsante per la prima mossa",
        "pt": "Toque o botão para o primeiro lance",
        "sv": "Tryck på knappen för första draget"
    },
    {
        "en": "Show and Say Move",
        "es": "Mostrar y decir la jugada",
        "de": "Zug zeigen und sagen",
        "fr": "Montrer et dire le coup",
        "it": "Mostra e pronuncia la mossa",
        "pt": "Mostrar e falar o lance",
        "sv": "Visa och säg draget"
    },
    {
        "en": "Say Move",
        "es": "Decir la jugada",
        "de": "Zug sagen",
        "fr": "Dire le coup",
        "it": "Pronuncia la mossa",
        "pt": "Dizer o lance",
        "sv": "Säg draget"
    },
    {
        "en": "Show Move",
        "es": "Mostrar la jugada",
        "de": "Zug zeigen",
        "fr": "Montrer le coup",
        "it": "Mostra la mossa",
        "pt": "Mostrar o lance",
        "sv": "Visa draget"
    },
    {
        "en": "Visualize the following moves",
        "es": "Visualiza las siguientes jugadas",
        "de": "Die folgenden Züge visualisieren",
        "fr": "Visualisez les coups suivants",
        "it": "Visualizza le mosse successive",
        "pt": "Visualize os lances seguintes",
        "sv": "Visualisera följande drag"
    },
    {
        "en": "Show Mine",
        "es": "Mostrar las mías",
        "de": "Meine zeigen",
        "fr": "Montrer les miens",
        "it": "Mostra le mie",
        "pt": "Mostrar o meu",
        "sv": "Visa mitt"
    },
    {
        "en": "Replicate",
        "es": "Replicar",
        "de": "Replizieren",
        "fr": "Répliquer",
        "it": "Replica",
        "pt": "Replicar",
        "sv": "Replikera"
    },
    {
        "en": "Show Actual",
        "es": "Mostrar la real",
        "de": "Tatsächliche zeigen",
        "fr": "Montrer la solution",
        "it": "Mostra quella reale",
        "pt": "Mostrar o real",
        "sv": "Visa verkligt"
    },
    {
        "en": "Check Work",
        "es": "Comprobar trabajo",
        "de": "Arbeit prüfen",
        "fr": "Vérifier le travail",
        "it": "Controlla il lavoro",
        "pt": "Verificar trabalho",
        "sv": "Kontrollera arbete"
    },
    {
        "en": "Get Next",
        "es": "Siguiente",
        "de": "Nächstes holen",
        "fr": "Suivant",
        "it": "Prendi il prossimo",
        "pt": "Obter próximo",
        "sv": "Hämta nästa"
    },
    {
        "en": "Undo",
        "es": "Deshacer",
        "de": "Rückgängig",
        "fr": "Annuler",
        "it": "Annulla",
        "pt": "Desfazer",
        "sv": "Ångra"
    },
    {
        "en": "Game Start",
        "es": "Inicio de la partida",
        "de": "Spielbeginn",
        "fr": "Début de la partie",
        "it": "Inizio partita",
        "pt": "Início do jogo",
        "sv": "Spelstart"
    },
    {
        "en": "For Review",
        "es": "Para repasar",
        "de": "Zur Überprüfung",
        "fr": "À revoir",
        "it": "Per revisione",
        "pt": "Para revisão",
        "sv": "För genomgång"
    },
    {
        "en": "# of Moves",
        "es": "# de jugadas",
        "de": "# Züge",
        "fr": "# de coups",
        "it": "# di mosse",
        "pt": "# de lances",
        "sv": "Antal drag"
    },
    {
        "en": "Announce Moves",
        "es": "Anunciar jugadas",
        "de": "Züge ansagen",
        "fr": "Annoncer les coups",
        "it": "Annuncia le mosse",
        "pt": "Anunciar lances",
        "sv": "Meddela drag"
    },
    {
        "en": "Show 1 Move at time",
        "es": "Mostrar 1 jugada a la vez",
        "de": "Jeweils 1 Zug zeigen",
        "fr": "Montrer 1 coup à la fois",
        "it": "Mostra 1 mossa alla volta",
        "pt": "Mostrar 1 lance por vez",
        "sv": "Visa ett drag i taget"
    },
    {
        "en": "Specific Pieces",
        "es": "Piezas específicas",
        "de": "Bestimmte Figuren",
        "fr": "Pièces spécifiques",
        "it": "Pezzi specifici",
        "pt": "Peças específicas",
        "sv": "Specifika pjäser"
    },
    {
        "en": "Set # of Pieces on Board",
        "es": "Fijar # de piezas en el tablero",
        "de": "# Figuren auf dem Brett einstellen",
        "fr": "Définir le # de pièces sur l'échiquier",
        "it": "Imposta # di pezzi sulla scacchiera",
        "pt": "Definir # de peças no tabuleiro",
        "sv": "Ställ in antal pjäser på brädet"
    },
    {
        "en": "# of Moves in Sequence",
        "es": "# de jugadas en la secuencia",
        "de": "# Züge in Folge",
        "fr": "# de coups dans la séquence",
        "it": "# di mosse nella sequenza",
        "pt": "# de lances na sequência",
        "sv": "Antal drag i sekvensen"
    },
    {
        "en": "Show only one move at a time?",
        "es": "¿Mostrar solo una jugada a la vez?",
        "de": "Nur einen Zug auf einmal zeigen?",
        "fr": "Montrer un seul coup à la fois ?",
        "it": "Mostrare solo una mossa alla volta?",
        "pt": "Mostrar apenas um lance por vez?",
        "sv": "Visa bara ett drag i taget?"
    },
    {
        "en": "Yes",
        "es": "Sí",
        "de": "Ja",
        "fr": "Oui",
        "it": "Sì",
        "pt": "Sim",
        "sv": "Ja"
    },
    {
        "en": "No",
        "es": "No",
        "de": "Nein",
        "fr": "Non",
        "it": "No",
        "pt": "Não",
        "sv": "Nej"
    },
    {
        "en": "Piece",
        "es": "Pieza",
        "de": "Figur",
        "fr": "Pièce",
        "it": "Pezzo",
        "pt": "Peça",
        "sv": "Pjäs"
    },
    {
        "en": "Pieces",
        "es": "Piezas",
        "de": "Figuren",
        "fr": "Pièces",
        "it": "Pezzi",
        "pt": "Peças",
        "sv": "Pjäser"
    },
    {
        "en": "Select the # of Pieces You want to Track",
        "es": "Selecciona el # de piezas que quieres seguir",
        "de": "Wähle die Anzahl der Figuren, die du verfolgen willst",
        "fr": "Sélectionnez le # de pièces à suivre",
        "it": "Seleziona il # di pezzi da seguire",
        "pt": "Selecione o # de peças que quer acompanhar",
        "sv": "Välj hur många pjäser du vill följa"
    },
    {
        "en": "One",
        "es": "Una",
        "de": "Eins",
        "fr": "Une",
        "it": "Uno",
        "pt": "Uma",
        "sv": "En"
    },
    {
        "en": "Two",
        "es": "Dos",
        "de": "Zwei",
        "fr": "Deux",
        "it": "Due",
        "pt": "Duas",
        "sv": "Två"
    },
    {
        "en": "Three",
        "es": "Tres",
        "de": "Drei",
        "fr": "Trois",
        "it": "Tre",
        "pt": "Três",
        "sv": "Tre"
    },
    {
        "en": "Four",
        "es": "Cuatro",
        "de": "Vier",
        "fr": "Quatre",
        "it": "Quattro",
        "pt": "Quatro",
        "sv": "Fyra"
    },
    {
        "en": "Five",
        "es": "Cinco",
        "de": "Fünf",
        "fr": "Cinq",
        "it": "Cinque",
        "pt": "Cinco",
        "sv": "Fem"
    },
    {
        "en": "Area of Board",
        "es": "Área del tablero",
        "de": "Brettbereich",
        "fr": "Zone de l'échiquier",
        "it": "Area della scacchiera",
        "pt": "Área do tabuleiro",
        "sv": "Brädets område"
    },
    {
        "en": "# of Pieces To Visualize",
        "es": "# de piezas a visualizar",
        "de": "# Figuren zum Visualisieren",
        "fr": "# de pièces à visualiser",
        "it": "# di pezzi da visualizzare",
        "pt": "# de peças a visualizar",
        "sv": "Antal pjäser att visualisera"
    },
    {
        "en": "Board Area",
        "es": "Área del tablero",
        "de": "Brettzone",
        "fr": "Zone du plateau",
        "it": "Area della scacchiera",
        "pt": "Área do tabuleiro",
        "sv": "Brädområde"
    },
    {
        "en": "Who's Guarding Whom",
        "es": "Quién defiende a quién",
        "de": "Wer bewacht wen",
        "fr": "Qui protège qui",
        "it": "Chi difende chi",
        "pt": "Quem está defendendo quem",
        "sv": "Vem bevakar vem"
    },
    {
        "en": "Static Boards",
        "es": "Tableros estáticos",
        "de": "Statische Bretter",
        "fr": "Plateaux statiques",
        "it": "Scacchiere statiche",
        "pt": "Tabuleiros estáticos",
        "sv": "Statisk bräden"
    },
    {
        "en": "Moves At Random Location",
        "es": "Jugadas en ubicación aleatoria",
        "de": "Züge an zufälligen Orten",
        "fr": "Coups à des emplacements aléatoires",
        "it": "Mosse in posizioni casuali",
        "pt": "Lances em local aleatório",
        "sv": "Drag på slumpad plats"
    },
    {
        "en": "Moves From Game Beginning",
        "es": "Jugadas desde el inicio de la partida",
        "de": "Züge ab Spielbeginn",
        "fr": "Coups depuis le début de la partie",
        "it": "Mosse dall'inizio della partita",
        "pt": "Lances desde o início da partida",
        "sv": "Drag från partiets början"
    },
    {
        "en": "Follow Specific Pieces",
        "es": "Seguir piezas específicas",
        "de": "Bestimmte Figuren verfolgen",
        "fr": "Suivre des pièces spécifiques",
        "it": "Segui pezzi specifici",
        "pt": "Seguir peças específicas",
        "sv": "Följ specifika pjäser"
    },
    {
        "en": "Visualization",
        "es": "Visualización",
        "de": "Visualisierung",
        "fr": "Visualisation",
        "it": "Visualizzazione",
        "pt": "Visualização",
        "sv": "Visualisering"
    },
    {
        "en": "Eighth",
        "es": "Octava",
        "de": "Achter",
        "fr": "Un huitième",
        "it": "Ottavo",
        "pt": "Oitavo",
        "sv": "En åttondel"
    },
    {
        "en": "Quarter",
        "es": "Cuarto",
        "de": "Viertel",
        "fr": "Un quart",
        "it": "Quarto",
        "pt": "Quarto",
        "sv": "En fjärdedel"
    },
    {
        "en": "Half",
        "es": "Mitad",
        "de": "Halb",
        "fr": "La moitié",
        "it": "Metà",
        "pt": "Metade",
        "sv": "Halv"
    },
    {
        "en": "Full",
        "es": "Completo",
        "de": "Voll",
        "fr": "Complet",
        "it": "Intero",
        "pt": "Completo",
        "sv": "Full"
    },
    {
        "en": "Board Shows the Actual Answer",
        "es": "El tablero muestra la respuesta real",
        "de": "Brett zeigt die tatsächliche Lösung",
        "fr": "Le plateau montre la réponse réelle",
        "it": "La scacchiera mostra la risposta reale",
        "pt": "O tabuleiro mostra a resposta real",
        "sv": "Brädet visar det faktiska svaret"
    },
    {
        "en": "Visualize the Board",
        "es": "Visualizar el tablero",
        "de": "Brett visualisieren",
        "fr": "Visualiser le plateau",
        "it": "Visualizza la scacchiera",
        "pt": "Visualizar o tabuleiro",
        "sv": "Visualisera brädet"
    },
    {
        "en": "Nothing Attempted",
        "es": "Nada intentado",
        "de": "Nichts versucht",
        "fr": "Rien tenté",
        "it": "Niente tentato",
        "pt": "Nada tentado",
        "sv": "Inget försökt"
    },
    {
        "en": "Copy to Clipboard",
        "es": "Copiar al portapapeles",
        "de": "In Zwischenablage kopieren",
        "fr": "Copier dans le presse-papiers",
        "it": "Copia negli appunti",
        "pt": "Copiar para área de transferência",
        "sv": "Kopiera till urklipp"
    },
    {
        "en": "'FEN' of current board OR entire 'PGN'?",
        "es": "¿'FEN' del tablero actual O 'PGN' completo?",
        "de": "'FEN' des aktuellen Brettes ODER ganze 'PGN'?",
        "fr": "'FEN' de la position courante OU 'PGN' entier ?",
        "it": "'FEN' della scacchiera corrente O l'intero 'PGN'?",
        "pt": "'FEN' do tabuleiro atual OU 'PGN' inteiro?",
        "sv": "'FEN' för aktuell ställning ELLER hela 'PGN'?"
    },
    {
        "en": "Flip",
        "es": "Girar",
        "de": "Drehen",
        "fr": "Retourner",
        "it": "Capovolgi",
        "pt": "Virar",
        "sv": "Vänd"
    },
    {
        "en": "Rewind",
        "es": "Retroceder",
        "de": "Zurückspulen",
        "fr": "Rembobiner",
        "it": "Riavvolgi",
        "pt": "Retroceder",
        "sv": "Spola tillbaka"
    },
    {
        "en": "Copy",
        "es": "Copiar",
        "de": "Kopieren",
        "fr": "Copier",
        "it": "Copia",
        "pt": "Copiar",
        "sv": "Kopiera"
    },
    {
        "en": "even",
        "es": "incluso",
        "de": "gleich",
        "fr": "même",
        "it": "pari",
        "pt": "empate\/mesmo",
        "sv": "oavgjort"
    },
    {
        "en": "White Win",
        "es": "Victoria blanca",
        "de": "Weiß gewinnt",
        "fr": "Victoire des blancs",
        "it": "Vittoria Bianco",
        "pt": "Vitória das brancas",
        "sv": "Vit vinst"
    },
    {
        "en": "Black Win",
        "es": "Victoria negra",
        "de": "Schwarz gewinnt",
        "fr": "Victoire des noirs",
        "it": "Vittoria Nero",
        "pt": "Vitória das negras",
        "sv": "Svart vinst"
    },
    {
        "en": "Explorer",
        "es": "Explorador",
        "de": "Explorer",
        "fr": "Explorateur",
        "it": "Esplora",
        "pt": "Explorador",
        "sv": "Utforskaren"
    },
    {
        "en": "Rating Range",
        "es": "Rango de valoración",
        "de": "Rating-Bereich",
        "fr": "Fourchette de cotes",
        "it": "Intervallo di valutazione",
        "pt": "Faixa de avaliação",
        "sv": "Betygsintervall"
    },
    {
        "en": "Set Min & Max Rating",
        "es": "Fijar valoración mínima y máxima",
        "de": "Min- & Max-Rating setzen",
        "fr": "Définir cote min & max",
        "it": "Imposta valutazione minima e massima",
        "pt": "Definir avaliação mínima e máxima",
        "sv": "Sätt min & max-betyg"
    },
    {
        "en": "Opening Mastery",
        "es": "Dominio de aperturas",
        "de": "Eröffnungsbeherrschung",
        "fr": "Maîtrise des ouvertures",
        "it": "Padronanza delle aperture",
        "pt": "Domínio de aberturas",
        "sv": "Öppningsmastery"
    },
    {
        "en": "Pull Lichess Games",
        "es": "Importar partidas de Lichess",
        "de": "Lichess-Partien importieren",
        "fr": "Importer parties Lichess",
        "it": "Importa partite da Lichess",
        "pt": "Importar partidas do Lichess",
        "sv": "Hämta Lichess-partier"
    },
    {
        "en": "Pull Chess.com Games",
        "es": "Importar partidas de Chess.com",
        "de": "Chess.com-Partien importieren",
        "fr": "Importer parties Chess.com",
        "it": "Importa partite da Chess.com",
        "pt": "Importar partidas do Chess.com",
        "sv": "Hämta Chess.com-partier"
    },
    {
        "en": "pulled through",
        "es": "importado a través de",
        "de": "importiert über",
        "fr": "importé via",
        "it": "importato tramite",
        "pt": "importado por",
        "sv": "hämtat via"
    },
    {
        "en": "Enter Lichess Name",
        "es": "Introduce nombre en Lichess",
        "de": "Lichess-Namen eingeben",
        "fr": "Entrez le nom Lichess",
        "it": "Inserisci nome Lichess",
        "pt": "Digite o nome no Lichess",
        "sv": "Ange Lichess-namn"
    },
    {
        "en": "Verify Lichess Name",
        "es": "Verificar nombre en Lichess",
        "de": "Lichess-Namen verifizieren",
        "fr": "Vérifier le nom Lichess",
        "it": "Verifica nome Lichess",
        "pt": "Verificar nome do Lichess",
        "sv": "Verifiera Lichess-namn"
    },
    {
        "en": "Enter Chess.com Name",
        "es": "Introduce nombre en Chess.com",
        "de": "Chess.com-Namen eingeben",
        "fr": "Entrez le nom Chess.com",
        "it": "Inserisci nome Chess.com",
        "pt": "Digite o nome no Chess.com",
        "sv": "Ange Chess.com-namn"
    },
    {
        "en": "Verify Chess.com Name",
        "es": "Verificar nombre en Chess.com",
        "de": "Chess.com-Namen verifizieren",
        "fr": "Vérifier le nom Chess.com",
        "it": "Verifica nome Chess.com",
        "pt": "Verificar nome do Chess.com",
        "sv": "Verifiera Chess.com-namn"
    },
    {
        "en": "All Done through",
        "es": "Todo hecho a través de",
        "de": "Alles erledigt über",
        "fr": "Tout fait via",
        "it": "Tutto completato tramite",
        "pt": "Tudo feito através de",
        "sv": "Helt klar via"
    },
    {
        "en": "Processing Games After",
        "es": "Procesando partidas después de",
        "de": "Spiele verarbeiten nach",
        "fr": "Traitement des parties après",
        "it": "Elaborazione partite dopo",
        "pt": "Processando partidas após",
        "sv": "Bearbetar partier efter"
    },
    {
        "en": "Name Doesn't Exist",
        "es": "El nombre no existe",
        "de": "Name existiert nicht",
        "fr": "Le nom n'existe pas",
        "it": "Il nome non esiste",
        "pt": "Nome não existe",
        "sv": "Namnet finns inte"
    },
    {
        "en": "Valid Name, Updating Record",
        "es": "Nombre válido, actualizando registro",
        "de": "Gültiger Name, Datensatz wird aktualisiert",
        "fr": "Nom valide, mise à jour de l'enregistrement",
        "it": "Nome valido, aggiornamento record",
        "pt": "Nome válido, atualizando registro",
        "sv": "Giltigt namn, uppdaterar register"
    },
    {
        "en": "Pulling Games After",
        "es": "Importando partidas después de",
        "de": "Spiele ab ... werden gezogen",
        "fr": "Import des parties après",
        "it": "Importo partite dopo",
        "pt": "Importando partidas após",
        "sv": "Hämtar partier efter"
    },
    {
        "en": "Pulling Games For",
        "es": "Importando partidas para",
        "de": "Spiele für ... werden gezogen",
        "fr": "Import des parties pour",
        "it": "Importo partite per",
        "pt": "Importando partidas para",
        "sv": "Hämtar partier för"
    },
    {
        "en": "Year",
        "es": "Año",
        "de": "Jahr",
        "fr": "Année",
        "it": "Anno",
        "pt": "Ano",
        "sv": "År"
    },
    {
        "en": "Month",
        "es": "Mes",
        "de": "Monat",
        "fr": "Mois",
        "it": "Mese",
        "pt": "Mês",
        "sv": "Månad"
    },
    {
        "en": "# of moves waiting for score",
        "es": "# de jugadas esperando puntuación",
        "de": "# Züge warten auf Bewertung",
        "fr": "# de coups en attente d'évaluation",
        "it": "# di mosse in attesa di punteggio",
        "pt": "# de lances aguardando pontuação",
        "sv": "Antal drag som väntar på poäng"
    },
    {
        "en": "refresh in",
        "es": "actualizar en",
        "de": "aktualisiert in",
        "fr": "actualiser dans",
        "it": "aggiorna tra",
        "pt": "atualizar em",
        "sv": "uppdatera om"
    },
    {
        "en": "secs",
        "es": "seg",
        "de": "Sek.",
        "fr": "s",
        "it": "sec",
        "pt": "seg",
        "sv": "sek"
    },
    {
        "en": "User Name",
        "es": "Nombre de usuario",
        "de": "Benutzername",
        "fr": "Nom d'utilisateur",
        "it": "Nome utente",
        "pt": "Nome de usuário",
        "sv": "Användarnamn"
    },
    {
        "en": "Enter username",
        "es": "Introduce nombre de usuario",
        "de": "Benutzernamen eingeben",
        "fr": "Entrez le nom d'utilisateur",
        "it": "Inserisci nome utente",
        "pt": "Digite o nome de usuário",
        "sv": "Ange användarnamn"
    },
    {
        "en": "Download Your Games",
        "es": "Descargar tus partidas",
        "de": "Deine Partien herunterladen",
        "fr": "Télécharger vos parties",
        "it": "Scarica le tue partite",
        "pt": "Baixar suas partidas",
        "sv": "Ladda ner dina partier"
    },
    {
        "en": "Analyzing Your Downloaded Games",
        "es": "Analizando tus partidas descargadas",
        "de": "Deine heruntergeladenen Partien werden analysiert",
        "fr": "Analyse de vos parties téléchargées",
        "it": "Analisi delle partite scaricate",
        "pt": "Analisando suas partidas baixadas",
        "sv": "Analyserar dina nedladdade partier"
    },
    {
        "en": "total",
        "es": "total",
        "de": "gesamt",
        "fr": "total",
        "it": "totale",
        "pt": "total",
        "sv": "totalt"
    },
    {
        "en": "Analyze Your Games",
        "es": "Analizar tus partidas",
        "de": "Deine Partien analysieren",
        "fr": "Analyser vos parties",
        "it": "Analizza le tue partite",
        "pt": "Analisar suas partidas",
        "sv": "Analysera dina partier"
    },
    {
        "en": "Loading Repertoire Info",
        "es": "Cargando info del repertorio",
        "de": "Repertoire-Infos laden",
        "fr": "Chargement des infos du répertoire",
        "it": "Caricamento informazioni repertorio",
        "pt": "Carregando informações do repertório",
        "sv": "Läser in repertoarinfo"
    },
    {
        "en": "Tree",
        "es": "Árbol",
        "de": "Baum",
        "fr": "Arbre",
        "it": "Albero",
        "pt": "Árvore",
        "sv": "Träd"
    },
    {
        "en": "Comment",
        "es": "Comentario",
        "de": "Kommentar",
        "fr": "Commentaire",
        "it": "Commento",
        "pt": "Comentário",
        "sv": "Kommentar"
    },
    {
        "en": "White Adv",
        "es": "Ventaja blancas",
        "de": "Weiß-Vorteil",
        "fr": "Avantage blanc",
        "it": "Vant. Bianco",
        "pt": "Vantagem das brancas",
        "sv": "Vit fördel"
    },
    {
        "en": "All Buckets",
        "es": "Todos los grupos",
        "de": "Alle Kategorien",
        "fr": "Tous les compartiments",
        "it": "Tutti i gruppi",
        "pt": "Todos os grupos",
        "sv": "Alla spann"
    },
    {
        "en": "Comment for",
        "es": "Comentario para",
        "de": "Kommentar für",
        "fr": "Commentaire pour",
        "it": "Commento per",
        "pt": "Comentário para",
        "sv": "Kommentar för"
    },
    {
        "en": "Graph",
        "es": "Gráfico",
        "de": "Grafik",
        "fr": "Graphique",
        "it": "Grafico",
        "pt": "Gráfico",
        "sv": "Graf"
    },
    {
        "en": "Builder",
        "es": "Constructor",
        "de": "Ersteller",
        "fr": "Constructeur",
        "it": "Costruttore",
        "pt": "Construtor",
        "sv": "Byggare"
    },
    {
        "en": "with",
        "es": "con",
        "de": "mit",
        "fr": "avec",
        "it": "con",
        "pt": "com",
        "sv": "med"
    },
    {
        "en": "Filter",
        "es": "Filtro",
        "de": "Filter",
        "fr": "Filtre",
        "it": "Filtro",
        "pt": "Filtro",
        "sv": "Filter"
    },
    {
        "en": "Init",
        "es": "Iniciar",
        "de": "Initialisieren",
        "fr": "Init",
        "it": "Inizializza",
        "pt": "Iniciar",
        "sv": "Initiera"
    },
    {
        "en": "Tree Viewer",
        "es": "Visor de árbol",
        "de": "Baum-Ansicht",
        "fr": "Visionneuse d'arbre",
        "it": "Visualizzatore albero",
        "pt": "Visualizador de árvore",
        "sv": "Trädvisare"
    },
    {
        "en": "Trim",
        "es": "Recortar",
        "de": "Kürzen",
        "fr": "Élaguer",
        "it": "Taglia",
        "pt": "Aparar",
        "sv": "Trimma"
    },
    {
        "en": "Hide Comments",
        "es": "Ocultar comentarios",
        "de": "Kommentare verbergen",
        "fr": "Masquer les commentaires",
        "it": "Nascondi commenti",
        "pt": "Ocultar comentários",
        "sv": "Dölj kommentarer"
    },
    {
        "en": "Next-Rep",
        "es": "Siguiente-rep",
        "de": "Nächstes Repertoire",
        "fr": "Répetition suivante",
        "it": "Repertorio successivo",
        "pt": "Próx.-Rep.",
        "sv": "Nästa rep"
    },
    {
        "en": "All Done with Repertoire. Tap 'Next-Rep'",
        "es": "Repertorio completado. Pulsa 'Siguiente-rep'",
        "de": "Fertig mit Repertoire. 'Nächstes Repertoire' tippen",
        "fr": "Répertoire terminé. Appuyez sur 'Next-Rep'",
        "it": "Tutto fatto con il repertorio. Tocca 'Next-Rep'",
        "pt": "Finalizado com o repertório. Toque em 'Próx.-Rep.'",
        "sv": "Klart med repertoaren. Tryck 'Nästa rep'"
    },
    {
        "en": "All Done for the Day",
        "es": "Todo hecho por hoy",
        "de": "Für heute fertig",
        "fr": "Fini pour aujourd'hui",
        "it": "Tutto fatto per oggi",
        "pt": "Tudo feito para hoje",
        "sv": "Klart för dagen"
    },
    {
        "en": "Just one more path",
        "es": "Solo un camino más",
        "de": "Nur noch ein Weg",
        "fr": "Encore une voie",
        "it": "Ancora solo una linea",
        "pt": "Só mais um caminho",
        "sv": "Bara en väg till"
    },
    {
        "en": "paths to learn",
        "es": "caminos por aprender",
        "de": "Wege zu lernen",
        "fr": "voies à apprendre",
        "it": "linee da imparare",
        "pt": "caminhos para aprender",
        "sv": "vägar att lära"
    },
    {
        "en": "play",
        "es": "jugar",
        "de": "spielen",
        "fr": "jouer",
        "it": "gioca",
        "pt": "jogar",
        "sv": "spela"
    },
    {
        "en": "No Repertoires need spaced repetition today",
        "es": "Ningún repertorio necesita repetición espaciada hoy",
        "de": "Keine Repertoires brauchen heute Wiederholung",
        "fr": "Aucun répertoire n'a besoin de répétition espacée aujourd'hui",
        "it": "Nessun repertorio richiede ripetizione dilazionata oggi",
        "pt": "Nenhum repertório precisa de repetição espaçada hoje",
        "sv": "Inga repertoarer kräver repetition idag"
    },
    {
        "en": "Drill",
        "es": "Ejercicio",
        "de": "Drill",
        "fr": "Exercice",
        "it": "Esercizio",
        "pt": "Treino",
        "sv": "Träna"
    },
    {
        "en": "Practice",
        "es": "Practicar",
        "de": "Üben",
        "fr": "Pratique",
        "it": "Allenati",
        "pt": "Prática",
        "sv": "Öva"
    },
    {
        "en": "Pick Begin",
        "es": "Elegir inicio",
        "de": "Anfang wählen",
        "fr": "Choisir début",
        "it": "Scegli inizio",
        "pt": "Escolher início",
        "sv": "Välj start"
    },
    {
        "en": "Again",
        "es": "Otra vez",
        "de": "Nochmals",
        "fr": "Encore",
        "it": "Di nuovo",
        "pt": "Novamente",
        "sv": "Igen"
    },
    {
        "en": "Close Pick",
        "es": "Cerrar selección",
        "de": "Auswahl schließen",
        "fr": "Fermer la sélection",
        "it": "Chiudi selezione",
        "pt": "Fechar seleção",
        "sv": "Stäng val"
    },
    {
        "en": "You Got Checkmated",
        "es": "Te hicieron mate",
        "de": "Du wurdest schachgemattet",
        "fr": "Vous avez été maté",
        "it": "Sei stato messo sotto scacco matto",
        "pt": "Você foi mateado",
        "sv": "Du blev schackmatt"
    },
    {
        "en": "You Checkmated",
        "es": "Has dado mate",
        "de": "Du hast Matt gesetzt",
        "fr": "Vous avez maté",
        "it": "Hai dato scacco matto",
        "pt": "Você deu mate",
        "sv": "Du satte matt"
    },
    {
        "en": "Score",
        "es": "Puntuación",
        "de": "Punkte",
        "fr": "Score",
        "it": "Punteggio",
        "pt": "Pontuação",
        "sv": "Poäng"
    },
    {
        "en": "Select For Export",
        "es": "Seleccionar para exportar",
        "de": "Für Export auswählen",
        "fr": "Sélectionner pour export",
        "it": "Seleziona per esportazione",
        "pt": "Selecionar para exportar",
        "sv": "Välj för export"
    },
    {
        "en": "Repertoire List",
        "es": "Lista de repertorios",
        "de": "Repertoire-Liste",
        "fr": "Liste des répertoires",
        "it": "Elenco repertori",
        "pt": "Lista de repertórios",
        "sv": "Repertoarliste"
    },
    {
        "en": "Export",
        "es": "Exportar",
        "de": "Export",
        "fr": "Exporter",
        "it": "Esporta",
        "pt": "Exportar",
        "sv": "Exportera"
    },
    {
        "en": "Color",
        "es": "Color",
        "de": "Farbe",
        "fr": "Couleur",
        "it": "Colore",
        "pt": "Cor",
        "sv": "Färg"
    },
    {
        "en": "Name",
        "es": "Nombre",
        "de": "Name",
        "fr": "Nom",
        "it": "Nome",
        "pt": "Nome",
        "sv": "Namn"
    },
    {
        "en": "Min Rating",
        "es": "Valoración mínima",
        "de": "Min-Rating",
        "fr": "Cote min",
        "it": "Valutazione minima",
        "pt": "Avaliação mínima",
        "sv": "Minsta betyg"
    },
    {
        "en": "Max Rating",
        "es": "Valoración máxima",
        "de": "Max-Rating",
        "fr": "Cote max",
        "it": "Valutazione massima",
        "pt": "Avaliação máxima",
        "sv": "Högsta betyg"
    },
    {
        "en": "Percent Target",
        "es": "Porcentaje objetivo",
        "de": "Ziel-Prozent",
        "fr": "Pourcentage cible",
        "it": "Percentuale target",
        "pt": "Percentual alvo",
        "sv": "Procentmål"
    },
    {
        "en": "Last Update",
        "es": "Última actualización",
        "de": "Letzte Aktualisierung",
        "fr": "Dernière mise à jour",
        "it": "Ultimo aggiornamento",
        "pt": "Última atualização",
        "sv": "Senaste uppdatering"
    },
    {
        "en": "Download",
        "es": "Descargar",
        "de": "Herunterladen",
        "fr": "Télécharger",
        "it": "Scarica",
        "pt": "Baixar",
        "sv": "Ladda ner"
    },
    {
        "en": "Select-All",
        "es": "Seleccionar todo",
        "de": "Alles auswählen",
        "fr": "Tout sélectionner",
        "it": "Seleziona tutto",
        "pt": "Selecionar tudo",
        "sv": "Markera alla"
    },
    {
        "en": "Clear",
        "es": "Borrar",
        "de": "Löschen",
        "fr": "Effacer",
        "it": "Cancella",
        "pt": "Limpar",
        "sv": "Rensa"
    },
    {
        "en": "Lock",
        "es": "Bloquear",
        "de": "Sperren",
        "fr": "Verrouiller",
        "it": "Blocca",
        "pt": "Travar",
        "sv": "Lås"
    },
    {
        "en": "Add",
        "es": "Añadir",
        "de": "Hinzufügen",
        "fr": "Ajouter",
        "it": "Aggiungi",
        "pt": "Adicionar",
        "sv": "Lägg till"
    },
    {
        "en": "Edit",
        "es": "Editar",
        "de": "Bearbeiten",
        "fr": "Éditer",
        "it": "Modifica",
        "pt": "Editar",
        "sv": "Redigera"
    },
    {
        "en": "Delete",
        "es": "Eliminar",
        "de": "Löschen",
        "fr": "Supprimer",
        "it": "Elimina",
        "pt": "Excluir",
        "sv": "Radera"
    },
    {
        "en": "Enter name",
        "es": "Introduce nombre",
        "de": "Name eingeben",
        "fr": "Entrez le nom",
        "it": "Inserisci nome",
        "pt": "Digite o nome",
        "sv": "Ange namn"
    },
    {
        "en": "Repertoire",
        "es": "Repertorio",
        "de": "Repertoire",
        "fr": "Répertoire",
        "it": "Repertorio",
        "pt": "Repertório",
        "sv": "Repertoar"
    },
    {
        "en": "Percentage Filter",
        "es": "Filtro por porcentaje",
        "de": "Prozentfilter",
        "fr": "Filtre en pourcentage",
        "it": "Filtro percentuale",
        "pt": "Filtro por percentual",
        "sv": "Procentfilter"
    },
    {
        "en": "game in a",
        "es": "partida en una",
        "de": "Partie in einem",
        "fr": "partie en",
        "it": "partita in un",
        "pt": "partida em um",
        "sv": "parti i en"
    },
    {
        "en": "Percentage",
        "es": "Porcentaje",
        "de": "Prozentsatz",
        "fr": "Pourcentage",
        "it": "Percentuale",
        "pt": "Percentual",
        "sv": "Procent"
    },
    {
        "en": "Repertoire Name",
        "es": "Nombre del repertorio",
        "de": "Repertoire-Name",
        "fr": "Nom du répertoire",
        "it": "Nome repertorio",
        "pt": "Nome do repertório",
        "sv": "Repertoarnamn"
    },
    {
        "en": "Do you want to copy the selected repertoire?",
        "es": "¿Quieres copiar el repertorio seleccionado?",
        "de": "Möchtest du das ausgewählte Repertoire kopieren?",
        "fr": "Voulez-vous copier le répertoire sélectionné ?",
        "it": "Vuoi copiare il repertorio selezionato?",
        "pt": "Deseja copiar o repertório selecionado?",
        "sv": "Vill du kopiera den valda repertoaren?"
    },
    {
        "en": "Copy Repertoire?",
        "es": "¿Copiar repertorio?",
        "de": "Repertoire kopieren?",
        "fr": "Copier le répertoire ?",
        "it": "Copia repertorio?",
        "pt": "Copiar repertório?",
        "sv": "Kopiera repertoar?"
    },
    {
        "en": "Delete Repertoire?",
        "es": "¿Eliminar repertorio?",
        "de": "Repertoire löschen?",
        "fr": "Supprimer le répertoire ?",
        "it": "Eliminare il repertorio?",
        "pt": "Excluir repertório?",
        "sv": "Radera repertoar?"
    },
    {
        "en": "Do you want to delete the selected repertoire?",
        "es": "¿Quieres eliminar el repertorio seleccionado?",
        "de": "Möchtest du das ausgewählte Repertoire löschen?",
        "fr": "Voulez-vous supprimer le répertoire sélectionné ?",
        "it": "Vuoi eliminare il repertorio selezionato?",
        "pt": "Deseja excluir o repertório selecionado?",
        "sv": "Vill du radera den valda repertoaren?"
    },
    {
        "en": "Current Fen",
        "es": "FEN actual",
        "de": "Aktuelle FEN",
        "fr": "FEN actuel",
        "it": "FEN corrente",
        "pt": "FEN atual",
        "sv": "Aktuell FEN"
    },
    {
        "en": "Entire PGN",
        "es": "PGN completo",
        "de": "Ganze PGN",
        "fr": "PGN entier",
        "it": "PGN intero",
        "pt": "PGN inteiro",
        "sv": "Hela PGN"
    },
    {
        "en": "Current Board (FEN)",
        "es": "Tablero actual (FEN)",
        "de": "Aktuelles Brett (FEN)",
        "fr": "Plateau actuel (FEN)",
        "it": "Scacchiera corrente (FEN)",
        "pt": "Tabuleiro atual (FEN)",
        "sv": "Aktuellt bräde (FEN)"
    },
    {
        "en": "Entire Move Sequence (PGN)",
        "es": "Secuencia completa de jugadas (PGN)",
        "de": "Ganze Zugfolge (PGN)",
        "fr": "Séquence de coups entière (PGN)",
        "it": "Intera sequenza di mosse (PGN)",
        "pt": "Sequência completa de lances (PGN)",
        "sv": "Hela dragsekvensen (PGN)"
    },
    {
        "en": "YES",
        "es": "SÍ",
        "de": "JA",
        "fr": "OUI",
        "it": "SÌ",
        "pt": "SIM",
        "sv": "JA"
    },
    {
        "en": "NO",
        "es": "NO",
        "de": "NEIN",
        "fr": "NON",
        "it": "NO",
        "pt": "NÃO",
        "sv": "NEJ"
    },
    {
        "en": "Initial Board",
        "es": "Tablero inicial",
        "de": "Ausgangsstellung",
        "fr": "Position initiale",
        "it": "Scacchiera iniziale",
        "pt": "Tabuleiro inicial",
        "sv": "Startposition"
    },
    {
        "en": "Paste FEN from Clipboard",
        "es": "Pegar FEN desde el portapapeles",
        "de": "FEN aus Zwischenablage einfügen",
        "fr": "Collez le FEN depuis le presse-papiers",
        "it": "Incolla FEN dagli appunti",
        "pt": "Colar FEN da área de transferência",
        "sv": "Klistra in FEN från urklipp"
    },
    {
        "en": "Current Game",
        "es": "Partida actual",
        "de": "Aktuelle Partie",
        "fr": "Partie en cours",
        "it": "Partita corrente",
        "pt": "Partida atual",
        "sv": "Aktuellt parti"
    },
    {
        "en": "All Games",
        "es": "Todas las partidas",
        "de": "Alle Partien",
        "fr": "Toutes les parties",
        "it": "Tutte le partite",
        "pt": "Todas as partidas",
        "sv": "Alla partier"
    },
    {
        "en": "Fen to Clipboard",
        "es": "FEN al portapapeles",
        "de": "FEN in Zwischenablage",
        "fr": "FEN vers le presse-papiers",
        "it": "Copia FEN negli appunti",
        "pt": "FEN para área de transferência",
        "sv": "FEN till urklipp"
    },
    {
        "en": "Manager",
        "es": "Gestor",
        "de": "Manager",
        "fr": "Gestionnaire",
        "it": "Gestore",
        "pt": "Gerenciador",
        "sv": "Hantera"
    },
    {
        "en": "Repertoires",
        "es": "Repertorios",
        "de": "Repertoires",
        "fr": "Répertoires",
        "it": "Repertori",
        "pt": "Repertórios",
        "sv": "Repertoarer"
    },
    {
        "en": "Opening Explorer - Win\/Loss",
        "es": "Explorador de aperturas - Ganar\/Perder",
        "de": "Eröffnungs-Explorer – Sieg\/Verlust",
        "fr": "Explorateur d'ouvertures - Victoires\/Défaites",
        "it": "Esploratore aperture - Vittorie\/Sconfitte",
        "pt": "Explorador de Aberturas - Vitórias\/Derrotas",
        "sv": "Öppningsutforskare - Vinster\/Förluster"
    },
    {
        "en": "Play Against Game Collection",
        "es": "Jugar contra colección de partidas",
        "de": "Gegen Partiensammlung spielen",
        "fr": "Jouer contre une collection de parties",
        "it": "Gioca contro la collezione di partite",
        "pt": "Jogar contra coleção de partidas",
        "sv": "Spela mot partitillgång"
    },
    {
        "en": "Opening Explorer - Slice\/Dice",
        "es": "Explorador de aperturas - Filtrar",
        "de": "Eröffnungs-Explorer – analysieren",
        "fr": "Explorateur d'ouvertures - découper\/analyser",
        "it": "Esploratore aperture - Analisi dettagliata",
        "pt": "Explorador de Aberturas - Fatias\/Análise",
        "sv": "Öppningsutforskare - analysera"
    },
    {
        "en": "Master Player Explorer",
        "es": "Explorador de maestros",
        "de": "Meister-Spieler-Explorer",
        "fr": "Explorateur des joueurs maîtres",
        "it": "Esploratore player master",
        "pt": "Explorador de jogadores mestres",
        "sv": "Stormästarexploratorn"
    },
    {
        "en": "Legacy Opening",
        "es": "Apertura legada",
        "de": "Legacy-Eröffnung",
        "fr": "Ouverture héritée",
        "it": "Apertura legacy",
        "pt": "Abertura legada",
        "sv": "Äldre öppning"
    },
    {
        "en": "Your Games",
        "es": "Tus partidas",
        "de": "Deine Partien",
        "fr": "Vos parties",
        "it": "Le tue partite",
        "pt": "Suas partidas",
        "sv": "Dina partier"
    },
    {
        "en": "Main",
        "es": "Principal",
        "de": "Haupt",
        "fr": "Principal",
        "it": "Principale",
        "pt": "Principal",
        "sv": "Huvud"
    },
    {
        "en": "Master Games",
        "es": "Partidas de maestros",
        "de": "Meisterpartien",
        "fr": "Parties de maîtres",
        "it": "Partite dei maestri",
        "pt": "Partidas de mestres",
        "sv": "Stormästares partier"
    },
    {
        "en": "Compare",
        "es": "Comparar",
        "de": "Vergleichen",
        "fr": "Comparer",
        "it": "Confronta",
        "pt": "Comparar",
        "sv": "Jämför"
    },
    {
        "en": "Explorer Options",
        "es": "Opciones del explorador",
        "de": "Explorer-Optionen",
        "fr": "Options de l'explorateur",
        "it": "Opzioni esploratore",
        "pt": "Opções do explorador",
        "sv": "Utforskarinställningar"
    },
    {
        "en": "None",
        "es": "Ninguno",
        "de": "Keine",
        "fr": "Aucun",
        "it": "Nessuno",
        "pt": "Nenhum",
        "sv": "Ingen"
    },
    {
        "en": "Yours",
        "es": "Tuyas",
        "de": "Deine",
        "fr": "Les vôtres",
        "it": "Tuoi",
        "pt": "Seus",
        "sv": "Dina"
    },
    {
        "en": "Masters",
        "es": "Maestros",
        "de": "Meister",
        "fr": "Maîtres",
        "it": "Maestri",
        "pt": "Mestres",
        "sv": "Mästare"
    },
    {
        "en": "Main Game Source",
        "es": "Fuente principal de partidas",
        "de": "Haupt-Quellpartien",
        "fr": "Source principale des parties",
        "it": "Fonte principale delle partite",
        "pt": "Fonte principal de partidas",
        "sv": "Huvudkällan för partier"
    },
    {
        "en": "Comparison Game Source",
        "es": "Fuente de partidas para comparar",
        "de": "Vergleichs-Quellpartien",
        "fr": "Source de comparaison",
        "it": "Fonte delle partite per confronto",
        "pt": "Fonte de comparação de partidas",
        "sv": "Jämförelsekälla för partier"
    },
    {
        "en": "Show Stockfish Scores",
        "es": "Mostrar puntuaciones de Stockfish",
        "de": "Stockfish-Bewertungen anzeigen",
        "fr": "Afficher les évaluations Stockfish",
        "it": "Mostra valutazioni Stockfish",
        "pt": "Mostrar avaliações do Stockfish",
        "sv": "Visa Stockfish-poäng"
    },
    {
        "en": "Just Play & Opponent Moves will come from game collection - weighted by popularity",
        "es": "Solo las jugadas del juego y del oponente vendrán de la colección — ponderadas por popularidad",
        "de": "Nur Spiel- & Gegnerzüge stammen aus der Partiensammlung – gewichtet nach Beliebtheit",
        "fr": "Seuls les coups et ceux de l'adversaire proviendront de la collection - pondérés par popularité",
        "it": "Solo Gioca e mosse avversarie verranno dalla collezione di partite - ponderate per popolarità",
        "pt": "Apenas jogar & movimentos do oponente virão da coleção de partidas — ponderado por popularidade",
        "sv": "Endast 'Spela' & motståndarens drag kommer från partikollektionen - viktat efter popularitet"
    },
    {
        "en": "Rating Filter",
        "es": "Filtro de valoración",
        "de": "Rating-Filter",
        "fr": "Filtre de cote",
        "it": "Filtro valutazione",
        "pt": "Filtro de avaliação",
        "sv": "Betygsfilter"
    },
    {
        "en": "below",
        "es": "por debajo",
        "de": "unter",
        "fr": "en dessous",
        "it": "sotto",
        "pt": "abaixo",
        "sv": "under"
    },
    {
        "en": "above",
        "es": "por encima",
        "de": "über",
        "fr": "au-dessus",
        "it": "sopra",
        "pt": "acima",
        "sv": "över"
    },
    {
        "en": "Loading Players",
        "es": "Cargando jugadores",
        "de": "Spieler laden",
        "fr": "Chargement des joueurs",
        "it": "Caricamento giocatori",
        "pt": "Carregando jogadores",
        "sv": "Läser in spelare"
    },
    {
        "en": "Moves Played By",
        "es": "Jugadas realizadas por",
        "de": "Züge gespielt von",
        "fr": "Coups joués par",
        "it": "Mosse giocate da",
        "pt": "Lances jogados por",
        "sv": "Drag spelade av"
    },
    {
        "en": "Recent",
        "es": "Recientes",
        "de": "Kürzlich",
        "fr": "Récents",
        "it": "Recenti",
        "pt": "Recentes",
        "sv": "Senaste"
    },
    {
        "en": "Games",
        "es": "Partidas",
        "de": "Partien",
        "fr": "Parties",
        "it": "Partite",
        "pt": "Partidas",
        "sv": "Partier"
    },
    {
        "en": "Date",
        "es": "Fecha",
        "de": "Datum",
        "fr": "Date",
        "it": "Data",
        "pt": "Data",
        "sv": "Datum"
    },
    {
        "en": "Result",
        "es": "Resultado",
        "de": "Ergebnis",
        "fr": "Résultat",
        "it": "Risultato",
        "pt": "Resultado",
        "sv": "Resultat"
    },
    {
        "en": "W-Rating",
        "es": "Valoración B",
        "de": "Weiß-Rating",
        "fr": "Cote Blancs",
        "it": "Val. Bianco",
        "pt": "Avaliação brancas",
        "sv": "V-betyg"
    },
    {
        "en": "B-Rating",
        "es": "Valoración N",
        "de": "Schwarz-Rating",
        "fr": "Cote Noirs",
        "it": "Val. Nero",
        "pt": "Avaliação negras",
        "sv": "S-betyg"
    },
    {
        "en": "Score Game",
        "es": "Puntuación de la partida",
        "de": "Partie bewerten",
        "fr": "Évaluer la partie",
        "it": "Assegna punteggio partita",
        "pt": "Pontuar partida",
        "sv": "Poängsätt parti"
    },
    {
        "en": "Game Scored",
        "es": "Partida puntuado",
        "de": "Partie bewertet",
        "fr": "Partie évaluée",
        "it": "Partita valutata",
        "pt": "Partida pontuada",
        "sv": "Parti poängsatt"
    },
    {
        "en": "Moves Scored",
        "es": "Jugadas puntuadas",
        "de": "Züge bewertet",
        "fr": "Coups évalués",
        "it": "Mosse valutate",
        "pt": "Lances pontuados",
        "sv": "Drag poängsatta"
    },
    {
        "en": "Calc Score",
        "es": "Calcular puntuación",
        "de": "Score berechnen",
        "fr": "Calculer le score",
        "it": "Calcola punteggio",
        "pt": "Calcular pontuação",
        "sv": "Beräkna poäng"
    },
    {
        "en": "Still Scoring",
        "es": "Aún puntuando",
        "de": "Bewertung läuft",
        "fr": "Évaluation en cours",
        "it": "Ancora in valutazione",
        "pt": "Ainda pontuando",
        "sv": "Poängsätter fortfarande"
    },
    {
        "en": "Scoring",
        "es": "Puntuando",
        "de": "Bewertung",
        "fr": "Évaluation",
        "it": "Valutazione",
        "pt": "Pontuando",
        "sv": "Poängsättning"
    },
    {
        "en": "Done Scoring",
        "es": "Puntuación completa",
        "de": "Bewertung abgeschlossen",
        "fr": "Évaluation terminée",
        "it": "Valutazione completata",
        "pt": "Pontuação concluída",
        "sv": "Klar med poängsättning"
    },
    {
        "en": "Entire Game Scored",
        "es": "Partida completa puntuado",
        "de": "Ganze Partie bewertet",
        "fr": "Partie entière évaluée",
        "it": "Intera partita valutata",
        "pt": "Partida inteira pontuada",
        "sv": "Hela partiet poängsatt"
    },
    {
        "en": "FEN copied",
        "es": "FEN copiado",
        "de": "FEN kopiert",
        "fr": "FEN copié",
        "it": "FEN copiato",
        "pt": "FEN copiado",
        "sv": "FEN kopierad"
    },
    {
        "en": "What to Download?",
        "es": "¿Qué descargar?",
        "de": "Was herunterladen?",
        "fr": "Que télécharger ?",
        "it": "Cosa scaricare?",
        "pt": "O que baixar?",
        "sv": "Vad vill du ladda ner?"
    },
    {
        "en": "Bidirectional",
        "es": "Bidireccional",
        "de": "Bidirektional",
        "fr": "Bidirectionnel",
        "it": "Bidirezionale",
        "pt": "Bidirecional",
        "sv": "Bidirektionell"
    },
    {
        "en": "Display",
        "es": "Mostrar",
        "de": "Anzeige",
        "fr": "Afficher",
        "it": "Visualizza",
        "pt": "Exibir",
        "sv": "Visa"
    },
    {
        "en": "Follow Along",
        "es": "Seguir en tiempo real",
        "de": "Mitverfolgen",
        "fr": "Suivre",
        "it": "Segui",
        "pt": "Acompanhar",
        "sv": "Följ med"
    },
    {
        "en": "Using Repertoire",
        "es": "Usando repertorio",
        "de": "Repertoire verwenden",
        "fr": "Utilisant le répertoire",
        "it": "Usando repertorio",
        "pt": "Usando repertório",
        "sv": "Använder repertoar"
    },
    {
        "en": "Select Side to Play",
        "es": "Selecciona el bando para jugar",
        "de": "Farbe zum Spielen wählen",
        "fr": "Sélectionnez le côté à jouer",
        "it": "Seleziona il lato da giocare",
        "pt": "Selecione o lado para jogar",
        "sv": "Välj sida att spela"
    },
    {
        "en": "Practice Playing White",
        "es": "Practicar jugando con blancas",
        "de": "Weiß spielen üben",
        "fr": "S'entraîner à jouer les blancs",
        "it": "Allenati a giocare col Bianco",
        "pt": "Praticar jogando com as brancas",
        "sv": "Öva på att spela vit"
    },
    {
        "en": "Playing White",
        "es": "Jugando con blancas",
        "de": "Weiß spielen",
        "fr": "Jouer les blancs",
        "it": "Giocando col Bianco",
        "pt": "Jogando com as brancas",
        "sv": "Spelar vit"
    },
    {
        "en": "Playing Black",
        "es": "Jugando con negras",
        "de": "Schwarz spielen",
        "fr": "Jouer les noirs",
        "it": "Giocando col Nero",
        "pt": "Jogando com as negras",
        "sv": "Spelar svart"
    },
    {
        "en": "Imported - Must Assign Color Before Use",
        "es": "Importado - Debes asignar color antes de usar",
        "de": "Importiert – Farbe vor Nutzung zuweisen",
        "fr": "Importé - attribuer une couleur avant utilisation",
        "it": "Importato - assegnare colore prima dell'uso",
        "pt": "Importado - é preciso atribuir cor antes de usar",
        "sv": "Importerad - måste tilldela färg innan användning"
    },
    {
        "en": "Select the Repertoire to build",
        "es": "Selecciona el repertorio a construir",
        "de": "Repertoire zum Aufbau auswählen",
        "fr": "Sélectionnez le répertoire à construire",
        "it": "Seleziona il repertorio da costruire",
        "pt": "Selecione o repertório para construir",
        "sv": "Välj repertoar att bygga"
    },
    {
        "en": "Repertoire Selector",
        "es": "Selector de repertorios",
        "de": "Repertoire-Auswahl",
        "fr": "Sélecteur de répertoire",
        "it": "Selettore repertori",
        "pt": "Seletor de repertórios",
        "sv": "Repertoarväljare"
    },
    {
        "en": "Select the Repertoire to view",
        "es": "Selecciona el repertorio a ver",
        "de": "Anzuzeigendes Repertoire wählen",
        "fr": "Sélectionnez le répertoire à visualiser",
        "it": "Seleziona il repertorio da visualizzare",
        "pt": "Selecione o repertório para visualizar",
        "sv": "Välj repertoar att visa"
    },
    {
        "en": "Show Comments",
        "es": "Mostrar comentarios",
        "de": "Kommentare anzeigen",
        "fr": "Afficher les commentaires",
        "it": "Mostra commenti",
        "pt": "Mostrar comentários",
        "sv": "Visa kommentarer"
    },
    {
        "en": "Next",
        "es": "Siguiente",
        "de": "Weiter",
        "fr": "Suivant",
        "it": "Avanti",
        "pt": "Próximo",
        "sv": "Nästa"
    },
    {
        "en": "Real-Time",
        "es": "En tiempo real",
        "de": "Echtzeit",
        "fr": "Temps réel",
        "it": "Tempo reale",
        "pt": "Tempo real",
        "sv": "I realtid"
    },
    {
        "en": "No Repertoire Selected",
        "es": "Ningún repertorio seleccionado",
        "de": "Kein Repertoire ausgewählt",
        "fr": "Aucun répertoire sélectionné",
        "it": "Nessun repertorio selezionato",
        "pt": "Nenhum repertório selecionado",
        "sv": "Ingen repertoar vald"
    },
    {
        "en": "End of Line",
        "es": "Final de la línea",
        "de": "Ende der Linie",
        "fr": "Fin de ligne",
        "it": "Fine linea",
        "pt": "Fim de linha",
        "sv": "Slut på linjen"
    },
    {
        "en": "Merged",
        "es": "Fusionado",
        "de": "Zusammengeführt",
        "fr": "Fusionné",
        "it": "Fuso",
        "pt": "Mesclado",
        "sv": "Slås ihop"
    },
    {
        "en": "lines done",
        "es": "líneas hechas",
        "de": "Linien erledigt",
        "fr": "lignes terminées",
        "it": "linee fatte",
        "pt": "linhas concluídas",
        "sv": "linjer klara"
    },
    {
        "en": "of",
        "es": "de",
        "de": "von",
        "fr": "sur",
        "it": "di",
        "pt": "de",
        "sv": "av"
    },
    {
        "en": "Select the Repertoires and color you want to practice. Multiple repertoires can be merged. One color at a time",
        "es": "Selecciona los repertorios y el color que quieres practicar. Se pueden fusionar varios repertorios. Un color a la vez",
        "de": "Wähle Repertoires und Farbe zum Üben. Mehrere Repertoires können zusammengeführt werden. Jeweils eine Farbe.",
        "fr": "Sélectionnez les répertoires et la couleur à pratiquer. Plusieurs répertoires peuvent être fusionnés. Une couleur à la fois",
        "it": "Seleziona i repertori e il colore che vuoi praticare. Più repertori possono essere uniti. Un colore alla volta",
        "pt": "Selecione os repertórios e a cor que quer praticar. Vários repertórios podem ser mesclados. Uma cor por vez",
        "sv": "Välj de repertoarer och den färg du vill öva. Flera repertoarer kan slås ihop. En färg åt gången"
    },
    {
        "en": "Repertoire Manager",
        "es": "Gestor de repertorios",
        "de": "Repertoire-Manager",
        "fr": "Gestionnaire de répertoires",
        "it": "Gestore repertori",
        "pt": "Gerenciador de repertórios",
        "sv": "Repertoarhanterare"
    },
    {
        "en": "Switch to Multiple Selector",
        "es": "Cambiar a selector múltiple",
        "de": "Auf Mehrfachauswahl umschalten",
        "fr": "Passer au sélecteur multiple",
        "it": "Passa al selettore multiplo",
        "pt": "Alternar para seletor múltiplo",
        "sv": "Byt till multipelväljare"
    },
    {
        "en": "Switch to Single Selector",
        "es": "Cambiar a selector único",
        "de": "Auf Einzelauswahl umschalten",
        "fr": "Passer au sélecteur unique",
        "it": "Passa al selettore singolo",
        "pt": "Alternar para seletor único",
        "sv": "Byt till enkelväljare"
    },
    {
        "en": "White Repertoires",
        "es": "Repertorios de blancas",
        "de": "Weiß-Repertoires",
        "fr": "Répertoires blancs",
        "it": "Repertori per il Bianco",
        "pt": "Repertórios das brancas",
        "sv": "Vita repertoarer"
    },
    {
        "en": "Black Repertoires",
        "es": "Repertorios de negras",
        "de": "Schwarz-Repertoires",
        "fr": "Répertoires noirs",
        "it": "Repertori per il Nero",
        "pt": "Repertórios das negras",
        "sv": "Svarta repertoarer"
    },
    {
        "en": "Unknown Color - Need to be Assigned",
        "es": "Color desconocido - necesita asignarse",
        "de": "Unbekannte Farbe – muss zugewiesen werden",
        "fr": "Couleur inconnue - doit être assignée",
        "it": "Colore sconosciuto - da assegnare",
        "pt": "Cor desconhecida - precisa ser atribuída",
        "sv": "Okänd färg - måste tilldelas"
    },
    {
        "en": "Select color to assign to",
        "es": "Selecciona el color para asignar a",
        "de": "Farbe auswählen, die zugewiesen werden soll",
        "fr": "Sélectionnez la couleur à attribuer",
        "it": "Seleziona il colore da assegnare a",
        "pt": "Selecione a cor para atribuir a",
        "sv": "Välj färg att tilldela"
    },
    {
        "en": "Assign Repertoire Color",
        "es": "Asignar color al repertorio",
        "de": "Repertoire-Farbe zuweisen",
        "fr": "Attribuer une couleur au répertoire",
        "it": "Assegna colore al repertorio",
        "pt": "Atribuir cor ao repertório",
        "sv": "Tilldela repertoarfärg"
    },
    {
        "en": "Do you want to delete",
        "es": "¿Quieres eliminar",
        "de": "Möchtest du löschen",
        "fr": "Voulez-vous supprimer",
        "it": "Vuoi eliminare",
        "pt": "Deseja excluir",
        "sv": "Vill du radera"
    },
    {
        "en": "Name is empty",
        "es": "El nombre está vacío",
        "de": "Name ist leer",
        "fr": "Le nom est vide",
        "it": "Il nome è vuoto",
        "pt": "Nome está vazio",
        "sv": "Namnet är tomt"
    },
    {
        "en": "Rename",
        "es": "Renombrar",
        "de": "Umbenennen",
        "fr": "Renommer",
        "it": "Rinomina",
        "pt": "Renomear",
        "sv": "Byt namn"
    },
    {
        "en": "Set-Color",
        "es": "Fijar color",
        "de": "Farbe setzen",
        "fr": "Définir couleur",
        "it": "Imposta colore",
        "pt": "Definir cor",
        "sv": "Ställ in färg"
    },
    {
        "en": "Copy Repertoire",
        "es": "Copiar repertorio",
        "de": "Repertoire kopieren",
        "fr": "Copier le répertoire",
        "it": "Copia repertorio",
        "pt": "Copiar repertório",
        "sv": "Kopiera repertoar"
    },
    {
        "en": "Rename Repertoire",
        "es": "Renombrar repertorio",
        "de": "Repertoire umbenennen",
        "fr": "Renommer le répertoire",
        "it": "Rinomina repertorio",
        "pt": "Renomear repertório",
        "sv": "Byt namn på repertoar"
    },
    {
        "en": "Copy To",
        "es": "Copiar a",
        "de": "Kopieren nach",
        "fr": "Copier vers",
        "it": "Copia in",
        "pt": "Copiar para",
        "sv": "Kopiera till"
    },
    {
        "en": "Rename To",
        "es": "Renombrar a",
        "de": "Umbenennen zu",
        "fr": "Renommer en",
        "it": "Rinomina in",
        "pt": "Renomear para",
        "sv": "Byt namn till"
    },
    {
        "en": "Add Repertoire",
        "es": "Añadir repertorio",
        "de": "Repertoire hinzufügen",
        "fr": "Ajouter un répertoire",
        "it": "Aggiungi repertorio",
        "pt": "Adicionar repertório",
        "sv": "Lägg till repertoar"
    },
    {
        "en": "Select Repertoires To Download",
        "es": "Selecciona repertorios para descargar",
        "de": "Repertoires zum Herunterladen auswählen",
        "fr": "Sélectionner les répertoires à télécharger",
        "it": "Seleziona repertori da scaricare",
        "pt": "Selecionar repertórios para baixar",
        "sv": "Välj repertoarer att ladda ner"
    },
    {
        "en": "Repertoire Import (Web)",
        "es": "Importar repertorio (Web)",
        "de": "Repertoire-Import (Web)",
        "fr": "Import de répertoire (Web)",
        "it": "Importa repertorio (Web)",
        "pt": "Importar repertório (Web)",
        "sv": "Repertoarimport (web)"
    },
    {
        "en": "Repertoire Builder",
        "es": "Constructor de repertorios",
        "de": "Repertoire-Builder",
        "fr": "Constructeur de répertoire",
        "it": "Costruttore repertorio",
        "pt": "Construtor de repertório",
        "sv": "Repertoarbyggare"
    },
    {
        "en": "Repertoire Tree",
        "es": "Árbol del repertorio",
        "de": "Repertoire-Baum",
        "fr": "Arbre du répertoire",
        "it": "Albero del repertorio",
        "pt": "Árvore do repertório",
        "sv": "Repertoarträd"
    },
    {
        "en": "Repertoire Practice",
        "es": "Práctica de repertorio",
        "de": "Repertoire-Training",
        "fr": "Pratique du répertoire",
        "it": "Pratica repertorio",
        "pt": "Prática de repertório",
        "sv": "Repertoarträning"
    },
    {
        "en": "Repertoire Export",
        "es": "Exportar repertorio",
        "de": "Repertoire-Export",
        "fr": "Export de répertoire",
        "it": "Esporta repertorio",
        "pt": "Exportar repertório",
        "sv": "Repertoarexport"
    },
    {
        "en": "Import PGN files containing Repertoires",
        "es": "Importar archivos PGN que contienen repertorios",
        "de": "PGN-Dateien mit Repertoires importieren",
        "fr": "Importer des fichiers PGN contenant des répertoires",
        "it": "Importa file PGN contenenti repertori",
        "pt": "Importar arquivos PGN contendo repertórios",
        "sv": "Importera PGN-filer med repertoarer"
    },
    {
        "en": "Drop PGN files with Repertoires here",
        "es": "Suelta archivos PGN con repertorios aquí",
        "de": "PGN-Dateien mit Repertoires hier ablegen",
        "fr": "Déposez les fichiers PGN avec répertoires ici",
        "it": "Trascina qui i file PGN con repertori",
        "pt": "Solte aqui arquivos PGN com repertórios",
        "sv": "Släpp PGN-filer med repertoarer här"
    },
    {
        "en": "Import",
        "es": "Importar",
        "de": "Importieren",
        "fr": "Importer",
        "it": "Importa",
        "pt": "Importar",
        "sv": "Importera"
    },
    {
        "en": "Results",
        "es": "Resultados",
        "de": "Ergebnisse",
        "fr": "Résultats",
        "it": "Risultati",
        "pt": "Resultados",
        "sv": "Resultat"
    },
    {
        "en": "Repertoires in Download",
        "es": "Repertorios en la descarga",
        "de": "Repertoires im Download",
        "fr": "Répertoires dans le téléchargement",
        "it": "Repertori nel download",
        "pt": "Repertórios no download",
        "sv": "Repertoarer i nedladdning"
    },
    {
        "en": "Source",
        "es": "Fuente",
        "de": "Quelle",
        "fr": "Source",
        "it": "Fonte",
        "pt": "Fonte",
        "sv": "Källa"
    },
    {
        "en": "Your Filename",
        "es": "Tu nombre de archivo",
        "de": "Dein Dateiname",
        "fr": "Votre nom de fichier",
        "it": "Il tuo nome file",
        "pt": "Seu nome de arquivo",
        "sv": "Ditt filnamn"
    },
    {
        "en": "Rep#",
        "es": "Rep#",
        "de": "Rep#",
        "fr": "Rep#",
        "it": "Rep#",
        "pt": "Rep#",
        "sv": "Rep#"
    },
    {
        "en": "Start Game",
        "es": "Empezar partida",
        "de": "Spiel starten",
        "fr": "Démarrer la partie",
        "it": "Avvia partita",
        "pt": "Iniciar partida",
        "sv": "Starta parti"
    },
    {
        "en": "Takeback",
        "es": "Retracción",
        "de": "Zug zurücknehmen",
        "fr": "Retourner un coup",
        "it": "Riprendi mossa",
        "pt": "Desfazer lance",
        "sv": "Ta tillbaka"
    },
    {
        "en": "Replay",
        "es": "Repetir",
        "de": "Wiederholen",
        "fr": "Rejouer",
        "it": "Riprova",
        "pt": "Reproduzir",
        "sv": "Spela om"
    },
    {
        "en": "Engine for Opponent",
        "es": "Motor para el oponente",
        "de": "Engine als Gegner",
        "fr": "Moteur pour l'adversaire",
        "it": "Motore come avversario",
        "pt": "Motor como oponente",
        "sv": "Motståndarmotor"
    },
    {
        "en": "Engine Strength",
        "es": "Fuerza del motor",
        "de": "Engine-Stärke",
        "fr": "Puissance du moteur",
        "it": "Forza del motore",
        "pt": "Força do motor",
        "sv": "Motorstyrka"
    },
    {
        "en": "Color You Play",
        "es": "Color que juegas",
        "de": "Farbe, die du spielst",
        "fr": "Couleur que vous jouez",
        "it": "Colore che giochi",
        "pt": "Cor que você joga",
        "sv": "Färg du spelar"
    },
    {
        "en": "Takeback Time Delay",
        "es": "Retardo para retractaciones",
        "de": "Verzögerung für Takeback",
        "fr": "Délai pour takeback",
        "it": "Ritardo tempo ripresa mossa",
        "pt": "Atraso no desfazer lance",
        "sv": "Fördröjning för takeback"
    },
    {
        "en": "Reveal Board",
        "es": "Revelar tablero",
        "de": "Brett aufdecken",
        "fr": "Révéler le plateau",
        "it": "Rivela la scacchiera",
        "pt": "Revelar tabuleiro",
        "sv": "Visa bräde"
    },
    {
        "en": "Skill",
        "es": "Nivel",
        "de": "Skill",
        "fr": "Compétence",
        "it": "Abilità",
        "pt": "Habilidade",
        "sv": "Färdighet"
    },
    {
        "en": "Never Reveal Board",
        "es": "Nunca revelar tablero",
        "de": "Brett nie aufdecken",
        "fr": "Ne jamais révéler le plateau",
        "it": "Mai rivelare la scacchiera",
        "pt": "Nunca revelar o tabuleiro",
        "sv": "Visa aldrig brädet"
    },
    {
        "en": "Reveal Every",
        "es": "Revelar cada",
        "de": "Alle ... aufdecken",
        "fr": "Révéler tous les",
        "it": "Rivela ogni",
        "pt": "Revelar a cada",
        "sv": "Visa var"
    },
    {
        "en": "Regular Pieces",
        "es": "Piezas normales",
        "de": "Normale Figuren",
        "fr": "Pièces régulières",
        "it": "Pezzi regolari",
        "pt": "Peças regulares",
        "sv": "Vanliga pjäser"
    },
    {
        "en": "Blindfold Difficulty",
        "es": "Dificultad a ciegas",
        "de": "Blindschach-Schwierigkeit",
        "fr": "Difficulté aveugle",
        "it": "Difficoltà bendato",
        "pt": "Dificuldade blindfold",
        "sv": "Blindfold-svårighet"
    },
    {
        "en": "Best To Start",
        "es": "Mejor empezar",
        "de": "Am besten starten",
        "fr": "Mieux vaut commencer",
        "it": "Meglio iniziare",
        "pt": "Melhor começar",
        "sv": "Bäst att börja"
    },
    {
        "en": "Engine Strength (Skill)",
        "es": "Fuerza del motor (nivel)",
        "de": "Engine-Stärke (Skill)",
        "fr": "Force du moteur (compétence)",
        "it": "Forza motore (abilità)",
        "pt": "Força do motor (habilidade)",
        "sv": "Motorstyrka (nivå)"
    },
    {
        "en": "Play as White",
        "es": "Jugar como blancas",
        "de": "Als Weiß spielen",
        "fr": "Jouer avec les blancs",
        "it": "Gioca con Bianco",
        "pt": "Jogar como brancas",
        "sv": "Spela som vit"
    },
    {
        "en": "Play as Black",
        "es": "Jugar como negras",
        "de": "Als Schwarz spielen",
        "fr": "Jouer avec les noirs",
        "it": "Gioca con Nero",
        "pt": "Jogar como negras",
        "sv": "Spela som svart"
    },
    {
        "en": "sec",
        "es": "seg",
        "de": "Sek",
        "fr": "s",
        "it": "sec",
        "pt": "seg",
        "sv": "sek"
    },
    {
        "en": "Reveal Board every # of Moves",
        "es": "Revelar tablero cada # de jugadas",
        "de": "Brett alle # Züge aufdecken",
        "fr": "Révéler le plateau tous les # coups",
        "it": "Rivela la scacchiera ogni # mosse",
        "pt": "Revelar tabuleiro a cada # de lances",
        "sv": "Visa brädet var # drag"
    },
    {
        "en": "Unknown",
        "es": "Desconocido",
        "de": "Unbekannt",
        "fr": "Inconnu",
        "it": "Sconosciuto",
        "pt": "Desconhecido",
        "sv": "Okänt"
    },
    {
        "en": "Using",
        "es": "Usando",
        "de": "Verwendet",
        "fr": "Utilisation de",
        "it": "Usando",
        "pt": "Usando",
        "sv": "Använder"
    },
    {
        "en": "Engine",
        "es": "Motor",
        "de": "Engine",
        "fr": "Moteur",
        "it": "Motore",
        "pt": "Motor",
        "sv": "Motor"
    },
    {
        "en": "Takeback Time",
        "es": "Tiempo de retractación",
        "de": "Takeback-Zeit",
        "fr": "Temps de retour",
        "it": "Tempo ripresa mossa",
        "pt": "Tempo de desfazer lance",
        "sv": "Takeback-tid"
    },
    {
        "en": "End Game",
        "es": "Finalizar partida",
        "de": "Spiel beenden",
        "fr": "Fin de partie",
        "it": "Termina partita",
        "pt": "Final de jogo",
        "sv": "Avsluta spel"
    },
    {
        "en": "Do you want to end the current game?",
        "es": "¿Quieres terminar la partida actual?",
        "de": "Möchtest du die aktuelle Partie beenden?",
        "fr": "Voulez-vous terminer la partie en cours ?",
        "it": "Vuoi terminare la partita corrente?",
        "pt": "Deseja encerrar a partida atual?",
        "sv": "Vill du avsluta det aktuella partiet?"
    },
    {
        "en": "White's Move",
        "es": "Juegan las blancas",
        "de": "Weiß am Zug",
        "fr": "Coup des blancs",
        "it": "Mossa del Bianco",
        "pt": "Lance das brancas",
        "sv": "Vits drag"
    },
    {
        "en": "Black's Move",
        "es": "Juegan las negras",
        "de": "Schwarz am Zug",
        "fr": "Coup des noirs",
        "it": "Mossa del Nero",
        "pt": "Lance das negras",
        "sv": "Svarts drag"
    },
    {
        "en": "Last",
        "es": "Último",
        "de": "Letzter",
        "fr": "Dernier",
        "it": "Ultima",
        "pt": "Último",
        "sv": "Sista"
    },
    {
        "en": "Game Over",
        "es": "Partida terminada",
        "de": "Spiel vorbei",
        "fr": "Partie terminée",
        "it": "Partita finita",
        "pt": "Fim de jogo",
        "sv": "Partiet slut"
    },
    {
        "en": "New Game",
        "es": "Nueva partida",
        "de": "Neue Partie",
        "fr": "Nouvelle partie",
        "it": "Nuova partita",
        "pt": "Nova partida",
        "sv": "Nytt parti"
    },
    {
        "en": "Make Move",
        "es": "Realizar jugada",
        "de": "Zug machen",
        "fr": "Effectuer le coup",
        "it": "Esegui mossa",
        "pt": "Fazer lance",
        "sv": "Gör drag"
    },
    {
        "en": "Download Games",
        "es": "Descargar partidas",
        "de": "Partien herunterladen",
        "fr": "Télécharger les parties",
        "it": "Scarica partite",
        "pt": "Baixar partidas",
        "sv": "Ladda ner partier"
    },
    {
        "en": "Game",
        "es": "Partida",
        "de": "Partie",
        "fr": "Partie",
        "it": "Partita",
        "pt": "Partida",
        "sv": "Parti"
    },
    {
        "en": "Not Blind",
        "es": "No a ciegas",
        "de": "Nicht blind",
        "fr": "Pas en aveugle",
        "it": "Non bendato",
        "pt": "Não blindfold",
        "sv": "Inte blindfold"
    },
    {
        "en": "Disc",
        "es": "Disco",
        "de": "Scheibe",
        "fr": "Disque",
        "it": "Disco",
        "pt": "Disco",
        "sv": "Bricka"
    },
    {
        "en": "Discs",
        "es": "Discos",
        "de": "Scheiben",
        "fr": "Disques",
        "it": "Dischi",
        "pt": "Discos",
        "sv": "Brickor"
    },
    {
        "en": "Your Move",
        "es": "Tu jugada",
        "de": "Dein Zug",
        "fr": "Votre coup",
        "it": "La tua mossa",
        "pt": "Seu lance",
        "sv": "Ditt drag"
    },
    {
        "en": "Continue Game?",
        "es": "¿Continuar la partida?",
        "de": "Partie fortsetzen?",
        "fr": "Continuer la partie ?",
        "it": "Continuare la partita?",
        "pt": "Continuar a partida?",
        "sv": "Fortsätt partiet?"
    },
    {
        "en": "Play Computer",
        "es": "Jugar contra la computadora",
        "de": "Gegen Computer spielen",
        "fr": "Jouer contre l'ordinateur",
        "it": "Gioca contro il computer",
        "pt": "Jogar contra o computador",
        "sv": "Spela mot datorn"
    },
    {
        "en": "Play Blindfold",
        "es": "Jugar a ciegas",
        "de": "Blind spielen",
        "fr": "Jouer en aveugle",
        "it": "Gioca bendato",
        "pt": "Jogar blindfold",
        "sv": "Spela blindfold"
    },
    {
        "en": "Game History",
        "es": "Historial de la partida",
        "de": "Partie-Verlauf",
        "fr": "Historique des parties",
        "it": "Cronologia partite",
        "pt": "Histórico de partidas",
        "sv": "Partihistorik"
    },
    {
        "en": "Legacy Repertoires",
        "es": "Repertorios antiguos",
        "de": "Legacy-Repertoires",
        "fr": "Répertoires hérités",
        "it": "Repertori legacy",
        "pt": "Repertórios legados",
        "sv": "Arv-repertoarer"
    },
    {
        "en": "Time Period",
        "es": "Periodo de tiempo",
        "de": "Zeitraum",
        "fr": "Période",
        "it": "Periodo di tempo",
        "pt": "Período",
        "sv": "Tidsperiod"
    },
    {
        "en": "Puzzle Type",
        "es": "Tipo de puzzle",
        "de": "Rätsel-Typ",
        "fr": "Type de problème",
        "it": "Tipo di puzzle",
        "pt": "Tipo de problema",
        "sv": "Pusstyp"
    },
    {
        "en": "Timed Speed",
        "es": "Velocidad cronometrada",
        "de": "Zeitmodus",
        "fr": "Vitesse chronométrée",
        "it": "Velocità a tempo",
        "pt": "Velocidade cronometrada",
        "sv": "Tidsinställd hastighet"
    },
    {
        "en": "Visualize Moves",
        "es": "Visualizar jugadas",
        "de": "Züge visualisieren",
        "fr": "Visualiser les coups",
        "it": "Visualizza mosse",
        "pt": "Visualizar lances",
        "sv": "Visualisera drag"
    },
    {
        "en": "Select Time Period",
        "es": "Selecciona periodo de tiempo",
        "de": "Zeitraum wählen",
        "fr": "Sélectionner la période",
        "it": "Seleziona periodo",
        "pt": "Selecionar período",
        "sv": "Välj tidsperiod"
    },
    {
        "en": "For Timed Puzzles, Select Speed(s)",
        "es": "Para puzzles cronometrados, selecciona velocidad(es)",
        "de": "Für zeitbegrenzte Rätsel Geschwindigkeit(en) wählen",
        "fr": "Pour problèmes chronométrés, sélectionnez la\/les vitesse(s)",
        "it": "Per puzzle a tempo, seleziona la\/le velocità",
        "pt": "Para problemas cronometrados, selecione velocidade(s)",
        "sv": "För tidspussel, välj hastighet(er)"
    },
    {
        "en": "Select Puzzle Type(s)",
        "es": "Selecciona tipo(s) de puzzle",
        "de": "Rätseltyp(en) wählen",
        "fr": "Sélectionnez le(s) type(s) de problème",
        "it": "Seleziona il\/i tipo\/i di puzzle",
        "pt": "Selecione tipo(s) de problema",
        "sv": "Välj pusseltyp(er)"
    },
    {
        "en": "For Visualized Puzzles, Select # of Moves",
        "es": "Para puzzles visualizados, selecciona # de jugadas",
        "de": "Für visualisierte Rätsel # Züge auswählen",
        "fr": "Pour problèmes visualisés, sélectionnez le # de coups",
        "it": "Per puzzle visualizzati, seleziona # mosse",
        "pt": "Para problemas visualizados, selecione # de lances",
        "sv": "För visualiserade pussel, välj antal drag"
    },
    {
        "en": "days",
        "es": "días",
        "de": "Tage",
        "fr": "jours",
        "it": "giorni",
        "pt": "dias",
        "sv": "dagar"
    },
    {
        "en": "months",
        "es": "meses",
        "de": "Monate",
        "fr": "mois",
        "it": "mesi",
        "pt": "meses",
        "sv": "månader"
    },
    {
        "en": "Regular",
        "es": "Regular",
        "de": "Normal",
        "fr": "Régulier",
        "it": "Regolare",
        "pt": "Regular",
        "sv": "Vanligt"
    },
    {
        "en": "Visualized",
        "es": "Visualizado",
        "de": "Visualisiert",
        "fr": "Visualisé",
        "it": "Visualizzato",
        "pt": "Visualizado",
        "sv": "Visualiserat"
    },
    {
        "en": "Secs",
        "es": "Segs",
        "de": "Sek",
        "fr": "s",
        "it": "Sec",
        "pt": "Seg",
        "sv": "Sek"
    },
    {
        "en": "Visualize half move",
        "es": "Visualizar medio movimiento",
        "de": "Halben Zug visualisieren",
        "fr": "Visualiser demi-coup",
        "it": "Visualizza mezza mossa",
        "pt": "Visualizar meio-movimento",
        "sv": "Visualisera halvdrag"
    },
    {
        "en": "Time",
        "es": "Tiempo",
        "de": "Zeit",
        "fr": "Temps",
        "it": "Tempo",
        "pt": "Tempo",
        "sv": "Tid"
    },
    {
        "en": "Do Over",
        "es": "Reintentar",
        "de": "Nochmals",
        "fr": "Recommencer",
        "it": "Rifare",
        "pt": "Refazer",
        "sv": "Gör om"
    },
    {
        "en": "Visualize 1 move",
        "es": "Visualizar 1 jugada",
        "de": "1 Zug visualisieren",
        "fr": "Visualiser 1 coup",
        "it": "Visualizza 1 mossa",
        "pt": "Visualizar 1 lance",
        "sv": "Visualisera 1 drag"
    },
    {
        "en": "Lifetime",
        "es": "De por vida",
        "de": "Lebensdauer",
        "fr": "Durée de vie",
        "it": "A vita",
        "pt": "Tempo de vida",
        "sv": "Livstid"
    },
    {
        "en": "Loading Open Game List",
        "es": "Cargando lista de partidas abiertas",
        "de": "Offene Partien-Liste wird geladen",
        "fr": "Chargement de la liste des parties ouvertes",
        "it": "Caricamento lista partite aperte",
        "pt": "Carregando lista de partidas abertas",
        "sv": "Läser in listan över öppna partier"
    },
    {
        "en": "No Open Games",
        "es": "No hay partidas abiertas",
        "de": "Keine offenen Partien",
        "fr": "Aucune partie ouverte",
        "it": "Nessuna partita aperta",
        "pt": "Sem partidas abertas",
        "sv": "Inga öppna partier"
    },
    {
        "en": "Goto Game",
        "es": "Ir a la partida",
        "de": "Zur Partie gehen",
        "fr": "Aller à la partie",
        "it": "Vai alla partita",
        "pt": "Ir para a partida",
        "sv": "Gå till parti"
    },
    {
        "en": "Refresh",
        "es": "Actualizar",
        "de": "Aktualisieren",
        "fr": "Actualiser",
        "it": "Aggiorna",
        "pt": "Atualizar",
        "sv": "Uppdatera"
    },
    {
        "en": "rated",
        "es": "clasificadas",
        "de": "gewertet",
        "fr": "classée",
        "it": "classificata",
        "pt": "ranqueada",
        "sv": "rankat"
    },
    {
        "en": "casual",
        "es": "informales",
        "de": "ungezwungen",
        "fr": "amicale",
        "it": "amichevole",
        "pt": "casual",
        "sv": "vänskapligt"
    },
    {
        "en": "correspondence",
        "es": "correspondencia",
        "de": "Korrespondenz",
        "fr": "correspondance",
        "it": "corrispondenza",
        "pt": "correspondência",
        "sv": "korrespondens"
    },
    {
        "en": "rapid",
        "es": "rápidas",
        "de": "Blitz",
        "fr": "rapide",
        "it": "rapida",
        "pt": "rápida",
        "sv": "blixt"
    },
    {
        "en": "classical",
        "es": "clásicas",
        "de": "Klassisch",
        "fr": "classique",
        "it": "classica",
        "pt": "clássica",
        "sv": "klassiskt"
    },
    {
        "en": "Resign",
        "es": "Rendirse",
        "de": "Aufgeben",
        "fr": "Abandonner",
        "it": "Rinuncia",
        "pt": "Desistir",
        "sv": "Ge upp"
    },
    {
        "en": "Goto Open List",
        "es": "Ir a la lista de abiertas",
        "de": "Zur offenen Liste gehen",
        "fr": "Aller à la liste ouverte",
        "it": "Vai alla lista aperte",
        "pt": "Ir para lista de abertas",
        "sv": "Gå till öppna listan"
    },
    {
        "en": "Abort",
        "es": "Abortar",
        "de": "Abbrechen",
        "fr": "Avorter",
        "it": "Interrompi",
        "pt": "Abortar",
        "sv": "Avbryt"
    },
    {
        "en": "Not Timed",
        "es": "Sin tiempo",
        "de": "Nicht zeitgesteuert",
        "fr": "Non chronométrée",
        "it": "Senza tempo",
        "pt": "Sem tempo",
        "sv": "Ej tidsatt"
    },
    {
        "en": "Waiting",
        "es": "Esperando",
        "de": "Wartend",
        "fr": "En attente",
        "it": "In attesa",
        "pt": "Aguardando",
        "sv": "Väntar"
    },
    {
        "en": "Winner",
        "es": "Ganador",
        "de": "Gewinner",
        "fr": "Gagnant",
        "it": "Vincitore",
        "pt": "Vencedor",
        "sv": "Vinnare"
    },
    {
        "en": "Challenge",
        "es": "Desafío",
        "de": "Herausforderung",
        "fr": "Défi",
        "it": "Sfida",
        "pt": "Desafio",
        "sv": "Utmana"
    },
    {
        "en": "Challenge Expired.  Send Again",
        "es": "Desafío caducado. Enviar de nuevo",
        "de": "Herausforderung abgelaufen. Erneut senden",
        "fr": "Défi expiré. Renvoyer",
        "it": "Sfida scaduta. Invia di nuovo",
        "pt": "Desafio expirou. Enviar novamente",
        "sv": "Utmaning utgånget. Skicka igen"
    },
    {
        "en": "When Challenge Accepted, it will be in your 'Open Games' list",
        "es": "Cuando se acepte el desafío, aparecerá en tu lista 'Partidas abiertas'",
        "de": "Wenn die Herausforderung angenommen wird, erscheint sie in deinen 'Offenen Partien'",
        "fr": "Quand le défi est accepté, il apparaîtra dans votre liste 'Parties ouvertes'",
        "it": "Quando la sfida viene accettata, sarà nella tua lista 'Partite aperte'",
        "pt": "Quando o desafio for aceito, ficará na sua lista 'Partidas Abertas'",
        "sv": "När utmaningen accepteras hamnar den i 'Öppna partier'"
    },
    {
        "en": "Challenge Declined",
        "es": "Desafío rechazado",
        "de": "Herausforderung abgelehnt",
        "fr": "Défi refusé",
        "it": "Sfida rifiutata",
        "pt": "Desafio recusado",
        "sv": "Utmaning avvisad"
    },
    {
        "en": "Challenge Accepted",
        "es": "Desafío aceptado",
        "de": "Herausforderung angenommen",
        "fr": "Défi accepté",
        "it": "Sfida accettata",
        "pt": "Desafio aceito",
        "sv": "Utmaning accepterad"
    },
    {
        "en": "No Response",
        "es": "Sin respuesta",
        "de": "Keine Antwort",
        "fr": "Pas de réponse",
        "it": "Nessuna risposta",
        "pt": "Sem resposta",
        "sv": "Inget svar"
    },
    {
        "en": "Resign Game?",
        "es": "¿Rendirse en la partida?",
        "de": "Partie aufgeben?",
        "fr": "Voulez-vous abandonner la partie ?",
        "it": "Vuoi abbandonare la partita?",
        "pt": "Deseja desistir da partida?",
        "sv": "Vill du ge upp partiet?"
    },
    {
        "en": "Do you want to resign the game?",
        "es": "¿Quieres rendirte en la partida?",
        "de": "Möchtest du die Partie aufgeben?",
        "fr": "Souhaitez-vous abandonner la partie ?",
        "it": "Vuoi rinunciare alla partita?",
        "pt": "Deseja desistir da partida?",
        "sv": "Vill du ge upp det här partiet?"
    },
    {
        "en": "Issue Challenge",
        "es": "Enviar desafío",
        "de": "Herausforderung aussprechen",
        "fr": "Lancer un défi",
        "it": "Lancia sfida",
        "pt": "Lançar desafio",
        "sv": "Skicka utmaning"
    },
    {
        "en": "Challenge Issued",
        "es": "Desafío enviado",
        "de": "Herausforderung gesendet",
        "fr": "Défi lancé",
        "it": "Sfida inviata",
        "pt": "Desafio enviado",
        "sv": "Utmaning skickad"
    },
    {
        "en": "Rated Game?",
        "es": "¿Partida con clasificación?",
        "de": "Gewertete Partie?",
        "fr": "Partie classée ?",
        "it": "Partita valutata?",
        "pt": "Partida ranqueada?",
        "sv": "Rankat parti?"
    },
    {
        "en": "'Rapid' Pairing",
        "es": "Emparejamiento 'rápido'",
        "de": "'Blitz'-Paarung",
        "fr": "Appariement 'Rapide'",
        "it": "Abbinamento 'Rapido'",
        "pt": "'Par de Rápidas'",
        "sv": "'Rapid'-parning"
    },
    {
        "en": "'Correspondence' Pairing",
        "es": "Emparejamiento 'correspondencia'",
        "de": "'Korrespondenz'-Paarung",
        "fr": "Appariement 'Correspondance'",
        "it": "'Corrispondenza' abbinamento",
        "pt": "'Par de Correspondência'",
        "sv": "'Korrespondens'-parning"
    },
    {
        "en": "Challenge Friend",
        "es": "Desafiar a un amigo",
        "de": "Freund herausfordern",
        "fr": "Défier un ami",
        "it": "Sfida un amico",
        "pt": "Desafiar amigo",
        "sv": "Utmana vän"
    },
    {
        "en": "Arena Tournaments",
        "es": "Torneos Arena",
        "de": "Arena-Turniere",
        "fr": "Tournois Arena",
        "it": "Tornei Arena",
        "pt": "Torneios Arena",
        "sv": "Arena-turneringar"
    },
    {
        "en": "Open Game List",
        "es": "Lista de partidas abiertas",
        "de": "Offene Partien-Liste",
        "fr": "Liste des parties ouvertes",
        "it": "Lista partite aperte",
        "pt": "Lista de partidas abertas",
        "sv": "Lista öppna partier"
    },
    {
        "en": "Connect to Lichess (do first)",
        "es": "Conectar a Lichess (hacer primero)",
        "de": "Mit Lichess verbinden (zuerst)",
        "fr": "Connecter à Lichess (faire d'abord)",
        "it": "Connettiti a Lichess (prima fallo)",
        "pt": "Conectar ao Lichess (faça primeiro)",
        "sv": "Anslut till Lichess (gör först)"
    },
    {
        "en": "Disconnect",
        "es": "Desconectar",
        "de": "Trennen",
        "fr": "Déconnecter",
        "it": "Disconnetti",
        "pt": "Desconectar",
        "sv": "Koppla bort"
    },
    {
        "en": "Lichess Play (Web)",
        "es": "Jugar en Lichess (Web)",
        "de": "Lichess spielen (Web)",
        "fr": "Jeu Lichess (Web)",
        "it": "Gioca su Lichess (Web)",
        "pt": "Jogar no Lichess (Web)",
        "sv": "Lichess-spel (web)"
    },
    {
        "en": "You're Off-line",
        "es": "Estás sin conexión",
        "de": "Du bist offline",
        "fr": "Vous êtes hors ligne",
        "it": "Sei offline",
        "pt": "Você está offline",
        "sv": "Du är offline"
    },
    {
        "en": "That program is only available when on-line",
        "es": "Ese programa solo está disponible en línea",
        "de": "Dieses Programm ist nur online verfügbar",
        "fr": "Ce programme est disponible uniquement en ligne",
        "it": "Questa funzione è disponibile solo online",
        "pt": "Esse recurso só está disponível online",
        "sv": "Det här programmet kräver internet"
    },
    {
        "en": "Repertoire Import",
        "es": "Importar repertorio",
        "de": "Repertoire-Import",
        "fr": "Import de répertoire",
        "it": "Importa repertorio",
        "pt": "Importar repertório",
        "sv": "Repertoarimport"
    },
    {
        "en": "The drag&drop functionality requires the web version. After import, the repertoires can be used on your mobile device",
        "es": "La función arrastrar&soltar requiere la versión web. Tras importar, los repertorios se pueden usar en tu móvil",
        "de": "Drag&Drop funktioniert nur in der Webversion. Nach dem Import sind die Repertoires auf deinem mobilen Gerät nutzbar",
        "fr": "La fonction glisser-déposer nécessite la version web. Après import, les répertoires peuvent être utilisés sur mobile",
        "it": "La funzionalità drag&drop richiede la versione web. Dopo l'importazione, i repertori possono essere usati sul tuo dispositivo mobile",
        "pt": "A funcionalidade arrastar e soltar exige a versão web. Após importar, os repertórios podem ser usados no dispositivo móvel",
        "sv": "Drag & drop kräver webbversionen. Efter import kan repertoarerna användas i mobilen"
    },
    {
        "en": "Connect to Lichess",
        "es": "Conectar a Lichess",
        "de": "Mit Lichess verbinden",
        "fr": "Se connecter à Lichess",
        "it": "Connettiti a Lichess",
        "pt": "Conectar ao Lichess",
        "sv": "Anslut till Lichess"
    },
    {
        "en": "That program requires that you've connected to lichess and given Chessvis permission to play on your behalf",
        "es": "Ese programa requiere que te conectes a Lichess y des permiso a Chessvis para jugar en tu nombre",
        "de": "Dieses Programm benötigt, dass du dich mit Lichess verbunden und Chessvis die Erlaubnis zum Spielen erteilt hast",
        "fr": "Ce programme nécessite que vous soyez connecté à Lichess et ayez autorisé Chessvis à jouer en votre nom",
        "it": "Questa funzione richiede che ti sia connesso a Lichess e che tu abbia dato a Chessvis il permesso di giocare per tuo conto",
        "pt": "Esse recurso exige que você esteja conectado ao Lichess e tenha dado permissão ao Chessvis para jogar em seu nome",
        "sv": "Programmet kräver att du anslutit till Lichess och gett Chessvis rätt att spela åt dig"
    },
    {
        "en": "Become A Subscriber?",
        "es": "¿Hacerse suscriptor?",
        "de": "Abonnent werden?",
        "fr": "Devenir abonné ?",
        "it": "Diventare abbonato?",
        "pt": "Tornar-se assinante?",
        "sv": "Bli prenumerant?"
    },
    {
        "en": "That program is reserved for subscribers. Would you like to read about the benefits of subscribing?",
        "es": "Ese programa está reservado a suscriptores. ¿Quieres leer los beneficios de suscribirte?",
        "de": "Dieses Programm ist Abonnenten vorbehalten. Möchtest du die Abo-Vorteile ansehen?",
        "fr": "Ce programme est réservé aux abonnés. Voulez-vous lire les avantages de l'abonnement ?",
        "it": "Questa funzione è riservata agli abbonati. Vuoi leggere i vantaggi dell'abbonamento?",
        "pt": "Esse recurso é reservado para assinantes. Deseja ler sobre os benefícios da assinatura?",
        "sv": "Detta är för prenumeranter. Vill du läsa om fördelarna?"
    },
    {
        "en": "Disconnect From Lichess?",
        "es": "¿Desconectar de Lichess?",
        "de": "Von Lichess trennen?",
        "fr": "Se déconnecter de Lichess ?",
        "it": "Disconnettersi da Lichess?",
        "pt": "Desconectar do Lichess?",
        "sv": "Koppla från Lichess?"
    },
    {
        "en": "Yes - Disconnect",
        "es": "Sí - Desconectar",
        "de": "Ja – trennen",
        "fr": "Oui - Déconnecter",
        "it": "Sì - Disconnetti",
        "pt": "Sim - desconectar",
        "sv": "Ja - koppla från"
    },
    {
        "en": "You have been Disconnected from Lichess.org",
        "es": "Has sido desconectado de Lichess.org",
        "de": "Du wurdest von Lichess.org getrennt",
        "fr": "Vous avez été déconnecté de Lichess.org",
        "it": "Sei stato disconnesso da Lichess.org",
        "pt": "Você foi desconectado do Lichess.org",
        "sv": "Du har kopplats från Lichess.org"
    },
    {
        "en": "Connect",
        "es": "Conectar",
        "de": "Verbinden",
        "fr": "Connecter",
        "it": "Connetti",
        "pt": "Conectar",
        "sv": "Anslut"
    },
    {
        "en": "Click 'Connect' to bring up a lichess.org screen where you'll tell Lichess that this program has permission to play using your Lichess account.<p>Note: when you 'Connect' it will say the request is coming from Chessvis and that's okay.<p>Click 'Refresh' after connecting to load the access token",
        "es": "Pulsa 'Conectar' para abrir una pantalla de lichess.org donde le darás permiso al programa para jugar con tu cuenta. <p>Nota: al 'Conectar' aparecerá que la petición viene de Chessvis y está bien. <p>Pulsa 'Actualizar' después de conectar para cargar el token de acceso",
        "de": "Klicke 'Verbinden', um ein lichess.org-Fenster zu öffnen, in dem du Lichess die Erlaubnis gibst, mit deinem Konto zu spielen.<p>Hinweis: Beim Verbinden steht, die Anfrage kommt von Chessvis – das ist korrekt.<p>Klicke nach dem Verbinden auf 'Aktualisieren', um das Zugangstoken zu laden",
        "fr": "Cliquez 'Connecter' pour ouvrir une fenêtre lichess.org où vous autoriserez ce programme à jouer avec votre compte. Remarque : lorsqu'il dira que la requête vient de Chessvis, c'est normal. Cliquez 'Actualiser' après la connexion pour charger le jeton d'accès.",
        "it": "Clicca 'Connetti' per aprire la schermata di Lichess.org dove darai a Lichess il permesso di usare il tuo account per giocare.<p>Nota: quando clicchi 'Connetti' apparirà che la richiesta arriva da Chessvis ed è normale.<p>Clicca 'Aggiorna' dopo la connessione per caricare il token di accesso",
        "pt": "Clique em 'Conectar' para abrir uma tela do lichess.org onde você autorizará o programa a jogar usando sua conta do Lichess.<p>Obs.: ao 'Conectar' aparecerá que a solicitação vem do Chessvis — isso é normal.<p>Após conectar, clique em 'Atualizar' para carregar o token de acesso",
        "sv": "Klicka 'Anslut' för att öppna Lichess där du ger programmet tillåtelse att spela via ditt konto. Obs: det kan stå att förfrågan kommer från Chessvis — det är OK. Klicka 'Uppdatera' efter anslutning för att hämta access-token"
    },
    {
        "en": "You are connected to Lichess<p>If the connection isn't working, try 'Disconnecting' and then 'Connecting' again",
        "es": "Estás conectado a Lichess<p>Si la conexión falla, prueba a 'Desconectar' y luego 'Conectar' de nuevo",
        "de": "Du bist mit Lichess verbunden<p>Wenn die Verbindung nicht funktioniert, versuche 'Trennen' und dann erneut 'Verbinden'",
        "fr": "Vous êtes connecté à Lichess. Si la connexion ne fonctionne pas, essayez de vous déconnecter puis de reconnecter.",
        "it": "Sei connesso a Lichess<p>Se la connessione non funziona, prova a 'Disconnettere' e poi a 'Connettere' di nuovo",
        "pt": "Você está conectado ao Lichess<p>Se a conexão não estiver funcionando, tente 'Desconectar' e depois 'Conectar' novamente",
        "sv": "Du är ansluten till Lichess. Om anslutningen strular, koppla från och anslut igen"
    },
    {
        "en": "Select Online Friend",
        "es": "Seleccionar amigo en línea",
        "de": "Online-Freund wählen",
        "fr": "Sélectionnez un ami en ligne",
        "it": "Seleziona amico online",
        "pt": "Selecionar amigo online",
        "sv": "Välj online-vän"
    },
    {
        "en": "On",
        "es": "Activado",
        "de": "An",
        "fr": "Activé",
        "it": "Attivo",
        "pt": "Ativado",
        "sv": "På"
    },
    {
        "en": "Off",
        "es": "Desactivado",
        "de": "Aus",
        "fr": "Désactivé",
        "it": "Disattivo",
        "pt": "Desativado",
        "sv": "Av"
    },
    {
        "en": "Rated",
        "es": "Clasificadas",
        "de": "Gewertet",
        "fr": "Classé",
        "it": "Classificato",
        "pt": "Ranqueado",
        "sv": "Rankat"
    },
    {
        "en": "Random Color",
        "es": "Color aleatorio",
        "de": "Zufällige Farbe",
        "fr": "Couleur aléatoire",
        "it": "Colore casuale",
        "pt": "Cor aleatória",
        "sv": "Slumpmässig färg"
    },
    {
        "en": "minutes",
        "es": "minutos",
        "de": "Minuten",
        "fr": "minutes",
        "it": "minuti",
        "pt": "minutos",
        "sv": "minuter"
    },
    {
        "en": "no increment",
        "es": "sin incremento",
        "de": "keine Inkrement",
        "fr": "sans incrément",
        "it": "nessun incremento",
        "pt": "sem incremento",
        "sv": "ingen increment"
    },
    {
        "en": "sec increment",
        "es": "incremento (seg)",
        "de": "Sek-Inkrement",
        "fr": "incrément s",
        "it": "incremento sec",
        "pt": "incremento (seg)",
        "sv": "sek increment"
    },
    {
        "en": "Rapid Challenge",
        "es": "Desafío rápido",
        "de": "Blitz-Herausforderung",
        "fr": "Défi rapide",
        "it": "Sfida rapida",
        "pt": "Desafio rápido",
        "sv": "Rapid-utmaning"
    },
    {
        "en": "Correspondence Challenge",
        "es": "Desafío por correspondencia",
        "de": "Korrespondenz-Herausforderung",
        "fr": "Défi correspondance",
        "it": "Sfida in corrispondenza",
        "pt": "Desafio por correspondência",
        "sv": "Korrespondensutmaning"
    },
    {
        "en": "BOT Challenge",
        "es": "Desafío BOT",
        "de": "BOT-Herausforderung",
        "fr": "Défi BOT",
        "it": "Sfida BOT",
        "pt": "Desafio BOT",
        "sv": "BOT-utmaning"
    },
    {
        "en": "Apple Subscriber: You can manage your subscriptions on your IOS device, go to Settings -> Subscriptions.",
        "es": "Suscriptor Apple: puedes gestionar tus suscripciones en tu dispositivo iOS en Ajustes -> Suscripciones.",
        "de": "Apple-Abonnenten: Verwalte Abos auf deinem iOS-Gerät unter Einstellungen -> Abonnements.",
        "fr": "Abonné Apple : gérez vos abonnements sur iOS via Réglages -> Abonnements.",
        "it": "Abbonato Apple: puoi gestire gli abbonamenti sul tuo dispositivo iOS, vai su Impostazioni -> Abbonamenti.",
        "pt": "Assinante Apple: você pode gerenciar suas assinaturas no iOS em Ajustes -> Assinaturas.",
        "sv": "Apple-prenumerant: Hantera prenumerationer i iOS: Inställningar → Prenumerationer."
    },
    {
        "en": "Google Subscriber: You can manage your subscriptions in the Google Play Store, tap on your profile icon, tap Payments & subscriptions.",
        "es": "Suscriptor Google: gestiona tus suscripciones en Google Play Store, toca tu icono de perfil -> Pagos y suscripciones.",
        "de": "Google-Abonnenten: Verwalte Abos im Google Play Store über dein Profil -> Zahlungen & Abos.",
        "fr": "Abonné Google : gérez vos abonnements dans le Play Store Google via votre profil -> Paiements & abonnements.",
        "it": "Abbonato Google: puoi gestire gli abbonamenti nel Google Play Store, tocca l'icona del profilo, poi Pagamenti e abbonamenti.",
        "pt": "Assinante Google: gerencie suas assinaturas na Google Play Store, toque no ícone do perfil -> Pagamentos e assinaturas.",
        "sv": "Google-prenumerant: Hantera prenumerationer i Google Play: tryck på profilen → Betalningar & prenumerationer."
    },
    {
        "en": "Web (Stripe) Subscriber: Email me and I will cancel the subscription",
        "es": "Suscriptor Web (Stripe): envíame un email y cancelaré la suscripción",
        "de": "Web (Stripe)-Abonnenten: Schick mir eine E-Mail und ich storniere das Abo",
        "fr": "Abonné Web (Stripe) : envoyez-moi un e-mail et j'annulerai l'abonnement",
        "it": "Abbonamento Web (Stripe): mandami una email e annullerò l'abbonamento",
        "pt": "Assinante Web (Stripe): envie-me um e-mail e eu cancelarei a assinatura",
        "sv": "Webb (Stripe)-prenumerant: mejla så kan jag avsluta prenumerationen"
    },
    {
        "en": "If you wish to have your Chessvis and Verbal Chess account deleted, the button below will send you an email which you can then reply to. Upon receipt of your reply, I will delete your account.",
        "es": "Si quieres que borrеn tu cuenta de Chessvis y Verbal Chess, el botón de abajo enviará un email al que podrás responder. Al recibir tu respuesta, borraré tu cuenta.",
        "de": "Wenn du deinen Chessvis- und Verbal Chess-Account löschen möchtest, sendet der Button unten eine E-Mail, auf die du antworten kannst. Nach Erhalt lösche ich dein Konto.",
        "fr": "Si vous souhaitez supprimer votre compte Chessvis et Verbal Chess, le bouton ci-dessous enverra un e-mail auquel vous pourrez répondre. À réception, je supprimerai votre compte.",
        "it": "Se vuoi eliminare il tuo account Chessvis e Verbal Chess, il pulsante qui sotto invierà una email a cui potrai rispondere. Alla ricezione della tua risposta eliminerò il tuo account.",
        "pt": "Se desejar excluir sua conta Chessvis e Verbal Chess, o botão abaixo enviará um e-mail para o qual você poderá responder. Ao receber sua resposta, eu excluirei sua conta.",
        "sv": "Vill du radera Chessvis- och Verbal Chess-konton skickar knappen nedan ett mejl du kan svara på — efter svar tar jag bort kontot."
    },
    {
        "en": "Send Delete Account Request Email",
        "es": "Enviar email de solicitud de borrado de cuenta",
        "de": "Löschanfrage per E-Mail senden",
        "fr": "Envoyer l'e-mail de demande de suppression",
        "it": "Invia email richiesta eliminazione account",
        "pt": "Enviar e-mail de solicitação de exclusão de conta",
        "sv": "Skicka begäran om kontoradering"
    },
    {
        "en": "Sending Delete Request Email",
        "es": "Enviando email de solicitud de borrado",
        "de": "Löschanfrage-E-Mail wird gesendet",
        "fr": "Envoi de l'e-mail de demande de suppression",
        "it": "Invio email richiesta eliminazione",
        "pt": "Enviando e-mail de solicitação de exclusão",
        "sv": "Skickar raderingsbegäran"
    },
    {
        "en": "For",
        "es": "Para",
        "de": "Für",
        "fr": "Pour",
        "it": "Per",
        "pt": "Para",
        "sv": "För"
    },
    {
        "en": "Account",
        "es": "Cuenta",
        "de": "Konto",
        "fr": "Compte",
        "it": "Account",
        "pt": "Conta",
        "sv": "Konto"
    },
    {
        "en": "Account & Support",
        "es": "Cuenta y soporte",
        "de": "Konto & Support",
        "fr": "Compte & Support",
        "it": "Account e supporto",
        "pt": "Conta & Suporte",
        "sv": "Konto & support"
    },
    {
        "en": "Signoff",
        "es": "Cerrar sesión",
        "de": "Abmelden",
        "fr": "Déconnexion",
        "it": "Disconnessione",
        "pt": "Sair",
        "sv": "Logga ut"
    },
    {
        "en": "Subscriber",
        "es": "Suscriptor",
        "de": "Abonnent",
        "fr": "Abonné",
        "it": "Abbonato",
        "pt": "Assinante",
        "sv": "Prenumerant"
    },
    {
        "en": "Subscribe",
        "es": "Suscribirse",
        "de": "Abonnieren",
        "fr": "S'abonner",
        "it": "Abbonati",
        "pt": "Assinar",
        "sv": "Prenumerera"
    },
    {
        "en": "Preferences & Language",
        "es": "Preferencias y idioma",
        "fr": "Préférences et langue",
        "de": "Einstellungen und Sprache",
        "it": "Preferenze e lingua",
        "pt": "Preferências e idioma",
        "sv": "Inställningar & språk"
    },
    {
        "en": "Preferences",
        "es": "Preferencias",
        "de": "Einstellungen",
        "fr": "Préférences",
        "it": "Preferenze",
        "pt": "Preferências",
        "sv": "Inställningar"
    },
    {
        "en": "Delete Account",
        "es": "Borrar cuenta",
        "de": "Konto löschen",
        "fr": "Supprimer le compte",
        "it": "Elimina account",
        "pt": "Excluir conta",
        "sv": "Radera konto"
    },
    {
        "en": "Cancel Subscription",
        "es": "Cancelar suscripción",
        "de": "Abo kündigen",
        "fr": "Annuler l'abonnement",
        "it": "Annulla abbonamento",
        "pt": "Cancelar assinatura",
        "sv": "Avsluta prenumeration"
    },
    {
        "en": "Videos",
        "es": "Videos",
        "de": "Videos",
        "fr": "Vidéos",
        "it": "Video",
        "pt": "Vídeos",
        "sv": "Videor"
    },
    {
        "en": "Support",
        "es": "Soporte",
        "de": "Support",
        "fr": "Support",
        "it": "Supporto",
        "pt": "Suporte",
        "sv": "Support"
    },
    {
        "en": "Welcome & App Landing",
        "es": "Bienvenido & pantalla de la app",
        "de": "Willkommen & App-Start",
        "fr": "Bienvenue & page d'accueil de l'appli",
        "it": "Benvenuto & pagina app",
        "pt": "Bem-vindo & página do app",
        "sv": "Välkommen & appens startsida"
    },
    {
        "en": "What's New",
        "es": "Novedades",
        "de": "Neuigkeiten",
        "fr": "Nouveautés",
        "it": "Novità",
        "pt": "Novidades",
        "sv": "Nyheter"
    },
    {
        "en": "Contact",
        "es": "Contacto",
        "de": "Kontakt",
        "fr": "Contact",
        "it": "Contatti",
        "pt": "Contato",
        "sv": "Kontakta"
    },
    {
        "en": "Terms of Service",
        "es": "Términos del servicio",
        "de": "Nutzungsbedingungen",
        "fr": "Conditions d'utilisation",
        "it": "Termini del servizio",
        "pt": "Termos de serviço",
        "sv": "Användarvillkor"
    },
    {
        "en": "Info",
        "es": "Información",
        "de": "Info",
        "fr": "Infos",
        "it": "Info",
        "pt": "Informações",
        "sv": "Info"
    },
    {
        "en": "Email Verification Check",
        "es": "Comprobación de verificación de email",
        "de": "E-Mail-Verifizierungsprüfung",
        "fr": "Vérification de l'e-mail",
        "it": "Verifica email",
        "pt": "Verificação de e-mail",
        "sv": "E-postverifiering"
    },
    {
        "en": "Email Verified",
        "es": "Email verificado",
        "de": "E-Mail verifiziert",
        "fr": "E-mail vérifié",
        "it": "Email verificata",
        "pt": "E-mail verificado",
        "sv": "E-post verifierad"
    },
    {
        "en": "processing email verification",
        "es": "procesando verificación de email",
        "de": "E-Mail-Verifizierung läuft",
        "fr": "vérification de l'e-mail en cours",
        "it": "verifica email in corso",
        "pt": "processando verificação de e-mail",
        "sv": "bearbetar e-postverifiering"
    },
    {
        "en": "The version 9 has all the programs under the 'Hamburger - 3 bar' icon in the upper left.",
        "es": "La versión 9 tiene todos los programas bajo el ícono 'Hamburguesa - 3 barras' en la esquina superior izquierda.",
        "de": "Version 9 hat alle Programme unter dem Hamburger - 3 Striche-Icon oben links.",
        "fr": "La version 9 regroupe tous les programmes sous l'icône 'Hamburger - 3 barres' en haut à gauche.",
        "it": "La versione 9 ha tutti i programmi sotto l'icona 'Hamburger - 3 barre' in alto a sinistra.",
        "pt": "A versão 9 reúne todos os programas no ícone Hamburger - 3 barras no canto superior esquerdo.",
        "sv": "Version 9 har alla program under 'hamburger'-ikonen (tre streck) uppe till vänster."
    },
    {
        "en": "Note: The Video menu has moved to the righthand menu.",
        "es": "Nota: el menú de Videos se ha movido al menú derecho.",
        "de": "Hinweis: Das Video-Menü wurde ins rechte Menü verschoben.",
        "fr": "Remarque : le menu Vidéos est maintenant dans le menu de droite.",
        "it": "Nota: il menu Video si è spostato nel menu a destra.",
        "pt": "Obs.: o menu Vídeos foi movido para o menu da direita.",
        "sv": "Obs: Videomenyn har flyttat till högermenyn."
    },
    {
        "en": "Signin",
        "es": "Iniciar sesión",
        "de": "Anmelden",
        "fr": "Connexion",
        "it": "Accedi",
        "pt": "Entrar",
        "sv": "Logga in"
    },
    {
        "en": "Register",
        "es": "Registrarse",
        "de": "Registrieren",
        "fr": "Inscription",
        "it": "Registrati",
        "pt": "Registrar",
        "sv": "Registrera"
    },
    {
        "en": "Please enter your email & password below",
        "es": "Introduce tu email y contraseña abajo",
        "de": "Bitte unten E-Mail & Passwort eingeben",
        "fr": "Veuillez entrer votre e-mail et mot de passe ci-dessous",
        "it": "Inserisci qui sotto la tua email e password",
        "pt": "Por favor, digite seu e-mail e senha abaixo",
        "sv": "Ange din e-post och lösenord nedan"
    },
    {
        "en": "Forgot Password?",
        "es": "¿Olvidaste la contraseña?",
        "de": "Passwort vergessen?",
        "fr": "Mot de passe oublié ?",
        "it": "Password dimenticata?",
        "pt": "Esqueceu a senha?",
        "sv": "Glömt lösenord?"
    },
    {
        "en": "Email",
        "es": "Email",
        "de": "E-Mail",
        "fr": "E-mail",
        "it": "Email",
        "pt": "E-mail",
        "sv": "E-post"
    },
    {
        "en": "Password",
        "es": "Contraseña",
        "de": "Passwort",
        "fr": "Mot de passe",
        "it": "Password",
        "pt": "Senha",
        "sv": "Lösenord"
    },
    {
        "en": "Enter email",
        "es": "Introduce email",
        "de": "E-Mail eingeben",
        "fr": "Entrez l'e-mail",
        "it": "Inserisci email",
        "pt": "Digite o e-mail",
        "sv": "Ange e-post"
    },
    {
        "en": "Enter password",
        "es": "Introduce contraseña",
        "de": "Passwort eingeben",
        "fr": "Entrez le mot de passe",
        "it": "Inserisci password",
        "pt": "Digite a senha",
        "sv": "Ange lösenord"
    },
    {
        "en": "Password is incorrect",
        "es": "La contraseña es incorrecta",
        "de": "Passwort ist falsch",
        "fr": "Mot de passe incorrect",
        "it": "Password errata",
        "pt": "Senha incorreta",
        "sv": "Lösenordet är fel"
    },
    {
        "en": "Email is not in the system",
        "es": "El email no está en el sistema",
        "de": "E-Mail ist nicht im System",
        "fr": "E-mail non trouvé dans le système",
        "it": "Email non presente nel sistema",
        "pt": "E-mail não cadastrado",
        "sv": "E-posten finns inte i systemet"
    },
    {
        "en": "Please enter your email address",
        "es": "Por favor introduce tu dirección de email",
        "de": "Bitte gib deine E-Mail-Adresse ein",
        "fr": "Veuillez entrer votre adresse e-mail",
        "it": "Per favore inserisci il tuo indirizzo email",
        "pt": "Por favor, informe seu endereço de e-mail",
        "sv": "Ange din e-postadress"
    },
    {
        "en": "Please enter your password",
        "es": "Por favor introduce tu contraseña",
        "de": "Bitte gib dein Passwort ein",
        "fr": "Veuillez entrer votre mot de passe",
        "it": "Per favore inserisci la tua password",
        "pt": "Por favor, informe sua senha",
        "sv": "Ange ditt lösenord"
    },
    {
        "en": "Password Reset Email Sent",
        "es": "Email para restablecer contraseña enviado",
        "de": "Passwort zurücksetzen – E-Mail gesendet",
        "fr": "E-mail de réinitialisation envoyé",
        "it": "Email per reset password inviata",
        "pt": "E-mail de redefinição de senha enviado",
        "sv": "Återställningsmejl skickat"
    },
    {
        "en": "checking",
        "es": "comprobando",
        "de": "Überprüfe",
        "fr": "vérification",
        "it": "verifica in corso",
        "pt": "verificando",
        "sv": "kontrollerar"
    },
    {
        "en": "Please Register below",
        "es": "Por favor regístrate abajo",
        "de": "Bitte unten registrieren",
        "fr": "Veuillez vous inscrire ci-dessous",
        "it": "Per favore registrati qui sotto",
        "pt": "Por favor registre-se abaixo",
        "sv": "Vänligen registrera dig nedan"
    },
    {
        "en": "Welcome",
        "es": "Bienvenido",
        "de": "Willkommen",
        "fr": "Bienvenue",
        "it": "Benvenuto",
        "pt": "Bem-vindo",
        "sv": "Välkommen"
    },
    {
        "en": "Passwords don't match",
        "es": "Las contraseñas no coinciden",
        "de": "Passwörter stimmen nicht überein",
        "fr": "Les mots de passe ne correspondent pas",
        "it": "Le password non coincidono",
        "pt": "As senhas não correspondem",
        "sv": "Lösenorden matchar inte"
    },
    {
        "en": "registering",
        "es": "registrando",
        "de": "Registriere",
        "fr": "inscription en cours",
        "it": "registrazione in corso",
        "pt": "registrando",
        "sv": "registrerar"
    },
    {
        "en": "Email is already in the system. Please Signin",
        "es": "El email ya está en el sistema. Por favor inicia sesión",
        "de": "E-Mail ist bereits im System. Bitte anmelden",
        "fr": "E-mail déjà utilisé. Veuillez vous connecter",
        "it": "Email già presente nel sistema. Effettua l'accesso",
        "pt": "E-mail já cadastrado. Faça login, por favor",
        "sv": "E-posten finns redan. Logga in istället"
    },
    {
        "en": "Verify Email Address",
        "es": "Verificar dirección de email",
        "de": "E-Mail-Adresse verifizieren",
        "fr": "Vérifier l'adresse e-mail",
        "it": "Verifica indirizzo email",
        "pt": "Verificar endereço de e-mail",
        "sv": "Verifiera e-postadress"
    },
    {
        "en": "Please verify your email address",
        "es": "Por favor verifica tu dirección de email",
        "de": "Bitte bestätige deine E-Mail-Adresse",
        "fr": "Veuillez vérifier votre adresse e-mail",
        "it": "Per favore verifica il tuo indirizzo email",
        "pt": "Por favor verifique seu endereço de e-mail",
        "sv": "Verifiera din e-postadress"
    },
    {
        "en": "Sending Verification Email",
        "es": "Enviando email de verificación",
        "de": "Verifizierungs-E-Mail wird gesendet",
        "fr": "Envoi de l'e-mail de vérification",
        "it": "Invio email di verifica",
        "pt": "Enviando e-mail de verificação",
        "sv": "Skickar verifieringsmejl"
    },
    {
        "en": "Send Verification Email",
        "es": "Enviar email de verificación",
        "de": "Verifizierungs-E-Mail senden",
        "fr": "Envoyer l'e-mail de vérification",
        "it": "Invia email di verifica",
        "pt": "Enviar e-mail de verificação",
        "sv": "Skicka verifieringsmejl"
    },
    {
        "en": "Please verify changing YOUR move from",
        "es": "Por favor verifica el cambio de TU jugada desde",
        "de": "Bitte bestätige die Änderung DEINES Zugs von",
        "fr": "Veuillez vérifier le changement de VOTRE coup depuis",
        "it": "Per favore verifica la modifica della TUA mossa da",
        "pt": "Por favor verifique a alteração do SEU lance de",
        "sv": "Verifiera ändringen av DITT drag från"
    },
    {
        "en": "This is not reversable and will drop any moves following",
        "es": "Esto no es reversible y eliminará cualquier jugada posterior",
        "de": "Das ist nicht rückgängig zu machen und entfernt alle folgenden Züge",
        "fr": "Ceci est irréversible et supprimera tous les coups suivants",
        "it": "Questo non è reversibile e cancellerà eventuali mosse successive",
        "pt": "Isto não é reversível e apagará quaisquer lances subsequentes",
        "sv": "Detta går inte att ångra och tar bort efterföljande drag"
    },
    {
        "en": "For Email",
        "es": "Para email",
        "de": "Für E-Mail",
        "fr": "Pour e-mail",
        "it": "Per email",
        "pt": "Para e-mail",
        "sv": "För e-post"
    },
    {
        "en": "Reset Password",
        "es": "Restablecer contraseña",
        "de": "Passwort zurücksetzen",
        "fr": "Réinitialiser le mot de passe",
        "it": "Reimposta password",
        "pt": "Redefinir senha",
        "sv": "Återställ lösenord"
    },
    {
        "en": "Password Reset. Please use the 'Signin' screen with the new password.",
        "es": "Contraseña restablecida. Usa la pantalla 'Iniciar sesión' con la nueva contraseña.",
        "de": "Passwort zurückgesetzt. Bitte mit dem neuen Passwort einloggen.",
        "fr": "Mot de passe réinitialisé. Utilisez l'écran 'Connexion' avec le nouveau mot de passe.",
        "it": "Password reimpostata. Usa la schermata 'Accedi' con la nuova password.",
        "pt": "Senha redefinida. Use a tela 'Entrar' com a nova senha.",
        "sv": "Lösenord återställt. Logga in med det nya lösenordet."
    },
    {
        "en": "resetting password",
        "es": "restableciendo contraseña",
        "de": "Passwort wird zurückgesetzt",
        "fr": "réinitialisation du mot de passe",
        "it": "reimpostazione password",
        "pt": "redefinindo senha",
        "sv": "återställer lösenord"
    },
    {
        "en": "Cancel any open sessions on other devices.<br><em>(Not needed if you only forgot your password)<\/em>",
        "es": "Cancelar cualquier sesión abierta en otros dispositivos.<br><em>(No es necesario si solo olvidaste la contraseña)<\/em>",
        "de": "Offene Sitzungen auf anderen Geräten abbrechen.<br><em>(Nicht nötig, falls du nur dein Passwort vergessen hast)<\/em>",
        "fr": "Annulez toutes les sessions ouvertes sur d'autres appareils. (Pas nécessaire si vous avez seulement oublié le mot de passe)",
        "it": "Annulla eventuali sessioni aperte su altri dispositivi.<br><em>(Non necessario se hai solo dimenticato la password)<\/em>",
        "pt": "Cancelar sessões abertas em outros dispositivos.<br><em>(Não necessário se você apenas esqueceu a senha)<\/em>",
        "sv": "Avbryt öppna sessioner på andra enheter. (Behövs inte om du bara glömt lösenordet)"
    },
    {
        "en": "Remember my email address",
        "es": "Recordar mi email",
        "de": "E-Mail-Adresse merken",
        "fr": "Se souvenir de mon e-mail",
        "it": "Ricorda il mio indirizzo email",
        "pt": "Lembrar meu e-mail",
        "sv": "Kom ihåg min e-postadress"
    },
    {
        "en": "Confirm Signoff",
        "es": "Confirmar cierre de sesión",
        "de": "Abmeldung bestätigen",
        "fr": "Confirmer la déconnexion",
        "it": "Conferma disconnessione",
        "pt": "Confirmar saída",
        "sv": "Bekräfta utloggning"
    },
    {
        "en": "You are now back in Chessvis",
        "es": "Has vuelto a Chessvis",
        "de": "Du bist jetzt wieder in Chessvis",
        "fr": "Vous êtes de retour dans Chessvis",
        "it": "Sei tornato in Chessvis",
        "pt": "Você voltou para o Chessvis",
        "sv": "Du är tillbaka i Chessvis"
    },
    {
        "en": "Thank you for Subscribing!",
        "es": "¡Gracias por suscribirte!",
        "de": "Danke fürs Abonnieren!",
        "fr": "Merci pour votre abonnement !",
        "it": "Grazie per esserti abbonato!",
        "pt": "Obrigado por assinar!",
        "sv": "Tack för att du prenumererar!"
    },
    {
        "en": "This should be reflected on the 'You' menu",
        "es": "Esto debería reflejarse en el menú 'Tú'",
        "de": "Das sollte im 'Du'-Menü sichtbar sein",
        "fr": "Cela devrait être visible dans le menu 'Vous'",
        "it": "Questo dovrebbe riflettersi nel menu 'Tu'",
        "pt": "Isto deve aparecer no menu 'Você'",
        "sv": "Det bör synas under 'Du'-menyn"
    },
    {
        "en": "If you have any problems with the stripe billing process, please let me know.",
        "es": "Si tienes problemas con el proceso de facturación de Stripe, por favor avísame.",
        "de": "Bei Problemen mit Stripe-Zahlungen sag mir bitte Bescheid.",
        "fr": "Si vous rencontrez des problèmes avec la facturation Stripe, merci de me le signaler.",
        "it": "Se hai problemi con il processo di pagamento Stripe, fammelo sapere.",
        "pt": "Se tiver problemas com o processo de pagamento via Stripe, avise-me por favor.",
        "sv": "Om du har problem med Stripe-betalningen, hör av dig."
    },
    {
        "en": "You are not currently logged in",
        "es": "Actualmente no has iniciado sesión",
        "de": "Du bist momentan nicht eingeloggt",
        "fr": "Vous n'êtes pas connecté actuellement",
        "it": "Non sei al momento connesso",
        "pt": "Você não está conectado no momento",
        "sv": "Du är inte inloggad"
    },
    {
        "en": "It's not necessary to register or login to subscribe. Doing so will enable you to access the content from any of your iOS devices and desktop web browsers.",
        "es": "No es necesario registrarse o iniciar sesión para suscribirse. Hacerlo te permitirá acceder al contenido desde tus dispositivos iOS y navegadores de escritorio.",
        "de": "Registrieren oder einloggen ist fürs Abonnieren nicht nötig. Mit Konto kannst du Inhalte auf iOS-Geräten und im Web synchron nutzen.",
        "fr": "Il n'est pas nécessaire de s'inscrire ou de se connecter pour s'abonner. Le faire vous permettra d'accéder au contenu depuis vos appareils iOS et navigateurs de bureau.",
        "it": "Non è necessario registrarsi o accedere per abbonarsi. Farlo ti permetterà di accedere ai contenuti da qualsiasi dispositivo iOS e browser desktop.",
        "pt": "Não é necessário se registrar ou entrar para assinar. Fazer isso permitirá acessar o conteúdo em seus dispositivos iOS e navegadores de desktop.",
        "sv": "Det är inte nödvändigt att registrera sig för att prenumerera, men det gör innehållet åtkomligt från dina enheter."
    },
    {
        "en": "Hi, doing the subscriptions this way is new to me and it generated an error. PLEASE send henry@conceptual.com this message -> ",
        "es": "Hola, gestionar suscripciones así es nuevo para mí y generó un error. POR FAVOR envía este mensaje a henry@conceptual.com -> ",
        "de": "Hi, das Abo-Verfahren ist neu für mich und hat einen Fehler erzeugt. Bitte schicke diese Nachricht an henry@conceptual.com -> ",
        "fr": "Bonjour, gérer les abonnements ainsi est nouveau pour moi et a généré une erreur. VEUILLEZ envoyer ce message à henry@conceptual.com -> ",
        "it": "Ciao, gestire gli abbonamenti così è nuovo per me e ha generato un errore. PER FAVORE manda questo messaggio a henry@conceptual.com -> ",
        "pt": "Oi, fazer assinaturas assim é novo para mim e ocorreu um erro. POR FAVOR envie a mensagem abaixo para henry@conceptual.com -> ",
        "sv": "Hej, att hantera prenumerationer så här är nytt för mig och ett fel uppstod. Skicka gärna detta meddelande till henry@conceptual.com -> "
    },
    {
        "en": "Thank you for being a subscriber",
        "es": "Gracias por ser suscriptor",
        "de": "Danke, dass du Abonnent bist",
        "fr": "Merci d'être abonné",
        "it": "Grazie per essere un abbonato",
        "pt": "Obrigado por ser assinante",
        "sv": "Tack för att du är prenumerant"
    },
    {
        "en": "Take me to the 'Email Verify' screen",
        "es": "Llévame a la pantalla 'Verificar email'",
        "de": "Bring mich zur 'E-Mail-Verifizierung'",
        "fr": "Amenez-moi à l'écran 'Vérifier l'e-mail'",
        "it": "Portami alla schermata 'Verifica Email'",
        "pt": "Leve-me para a tela 'Verificar e-mail'",
        "sv": "Ta mig till 'E-postverifiering'"
    },
    {
        "en": "Review all Subscription Options",
        "es": "Revisar todas las opciones de suscripción",
        "de": "Alle Abo-Optionen ansehen",
        "fr": "Consulter toutes les options d'abonnement",
        "it": "Rivedi tutte le opzioni di abbonamento",
        "pt": "Revisar todas as opções de assinatura",
        "sv": "Granska alla prenumerationsalternativ"
    },
    {
        "en": "Please signin\/register to sync across all devices",
        "es": "Por favor inicia sesión\/registrate para sincronizar en todos los dispositivos",
        "de": "Bitte anmelden\/registrieren, um über Geräte zu synchronisieren",
        "fr": "Veuillez vous connecter\/s'inscrire pour synchroniser sur tous les appareils",
        "it": "Per favore accedi\/registrati per sincronizzare su tutti i dispositivi",
        "pt": "Por favor entre\/registre-se para sincronizar entre todos os dispositivos",
        "sv": "Logga in\/registrera för att synka över alla enheter"
    },
    {
        "en": "Take me to the 'Signin' screen",
        "es": "Llévame a la pantalla 'Iniciar sesión'",
        "de": "Bring mich zum 'Anmelden'-Bildschirm",
        "fr": "Amenez-moi à l'écran 'Connexion'",
        "it": "Portami alla schermata 'Accedi'",
        "pt": "Leve-me para a tela 'Entrar'",
        "sv": "Ta mig till inloggningssidan"
    },
    {
        "en": "Subscribing has lots of benefits",
        "es": "Suscribirse tiene muchos beneficios",
        "de": "Ein Abo hat viele Vorteile",
        "fr": "L'abonnement offre de nombreux avantages",
        "it": "L'abbonamento offre molti vantaggi",
        "pt": "Assinar traz muitos benefícios",
        "sv": "Prenumeration har många fördelar"
    },
    {
        "en": "YES! I want to subscribe!",
        "es": "¡SÍ! ¡Quiero suscribirme!",
        "de": "JA! Ich möchte abonnieren!",
        "fr": "OUI ! Je veux m'abonner !",
        "it": "SÌ! Voglio abbonarmi!",
        "pt": "SIM! Quero assinar!",
        "sv": "JA! Jag vill prenumerera!"
    },
    {
        "en": "Verify your email to subscribe",
        "es": "Verifica tu email para suscribirte",
        "de": "Bestätige deine E-Mail zum Abonnieren",
        "fr": "Vérifiez votre e-mail pour vous abonner",
        "it": "Verifica la tua email per abbonarti",
        "pt": "Verifique seu e-mail para assinar",
        "sv": "Verifiera din e-post för att prenumerera"
    },
    {
        "en": "Thank you for subscribing!",
        "es": "¡Gracias por suscribirte!",
        "de": "Danke fürs Abonnieren!",
        "fr": "Merci pour votre abonnement !",
        "it": "Grazie per esserti abbonato!",
        "pt": "Obrigado por assinar!",
        "sv": "Tack för prenumerationen!"
    },
    {
        "en": "Purchase Cancelled",
        "es": "Compra cancelada",
        "de": "Kauf abgebrochen",
        "fr": "Achat annulé",
        "it": "Acquisto annullato",
        "pt": "Compra cancelada",
        "sv": "Köp avbrutet"
    },
    {
        "en": "Purchase ERROR",
        "es": "ERROR en la compra",
        "de": "Kauf FEHLER",
        "fr": "ERREUR d'achat",
        "it": "ERRORE acquisto",
        "pt": "ERRO na compra",
        "sv": "KÖPFEL"
    },
    {
        "en": "Return to the Description",
        "es": "Volver a la descripción",
        "de": "Zur Beschreibung zurück",
        "fr": "Retour à la description",
        "it": "Torna alla descrizione",
        "pt": "Voltar para a descrição",
        "sv": "Tillbaka till beskrivningen"
    },
    {
        "en": "Board Coordinate Location",
        "es": "Ubicación de coordenadas del tablero",
        "de": "Brett-Koordinaten",
        "fr": "Emplacement des coordonnées du plateau",
        "it": "Posizione coordinate della scacchiera",
        "pt": "Localização das coordenadas do tabuleiro",
        "sv": "Brädkoordinat"
    },
    {
        "en": "Board Colors",
        "es": "Colores del tablero",
        "de": "Brett-Farben",
        "fr": "Couleurs du plateau",
        "it": "Colori scacchiera",
        "pt": "Cores do tabuleiro",
        "sv": "Brädfärger"
    },
    {
        "en": "Disable Hint for Puzzles",
        "es": "Desactivar pista para puzzles",
        "de": "Hinweise für Rätsel deaktivieren",
        "fr": "Désactiver l'indice pour les problèmes",
        "it": "Disabilita suggerimenti per i puzzle",
        "pt": "Desativar dica para problemas",
        "sv": "Stäng av tips för pussel"
    },
    {
        "en": "Chessvis Light",
        "es": "Chessvis claro",
        "de": "Chessvis Light",
        "fr": "Chessvis Clair",
        "it": "Chessvis Light",
        "pt": "Chessvis Claro",
        "sv": "Chessvis – Ljus"
    },
    {
        "en": "Chessvis Dark",
        "es": "Chessvis oscuro",
        "de": "Chessvis Dark",
        "fr": "Chessvis Sombre",
        "it": "Chessvis Dark",
        "pt": "Chessvis Escuro",
        "sv": "Chessvis – Mörk"
    },
    {
        "en": "Lichess Dark",
        "es": "Lichess oscuro",
        "de": "Lichess Dark",
        "fr": "Lichess Sombre",
        "it": "Lichess Dark",
        "pt": "Lichess Escuro",
        "sv": "Lichess – Mörk"
    },
    {
        "en": "Inside",
        "es": "Dentro",
        "de": "Innen",
        "fr": "Intérieur",
        "it": "Interno",
        "pt": "Interno",
        "sv": "Insida"
    },
    {
        "en": "Outside",
        "es": "Fuera",
        "de": "Außen",
        "fr": "Extérieur",
        "it": "Esterno",
        "pt": "Externo",
        "sv": "Utsida"
    },
    {
        "en": "Subscribers - Daily Puzzle Count Confetti",
        "es": "Suscriptores - confeti por conteo diario de puzzles",
        "de": "Abonnenten – Tagesrätsel-Konfetti",
        "fr": "Abonnés - Confettis du compteur quotidien de problèmes",
        "it": "Abbonati - coriandoli conteggio puzzle giornaliero",
        "pt": "Assinantes - Confete da contagem diária de problemas",
        "sv": "Prenumeranter - konfetti för dagligt pusselantal"
    },
    {
        "en": "Daily Puzzle Count",
        "es": "Conteo diario de puzzles",
        "de": "Tägliche Rätsel-Anzahl",
        "fr": "Nombre quotidien de problèmes",
        "it": "Conteggio puzzle giornaliero",
        "pt": "Contagem diária de problemas",
        "sv": "Dagligt pusselantal"
    },
    {
        "en": "System",
        "es": "Sistema",
        "de": "System",
        "fr": "Système",
        "it": "Sistema",
        "pt": "Sistema",
        "sv": "System"
    },
    {
        "en": "English",
        "es": "Inglés",
        "de": "Englisch",
        "fr": "Anglais",
        "it": "Inglese",
        "pt": "Inglês",
        "sv": "Engelska"
    },
    {
        "en": "Spanish",
        "es": "Español",
        "de": "Spanisch",
        "fr": "Espagnol",
        "it": "Spagnolo",
        "pt": "Espanhol",
        "sv": "Spanska"
    },
    {
        "en": "French",
        "es": "Francés",
        "de": "Französisch",
        "fr": "Français",
        "it": "Francese",
        "pt": "Francês",
        "sv": "Franska"
    },
    {
        "en": "Italian",
        "es": "Italiano",
        "de": "Italienisch",
        "fr": "Italien",
        "it": "Italiano",
        "pt": "Italiano",
        "sv": "Italienska"
    },
    {
        "en": "German",
        "es": "Alemán",
        "de": "Deutsch",
        "fr": "Allemand",
        "it": "Tedesco",
        "pt": "Alemão",
        "sv": "Tyska"
    },
    {
        "en": "Portuguese",
        "es": "Portugués",
        "de": "Portugiesisch",
        "fr": "Portugais",
        "it": "Portoghese",
        "pt": "Português",
        "sv": "Portugisiska"
    },
    {
        "en": "Language",
        "es": "Idioma",
        "de": "Sprache",
        "fr": "Langue",
        "it": "Lingua",
        "pt": "Idioma",
        "sv": "Språk"
    },
    {
        "en": "Preferences & Languages",
        "es": "Preferencias y idiomas",
        "fr": "Préférences et langues",
        "de": "Einstellungen und Sprachen",
        "it": "Preferenze e lingue",
        "pt": "Preferências e idiomas",
        "sv": "Inställningar & språk"
    },
    {
        "en": "Favorites",
        "es": "Favoritos",
        "fr": "Favoris",
        "de": "Favoriten",
        "it": "Preferiti",
        "pt": "Favoritos",
        "sv": "Favoriter"
    },
    {
        "en": "Favorites & Customs",
        "es": "Favoritos y personalizados",
        "fr": "Favoris et personnalisés",
        "de": "Favoriten und Anpassungen",
        "it": "Preferiti e personalizzati",
        "pt": "Favoritos e personalizados",
        "sv": "Favoriter & egna"
    },
    {
        "en": "Favorites (subscriber benefit)",
        "es": "Favoritos (beneficio para suscriptores)",
        "fr": "Favoris (avantage pour les abonnés)",
        "de": "Favoriten (Vorteil für Abonnenten)",
        "it": "Preferiti (vantaggio per abbonati)",
        "pt": "Favoritos (benefício para assinantes)",
        "sv": "Favoriter (fördel för prenumeranter)"
    },
    {
        "en": "Chessvis can make you a better chess player",
        "es": "Chessvis puede hacerte un mejor jugador de ajedrez",
        "fr": "Chessvis peut faire de vous un meilleur joueur d’échecs",
        "de": "Chessvis kann dich zu einem besseren Schachspieler machen",
        "it": "Chessvis può renderti un giocatore di scacchi migliore",
        "pt": "O Chessvis pode fazer de você um jogador de xadrez melhor",
        "sv": "Chessvis kan göra dig bättre i schack"
    },
    {
        "en": "Put it's unique puzzle visualization, opening preparation and blindfold play tools to work for you here: Right Now! on the web or in the native apps",
        "es": "Pon a trabajar sus exclusivas herramientas de visualización de ejercicios, preparación de aperturas y juego a ciegas <b>¡ahora mismo! en la web o en las apps nativas",
        "fr": "Mettez ses outils uniques de visualisation de puzzles, de préparation d’ouvertures et de jeu à l’aveugle à votre service <b>dès maintenant sur le web ou dans les applications natives",
        "de": "Nutze seine einzigartigen Tools für Puzzle-Visualisierung, Eröffnungs­vorbereitung und Blindschach <b>jetzt sofort im Web oder in den nativen Apps",
        "it": "Sfrutta i suoi strumenti unici di visualizzazione dei problemi, preparazione delle aperture e gioco alla cieca <b>subito, sul web o nelle app native",
        "pt": "Coloque suas ferramentas exclusivas de visualização de táticas, preparação de aberturas e jogo às cegas para funcionar <b>agora mesmo! na web ou nos aplicativos nativos",
        "sv": "Använd dess unika pusselvisualisering, öppningsförberedelser och blindfold-verktyg här: nu — på webben eller i appen"
    },
    {
        "en": "The Chessvis puzzle collection starts with the over 1.6 million categorized and rated puzzles from Lichess and adds several unique features including:",
        "es": "La colección de ejercicios de Chessvis comienza con más de 1.6 millones de problemas clasificados y valorados de Lichess, y añade varias funciones únicas, entre ellas:",
        "fr": "La collection de puzzles de Chessvis commence avec plus de 1,6 million de puzzles classés et notés de Lichess, et ajoute plusieurs fonctionnalités uniques, notamment :",
        "de": "Die Puzzle-Sammlung von Chessvis basiert auf über 1,6 Millionen kategorisierten und bewerteten Aufgaben von Lichess und ergänzt sie um mehrere einzigartige Funktionen, darunter:",
        "it": "La raccolta di problemi di Chessvis parte da oltre 1,6 milioni di puzzle classificati e valutati di Lichess, aggiungendo diverse funzioni uniche, tra cui:",
        "pt": "A coleção de táticas do Chessvis começa com mais de 1,6 milhão de problemas categorizados e avaliados do Lichess e adiciona vários recursos exclusivos, incluindo:",
        "sv": "Chessvis pusselsamling börjar med över 1,6 miljoner kategoriserade och betygsatta pussel från Lichess och lägger till flera unika funktioner, bland annat:"
    },
    {
        "en": "Category and Rating Control",
        "es": "Control de categoría y nivel",
        "fr": "Contrôle de catégorie et de niveau",
        "de": "Kategorie- und Schwierigkeitskontrolle",
        "it": "Controllo di categoria e livello",
        "pt": "Controle de categoria e nível",
        "sv": "Kontroll över kategori och svårighetsbetyg"
    },
    {
        "en": "Chessvis lets you set both the category and rating of the puzzles you’re challenged with. Want to try easy forks one day and hard multiple move mates the next? Do it! You’ll never be forced to only do puzzles around some hypothetical rating you’ve 'earned'. The entire puzzle collection is always available for you.",
        "es": "Chessvis te permite elegir tanto la categoría como la dificultad de los ejercicios. ¿Quieres probar capturas simples un día y mates complicados al siguiente? ¡Hazlo! Nunca estarás limitado a ejercicios según un supuesto nivel que hayas 'ganado'. Toda la colección está siempre disponible para ti.",
        "fr": "Chessvis vous permet de choisir la catégorie et la difficulté des puzzles à résoudre. Vous voulez essayer des fourchettes faciles un jour et des mats complexes le lendemain ? Allez-y ! Vous n’êtes jamais limité à un niveau fixe — toute la collection est toujours disponible.",
        "de": "Mit Chessvis kannst du sowohl die Kategorie als auch die Schwierigkeit der Aufgaben selbst festlegen. Willst du heute einfache Gabeln und morgen komplizierte Mattkombinationen üben? Mach’s einfach! Du wirst nie auf ein fiktives Rating beschränkt – die gesamte Sammlung steht dir immer offen.",
        "it": "Chessvis ti permette di impostare sia la categoria che la difficoltà dei problemi. Vuoi provare forchette facili un giorno e mattoni complessi il giorno dopo? Fallo! Non sarai mai limitato a puzzle legati a un punteggio ‘guadagnato’. Tutta la raccolta è sempre disponibile per te.",
        "pt": "O Chessvis permite definir a categoria e o nível de dificuldade das táticas. Quer resolver capturas simples hoje e mates difíceis amanhã? Vá em frente! Você nunca ficará preso a um nível fixo — toda a coleção está sempre disponível para você.",
        "sv": "Chessvis låter dig välja både kategori och svårighetsbetyg för pusslen. Vill du köra enkla gafflar ena dagen och svåra flerdagsmatt nästa — kör på! Du tvingas aldrig hålla dig till ett 'intjänat' betyg, hela samlingen finns alltid tillgänglig."
    },
    {
        "en": "Visualized Puzzles",
        "es": "Ejercicios visualizados",
        "fr": "Puzzles visualisés",
        "de": "Visualisierte Aufgaben",
        "it": "Problemi visualizzati",
        "pt": "Táticas visualizadas",
        "sv": "Visualiserade pussel"
    },
    {
        "en": "A unique feature of Chessvis is the 'Visualized' puzzle. It presents a puzzle showing the diagram from some number of moves before the actual tactic sequence starts. You're told the number of moves to 'visualize' and then solve the problem from a board position that only exists in your mind. This is what got Chessvis started and it’s the only app with it.(There's a short video showing the power of this technique. You'll find it on the right side menu.)",
        "es": "Una función única de Chessvis es el ejercicio 'Visualizado'. Muestra el tablero varios movimientos antes de que empiece la táctica real. Se te indica cuántos movimientos debes 'visualizar' y luego resolver el problema desde una posición que solo existe en tu mente. Esta fue la idea original de Chessvis, y sigue siendo la única app con esta función. (Hay un breve video que muestra el poder de esta técnica en el menú lateral derecho.)",
        "fr": "Une fonctionnalité unique de Chessvis est le puzzle 'Visualisé'. Il montre le diagramme quelques coups avant le début de la combinaison réelle. On vous indique combien de coups visualiser, puis vous résolvez depuis une position qui n’existe que dans votre tête. C’est ce qui a lancé Chessvis, et c’est la seule application à proposer cela. (Une courte vidéo expliquant cette technique se trouve dans le menu latéral droit.)",
        "de": "Eine einzigartige Funktion von Chessvis ist das 'Visualisierte' Puzzle. Es zeigt das Diagramm einige Züge vor Beginn der eigentlichen Taktik. Du erfährst, wie viele Züge du dir vorstellen sollst, und löst dann die Aufgabe aus einer Position, die nur in deinem Kopf existiert. Das war die Ursprungsidee von Chessvis – und bis heute die einzige App mit dieser Funktion. (Ein kurzes Video dazu findest du im Menü auf der rechten Seite.)",
        "it": "Una funzione unica di Chessvis è il problema 'Visualizzato'. Mostra la posizione alcuni movimenti prima che inizi la combinazione reale. Ti viene detto quanti movimenti 'visualizzare' e poi risolvi il problema da una posizione che esiste solo nella tua mente. È da qui che è nato Chessvis, ed è l’unica app che lo fa. (C’è un breve video che mostra la potenza di questa tecnica nel menu a destra.)",
        "pt": "Um recurso exclusivo do Chessvis é a tática 'Visualizada'. Ela mostra o diagrama alguns lances antes de a sequência tática começar. Você é informado sobre quantos lances deve 'visualizar' e resolve o problema a partir de uma posição que só existe na sua mente. Foi assim que o Chessvis começou — e é o único app com isso. (Há um vídeo curto mostrando essa técnica no menu lateral direito.)",
        "sv": "En unik funktion är 'visualiserade' pussel: du får se en ställning några drag innan taktiken börjar, måste visualisera ett antal drag i huvudet och lösa pusslet från den inre ställningen. Det här är vad som startade Chessvis — och det är den enda appen med detta. (Kort video finns i menyn.)"
    },
    {
        "en": "Other Puzzle Collection Features",
        "es": "Otras funciones de la colección de ejercicios",
        "fr": "Autres fonctionnalités de la collection de puzzles",
        "de": "Weitere Funktionen der Aufgabensammlung",
        "it": "Altre funzioni della raccolta di problemi",
        "pt": "Outros recursos da coleção de táticas",
        "sv": "Andra funktioner i pusselsamlingen"
    },
    {
        "en": "The 'no repeat pledge' - with such an extensive puzzle collection, Chessvis is able to make sure you don’t see the same puzzle twice. Want to focus on solving puzzles quickly? Turn on the timer. Going to be away from the internet? Pull two thousand puzzles down to your device and work off-line. See your puzzle history. Download the puzzles you’ve done. Graph the results. Compare with others. All that is in Chessvis.",
        "es": "La 'promesa sin repeticiones': con una colección tan grande, Chessvis garantiza que no verás el mismo ejercicio dos veces. ¿Quieres concentrarte en resolver rápido? Activa el temporizador. ¿Sin conexión? Descarga dos mil ejercicios a tu dispositivo y sigue practicando. Mira tu historial, descarga tus resultados, grafícalos y compáralos con otros. Todo eso está en Chessvis.",
        "fr": "La 'promesse sans répétition' : avec une collection aussi vaste, Chessvis garantit que vous ne verrez jamais deux fois le même puzzle. Vous voulez vous concentrer sur la rapidité ? Activez le minuteur. Pas d’accès Internet ? Téléchargez deux mille puzzles sur votre appareil et continuez hors ligne. Consultez votre historique, téléchargez vos résultats, visualisez vos progrès, comparez-vous aux autres. Tout cela est dans Chessvis.",
        "de": "Das 'Keine-Wiederholungen-Versprechen': Mit einer so großen Sammlung sorgt Chessvis dafür, dass du nie dieselbe Aufgabe zweimal siehst. Willst du deine Geschwindigkeit trainieren? Schalte den Timer ein. Kein Internet? Lade dir zweitausend Aufgaben herunter und arbeite offline. Sieh dir deine Historie an, lade gelöste Aufgaben herunter, analysiere deine Fortschritte und vergleiche dich mit anderen – all das ist Chessvis.",
        "it": "La 'promessa senza ripetizioni': con una raccolta così ampia, Chessvis ti assicura di non vedere mai lo stesso problema due volte. Vuoi allenare la velocità? Attiva il timer. Sei senza connessione? Scarica duemila problemi e continua offline. Guarda la tua cronologia, scarica i problemi risolti, analizza i risultati e confrontali con altri. Tutto questo è in Chessvis.",
        "pt": "A 'promessa sem repetições': com uma coleção tão grande, o Chessvis garante que você não verá o mesmo problema duas vezes. Quer focar em resolver rápido? Ative o cronômetro. Vai ficar sem internet? Baixe dois mil problemas no seu dispositivo e jogue offline. Veja seu histórico, baixe suas táticas, analise seus resultados e compare com outros. Tudo isso está no Chessvis.",
        "sv": "'Ingen upprepning'-löftet — med en så stor samling ser Chessvis till att du inte får samma pussel två gånger. Vill du träna snabb lösning? Sätt på timer. Utan internet? Ladda ner tusentals pussel och kör offline. Se historik, ladda ner gjorda pussel, grafiska resultat, jämför med andra — allt finns i Chessvis."
    },
    {
        "en": "A radically new, data driven approach to chess openings! Watch one of the 'Opening' videos to see it in action and how it can maximize your opening preparation time.",
        "es": "¡Un enfoque completamente nuevo y basado en datos para las aperturas! Mira uno de los videos de 'Aperturas' para verlo en acción y descubrir cómo puede optimizar tu tiempo de preparación.",
        "fr": "Une approche totalement nouvelle et axée sur les données des ouvertures d’échecs ! Regardez une des vidéos 'Openings' pour la voir en action et découvrir comment elle optimise votre préparation.",
        "de": "Ein völlig neuer, datengesteuerter Ansatz für Schacheröffnungen! Sieh dir eines der 'Opening'-Videos an, um zu sehen, wie es funktioniert und deine Eröffnungsvorbereitung maximiert.",
        "it": "Un approccio radicalmente nuovo e basato sui dati alle aperture! Guarda uno dei video 'Opening' per vederlo in azione e scoprire come può massimizzare il tuo tempo di preparazione.",
        "pt": "Uma abordagem totalmente nova e orientada por dados para aberturas de xadrez! Assista a um dos vídeos de 'Aberturas' para ver em ação e descobrir como otimizar seu tempo de preparo.",
        "sv": "En radikalt ny, datadriven approach till öppningar! Se någon 'Öppning'-video för att se hur det maximerar din öppningsförberedelse."
    },
    {
        "en": "Focus on the moves you'll see",
        "es": "Concéntrate en las jugadas que realmente verás",
        "fr": "Concentrez-vous sur les coups que vous verrez vraiment",
        "de": "Fokussiere dich auf die Züge, die du wirklich sehen wirst",
        "it": "Concentrati sulle mosse che vedrai davvero",
        "pt": "Concentre-se nos lances que você realmente verá",
        "sv": "Fokusera på de drag du verkligen kommer att möta"
    },
    {
        "en": "Track a sequence of moves and then update the board to that point. Follow a game from the beginning, some random location within a game or specify the number of pieces you want to follow.",
        "es": "Sigue una secuencia de jugadas y actualiza el tablero hasta ese punto. Observa una partida desde el inicio, desde un punto aleatorio o elige cuántas piezas quieres seguir.",
        "fr": "Suivez une séquence de coups et mettez le plateau à jour jusqu’à ce point. Suivez une partie depuis le début, un moment aléatoire ou choisissez combien de pièces suivre.",
        "de": "Verfolge eine Zugfolge und aktualisiere das Brett bis zu diesem Punkt. Verfolge eine Partie vom Anfang an, von einer zufälligen Stelle oder gib an, wie viele Figuren du verfolgen möchtest.",
        "it": "Segui una sequenza di mosse e aggiorna la scacchiera fino a quel punto. Segui una partita dall’inizio, da un punto casuale o scegli quante pezzi vuoi seguire.",
        "pt": "Acompanhe uma sequência de lances e atualize o tabuleiro até esse ponto. Siga uma partida desde o início, de um ponto aleatório ou escolha quantas peças quer acompanhar.",
        "sv": "Följ en dragsekvens och uppdatera brädet till den punkten. Följ ett parti från början, slumpmässigt ställe eller välj antal pjäser att följa."
    },
    {
        "en": "Move percentages",
        "es": "Porcentajes de jugadas",
        "fr": "Pourcentages des coups",
        "de": "Zug-Prozentsätze",
        "it": "Percentuali delle mosse",
        "pt": "Percentuais de lances",
        "sv": "Dragprocent"
    },
    {
        "en": "Unique Head-to-Head Game Collection",
        "es": "Colección única de partidas cara a cara",
        "fr": "Collection unique de parties en tête-à-tête",
        "de": "Einzigartige Sammlung von direkten Duellen",
        "it": "Collezione unica di partite testa a testa",
        "pt": "Coleção única de partidas frente a frente",
        "sv": "Unik head-to-head-partisamling"
    },
    {
        "en": "over 200+ Million games",
        "es": "más de 200 millones de partidas",
        "fr": "plus de 200 millions de parties",
        "de": "über 200 Millionen Partien",
        "it": "oltre 200 milioni di partite",
        "pt": "mais de 200 milhões de partidas",
        "sv": "över 200 miljoner partier"
    },
    {
        "en": "Concentrate on the games of your peers",
        "es": "Concéntrate en las partidas de tus rivales de nivel",
        "fr": "Concentrez-vous sur les parties de vos pairs",
        "de": "Konzentriere dich auf die Partien deiner Spielstärke",
        "it": "Concentrati sulle partite dei tuoi pari livello",
        "pt": "Concentre-se nas partidas de jogadores do seu nível",
        "sv": "Fokusera på partier av spelare i din nivå"
    },
    {
        "en": "Concentrate your study time on the moves that you'll actually see and not complex long move sequences that will rarely appear.",
        "es": "Dedica tu tiempo de estudio a las jugadas que realmente verás y no a secuencias largas y complejas que casi nunca aparecerán.",
        "fr": "Consacrez votre temps d’étude aux coups que vous verrez vraiment, et non aux longues séquences complexes qui apparaissent rarement.",
        "de": "Verwende deine Lernzeit auf Züge, die du wirklich siehst, und nicht auf lange, komplizierte Sequenzen, die kaum vorkommen.",
        "it": "Dedica il tuo tempo di studio alle mosse che vedrai davvero, non a lunghe sequenze complesse che appaiono raramente.",
        "pt": "Dedique seu tempo de estudo aos lances que realmente verá e não a longas sequências complicadas que quase nunca aparecem.",
        "sv": "Lägg studietiden på drag du faktiskt kommer se, inte på komplexa långa varianter som sällan dyker upp."
    },
    {
        "en": "Only games where both players are in the same 50 point rating bracket are included. Why? Because even a 50 point rating difference skews the results.",
        "es": "Solo se incluyen partidas donde ambos jugadores están en el mismo rango de 50 puntos de rating. ¿Por qué? Porque incluso una diferencia de 50 puntos cambia los resultados.",
        "fr": "Seules les parties où les deux joueurs sont dans la même tranche de 50 points sont incluses. Pourquoi ? Parce qu’une différence de 50 points fausse déjà les résultats.",
        "de": "Nur Partien, bei denen beide Spieler in derselben 50-Punkte-Wertungsstufe sind, werden einbezogen. Warum? Schon 50 Punkte Unterschied verzerren die Ergebnisse.",
        "it": "Sono incluse solo le partite in cui entrambi i giocatori sono nella stessa fascia di 50 punti di rating. Perché? Anche 50 punti di differenza falsano i risultati.",
        "pt": "Somente partidas em que ambos os jogadores estão na mesma faixa de 50 pontos de rating são incluídas. Por quê? Porque até 50 pontos de diferença distorcem os resultados.",
        "sv": "Endast partier där båda spelarna ligger i samma 50-punktsintervall ingår — även 50 poäng skillnad påverkar resultaten mycket."
    },
    {
        "en": "Only the Lichess 'Rapid' games with their longer time control are used. You get millions of games per rating bracket but at the same time get games where more thought was given.",
        "es": "Solo se usan las partidas 'Rápidas' de Lichess con control de tiempo más largo. Obtienes millones de partidas por rango de rating, pero con jugadas más pensadas.",
        "fr": "Seules les parties ‘Rapides’ de Lichess avec un temps plus long sont utilisées. Vous obtenez des millions de parties par niveau, mais avec des coups plus réfléchis.",
        "de": "Nur die Lichess-„Rapid“-Partien mit längerer Bedenkzeit werden verwendet. So bekommst du Millionen Partien pro Wertungsklasse – aber mit überlegteren Zügen.",
        "it": "Sono usate solo le partite 'Rapid' di Lichess, con tempi più lunghi. Hai milioni di partite per fascia di rating, ma con mosse più ragionate.",
        "pt": "Somente as partidas 'Rápidas' do Lichess, com controle de tempo mais longo, são usadas. Você tem milhões de partidas por faixa de rating, mas com jogadas mais pensadas.",
        "sv": "Endast Lichess 'rapid'-partier (längre tidskontroll) används. Du får miljontals partier per betygsintervall men också partier där mer eftertanke lades ner."
    },
    {
        "en": "Filter the games down to your rating. Different rated players make different moves. And while 'studying the masters' is a nice theory, in reality they don't play like us.",
        "es": "Filtra las partidas según tu rating. Los jugadores de distintos niveles hacen jugadas distintas. Estudiar a los maestros suena bien, pero no juegan como nosotros.",
        "fr": "Filtrez les parties selon votre classement. Les joueurs de niveaux différents jouent différemment. Étudier les maîtres, c’est bien, mais ils ne jouent pas comme nous.",
        "de": "Filtere die Partien nach deiner Wertung. Spieler mit unterschiedlichen Wertungen spielen unterschiedlich. Meister zu studieren ist schön – aber sie spielen nicht wie wir.",
        "it": "Filtra le partite in base al tuo rating. I giocatori di livello diverso fanno mosse diverse. Studiare i maestri è utile, ma non giocano come noi.",
        "pt": "Filtre as partidas pelo seu rating. Jogadores de níveis diferentes fazem lances diferentes. Estudar os mestres é bom, mas eles não jogam como nós.",
        "sv": "Filtrera till ditt betyg. Spelare i olika rating gör olika drag — och även om 'studera mästarna' låter bra, spelar de inte som vi i praktiken."
    },
    {
        "en": "Focus on the moves that work!",
        "es": "¡Concéntrate en las jugadas que funcionan!",
        "fr": "Concentrez-vous sur les coups qui marchent !",
        "de": "Konzentriere dich auf die Züge, die funktionieren!",
        "it": "Concentrati sulle mosse che funzionano!",
        "pt": "Concentre-se nos lances que funcionam!",
        "sv": "Fokusera på drag som fungerar!"
    },
    {
        "en": "Compare Move Choices",
        "es": "Compara las opciones de jugadas",
        "fr": "Comparez les choix de coups",
        "de": "Vergleiche Zugoptionen",
        "it": "Confronta le scelte di mosse",
        "pt": "Compare as opções de lances",
        "sv": "Jämför dragval"
    },
    {
        "en": "See into the Middle Game",
        "es": "Mira dentro del medio juego",
        "fr": "Voyez à l’intérieur du milieu de partie",
        "de": "Blicke ins Mittelspiel",
        "it": "Guarda dentro il mediogioco",
        "pt": "Veja dentro do meio-jogo",
        "sv": "Se in i mittspelet"
    },
    {
        "en": "Move Beyond Win\/Loss percentages",
        "es": "Ve más allá de los porcentajes de victorias y derrotas",
        "fr": "Allez au-delà des pourcentages de victoires et de défaites",
        "de": "Geh über Gewinn-\/Verlustprozente hinaus",
        "it": "Vai oltre le percentuali di vittoria e sconfitta",
        "pt": "Vá além das porcentagens de vitória e derrota",
        "sv": "Gå förbi enbart vinst\/förlust-procent"
    },
    {
        "en": "Avoid Traps",
        "es": "Evita las trampas",
        "fr": "Évitez les pièges",
        "de": "Vermeide Fallen",
        "it": "Evita le trappole",
        "pt": "Evite as armadilhas",
        "sv": "Undvik fällor"
    },
    {
        "en": "Chess Opening Mastery can display any number of move choices side by side in the graph.",
        "es": "Chess Opening Mastery puede mostrar cualquier número de opciones de jugadas una al lado de la otra en el gráfico.",
        "fr": "Chess Opening Mastery peut afficher plusieurs choix de coups côte à côte dans le graphique.",
        "de": "Chess Opening Mastery kann beliebig viele Zugoptionen nebeneinander im Diagramm anzeigen.",
        "it": "Chess Opening Mastery può mostrare qualsiasi numero di mosse affiancate nel grafico.",
        "pt": "O Chess Opening Mastery pode exibir qualquer número de opções de lances lado a lado no gráfico.",
        "sv": "Öppningsverktyget visar flera dragval sida vid sida i grafen."
    },
    {
        "en": "This is the only program in the world that shows the impact of opening moves on the middle game.",
        "es": "Este es el único programa del mundo que muestra el impacto de las jugadas iniciales en el medio juego.",
        "fr": "C’est le seul programme au monde qui montre l’impact des coups d’ouverture sur le milieu de partie.",
        "de": "Dies ist das einzige Programm der Welt, das die Auswirkungen der Eröffnungszüge auf das Mittelspiel zeigt.",
        "it": "È l’unico programma al mondo che mostra l’impatto delle mosse d’apertura sul mediogioco.",
        "pt": "Este é o único programa do mundo que mostra o impacto dos lances iniciais no meio-jogo.",
        "sv": "Detta är det enda programmet som visar hur öppningsdrag påverkar mittspelet."
    },
    {
        "en": "Why are we still picking first moves based on the way games end 40 or 60 moves later? That's an unfair burden to place on the first move.",
        "es": "¿Por qué seguimos eligiendo las primeras jugadas basándonos en cómo terminan las partidas 40 o 60 jugadas después? Es una carga injusta para el primer movimiento.",
        "fr": "Pourquoi choisissons-nous encore les premiers coups en fonction de la façon dont les parties se terminent 40 ou 60 coups plus tard ? C’est une lourde charge pour le premier coup.",
        "de": "Warum wählen wir Eröffnungszüge immer noch danach, wie Partien 40 oder 60 Züge später enden? Das ist eine unfaire Last für den ersten Zug.",
        "it": "Perché scegliamo ancora le prime mosse in base a come finiscono le partite 40 o 60 mosse dopo? È un peso ingiusto da mettere sulla prima mossa.",
        "pt": "Por que ainda escolhemos os primeiros lances com base em como as partidas terminam 40 ou 60 lances depois? É um peso injusto para o primeiro lance.",
        "sv": "Varför välja första drag utifrån hur partier slutar 40–60 drag senare? Det är orimligt att lägga den belastningen på första draget."
    },
    {
        "en": "With the program's focus on how games are doing in the middle game, your opponent's trappy openings show themselves quickly and show you how to easily avoid them.",
        "es": "Con el enfoque del programa en el medio juego, las aperturas trampa de tu oponente se revelan rápido y te muestran cómo evitarlas fácilmente.",
        "fr": "Grâce à l’accent mis sur le milieu de partie, les ouvertures piégées de votre adversaire se révèlent rapidement et vous montrent comment les éviter facilement.",
        "de": "Da sich das Programm auf das Mittelspiel konzentriert, werden die Fallen-Eröffnungen deines Gegners schnell sichtbar – und du siehst, wie du sie leicht vermeiden kannst.",
        "it": "Con il focus del programma sul mediogioco, le aperture trappola del tuo avversario si rivelano rapidamente e ti mostrano come evitarle facilmente.",
        "pt": "Com o foco do programa no meio-jogo, as aberturas armadilha do seu oponente aparecem rápido e mostram como evitá-las com facilidade.",
        "sv": "Med fokus på spelets mitt visar motståndarens fällor sig snabbt och visar hur du enkelt undviker dem."
    },
    {
        "en": "Visualization Tools",
        "es": "Herramientas de visualización",
        "fr": "Outils de visualisation",
        "de": "Visualisierungswerkzeuge",
        "it": "Strumenti di visualizzazione",
        "pt": "Ferramentas de visualização",
        "sv": "Visualiseringsverktyg"
    },
    {
        "en": "Chessvis started as a 'visualization' app. (That is the source of the 'vis' in the name.) Yes, it has grown, but it has never forgotten the importance of visualization in helping a player get better.",
        "es": "Chessvis comenzó como una app de 'visualización'. (De ahí viene el 'vis' en el nombre.) Sí, ha crecido, pero nunca ha olvidado la importancia de visualizar para mejorar como jugador.",
        "fr": "Chessvis a commencé comme une application de ‘visualisation’. (C’est de là que vient le ‘vis’ du nom.) Oui, elle a évolué, mais n’a jamais oublié l’importance de la visualisation pour progresser.",
        "de": "Chessvis begann als App zur „Visualisierung“. (Daher kommt das „vis“ im Namen.) Ja, sie ist gewachsen, hat aber nie vergessen, wie wichtig Visualisierung ist, um besser zu werden.",
        "it": "Chessvis è nata come app di 'visualizzazione'. (È da lì che viene il 'vis' del nome.) Sì, è cresciuta, ma non ha mai dimenticato l’importanza della visualizzazione per migliorare.",
        "pt": "O Chessvis começou como um app de 'visualização'. (É daí que vem o 'vis' do nome.) Sim, ele cresceu, mas nunca esqueceu a importância da visualização para evoluir como jogador.",
        "sv": "Chessvis började som en visualiseringsapp (därav 'vis'). Den har vuxit men glömmer inte vikten av visualisering för att bli bättre."
    },
    {
        "en": "Who’s Guarding Whom",
        "es": "Quién protege a quién",
        "fr": "Qui protège qui",
        "de": "Wer deckt wen",
        "it": "Chi protegge chi",
        "pt": "Quem protege quem",
        "sv": "Vem bevakar vem"
    },
    {
        "en": "A deceptively simple visualization exercise that forces you to mentally track piece movements and how they interact. (No other app has this.) The 'Video' section on the right side menu has a short video on it.",
        "es": "Un ejercicio de visualización engañosamente simple que te obliga a seguir mentalmente los movimientos de las piezas y cómo interactúan. (Ninguna otra app lo tiene.) En la sección 'Video' del menú derecho hay un video corto sobre esto.",
        "fr": "Un exercice de visualisation trompeusement simple qui vous pousse à suivre mentalement les mouvements des pièces et leurs interactions. (Aucune autre app ne le propose.) La section 'Vidéo' du menu à droite contient une courte démo.",
        "de": "Eine scheinbar einfache Visualisierungsübung, die dich zwingt, die Bewegungen und Interaktionen der Figuren im Kopf zu verfolgen. (Keine andere App hat das.) Im Menü rechts findest du unter „Video“ eine kurze Demonstration.",
        "it": "Un esercizio di visualizzazione apparentemente semplice che ti costringe a seguire mentalmente i movimenti dei pezzi e le loro interazioni. (Nessun’altra app lo ha.) Nella sezione 'Video' del menu a destra c’è un breve video su questo.",
        "pt": "Um exercício de visualização aparentemente simples que obriga você a acompanhar mentalmente os movimentos das peças e como interagem. (Nenhum outro app tem isso.) Na seção 'Vídeo' do menu à direita há um vídeo curto sobre isso.",
        "sv": "En förvillande enkel visualiseringsövning som tvingar dig följa pjäsernas rörelser och interaktion i huvudet. (Ingen annan app har detta.) Kort video i meny."
    },
    {
        "en": "Move Following",
        "es": "Seguimiento de jugadas",
        "fr": "Suivi des coups",
        "de": "Zugverfolgung",
        "it": "Seguire le mosse",
        "pt": "Acompanhamento de lances",
        "sv": "Följa drag"
    },
    {
        "en": "What could be simpler than this? You look at and memorize a board layout, then recreate it. Start off easy with just a few pieces and work your way up.",
        "es": "¿Qué podría ser más simple que esto? Observa y memoriza la posición del tablero, luego recréala. Comienza con pocas piezas y aumenta la dificultad progresivamente.",
        "fr": "Quoi de plus simple ? Vous regardez et mémorisez une position, puis vous la recréez. Commencez facilement avec quelques pièces et augmentez progressivement la difficulté.",
        "de": "Was könnte einfacher sein? Schau dir die Brettposition an, merke sie dir und setze sie dann wieder. Beginne leicht mit wenigen Figuren und steigere dich nach und nach.",
        "it": "Cosa potrebbe essere più semplice? Guarda e memorizza la posizione sulla scacchiera, poi ricreala. Inizia facilmente con poche pezzi e aumenta gradualmente.",
        "pt": "O que poderia ser mais simples do que isso? Olhe e memorize a posição no tabuleiro, depois recrie-a. Comece fácil com poucas peças e aumente gradualmente a dificuldade.",
        "sv": "Vad kan vara enklare? Memorera en ställning och återskapa den. Börja enkelt med få pjäser och bygg upp."
    },
    {
        "en": "Blindfold Chess",
        "es": "Ajedrez a ciegas",
        "fr": "Échecs à l’aveugle",
        "de": "Blindschach",
        "it": "Scacchi alla cieca",
        "pt": "Xadrez às cegas",
        "sv": "Blindfold-schack"
    },
    {
        "en": "Play against the computer with 'stepping stones' to help you ease your way into blindfold chess.",
        "es": "Juega contra la computadora con 'piedras de apoyo' para ayudarte a iniciarte en el ajedrez a ciegas.",
        "fr": "Jouez contre l’ordinateur avec des « pierres d’étape » pour progresser vers les échecs à l’aveugle.",
        "de": "Spiele gegen den Computer mit 'Stufensteinen', um dich langsam ins Blindschach einzuarbeiten.",
        "it": "Gioca contro il computer con 'passaggi graduali' per aiutarti a entrare negli scacchi alla cieca.",
        "pt": "Jogue contra o computador com 'pedras de apoio' para ajudar a entrar no xadrez às cegas.",
        "sv": "Spela mot datorn med 'stegsstenar' som hjälper dig in i blindfold-spel."
    },
    {
        "en": "Stepping Stones",
        "es": "Piedras de apoyo",
        "fr": "Pierres d’étape",
        "de": "Stufensteine",
        "it": "Passaggi graduali",
        "pt": "Pedras de apoio",
        "sv": "Stegstenar"
    },
    {
        "en": "Start with all pieces sharing one color then go to two color disks, one shared color disk and then eventually an empty board.",
        "es": "Comienza con todas las piezas del mismo color, luego pasa a discos de dos colores, un disco compartido y finalmente un tablero vacío.",
        "fr": "Commencez avec toutes les pièces d’une seule couleur, puis passez à des disques de deux couleurs, un disque partagé, et enfin un plateau vide.",
        "de": "Beginne mit allen Figuren einer Farbe, dann zu zwei Farbscheiben, einer gemeinsamen Farbscheibe und schließlich einem leeren Brett.",
        "it": "Inizia con tutti i pezzi di un colore, poi passa a dischi di due colori, un disco condiviso e infine una scacchiera vuota.",
        "pt": "Comece com todas as peças de uma cor, depois vá para discos de duas cores, um disco de cor compartilhada e finalmente um tabuleiro vazio.",
        "sv": "Börja med alla pjäser i samma färg, gå vidare till tvåfärgade brickor, en gemensam bricka och till slut tomt bräde."
    },
    {
        "en": "Reveal the board when you feel the need or automatically every # of moves to check on your visualization.",
        "es": "Revela el tablero cuando lo necesites o automáticamente cada cierto número de jugadas para comprobar tu visualización.",
        "fr": "Révélez le plateau quand vous en ressentez le besoin ou automatiquement tous les # coups pour vérifier votre visualisation.",
        "de": "Enthülle das Brett, wenn du es brauchst, oder automatisch nach # Zügen, um deine Visualisierung zu überprüfen.",
        "it": "Mostra la scacchiera quando ne senti il bisogno o automaticamente ogni # mosse per controllare la tua visualizzazione.",
        "pt": "Revele o tabuleiro quando sentir necessidade ou automaticamente a cada # de lances para conferir sua visualização.",
        "sv": "Visa brädet när du behöver eller automatiskt var # drag för att kontrollera din visualisering."
    },
    {
        "en": "How about Voice Controlled Blindfold Chess??",
        "es": "¿Qué tal ajedrez a ciegas controlado por voz?",
        "fr": "Et si vous essayiez les échecs à l’aveugle contrôlés par la voix ?",
        "de": "Wie wäre es mit Sprachgesteuertem Blindschach?",
        "it": "Che ne dici degli scacchi alla cieca controllati a voce?",
        "pt": "Que tal Xadrez às cegas controlado por voz?",
        "sv": "Vad sägs om röststyrd blindfold-schack??"
    },
    {
        "en": "Looking for a blindfold chess game where you can speak your moves and hear the opponent's? Check out my other app - Verbal Chess. You'll find a link to its 'Landing' page under right hand's 'Support' menu",
        "es": "¿Buscas un juego de ajedrez a ciegas donde puedas hablar tus jugadas y escuchar las del oponente? Prueba mi otra app - Verbal Chess. Encontrarás un enlace a su página de inicio en el menú 'Soporte' a la derecha.",
        "fr": "Vous cherchez un jeu d’échecs à l’aveugle où vous pouvez parler vos coups et entendre ceux de votre adversaire ? Découvrez mon autre application – Verbal Chess. Le lien vers sa page d’accueil se trouve dans le menu 'Support' à droite.",
        "de": "Suchst du ein Blindschach-Spiel, bei dem du deine Züge ansagen und die des Gegners hören kannst? Probier meine andere App – Verbal Chess. Den Link zur Startseite findest du im rechten 'Support'-Menü.",
        "it": "Cerchi un gioco di scacchi alla cieca in cui puoi dire le mosse e ascoltare quelle dell’avversario? Prova la mia altra app - Verbal Chess. Troverai un link alla sua pagina principale nel menu 'Supporto' a destra.",
        "pt": "Procurando um jogo de xadrez às cegas onde você possa falar seus lances e ouvir os do oponente? Confira meu outro app – Verbal Chess. Você encontrará o link para a página inicial no menu 'Suporte' à direita.",
        "sv": "Letar du efter blindfold där du kan säga drag och höra motståndaren? Kolla min andra app — Verbal Chess. Länk i 'Support'-menyn."
    },
    {
        "en": "See The Terms & Privacy Statement",
        "es": "Ver Términos y Declaración de Privacidad",
        "fr": "Voir les Conditions et la Déclaration de confidentialité",
        "de": "Siehe Geschäftsbedingungen & Datenschutzerklärung",
        "it": "Visualizza Termini e Informativa sulla Privacy",
        "pt": "Veja os Termos e a Declaração de Privacidade",
        "sv": "Se villkor & sekretesspolicy"
    },
    {
        "en": "Home",
        "es": "Inicio",
        "fr": "Accueil",
        "de": "Startseite",
        "it": "Home",
        "pt": "Início",
        "sv": "Hem"
    },
    {
        "en": "Puzzle",
        "es": "Ejercicio",
        "fr": "Puzzle",
        "de": "Rätsel",
        "it": "Puzzle",
        "pt": "Tática",
        "sv": "Pussel"
    },
    {
        "en": "Access the 3 million Lichess puzzles.<br><br>Chessvis is the only program that lets you choose both the category AND rating of the puzzles you want to try.<br><br>Want to do hard 5 move puzzles one day and easy 2 move mates the next? Go ahead!",
        "es": "Accede a los 3 millones de puzzles de Lichess.<br><br>Chessvis es el único programa que te permite elegir tanto la categoría COMO el nivel de los ejercicios que quieres intentar.<br><br>¿Quieres hacer puzzles difíciles de 5 jugadas un día y mates fáciles de 2 jugadas al siguiente? ¡Adelante!",
        "fr": "Accédez aux 3 millions de puzzles Lichess.<br><br>Chessvis est le seul programme qui vous permet de choisir à la fois la catégorie ET le niveau des puzzles que vous souhaitez essayer.<br><br>Envie de faire des puzzles difficiles de 5 coups un jour et des mats faciles en 2 coups le lendemain ? Allez-y !",
        "de": "Greife auf 3 Millionen Lichess-Rätsel zu.<br><br>Chessvis ist das einzige Programm, das es dir erlaubt, sowohl die Kategorie ALS AUCH die Wertung der Rätsel zu wählen, die du ausprobieren möchtest.<br><br>Willst du eines Tages schwierige 5-Zug-Rätsel lösen und am nächsten einfache 2-Zug-Matts? Dann los!",
        "it": "Accedi ai 3 milioni di puzzle di Lichess.<br><br>Chessvis è l’unico programma che ti permette di scegliere sia la categoria CHE il livello dei puzzle che vuoi provare.<br><br>Vuoi fare puzzle difficili di 5 mosse un giorno e mate facili di 2 mosse il giorno dopo? Vai avanti!",
        "pt": "Acesse os 3 milhões de puzzles do Lichess.<br><br>Chessvis é o único programa que permite escolher tanto a categoria QUANTO a dificuldade dos puzzles que você quer tentar.<br><br>Quer fazer puzzles difíceis de 5 lances um dia e mates fáceis de 2 lances no dia seguinte? Vá em frente!",
        "sv": "Få åtkomst till 3 miljoner Lichess-pussel. Chessvis är det enda programmet där du kan välja både kategori OCH svårighetsbetyg. Vill du köra svåra 5-drarepussel ena dagen och lätta 2-drarepussel nästa — gör det!"
    },
    {
        "en": "The Mechanics",
        "es": "La mecánica",
        "fr": "La mécanique",
        "de": "Die Mechanik",
        "it": "La meccanica",
        "pt": "A mecânica",
        "sv": "Funktionerna"
    },
    {
        "en": "Make moves on the board by either 'drag and drop' or 'tap and go'.",
        "es": "Haz movimientos en el tablero arrastrando y soltando o tocando y moviendo.",
        "fr": "Effectuez des coups sur le plateau en utilisant « glisser-déposer » ou « toucher et jouer ».",
        "de": "Mache Züge auf dem Brett entweder per 'Drag & Drop' oder 'Tippen & Ziehen'.",
        "it": "Effettua le mosse sulla scacchiera trascinando o toccando e muovendo.",
        "pt": "Faça movimentos no tabuleiro arrastando e soltando ou tocando e movendo.",
        "sv": "Gör drag på brädet med drag & släpp eller tryck 'Från' och 'Till'."
    },
    {
        "en": "Moves you've played",
        "es": "Jugadas que has hecho",
        "fr": "Coups joués",
        "de": "Gespielte Züge",
        "it": "Mosse giocate",
        "pt": "Lances que você fez",
        "sv": "Drag du spelat"
    },
    {
        "en": "The move history",
        "es": "Historial de jugadas",
        "fr": "Historique des coups",
        "de": "Zugverlauf",
        "it": "Cronologia delle mosse",
        "pt": "Histórico de lances",
        "sv": "Draghistorik"
    },
    {
        "en": "Reveal - Toolbar",
        "es": "Revelar - Barra de herramientas",
        "fr": "Révéler - Barre d’outils",
        "de": "Anzeigen - Werkzeugleiste",
        "it": "Mostra - Barra degli strumenti",
        "pt": "Revelar - Barra de ferramentas",
        "sv": "Avslöja - Verktygsfält"
    },
    {
        "en": "The entire sequence of moves to solve the puzzle are played out",
        "es": "Se reproducen todas las jugadas necesarias para resolver el puzzle",
        "fr": "La séquence complète de coups pour résoudre le puzzle est jouée",
        "de": "Die gesamte Zugfolge zur Lösung des Rätsels wird gezeigt",
        "it": "Viene mostrata l’intera sequenza di mosse per risolvere il puzzle",
        "pt": "A sequência completa de lances para resolver o puzzle é exibida",
        "sv": "Hela lösningssekvensen spelas upp"
    },
    {
        "en": "How about solving puzzles with a blindfold on?<br><br>Chessvis offers several 'stepping stones' on the way to an empty board",
        "es": "¿Qué tal resolver puzzles con los ojos vendados?<br><br>Chessvis ofrece varios 'pasos intermedios' hacia un tablero vacío",
        "fr": "Et si vous résolviez des puzzles les yeux bandés ?<br><br>Chessvis propose plusieurs « étapes » vers un plateau vide",
        "de": "Wie wäre es, Rätsel mit verbundenen Augen zu lösen?<br><br>Chessvis bietet mehrere 'Schritte' auf dem Weg zu einem leeren Brett",
        "it": "Che ne dici di risolvere puzzle a occhi chiusi?<br><br>Chessvis offre diversi 'passaggi graduali' verso una scacchiera vuota",
        "pt": "Que tal resolver puzzles vendado?<br><br>O Chessvis oferece várias 'etapas' para chegar a um tabuleiro vazio",
        "sv": "Vad sägs om att lösa pussel med blindfold? Chessvis erbjuder flera steg mot ett tomt bräde"
    },
    {
        "en": "Blindfold Levels",
        "es": "Niveles a ciegas",
        "fr": "Niveaux à l’aveugle",
        "de": "Blindschach-Level",
        "it": "Livelli alla cieca",
        "pt": "Níveis às cegas",
        "sv": "Blindfold-nivåer"
    },
    {
        "en": "Most people think of an empty board when they hear '<i>blindfold<\/i>'.<br><br>With Chessvis, you can have all the pieces be of the same color, two color disks, or one color disks plus the 'empty board'",
        "es": "La mayoría piensa en un tablero vacío cuando escucha '<i>a ciegas<\/i>'.<br><br>Con Chessvis, puedes tener todas las piezas de un mismo color, discos de dos colores o un disco de un color más el 'tablero vacío'",
        "fr": "La plupart des gens pensent à un plateau vide lorsqu’ils entendent '<i>à l’aveugle<\/i>'.<br><br>Avec Chessvis, toutes les pièces peuvent être de la même couleur, deux couleurs de disques, ou un disque coloré plus le plateau vide",
        "de": "Die meisten denken an ein leeres Brett, wenn sie '<i>Blindschach<\/i>' hören.<br><br>Mit Chessvis können alle Figuren die gleiche Farbe haben, zwei Farbkreise oder ein Farbkreis plus das 'leere Brett'.",
        "it": "La maggior parte delle persone pensa a una scacchiera vuota quando sente '<i>alla cieca<\/i>'.<br><br>Con Chessvis puoi avere tutti i pezzi dello stesso colore, dischi di due colori o un disco colorato più la scacchiera vuota",
        "pt": "A maioria pensa em um tabuleiro vazio quando ouve '<i>às cegas<\/i>'.<br><br>Com Chessvis, todas as peças podem ser da mesma cor, discos de duas cores ou um disco colorido mais o 'tabuleiro vazio'",
        "sv": "Många tänker på ett tomt bräde när de hör 'blindfold'. I Chessvis kan alla pjäser vara samma färg, tvåfärgade brickor, en gemensam bricka eller tomt bräde."
    },
    {
        "en": "Blindfold Mechanics",
        "es": "Mecánica a ciegas",
        "fr": "Mécanique à l’aveugle",
        "de": "Blindschach-Mechanik",
        "it": "Meccanica alla cieca",
        "pt": "Mecânica às cegas",
        "sv": "Blindfold-mekanik"
    },
    {
        "en": "Make moves on the board by either 'drag and drop' or 'tap and go'.<br><br>And yes, even with an 'empty board' there are invisible pieces for you to move around.",
        "es": "Haz movimientos en el tablero arrastrando y soltando o tocando y moviendo.<br><br>Sí, incluso con un 'tablero vacío', hay piezas invisibles para mover.",
        "fr": "Effectuez des coups sur le plateau en utilisant « glisser-déposer » ou « toucher et jouer ».<br><br>Et oui, même avec un « plateau vide », il y a des pièces invisibles à déplacer.",
        "de": "Mache Züge auf dem Brett entweder per 'Drag & Drop' oder 'Tippen & Ziehen'.<br><br>Und ja, selbst auf einem 'leeren Brett' gibt es unsichtbare Figuren zum Bewegen.",
        "it": "Effettua le mosse sulla scacchiera trascinando o toccando e muovendo.<br><br>E sì, anche con una 'scacchiera vuota' ci sono pezzi invisibili da muovere.",
        "pt": "Faça movimentos no tabuleiro arrastando e soltando ou tocando e movendo.<br><br>E sim, mesmo com um 'tabuleiro vazio' há peças invisíveis para movimentar.",
        "sv": "Gör drag med drag & släpp eller tryck 'Från' och 'Till'. Även med 'tomt bräde' finns osynliga pjäser att flytta."
    },
    {
        "en": "Where the pieces are",
        "es": "Dónde están las piezas",
        "fr": "Où sont les pièces",
        "de": "Wo die Figuren sind",
        "it": "Dove sono i pezzi",
        "pt": "Onde estão as peças",
        "sv": "Var pjäserna står"
    },
    {
        "en": "Here, you'll see a list of where all the pieces are located. It's your job to visualize the board from that list.",
        "es": "Aquí verás una lista con la ubicación de todas las piezas. Tu tarea es visualizar el tablero a partir de esa lista.",
        "fr": "Ici, vous verrez une liste indiquant où se trouvent toutes les pièces. À vous de visualiser le plateau à partir de cette liste.",
        "de": "Hier siehst du eine Liste, wo sich alle Figuren befinden. Deine Aufgabe ist es, das Brett aus dieser Liste zu visualisieren.",
        "it": "Qui vedrai un elenco di dove si trovano tutti i pezzi. Il tuo compito è visualizzare la scacchiera da quell’elenco.",
        "pt": "Aqui você verá uma lista mostrando onde todas as peças estão. Seu trabalho é visualizar o tabuleiro a partir dessa lista.",
        "sv": "Här ser du en lista över pjäsernas placering — din uppgift är att visualisera brädet utifrån den."
    },
    {
        "en": "Blindfold Option - Toolbar",
        "es": "Opción a ciegas - Barra de herramientas",
        "fr": "Option à l’aveugle - Barre d’outils",
        "de": "Blindschach-Option - Werkzeugleiste",
        "it": "Opzione alla cieca - Barra degli strumenti",
        "pt": "Opção às cegas - Barra de ferramentas",
        "sv": "Blindfold-alternativ - Verktygsfält"
    },
    {
        "en": "Start with all the pieces on the board sharing one color. Then move up to 2 color disks, 1 shared color disk and then the empty board.",
        "es": "Comienza con todas las piezas del mismo color en el tablero. Luego pasa a discos de dos colores, un disco compartido y finalmente al tablero vacío.",
        "fr": "Commencez avec toutes les pièces sur le plateau de la même couleur. Puis passez à deux couleurs de disques, un disque partagé, puis au plateau vide.",
        "de": "Beginne mit allen Figuren auf dem Brett in einer Farbe. Dann zu zwei Farbkreisen, einem gemeinsamen Farbkreis und schließlich zum leeren Brett.",
        "it": "Inizia con tutti i pezzi sulla scacchiera dello stesso colore. Poi passa ai dischi di due colori, un disco condiviso e infine alla scacchiera vuota.",
        "pt": "Comece com todas as peças no tabuleiro de uma cor. Depois passe para discos de 2 cores, 1 disco compartilhado e finalmente para o tabuleiro vazio.",
        "sv": "Börja med alla pjäser i samma färg, gå vidare till tvåfärgade brickor, en gemensam bricka och slutligen tomt bräde."
    },
    {
        "en": "Chessvis adds a unique twist on puzzles called <b>'visualization'<\/b>. The board on the screen you see is from some number of moves before the puzzle actually starts.<br><br><i>And while the text that follows describes it, watching the 5 minute video is the way to go.<\/i>",
        "es": "Chessvis agrega un giro único a los puzzles llamado <b>'visualización'<\/b>. El tablero que ves en pantalla es de algunos movimientos antes de que el puzzle realmente comience.<br><br><i>Y aunque el texto lo describa, ver el video de 5 minutos es la mejor manera de entenderlo.<\/i>",
        "fr": "Chessvis ajoute une touche unique aux puzzles appelée <b>'visualisation'<\/b>. Le plateau affiché à l’écran correspond à quelques coups avant le début réel du puzzle.<br><br><i>Et bien que le texte ci-dessous le décrive, regarder la vidéo de 5 minutes est le meilleur moyen de comprendre.<\/i>",
        "de": "Chessvis fügt den Rätseln eine einzigartige Wendung hinzu, genannt <b>'Visualisierung'<\/b>. Das auf dem Bildschirm gezeigte Brett ist einige Züge vor Beginn des Rätsels.<br><br><i>Und obwohl der Text es beschreibt, ist es am besten, das 5-minütige Video anzuschauen.<\/i>",
        "it": "Chessvis aggiunge un tocco unico ai puzzle chiamato <b>'visualizzazione'<\/b>. La scacchiera che vedi sullo schermo mostra alcune mosse prima dell’inizio effettivo del puzzle.<br><br><i>E anche se il testo lo descrive, guardare il video di 5 minuti è il modo migliore per capirlo.<\/i>",
        "pt": "Chessvis adiciona uma característica única aos puzzles chamada <b>'visualização'<\/b>. O tabuleiro que você vê na tela é de alguns lances antes do início real do puzzle.<br><br><i>E embora o texto explique, assistir ao vídeo de 5 minutos é a melhor maneira de entender.<\/i>",
        "sv": "Chessvis har en unik twist: 'visualisering'. Brädet du ser är ett antal drag före pusslets start. Läs gärna texten men titta på 5-minutersvideon för bästa förklaring."
    },
    {
        "en": "Timed Puzzle Visualization",
        "es": "Visualización de Puzzles con Temporizador",
        "fr": "Visualisation de Puzzle Chronométrée",
        "de": "Zeitgesteuerte Rätsel-Visualisierung",
        "it": "Visualizzazione dei Puzzle a Tempo",
        "pt": "Visualização de Puzzles Cronometrada",
        "sv": "Tidsstyrd pusselvisualisering"
    },
    {
        "en": "Chessvis combines a timer with the unique <b>'visualization'<\/b> twist. The board on the screen you see is from some number of moves before the puzzle actually starts.<br><br><i>And while the text that follows describes it, watching the 5 minute video is the way to go.<\/i>",
        "es": "Chessvis combina un temporizador con el giro único de <b>'visualización'<\/b>. El tablero que ves en pantalla es de algunos movimientos antes de que el puzzle realmente comience.<br><br><i>Y aunque el texto lo describa, ver el video de 5 minutos es la mejor manera de entenderlo.<\/i>",
        "fr": "Chessvis combine un chronomètre avec la touche unique <b>'visualisation'<\/b>. Le plateau à l’écran est quelques coups avant le début réel du puzzle.<br><br><i>Et bien que le texte ci-dessous le décrive, regarder la vidéo de 5 minutes est le meilleur moyen de comprendre.<\/i>",
        "de": "Chessvis kombiniert einen Timer mit der einzigartigen <b>'Visualisierung'<\/b>. Das Brett auf dem Bildschirm zeigt einige Züge vor Beginn des Rätsels.<br><br><i>Und obwohl der Text es beschreibt, ist es am besten, das 5-minütige Video anzuschauen.<\/i>",
        "it": "Chessvis combina un timer con l’unico tocco di <b>'visualizzazione'<\/b>. La scacchiera sullo schermo mostra alcune mosse prima dell’inizio effettivo del puzzle.<br><br><i>E anche se il testo lo descrive, guardare il video di 5 minuti è il modo migliore per capirlo.<\/i>",
        "pt": "Chessvis combina um temporizador com a característica única <b>'visualização'<\/b>. O tabuleiro na tela é de alguns lances antes do início real do puzzle.<br><br><i>E embora o texto descreva, assistir ao vídeo de 5 minutos é a melhor maneira de entender.<\/i>",
        "sv": "Chessvis kombinerar timer med den unika 'visualiseringen': brädet är några drag före pusslets start. Videon förklarar bäst."
    },
    {
        "en": "The Idea",
        "es": "La Idea",
        "fr": "L’Idée",
        "de": "Die Idee",
        "it": "L’Idea",
        "pt": "A Ideia",
        "sv": "Idén"
    },
    {
        "en": "You're told the moves that need to be made before attempting to solve the puzzle. This forces you to solve the puzzle all in your head.<br><br>For example, let's say a puzzle starts on move 50 of a game and you set visualization to 3 moves then the board on the screen will be from the game's move number 47.",
        "es": "Se te indican los movimientos que debes realizar antes de intentar resolver el puzzle. Esto te obliga a resolverlo completamente en tu cabeza.<br><br>Por ejemplo, si un puzzle comienza en la jugada 50 de una partida y configuras la visualización a 3 movimientos, entonces el tablero en pantalla será de la jugada 47.",
        "fr": "On vous indique les coups à effectuer avant de tenter de résoudre le puzzle. Cela vous oblige à résoudre le puzzle entièrement dans votre tête.<br><br>Par exemple, si un puzzle commence au coup 50 d’une partie et que vous réglez la visualisation sur 3 coups, le plateau affiché sera celui du coup 47.",
        "de": "Dir werden die Züge gesagt, die vor dem Lösen des Rätsels gemacht werden müssen. So musst du das Rätsel vollständig im Kopf lösen.<br><br>Beispiel: Ein Rätsel beginnt bei Zug 50 eines Spiels und du stellst die Visualisierung auf 3 Züge, dann zeigt das Brett auf dem Bildschirm Zug 47.",
        "it": "Ti vengono indicate le mosse da effettuare prima di provare a risolvere il puzzle. Questo ti costringe a risolverlo completamente nella mente.<br><br>Ad esempio, se un puzzle inizia alla mossa 50 di una partita e imposti la visualizzazione a 3 mosse, la scacchiera sullo schermo sarà quella della mossa 47.",
        "pt": "Você recebe os lances que precisam ser feitos antes de tentar resolver o puzzle. Isso força você a resolver o puzzle totalmente na cabeça.<br><br>Por exemplo, se um puzzle começa no lance 50 de uma partida e você define a visualização para 3 lances, o tabuleiro na tela será do lance 47.",
        "sv": "Du får veta vilka drag som spelats innan pusslet börjar — du måste lösa det i huvudet. Ex: om pusslet börjar på drag 50 och du väljer 3 drag visualisering visas brädet från drag 47."
    },
    {
        "en": "Your Task",
        "es": "Tu Tarea",
        "fr": "Votre Tâche",
        "de": "Deine Aufgabe",
        "it": "Il Tuo Compito",
        "pt": "Sua Tarefa",
        "sv": "Din uppgift"
    },
    {
        "en": "You'll be shown the text for the 3 moves needed to get to the puzzle start. You'll need to play those the 3 moves without benefit of updating the board. Then figure out the puzzle solution.",
        "es": "Se te mostrará el texto de los 3 movimientos necesarios para llegar al inicio del puzzle. Debes realizar esas 3 jugadas sin actualizar el tablero y luego resolver el puzzle.",
        "fr": "On vous montrera le texte des 3 coups nécessaires pour atteindre le début du puzzle. Vous devez jouer ces 3 coups sans mettre à jour le plateau, puis résoudre le puzzle.",
        "de": "Dir wird der Text für die 3 Züge gezeigt, die zum Start des Rätsels nötig sind. Du musst diese 3 Züge spielen, ohne das Brett zu aktualisieren, und dann die Lösung finden.",
        "it": "Ti verranno mostrati i testi delle 3 mosse necessarie per arrivare all’inizio del puzzle. Dovrai eseguire queste 3 mosse senza aggiornare la scacchiera e poi risolvere il puzzle.",
        "pt": "Você verá o texto dos 3 lances necessários para chegar ao início do puzzle. Você deve executar esses 3 lances sem atualizar o tabuleiro e depois descobrir a solução do puzzle.",
        "sv": "Du får texten för de tre dragen som leder fram till pusslet. Spela dem i huvudet utan bräduppdatering och hitta lösningen."
    },
    {
        "en": "Since the pieces aren't necessarily on the right square for the puzzle start, you use 'Tap and Go'. Tap on the 'from' and 'to' squares for where the pieces are after the 3 moves have been played.",
        "es": "Como las piezas no están necesariamente en la posición inicial del puzzle, usas 'Tocar y Mover'. Toca las casillas de 'origen' y 'destino' según la ubicación de las piezas después de las 3 jugadas.",
        "fr": "Comme les pièces ne sont pas forcément sur la bonne case au début du puzzle, utilisez « Toucher et Jouer ». Touchez les cases « de » et « à » pour placer les pièces après les 3 coups.",
        "de": "Da die Figuren nicht unbedingt auf dem richtigen Feld für den Puzzle-Start stehen, benutzt du 'Tippen & Ziehen'. Tippe auf die 'von'- und 'zu'-Felder entsprechend den Figurenpositionen nach den 3 Zügen.",
        "it": "Poiché i pezzi non sono necessariamente sulla casella giusta all’inizio del puzzle, usa 'Tocca e Vai'. Tocca le caselle 'da' e 'a' secondo dove si trovano i pezzi dopo le 3 mosse.",
        "pt": "Como as peças não estão necessariamente na casa correta no início do puzzle, use 'Toque e Vá'. Toque nas casas 'de' e 'para' de acordo com a posição das peças após os 3 lances.",
        "sv": "Eftersom pjäserna inte står rätt för pusslets start använder du 'Tryck och gå': tryck på 'från' och 'till' för var pjäserna är efter de tre dragen."
    },
    {
        "en": "Did you Watch the Video?",
        "es": "¿Viste el Video?",
        "fr": "Avez-vous Regardé la Vidéo ?",
        "de": "Hast du das Video gesehen?",
        "it": "Hai Guardato il Video?",
        "pt": "Você Assistiu ao Vídeo?",
        "sv": "Har du sett videon?"
    },
    {
        "en": "It's not that a 2 move mate has turned into a 5 move mate. It's still the same puzzle but you have to 'visualize' the solution.",
        "es": "No es que un mate de 2 jugadas se haya convertido en uno de 5. Sigue siendo el mismo puzzle, pero debes 'visualizar' la solución.",
        "fr": "Ce n’est pas qu’un mat en 2 coups soit devenu un mat en 5 coups. C’est toujours le même puzzle, mais vous devez 'visualiser' la solution.",
        "de": "Es ist nicht so, dass ein 2-Züge-Matt zu einem 5-Züge-Matt geworden ist. Es ist immer noch dasselbe Rätsel, aber du musst die Lösung 'visualisieren'.",
        "it": "Non è che un matto in 2 mosse sia diventato un matto in 5 mosse. È sempre lo stesso puzzle, ma devi 'visualizzare' la soluzione.",
        "pt": "Não é que um mate de 2 lances se transformou em um mate de 5 lances. Continua sendo o mesmo puzzle, mas você precisa 'visualizar' a solução.",
        "sv": "Det är inte så att ett 2-drarepussel blivit 5-drag — samma pussel, men du måste visualisera lösningen."
    },
    {
        "en": "Tap and Go",
        "es": "Tocar y Mover",
        "fr": "Toucher et Jouer",
        "de": "Tippen & Ziehen",
        "it": "Tocca e Vai",
        "pt": "Toque e Vá",
        "sv": "Tryck och gå"
    },
    {
        "en": "Since the board is before the puzzle starts, you 'tap' on the square where the piece is now located and then 'tap' on the square where the piece should move to",
        "es": "Como el tablero está antes del inicio del puzzle, debes 'tocar' la casilla donde la pieza está ahora y luego 'tocar' la casilla a la que debe moverse",
        "fr": "Comme le plateau est avant le début du puzzle, vous 'touchez' la case où se trouve la pièce, puis la case où elle doit aller.",
        "de": "Da das Brett vor dem Start des Rätsels ist, tippst du auf das Feld, auf dem sich die Figur jetzt befindet, und dann auf das Feld, wohin sie ziehen soll.",
        "it": "Poiché la scacchiera è prima dell’inizio del puzzle, 'tocca' la casella dove si trova il pezzo ora e poi 'tocca' la casella dove deve muoversi.",
        "pt": "Como o tabuleiro está antes do início do puzzle, você 'toca' na casa onde a peça está agora e depois 'toca' na casa para onde ela deve se mover.",
        "sv": "Eftersom brädet är före pusslets start 'trycker' du på rutan där pjäsen står nu och på rutan den ska flytta till."
    },
    {
        "en": "Puzzle Info and Status",
        "es": "Información y Estado del Puzzle",
        "fr": "Infos et Statut du Puzzle",
        "de": "Rätsel-Info und Status",
        "it": "Informazioni e Stato del Puzzle",
        "pt": "Informações e Status do Puzzle",
        "sv": "Pusselinformation och status"
    },
    {
        "en": "This area lets you know if your move is good or bad",
        "es": "Esta área te indica si tu jugada es buena o mala",
        "fr": "Cette zone vous indique si votre coup est bon ou mauvais",
        "de": "Dieser Bereich zeigt dir, ob dein Zug gut oder schlecht ist",
        "it": "Quest’area ti mostra se la tua mossa è corretta o sbagliata",
        "pt": "Esta área mostra se o seu lance está certo ou errado",
        "sv": "Här ser du om ditt drag är rätt eller fel"
    },
    {
        "en": "Moves To Visualize",
        "es": "Movimientos a Visualizar",
        "fr": "Coups à Visualiser",
        "de": "Zu visualisierende Züge",
        "it": "Mosse da Visualizzare",
        "pt": "Lances para Visualizar",
        "sv": "Drag att visualisera"
    },
    {
        "en": "Here are the moves you need to play out in your mind before solving the puzzle.",
        "es": "Aquí están los movimientos que debes imaginar antes de resolver el puzzle.",
        "fr": "Voici les coups que vous devez jouer dans votre tête avant de résoudre le puzzle.",
        "de": "Hier sind die Züge, die du in deinem Kopf ausführen musst, bevor du das Rätsel löst.",
        "it": "Ecco le mosse che devi eseguire mentalmente prima di risolvere il puzzle.",
        "pt": "Aqui estão os lances que você precisa visualizar na mente antes de resolver o puzzle.",
        "sv": "Här är de drag du måste spela i huvudet innan du löser pusslet."
    },
    {
        "fake": true,
        "en": "Timed Puzzle Visualization Mechanics",
        "es": "Mecánica de Visualización de Puzzles con Temporizador",
        "fr": "Mécanique de Visualisation de Puzzle Chronométrée",
        "de": "Mechanik der Zeitgesteuerten Rätsel-Visualisierung",
        "it": "Meccanica della Visualizzazione dei Puzzle a Tempo",
        "pt": "Mecânica da Visualização de Puzzles Cronometrada",
        "sv": "Mekanik för tidsstyrd visualisering"
    },
    {
        "fake": true,
        "en": "The timer runs as you visualize each move. Make sure to follow the move sequence in your mind accurately before attempting the puzzle solution.",
        "es": "El temporizador corre mientras visualizas cada movimiento. Asegúrate de seguir la secuencia de movimientos mentalmente antes de intentar resolver el puzzle.",
        "fr": "Le chronomètre tourne pendant que vous visualisez chaque coup. Assurez-vous de suivre correctement la séquence des coups dans votre tête avant de tenter la solution du puzzle.",
        "de": "Der Timer läuft, während du jeden Zug visualisierst. Stelle sicher, dass du die Zugfolge im Kopf genau verfolgst, bevor du die Lösung des Rätsels versuchst.",
        "it": "Il timer scorre mentre visualizzi ogni mossa. Assicurati di seguire la sequenza di mosse nella mente prima di tentare la soluzione del puzzle.",
        "pt": "O temporizador funciona enquanto você visualiza cada lance. Certifique-se de seguir a sequência de lances na mente antes de tentar a solução do puzzle.",
        "sv": "Timern går medan du visualiserar varje drag. Följ sekvensen noggrant i huvudet innan du försöker lösa pusslet."
    },
    {
        "fake": true,
        "en": "Visualizing moves helps you improve board memory and pattern recognition, key skills for blindfold chess and advanced play.",
        "es": "Visualizar movimientos te ayuda a mejorar la memoria del tablero y el reconocimiento de patrones, habilidades clave para el ajedrez a ciegas y el juego avanzado.",
        "fr": "Visualiser les coups vous aide à améliorer la mémoire du plateau et la reconnaissance des motifs, compétences clés pour les échecs à l’aveugle et le jeu avancé.",
        "de": "Das Visualisieren von Zügen hilft, das Brettgedächtnis und die Mustererkennung zu verbessern – wichtige Fähigkeiten für Blindschach und fortgeschrittenes Spiel.",
        "it": "Visualizzare le mosse ti aiuta a migliorare la memoria della scacchiera e il riconoscimento dei pattern, abilità chiave per gli scacchi a occhi chiusi e il gioco avanzato.",
        "pt": "Visualizar lances ajuda a melhorar a memória do tabuleiro e o reconhecimento de padrões, habilidades-chave para xadrez às cegas e jogo avançado.",
        "sv": "Visualisering förbättrar brädminne och mönsterigenkänning — viktiga färdigheter för blindfold och avancerat spel."
    },
    {
        "fake": true,
        "en": "Start with easier puzzles and shorter visualization sequences, then gradually increase difficulty as you gain confidence.",
        "es": "Comienza con puzzles más fáciles y secuencias de visualización cortas, luego aumenta la dificultad a medida que ganes confianza.",
        "fr": "Commencez par des puzzles plus faciles et des séquences de visualisation courtes, puis augmentez progressivement la difficulté à mesure que vous gagnez en confiance.",
        "de": "Beginne mit einfacheren Rätseln und kürzeren Visualisierungssequenzen, und steigere die Schwierigkeit allmählich, wenn du sicherer wirst.",
        "it": "Inizia con puzzle più semplici e sequenze di visualizzazione brevi, quindi aumenta gradualmente la difficoltà man mano che acquisisci sicurezza.",
        "pt": "Comece com puzzles mais fáceis e sequências de visualização curtas, depois aumente a dificuldade à medida que ganha confiança.",
        "sv": "Börja med enklare pussel och kortare sekvenser, öka svårigheten gradvis när du blir trygg."
    },
    {
        "fake": true,
        "en": "Timed Visualization is perfect for training your mind to anticipate moves quickly under pressure.",
        "es": "La visualización cronometrada es perfecta para entrenar tu mente a anticipar movimientos rápidamente bajo presión.",
        "fr": "La visualisation chronométrée est parfaite pour entraîner votre esprit à anticiper rapidement les coups sous pression.",
        "de": "Zeitgesteuerte Visualisierung ist ideal, um dein Gehirn zu trainieren, Züge unter Druck schnell vorherzusehen.",
        "it": "La visualizzazione a tempo è perfetta per allenare la mente ad anticipare le mosse rapidamente sotto pressione.",
        "pt": "A visualização cronometrada é perfeita para treinar sua mente a antecipar lances rapidamente sob pressão.",
        "sv": "Tidsstyrd visualisering är perfekt för att träna hjärnan att förutse drag snabbt under press."
    },
    {
        "en": "If you play on-line, you need fast puzzle recognition.<br><br>You don't have time to solve a fancy 5 move puzzle. Nope, you need to solve simpler puzzles faster.",
        "es": "Si juegas en línea, necesitas reconocer puzzles rápidamente.<br><br>No tienes tiempo para resolver un complicado puzzle de 5 movimientos. No, necesitas resolver puzzles más simples más rápido.",
        "fr": "Si vous jouez en ligne, vous avez besoin d’une reconnaissance rapide des puzzles.<br><br>Vous n’avez pas le temps de résoudre un puzzle complexe en 5 coups. Non, vous devez résoudre des puzzles plus simples plus rapidement.",
        "de": "Wenn du online spielst, brauchst du schnelle Rätselerkennung.<br><br>Du hast keine Zeit für ein kompliziertes 5-Züge-Rätsel. Nein, du musst einfachere Rätsel schneller lösen.",
        "it": "Se giochi online, hai bisogno di riconoscere i puzzle rapidamente.<br><br>Non hai tempo per risolvere un puzzle complesso di 5 mosse. No, devi risolvere puzzle più semplici più velocemente.",
        "pt": "Se você joga online, precisa reconhecer puzzles rapidamente.<br><br>Você não tem tempo para resolver um puzzle complicado de 5 lances. Não, você precisa resolver puzzles mais simples mais rápido.",
        "sv": "På nätet krävs snabb pusseligenkänning — du har inte tid för ett avancerat 5-drarepussel; du behöver lösa enklare pussel snabbare."
    },
    {
        "en": "Start, Give-Up and Get-Next - Toolbar",
        "es": "Iniciar, Rendirse y Siguiente - Barra de Herramientas",
        "fr": "Démarrer, Abandonner et Suivant - Barre d’Outils",
        "de": "Start, Aufgeben und Nächstes - Werkzeugleiste",
        "it": "Inizia, Rinuncia e Successivo - Barra degli Strumenti",
        "pt": "Iniciar, Desistir e Próximo - Barra de Ferramentas",
        "sv": "Start, ge upp och hämta nästa - Verktygsfält"
    },
    {
        "en": "Retrieve a puzzle",
        "es": "Recuperar un puzzle",
        "fr": "Récupérer un puzzle",
        "de": "Ein Rätsel abrufen",
        "it": "Recupera un puzzle",
        "pt": "Recuperar um puzzle",
        "sv": "Hämta ett pussel"
    },
    {
        "en": "Back - Toolbar",
        "es": "Atrás - Barra de Herramientas",
        "fr": "Retour - Barre d’Outils",
        "de": "Zurück - Werkzeugleiste",
        "it": "Indietro - Barra degli Strumenti",
        "pt": "Voltar - Barra de Ferramentas",
        "sv": "Tillbaka - Verktygsfält"
    },
    {
        "en": "Undo a wrong move or Undo a full move",
        "es": "Deshacer un movimiento incorrecto o deshacer un movimiento completo",
        "fr": "Annuler un coup incorrect ou annuler un coup complet",
        "de": "Einen falschen Zug oder einen ganzen Zug rückgängig machen",
        "it": "Annulla una mossa sbagliata o una mossa completa",
        "pt": "Desfazer um lance errado ou desfazer um lance completo",
        "sv": "Ångra ett felaktigt halvdrag eller ett helt drag"
    },
    {
        "en": "Rewind - Toolbar",
        "es": "Rebobinar - Barra de Herramientas",
        "fr": "Rembobiner - Barre d’Outils",
        "de": "Zurückspulen - Werkzeugleiste",
        "it": "Riavvolgi - Barra degli Strumenti",
        "pt": "Retroceder - Barra de Ferramentas",
        "sv": "Spola tillbaka - Verktygsfält"
    },
    {
        "en": "Restart the puzzle",
        "es": "Reiniciar el puzzle",
        "fr": "Recommencer le puzzle",
        "de": "Das Rätsel neu starten",
        "it": "Riavvia il puzzle",
        "pt": "Reiniciar o puzzle",
        "sv": "Starta om pusslet"
    },
    {
        "en": "Hint - Toolbar",
        "es": "Pista - Barra de Herramientas",
        "fr": "Indice - Barre d’Outils",
        "de": "Hinweis - Werkzeugleiste",
        "it": "Suggerimento - Barra degli Strumenti",
        "pt": "Dica - Barra de Ferramentas",
        "sv": "Tips - Verktygsfält"
    },
    {
        "en": "The move you're supposed to make is displayed on the status line",
        "es": "El movimiento que debes realizar se muestra en la línea de estado",
        "fr": "Le coup que vous devez jouer est affiché sur la barre d’état",
        "de": "Der Zug, den du machen sollst, wird in der Statuszeile angezeigt",
        "it": "La mossa che devi fare viene mostrata sulla barra di stato",
        "pt": "O lance que você deve fazer é exibido na linha de status",
        "sv": "Ditt förväntade drag visas i statusraden"
    },
    {
        "en": "The entire sequence of moves to solve the puzzle including the moves to visualize are played out",
        "es": "Se reproduce toda la secuencia de movimientos para resolver el puzzle, incluyendo los movimientos que debes visualizar",
        "fr": "La séquence complète de coups pour résoudre le puzzle, y compris les coups à visualiser, est exécutée",
        "de": "Die gesamte Zugfolge zur Lösung des Rätsels, einschließlich der zu visualisierenden Züge, wird ausgeführt",
        "it": "Viene eseguita l’intera sequenza di mosse per risolvere il puzzle, comprese le mosse da visualizzare",
        "pt": "Toda a sequência de lances para resolver o puzzle, incluindo os lances a visualizar, é executada",
        "sv": "Hela lösningssekvensen inklusive visualiseringsdragen spelas upp"
    },
    {
        "en": "Explore - Toolbar",
        "es": "Explorar - Barra de Herramientas",
        "fr": "Explorer - Barre d’Outils",
        "de": "Erkunden - Werkzeugleiste",
        "it": "Esplora - Barra degli Strumenti",
        "pt": "Explorar - Barra de Ferramentas",
        "sv": "Utforska - Verktygsfält"
    },
    {
        "en": "Curious why a particular move doesn't work? The 'explore' mode enables you to play any move for both sides.<br><br>'Best' moves are suggested by the Stockfish computer engine.",
        "es": "¿Curioso por qué un movimiento en particular no funciona? El modo 'explorar' te permite jugar cualquier movimiento para ambos lados.<br><br>Los movimientos 'mejores' son sugeridos por el motor de ajedrez Stockfish.",
        "fr": "Curieux de savoir pourquoi un coup particulier ne fonctionne pas ? Le mode 'explorer' vous permet de jouer n’importe quel coup pour les deux camps.<br><br>Les meilleurs coups sont suggérés par le moteur Stockfish.",
        "de": "Neugierig, warum ein bestimmter Zug nicht funktioniert? Der 'Erkunden'-Modus ermöglicht es dir, jeden Zug für beide Seiten zu spielen.<br><br>'Beste' Züge werden vom Stockfish-Computerprogramm vorgeschlagen.",
        "it": "Curioso di sapere perché una mossa particolare non funziona? La modalità 'esplora' ti permette di fare qualsiasi mossa per entrambi i lati.<br><br>Le mosse 'migliori' sono suggerite dal motore di scacchi Stockfish.",
        "pt": "Curioso por que um movimento específico não funciona? O modo 'explorar' permite jogar qualquer lance para ambos os lados.<br><br>Os melhores lances são sugeridos pelo motor de xadrez Stockfish.",
        "sv": "Nyfiken på varför ett drag inte fungerar? 'Utforska'-läget låter dig spela valfria drag för båda sidor. 'Bästa' drag föreslås av Stockfish."
    },
    {
        "en": "Category Option - Toolbar",
        "es": "Opción de Categoría - Barra de Herramientas",
        "fr": "Option de Catégorie - Barre d’Outils",
        "de": "Kategorie-Option - Werkzeugleiste",
        "it": "Opzione Categoria - Barra degli Strumenti",
        "pt": "Opção de Categoria - Barra de Ferramentas",
        "sv": "Kategori-val - Verktygsfält"
    },
    {
        "en": "Select from any one of 60+ puzzle categories",
        "es": "Selecciona entre más de 60 categorías de puzzles",
        "fr": "Sélectionnez parmi plus de 60 catégories de puzzles",
        "de": "Wähle aus über 60 Puzzle-Kategorien",
        "it": "Seleziona tra oltre 60 categorie di puzzle",
        "pt": "Selecione entre mais de 60 categorias de puzzles",
        "sv": "Välj bland 60+ pusselkategorier"
    },
    {
        "en": "Rating Option #1 - Toolbar",
        "es": "Opción de Rating #1 - Barra de Herramientas",
        "fr": "Option de Cote #1 - Barre d’Outils",
        "de": "Bewertungsoption #1 - Werkzeugleiste",
        "it": "Opzione Rating #1 - Barra degli Strumenti",
        "pt": "Opção de Rating #1 - Barra de Ferramentas",
        "sv": "Betygsval #1 - Verktygsfält"
    },
    {
        "en": "With Chessvis, you can specify a 'target' start rating. As you successfully solve puzzles or miss them, the rating will automatically drift upward and downward.<br><br>You are free to set whatever rating you feel like.",
        "es": "Con Chessvis, puedes especificar un rating inicial 'objetivo'. A medida que resuelvas los puzzles correctamente o falle, el rating se ajustará automáticamente hacia arriba o abajo.<br><br>Libertad para establecer el rating que desees.",
        "fr": "Avec Chessvis, vous pouvez spécifier un classement de départ 'cible'. En réussissant ou en échouant aux puzzles, le classement fluctue automatiquement.<br><br>Vous êtes libre de définir le classement que vous souhaitez.",
        "de": "Mit Chessvis kannst du eine 'Ziel'-Startbewertung festlegen. Wenn du Rätsel erfolgreich löst oder verfehlst, passt sich die Bewertung automatisch nach oben oder unten an.<br><br>Du kannst jede gewünschte Bewertung einstellen.",
        "it": "Con Chessvis puoi specificare un rating iniziale 'target'. Man mano che risolvi o sbagli i puzzle, il rating varierà automaticamente.<br><br>Puoi impostare liberamente qualsiasi rating tu voglia.",
        "pt": "Com o Chessvis, você pode especificar um rating inicial 'alvo'. À medida que resolve ou erra puzzles, o rating ajusta-se automaticamente para cima ou para baixo.<br><br>Você é livre para definir o rating que quiser.",
        "sv": "I Chessvis kan du sätta ett mål-startbetyg. När du klarar eller missar pussel justeras betyget automatiskt upp\/ner. Du väljer helt fritt."
    },
    {
        "en": "Rating Option #2 - Toolbar",
        "es": "Opción de Rating #2 - Barra de Herramientas",
        "fr": "Option de Cote #2 - Barre d’Outils",
        "de": "Bewertungsoption #2 - Werkzeugleiste",
        "it": "Opzione Rating #2 - Barra degli Strumenti",
        "pt": "Opção de Rating #2 - Barra de Ferramentas",
        "sv": "Betygsval #2 - Verktygsfält"
    },
    {
        "en": "Scroll beyond the target ratings and you'll find 'rating bands'.<br><br>Select among these to limit the puzzles show to ones in that band.",
        "es": "Desplázate más allá del rating objetivo y encontrarás 'rangos de rating'.<br><br>Selecciona entre ellos para limitar los puzzles mostrados a ese rango.",
        "fr": "Faites défiler au-delà des cotes cibles et vous trouverez des 'bandes de cote'.<br><br>Sélectionnez parmi elles pour limiter les puzzles affichés à cette bande.",
        "de": "Scrollen Sie über die Zielbewertung hinaus und Sie finden 'Bewertungsbänder'.<br><br>Wählen Sie unter diesen, um die angezeigten Rätsel auf dieses Band zu beschränken.",
        "it": "Scorri oltre il rating target e troverai le 'fasce di rating'.<br><br>Seleziona tra queste per limitare i puzzle mostrati a quella fascia.",
        "pt": "Role além dos ratings-alvo e você encontrará 'bandas de rating'.<br><br>Selecione entre elas para limitar os puzzles exibidos a essa faixa.",
        "sv": "Skrolla förbi mål-betygen för att hitta 'betygsband'. Välj bland dem för att begränsa vilka pussel som visas."
    },
    {
        "en": "# of Moves to Visualize Option - Toolbar",
        "es": "Opción de # de Movimientos a Visualizar - Barra de Herramientas",
        "fr": "Option # de Coups à Visualiser - Barre d’Outils",
        "de": "Option für # Züge zum Visualisieren - Werkzeugleiste",
        "it": "Opzione # di Mosse da Visualizzare - Barra degli Strumenti",
        "pt": "Opção # de Lances para Visualizar - Barra de Ferramentas",
        "sv": "Antal drag att visualisera - Verktygsfält"
    },
    {
        "en": "You can select from 1 opponent move up through 10 full moves to visualize.",
        "es": "Puedes seleccionar desde 1 movimiento del oponente hasta 10 movimientos completos para visualizar.",
        "fr": "Vous pouvez sélectionner de 1 coup de l’adversaire jusqu’à 10 coups complets à visualiser.",
        "de": "Du kannst von 1 Zug des Gegners bis zu 10 vollständigen Zügen visualisieren.",
        "it": "Puoi selezionare da 1 mossa dell’avversario fino a 10 mosse complete da visualizzare.",
        "pt": "Você pode selecionar de 1 lance do oponente até 10 lances completos para visualizar.",
        "sv": "Välj från 1 motståndardrag upp till 10 hela drag att visualisera."
    },
    {
        "en": "Time Control - Toolbar",
        "es": "Control de Tiempo - Barra de Herramientas",
        "fr": "Contrôle du Temps - Barre d’Outils",
        "de": "Zeitkontrolle - Werkzeugleiste",
        "it": "Controllo del Tempo - Barra degli Strumenti",
        "pt": "Controle de Tempo - Barra de Ferramentas",
        "sv": "Tidskontroll - Verktygsfält"
    },
    {
        "en": "Time to solve the puzzle<br><br>The options range from 10 to 60 seconds.<br><br>There are also time controls with an added 'per move increment'",
        "es": "Tiempo para resolver el puzzle<br><br>Las opciones van de 10 a 60 segundos.<br><br>También hay controles de tiempo con incremento 'por movimiento'",
        "fr": "Temps pour résoudre le puzzle<br><br>Les options vont de 10 à 60 secondes.<br><br>Il existe également des contrôles de temps avec un 'incrément par coup'",
        "de": "Zeit zum Lösen des Rätsels<br><br>Die Optionen reichen von 10 bis 60 Sekunden.<br><br>Es gibt auch Zeitkontrollen mit zusätzlichem 'pro Zug'-Increment.",
        "it": "Tempo per risolvere il puzzle<br><br>Le opzioni vanno da 10 a 60 secondi.<br><br>Ci sono anche controlli con incremento 'per mossa'.",
        "pt": "Tempo para resolver o puzzle<br><br>As opções vão de 10 a 60 segundos.<br><br>Existem também controles de tempo com incremento 'por lance'.",
        "sv": "Tid för att lösa pusslet: alternativ från 10 till 60 sekunder. Finns även kontroller med per-drag-inkrement."
    },
    {
        "en": "In Andrew Soltis' Book, <b><i>Studying Chess Made Easy<\/b><\/i>, he references an exercise cited by the Russian educator Alexey Bartashnikov in 64 magazine.<br><br>The 3 minute video shows the exercise in action. (Note: it hasn't been updated yet but is worthwhile",
        "es": "En el libro de Andrew Soltis, <b><i>Studying Chess Made Easy<\/b><\/i>, se hace referencia a un ejercicio citado por el educador ruso Alexey Bartashnikov en la revista 64.<br><br>El video de 3 minutos muestra el ejercicio en acción. (Nota: aún no se ha actualizado, pero vale la pena)",
        "fr": "Dans le livre d’Andrew Soltis, <b><i>Studying Chess Made Easy<\/b><\/i>, il fait référence à un exercice cité par l’éducateur russe Alexey Bartashnikov dans le magazine 64.<br><br>La vidéo de 3 minutes montre l’exercice en action. (Remarque : elle n’a pas encore été mise à jour mais en vaut la peine)",
        "de": "In Andrew Soltis’ Buch, <b><i>Studying Chess Made Easy<\/b><\/i>, wird auf eine Übung des russischen Pädagogen Alexey Bartashnikov in der Zeitschrift 64 verwiesen.<br><br>Das 3-minütige Video zeigt die Übung in Aktion. (Hinweis: Es wurde noch nicht aktualisiert, aber es lohnt sich)",
        "it": "Nel libro di Andrew Soltis, <b><i>Studying Chess Made Easy<\/b><\/i>, viene citato un esercizio menzionato dall’educatore russo Alexey Bartashnikov sulla rivista 64.<br><br>Il video di 3 minuti mostra l’esercizio in azione. (Nota: non è stato ancora aggiornato ma vale la pena guardarlo)",
        "pt": "No livro de Andrew Soltis, <b><i>Studying Chess Made Easy<\/b><\/i>, ele faz referência a um exercício citado pelo educador russo Alexey Bartashnikov na revista 64.<br><br>O vídeo de 3 minutos mostra o exercício em ação. (Nota: ainda não foi atualizado, mas vale a pena)",
        "sv": "I Andrew Soltis bok 'Studying Chess Made Easy' refereras en övning av Alexey Bartashnikov i tidningen 64. En 3-minutersvideo visar övningen i praktiken (ej uppdaterad men värd att se)."
    },
    {
        "en": "In summary, the exercise consists of a board with a random setup of a white queen, rook, knight and bishop.<br><br>Moves are given and after each move, you must determine how the pieces 'guard' each other.",
        "es": "En resumen, el ejercicio consiste en un tablero con una disposición aleatoria de una reina, torre, caballo y alfil blancos.<br><br>Se dan movimientos y después de cada uno debes determinar cómo las piezas se 'protegen' entre sí.",
        "fr": "En résumé, l’exercice consiste en un plateau avec une disposition aléatoire d’une dame, d’une tour, d’un cavalier et d’un fou blancs.<br><br>Les coups sont donnés et après chaque coup, vous devez déterminer comment les pièces se 'protègent' entre elles.",
        "de": "Zusammengefasst besteht die Übung aus einem Brett mit zufälliger Anordnung einer weißen Dame, Turm, Springer und Läufer.<br><br>Züge werden vorgegeben, und nach jedem Zug musst du bestimmen, wie die Figuren sich gegenseitig 'schützen'.",
        "it": "In sintesi, l’esercizio consiste in una scacchiera con una disposizione casuale di regina, torre, cavallo e alfiere bianchi.<br><br>Vengono dati dei movimenti e dopo ciascuno devi determinare come i pezzi si 'proteggono' a vicenda.",
        "pt": "Em resumo, o exercício consiste em um tabuleiro com uma disposição aleatória de uma dama, torre, cavalo e bispo brancos.<br><br>São fornecidos movimentos e após cada um, você deve determinar como as peças se 'protegendo' mutuamente.",
        "sv": "Sammanfattningsvis: ett bräde med en slumpmässig uppställning av vit dam, torn, springare och löpare. Drag ges och efter varje drag ska du avgöra hur pjäserna bevakar varandra."
    },
    {
        "en": "The Catch",
        "es": "La Trampa",
        "fr": "Le Piège",
        "de": "Der Haken",
        "it": "L’Inganno",
        "pt": "O Truque",
        "sv": "Finessen"
    },
    {
        "en": "The catch is that while any number of sequential moves can be done, the visible board is never updated beyond the initial display.<br><br>All moves must be visualized in your mind.",
        "es": "La trampa es que aunque se puedan hacer cualquier número de movimientos secuenciales, el tablero visible nunca se actualiza más allá de la visualización inicial.<br><br>Todos los movimientos deben ser visualizados en tu mente.",
        "fr": "Le piège est que, bien que tout nombre de coups consécutifs puisse être joué, le plateau visible n’est jamais mis à jour au-delà de l’affichage initial.<br><br>Tous les coups doivent être visualisés dans votre esprit.",
        "de": "Der Haken ist, dass, obwohl beliebig viele aufeinanderfolgende Züge gemacht werden können, das sichtbare Brett nie über die anfängliche Anzeige hinaus aktualisiert wird.<br><br>Alle Züge müssen im Kopf visualisiert werden.",
        "it": "L’inganno è che, sebbene possano essere effettuati un numero qualsiasi di mosse consecutive, la scacchiera visibile non viene mai aggiornata oltre la visualizzazione iniziale.<br><br>Tutte le mosse devono essere visualizzate nella mente.",
        "pt": "O truque é que, embora qualquer número de movimentos sequenciais possa ser feito, o tabuleiro visível nunca é atualizado além da exibição inicial.<br><br>Todos os movimentos devem ser visualizados na mente.",
        "sv": "Finessen är att även om flera drag ges uppdateras inte det synliga brädet — du måste visualisera alla drag i huvudet."
    },
    {
        "en": "The screen presentation is that of a board with the four pieces and a set of buttons for you to select indicating that a piece is <b>'guarding'<\/b> another.",
        "es": "La presentación en pantalla muestra un tablero con las cuatro piezas y un conjunto de botones para que selecciones indicando que una pieza está <b>'protegiendo'<\/b> a otra.",
        "fr": "La présentation à l’écran est celle d’un plateau avec les quatre pièces et un ensemble de boutons pour indiquer qu’une pièce <b>'protège'<\/b> une autre.",
        "de": "Die Bildschirmdarstellung zeigt ein Brett mit den vier Figuren und einer Reihe von Schaltflächen, um anzugeben, dass eine Figur eine andere <b>'schützt'<\/b>.",
        "it": "La schermata mostra una scacchiera con i quattro pezzi e una serie di pulsanti per selezionare quale pezzo sta <b>'proteggendo'<\/b> un altro.",
        "pt": "A apresentação na tela mostra um tabuleiro com as quatro peças e um conjunto de botões para indicar que uma peça está <b>'protegendo'<\/b> outra.",
        "sv": "Skärmen visar brädet med fyra pjäser och knappar för att markera att en pjäs 'bevakar' en annan."
    },
    {
        "en": "Board only shows 4 pieces",
        "es": "El tablero solo muestra 4 piezas",
        "fr": "Le plateau montre seulement 4 pièces",
        "de": "Das Brett zeigt nur 4 Figuren",
        "it": "La scacchiera mostra solo 4 pezzi",
        "pt": "O tabuleiro mostra apenas 4 peças",
        "sv": "Brädet visar bara 4 pjäser"
    },
    {
        "en": "Once you 'Start' the exercise, the board will only show the 4 pieces",
        "es": "Una vez que 'Inicias' el ejercicio, el tablero solo mostrará las 4 piezas",
        "fr": "Une fois que vous 'Démarrez' l’exercice, le plateau ne montrera que les 4 pièces",
        "de": "Sobald du die Übung 'Startest', zeigt das Brett nur die 4 Figuren",
        "it": "Una volta che 'Avvii' l’esercizio, la scacchiera mostrerà solo i 4 pezzi",
        "pt": "Uma vez que você 'Inicia' o exercício, o tabuleiro mostrará apenas as 4 peças",
        "sv": "När du startar övningen visar brädet bara de fyra pjäserna"
    },
    {
        "en": "Status Line",
        "es": "Línea de Estado",
        "fr": "Barre d’État",
        "de": "Statuszeile",
        "it": "Linea di Stato",
        "pt": "Linha de Status",
        "sv": "Statusrad"
    },
    {
        "en": "Here you will see instructions to follow, the move to visualize and how well you did",
        "es": "Aquí verás las instrucciones a seguir, el movimiento a visualizar y qué tan bien lo hiciste",
        "fr": "Ici, vous verrez les instructions à suivre, le coup à visualiser et vos résultats",
        "de": "Hier siehst du die Anweisungen, welchen Zug du visualisieren sollst und wie gut du warst",
        "it": "Qui vedrai le istruzioni da seguire, la mossa da visualizzare e quanto bene hai fatto",
        "pt": "Aqui você verá as instruções a seguir, o movimento a visualizar e quão bem você se saiu",
        "sv": "Här ser du instruktioner, vilka drag att visualisera och hur bra du gjorde det"
    },
    {
        "en": "Buttons",
        "es": "Botones",
        "fr": "Boutons",
        "de": "Schaltflächen",
        "it": "Pulsanti",
        "pt": "Botões",
        "sv": "Knappar"
    },
    {
        "en": "Your 'job' is to use the buttons to indicate which pieces are 'guarding' the other pieces",
        "es": "Tu 'tarea' es usar los botones para indicar qué piezas están 'protegiendo' a las otras piezas",
        "fr": "Votre 'mission' est d’utiliser les boutons pour indiquer quelles pièces 'protègent' les autres",
        "de": "Deine 'Aufgabe' ist es, die Schaltflächen zu verwenden, um anzugeben, welche Figuren die anderen 'schützen'",
        "it": "Il tuo 'compito' è usare i pulsanti per indicare quali pezzi stanno 'proteggendo' gli altri",
        "pt": "Sua 'tarefa' é usar os botões para indicar quais peças estão 'protegendo' as outras",
        "sv": "Din uppgift är att använda knapparna för att ange vilka pjäser som bevakar andra pjäser"
    },
    {
        "en": "Start - Toolbar",
        "es": "Iniciar - Barra de Herramientas",
        "fr": "Démarrer - Barre d’Outils",
        "de": "Start - Werkzeugleiste",
        "it": "Avvia - Barra degli Strumenti",
        "pt": "Iniciar - Barra de Ferramentas",
        "sv": "Start - Verktygsfält"
    },
    {
        "en": "Will load the 4 pieces in random locations",
        "es": "Cargará las 4 piezas en ubicaciones aleatorias",
        "fr": "Chargera les 4 pièces à des emplacements aléatoires",
        "de": "Lädt die 4 Figuren an zufälligen Positionen",
        "it": "Caricherà i 4 pezzi in posizioni casuali",
        "pt": "Carregará as 4 peças em posições aleatórias",
        "sv": "Läser in de fyra pjäserna på slumpmässiga rutor"
    },
    {
        "en": "Check - Toolbar",
        "es": "Comprobar - Barra de Herramientas",
        "fr": "Vérifier - Barre d’Outils",
        "de": "Überprüfen - Werkzeugleiste",
        "it": "Controlla - Barra degli Strumenti",
        "pt": "Verificar - Barra de Ferramentas",
        "sv": "Kolla - Verktygsfält"
    },
    {
        "en": "After you are finished using the buttons to indicate the 'guardings', <b>Check<\/b> your work. The status line will tell you how you did and any errors will cause the buttons to be highlighted",
        "es": "Después de usar los botones para indicar los 'guardianes', <b>Comprueba<\/b> tu trabajo. La línea de estado te dirá cómo lo hiciste y cualquier error resaltará los botones",
        "fr": "Après avoir utilisé les boutons pour indiquer les 'protections', <b>Vérifiez<\/b> votre travail. La barre d’état vous indiquera vos résultats et toute erreur fera surligner les boutons",
        "de": "Nachdem du die Schaltflächen benutzt hast, um die 'Schutzstellungen' anzuzeigen, überprüfe deine Arbeit. Die Statuszeile zeigt dir, wie gut du warst, und Fehler werden die Schaltflächen markieren",
        "it": "Dopo aver utilizzato i pulsanti per indicare le 'protezioni', <b>Controlla<\/b> il tuo lavoro. La linea di stato ti dirà come hai fatto e eventuali errori evidenzieranno i pulsanti",
        "pt": "Após usar os botões para indicar as 'proteções', <b>Verifique<\/b> seu trabalho. A linha de status dirá como você se saiu e quaisquer erros destacarão os botões",
        "sv": "När du markerat bevakningarna, tryck 'Kolla'. Statusraden visar resultatet och eventuella fel markeras."
    },
    {
        "en": "Next Move - Toolbar",
        "es": "Siguiente Movimiento - Barra de Herramientas",
        "fr": "Coup Suivant - Barre d’Outils",
        "de": "Nächster Zug - Werkzeugleiste",
        "it": "Mossa Successiva - Barra degli Strumenti",
        "pt": "Próximo Lance - Barra de Ferramentas",
        "sv": "Nästa drag - Verktygsfält"
    },
    {
        "en": "When you're ready, request the next move. It will be displayed in the 'status line'. Don't forget, the board itself is never updated.",
        "es": "Cuando estés listo, solicita el siguiente movimiento. Se mostrará en la 'línea de estado'. No olvides que el tablero nunca se actualiza.",
        "fr": "Lorsque vous êtes prêt, demandez le coup suivant. Il sera affiché dans la 'barre d’état'. N’oubliez pas que le plateau lui-même n’est jamais mis à jour.",
        "de": "Wenn du bereit bist, fordere den nächsten Zug an. Er wird in der Statuszeile angezeigt. Vergiss nicht, das Brett selbst wird nie aktualisiert.",
        "it": "Quando sei pronto, richiedi la mossa successiva. Verrà mostrata nella 'linea di stato'. Ricorda, la scacchiera stessa non viene mai aggiornata.",
        "pt": "Quando estiver pronto, solicite o próximo lance. Ele será exibido na 'linha de status'. Não se esqueça, o tabuleiro em si nunca é atualizado.",
        "sv": "När du är redo, begär nästa drag — det visas i statusraden. Brädet uppdateras aldrig."
    },
    {
        "en": "List - Toolbar",
        "es": "Lista - Barra de Herramientas",
        "fr": "Liste - Barre d’Outils",
        "de": "Liste - Werkzeugleiste",
        "it": "Elenco - Barra degli Strumenti",
        "pt": "Lista - Barra de Ferramentas",
        "sv": "Lista - Verktygsfält"
    },
    {
        "en": "If you feel really lost and you want to get back on track, this button will show you the sequence of all the moves",
        "es": "Si te sientes realmente perdido y quieres volver a encarrilarte, este botón te mostrará la secuencia de todos los movimientos",
        "fr": "Si vous vous sentez vraiment perdu et que vous voulez reprendre le fil, ce bouton affichera la séquence de tous les coups",
        "de": "Wenn du dich völlig verloren fühlst und wieder auf den richtigen Weg kommen möchtest, zeigt diese Taste die Abfolge aller Züge",
        "it": "Se ti senti davvero perso e vuoi rimetterti in carreggiata, questo pulsante mostrerà la sequenza di tutte le mosse",
        "pt": "Se você se sentir realmente perdido e quiser voltar ao caminho, este botão mostrará a sequência de todos os lances",
        "sv": "Om du är vilse visar den här knappen hela dragsekvensen för att komma tillbaka på spåret."
    },
    {
        "en": "Reveal \/ Revert - Toolbar",
        "es": "Revelar \/ Revertir - Barra de Herramientas",
        "fr": "Révéler \/ Revenir - Barre d’Outils",
        "de": "Aufdecken \/ Zurücksetzen - Werkzeugleiste",
        "it": "Rivela \/ Ripristina - Barra degli Strumenti",
        "pt": "Revelar \/ Reverter - Barra de Ferramentas",
        "sv": "Visa \/ Återställ - Verktygsfält"
    },
    {
        "en": "If you feel really, really lost, this button will update the board to where the pieces are actually located.<br><br>Toggling the button will restore the initial piece locations.",
        "es": "Si te sientes realmente, realmente perdido, este botón actualizará el tablero a la ubicación real de las piezas.<br><br>Alternar el botón restaurará las posiciones iniciales de las piezas.",
        "fr": "Si vous êtes vraiment, vraiment perdu, ce bouton mettra à jour le plateau là où les pièces se trouvent réellement.<br><br>Basculer le bouton restaurera les positions initiales des pièces.",
        "de": "Wenn du dich wirklich, wirklich verloren fühlst, aktualisiert diese Taste das Brett auf die tatsächlichen Positionen der Figuren.<br><br>Durch Umschalten wird die ursprüngliche Figurenposition wiederhergestellt.",
        "it": "Se ti senti davvero, davvero perso, questo pulsante aggiornerà la scacchiera alla posizione reale dei pezzi.<br><br>Attivando\/disattivando il pulsante, verranno ripristinate le posizioni iniziali dei pezzi.",
        "pt": "Se você se sentir realmente, realmente perdido, este botão atualizará o tabuleiro para onde as peças estão realmente localizadas.<br><br>Alternar o botão restaurará as posições iniciais das peças.",
        "sv": "Om du är helt förlorad uppdaterar den här knappen brädet till de verkliga platserna. Växla för att återställa startpositionerna."
    },
    {
        "en": "Visualizing a Static Board",
        "es": "Visualizando un Tablero Estático",
        "fr": "Visualiser un Plateau Statique",
        "de": "Ein Statisches Brett Visualisieren",
        "it": "Visualizzare una Scacchiera Statica",
        "pt": "Visualizando um Tabuleiro Estático",
        "sv": "Visualisera ett statiskt bräde"
    },
    {
        "en": "It is said that looking at the board while trying to work out a move sequence is more of a hindrance than a help.<br><br>Why? Because the board hides the ranks, files and diagonals that get opened up and closed down by piece movements.",
        "es": "Se dice que mirar el tablero mientras se intenta calcular una secuencia de movimientos es más un obstáculo que una ayuda.<br><br>¿Por qué? Porque el tablero oculta filas, columnas y diagonales que se abren y cierran con los movimientos de las piezas.",
        "fr": "On dit que regarder l’échiquier tout en essayant de calculer une séquence de coups est plus un obstacle qu’une aide.<br><br>Pourquoi ? Parce que l’échiquier cache les rangées, colonnes et diagonales qui s’ouvrent et se ferment avec les mouvements des pièces.",
        "de": "Es heißt, dass das Betrachten des Brettes beim Versuch, eine Zugfolge zu erarbeiten, eher hinderlich als hilfreich ist.<br><br>Warum? Weil das Brett die Reihen, Linien und Diagonalen verbirgt, die durch Figurenbewegungen geöffnet und geschlossen werden.",
        "it": "Si dice che guardare la scacchiera mentre si cerca di calcolare una sequenza di mosse sia più un ostacolo che un aiuto.<br><br>Perché? Perché la scacchiera nasconde righe, colonne e diagonali che si aprono e chiudono con i movimenti dei pezzi.",
        "pt": "Diz-se que olhar para o tabuleiro enquanto tenta calcular uma sequência de movimentos é mais um obstáculo do que uma ajuda.<br><br>Por quê? Porque o tabuleiro esconde fileiras, colunas e diagonais que são abertas e fechadas pelos movimentos das peças.",
        "sv": "Man säger att att titta på brädet medan man räknar drag kan hindra snarare än hjälpa — brädet döljer rader, linjer och diagonaler som öppnas och stängs vid flytt."
    },
    {
        "en": "Holding the Board Image",
        "es": "Manteniendo la Imagen del Tablero",
        "fr": "Maintenir l’Image du Plateau",
        "de": "Das Brettbild Halten",
        "it": "Mantenere l’Immagine della Scacchiera",
        "pt": "Mantendo a Imagem do Tabuleiro",
        "sv": "Hålla brädets bild i huvudet"
    },
    {
        "en": "If you can hold the board in your head then it is easy to shift the pieces around and visualize the new board just as easily as the current board.<br><br>This isn't an easy task but Chessvis is here to help you build up your visualization talent.",
        "es": "Si puedes mantener el tablero en tu mente, entonces es fácil mover las piezas y visualizar el nuevo tablero tan fácilmente como el tablero actual.<br><br>No es una tarea fácil, pero Chessvis está aquí para ayudarte a desarrollar tu talento de visualización.",
        "fr": "Si vous pouvez garder le plateau en tête, il est facile de déplacer les pièces et de visualiser le nouveau plateau aussi facilement que l’actuel.<br><br>Ce n’est pas une tâche facile, mais Chessvis est là pour vous aider à développer votre talent de visualisation.",
        "de": "Wenn du das Brett im Kopf halten kannst, ist es einfach, die Figuren zu verschieben und das neue Brett genauso leicht zu visualisieren wie das aktuelle.<br><br>Das ist keine leichte Aufgabe, aber Chessvis hilft dir, deine Visualisierungsfähigkeiten auszubauen.",
        "it": "Se riesci a tenere la scacchiera nella mente, è facile spostare i pezzi e visualizzare la nuova scacchiera con la stessa facilità di quella attuale.<br><br>Non è un compito facile, ma Chessvis è qui per aiutarti a sviluppare il tuo talento di visualizzazione.",
        "pt": "Se você conseguir manter o tabuleiro na cabeça, é fácil mover as peças e visualizar o novo tabuleiro tão facilmente quanto o atual.<br><br>Não é uma tarefa fácil, mas o Chessvis está aqui para ajudá-lo a desenvolver seu talento de visualização.",
        "sv": "Om du kan hålla bilden av brädet i huvudet blir det lätt att föreställa nya positioner. Det är svårt, men Chessvis hjälper dig bygga upp den förmågan."
    },
    {
        "en": "Get Next - Toolbar",
        "es": "Siguiente - Barra de Herramientas",
        "fr": "Suivant - Barre d’Outils",
        "de": "Nächstes - Werkzeugleiste",
        "it": "Prossimo - Barra degli Strumenti",
        "pt": "Próximo - Barra de Ferramentas",
        "sv": "Hämta nästa - Verktygsfält"
    },
    {
        "en": "Will display the random set of pieces",
        "es": "Mostrará el conjunto aleatorio de piezas",
        "fr": "Affichera l’ensemble aléatoire de pièces",
        "de": "Zeigt die zufällige Figurenanordnung an",
        "it": "Mostrerà l’insieme casuale dei pezzi",
        "pt": "Mostrará o conjunto aleatório de peças",
        "sv": "Visar en slumpmässig uppsättning pjäser"
    },
    {
        "en": "Replicate - Toolbar",
        "es": "Replicar - Barra de Herramientas",
        "fr": "Répliquer - Barre d’Outils",
        "de": "Replizieren - Werkzeugleiste",
        "it": "Replica - Barra degli Strumenti",
        "pt": "Replicar - Barra de Ferramentas",
        "sv": "Replikera - Verktygsfält"
    },
    {
        "en": "Do you have the image in your mind?<br><br>'Replicate' will position the pieces along the back rank ready for you to move them to the right squares.",
        "es": "¿Tienes la imagen en tu mente?<br><br>'Replicar' posicionará las piezas a lo largo de la fila de fondo listas para moverlas a las casillas correctas.",
        "fr": "Avez-vous l’image en tête ?<br><br>‘Répliquer’ positionnera les pièces sur la rangée arrière prêtes à être déplacées aux bonnes cases.",
        "de": "Hast du das Bild im Kopf?<br><br>'Replizieren' platziert die Figuren auf der Grundreihe, bereit, sie auf die richtigen Felder zu ziehen.",
        "it": "Hai l’immagine nella mente?<br><br>'Replica' posizionerà i pezzi sulla prima fila pronti per essere mossi nelle caselle corrette.",
        "pt": "Você tem a imagem na mente?<br><br>'Replicar' posicionará as peças na linha de trás prontas para você movê-las para as casas corretas.",
        "sv": "Har du bilden i huvudet? 'Replikera' placerar pjäserna på bakraden redo för dig att flytta till rätt rutor."
    },
    {
        "en": "Check Work - Toolbar",
        "es": "Comprobar Trabajo - Barra de Herramientas",
        "fr": "Vérifier le Travail - Barre d’Outils",
        "de": "Arbeit Prüfen - Werkzeugleiste",
        "it": "Controlla il Lavoro - Barra degli Strumenti",
        "pt": "Verificar Trabalho - Barra de Ferramentas",
        "sv": "Kontrollera arbete - Verktygsfält"
    },
    {
        "en": "Done placing the pieces?<br><br>'Check Work' will tell you how well you did.<br><br>The button title will change to 'Show Mine' and 'Show Actual' so you can toggle back and forth.",
        "es": "¿Terminaste de colocar las piezas?<br><br>'Comprobar Trabajo' te dirá qué tan bien lo hiciste.<br><br>El título del botón cambiará a 'Mostrar Mías' y 'Mostrar Reales' para que puedas alternar entre ambos.",
        "fr": "Vous avez terminé de placer les pièces ?<br><br>‘Vérifier le Travail’ vous indiquera votre performance.<br><br>Le titre du bouton changera en ‘Afficher les Miennes’ et ‘Afficher Réelles’ pour basculer entre les deux.",
        "de": "Fertig mit dem Platzieren der Figuren?<br><br>'Arbeit Prüfen' zeigt dir, wie gut du warst.<br><br>Der Button-Titel wechselt zu 'Meine Anzeigen' und 'Tatsächliche Anzeigen', sodass du hin- und herschalten kannst.",
        "it": "Hai finito di posizionare i pezzi?<br><br>'Controlla il Lavoro' ti dirà quanto bene hai fatto.<br><br>Il titolo del pulsante cambierà in 'Mostra i Miei' e 'Mostra Reali' così potrai alternare tra i due.",
        "pt": "Terminou de colocar as peças?<br><br>'Verificar Trabalho' mostrará como você se saiu.<br><br>O título do botão mudará para 'Mostrar Minhas' e 'Mostrar Reais', para que você possa alternar entre os dois.",
        "sv": "Klar med placeringen? 'Kontrollera arbete' visar hur bra du gjorde det. Knapparna ändras till 'Visa mitt' och 'Visa verkligt' för växling."
    },
    {
        "en": "Options - Toolbar",
        "es": "Opciones - Barra de Herramientas",
        "fr": "Options - Barre d’Outils",
        "de": "Optionen - Werkzeugleiste",
        "it": "Opzioni - Barra degli Strumenti",
        "pt": "Opções - Barra de Ferramentas",
        "sv": "Inställningar - Verktygsfält"
    },
    {
        "en": "You have control over the number of pieces to place and how much of the board they take up",
        "es": "Tienes control sobre el número de piezas a colocar y cuánto espacio ocupan en el tablero",
        "fr": "Vous contrôlez le nombre de pièces à placer et la part du plateau qu’elles occupent",
        "de": "Du hast Kontrolle über die Anzahl der zu platzierenden Figuren und wie viel Platz sie auf dem Brett einnehmen",
        "it": "Hai il controllo sul numero di pezzi da posizionare e su quanto spazio occupano sulla scacchiera",
        "pt": "Você tem controle sobre o número de peças a colocar e quanto espaço elas ocupam no tabuleiro",
        "sv": "Du bestämmer antal pjäser och hur mycket av brädet de täcker"
    },
    {
        "en": "Move Sequence Visualization",
        "es": "Visualización de Secuencias de Movimientos",
        "fr": "Visualisation de Séquences de Coups",
        "de": "Zugfolgen Visualisierung",
        "it": "Visualizzazione della Sequenza di Mosse",
        "pt": "Visualização de Sequência de Movimentos",
        "sv": "Visualisering av dragsekvens"
    },
    {
        "en": "This exercise will help you visualize a sequence of moves. You're shown a board position and then told the sequence of white and black moves. At the end of the move sequence, you will update the board to match the now current position.",
        "es": "Este ejercicio te ayudará a visualizar una secuencia de movimientos. Se te muestra una posición del tablero y luego se te indica la secuencia de movimientos de blancas y negras. Al final de la secuencia, actualizarás el tablero para reflejar la posición actual.",
        "fr": "Cet exercice vous aidera à visualiser une séquence de coups. On vous montre une position sur l’échiquier, puis la séquence des coups blancs et noirs. À la fin de la séquence, vous mettrez à jour le plateau pour correspondre à la position actuelle.",
        "de": "Diese Übung hilft dir, eine Zugfolge zu visualisieren. Dir wird eine Brettposition gezeigt und dann die Abfolge der weißen und schwarzen Züge genannt. Am Ende der Zugfolge aktualisierst du das Brett auf die aktuelle Position.",
        "it": "Questo esercizio ti aiuterà a visualizzare una sequenza di mosse. Ti viene mostrata una posizione sulla scacchiera e poi la sequenza delle mosse bianche e nere. Alla fine della sequenza aggiornerai la scacchiera alla posizione attuale.",
        "pt": "Este exercício ajudará você a visualizar uma sequência de movimentos. Uma posição do tabuleiro será mostrada e em seguida a sequência de movimentos das peças brancas e pretas. Ao final da sequência, você atualizará o tabuleiro para a posição atual.",
        "sv": "Denna övning hjälper dig visualisera en dragsekvens: du får en ställning och ser en följd av vita och svarta drag. Efteråt uppdaterar du brädet till den nya ställningen."
    },
    {
        "en": "First Variation",
        "es": "Primera Variación",
        "fr": "Première Variation",
        "de": "Erste Variante",
        "it": "Prima Variante",
        "pt": "Primeira Variação",
        "sv": "Första variationen"
    },
    {
        "en": "<b>Moves At Random Location<\/b> - Visualize a sequence of moves from a random point in a real game.",
        "es": "<b>Movimientos en Ubicación Aleatoria<\/b> - Visualiza una secuencia de movimientos desde un punto aleatorio en una partida real.",
        "fr": "<b>Coups à un Emplacement Aléatoire<\/b> - Visualisez une séquence de coups à partir d’un point aléatoire d’une partie réelle.",
        "de": "<b>Züge an Zufälliger Position<\/b> - Visualisiere eine Zugfolge von einem zufälligen Punkt in einem echten Spiel.",
        "it": "<b>Mosse in Posizione Casuale<\/b> - Visualizza una sequenza di mosse da un punto casuale in una partita reale.",
        "pt": "<b>Movimentos em Localização Aleatória<\/b> - Visualize uma sequência de movimentos a partir de um ponto aleatório em uma partida real.",
        "sv": "<b>Drag på slumpmässig plats<\/b> — visualisera en sekvens från en slumpmässig punkt i ett verkligt parti."
    },
    {
        "en": "Second Variation",
        "es": "Segunda Variación",
        "fr": "Deuxième Variation",
        "de": "Zweite Variante",
        "it": "Seconda Variante",
        "pt": "Segunda Variação",
        "sv": "Andra variationen"
    },
    {
        "en": "<b>Moves From Beginning of Game<\/b> - Gives you the option of playing through an entire real game a given set of moves at a time.",
        "es": "<b>Movimientos desde el Inicio de la Partida<\/b> - Te permite jugar toda una partida real un conjunto de movimientos a la vez.",
        "fr": "<b>Coups depuis le Début de la Partie<\/b> - Vous permet de jouer toute une partie réelle, un ensemble de coups à la fois.",
        "de": "<b>Züge vom Spielbeginn<\/b> - Ermöglicht dir, ein ganzes echtes Spiel Schritt für Schritt durchzugehen.",
        "it": "<b>Mosse dall’Inizio della Partita<\/b> - Ti permette di giocare un’intera partita reale un insieme di mosse alla volta.",
        "pt": "<b>Movimentos desde o Início do Jogo<\/b> - Permite jogar uma partida inteira real, um conjunto de movimentos por vez.",
        "sv": "<b>Drag från partiets början<\/b> — spel igenom ett helt parti i valda dragserier."
    },
    {
        "en": "Third Variation",
        "es": "Tercera Variación",
        "fr": "Troisième Variation",
        "de": "Dritte Variante",
        "it": "Terza Variante",
        "pt": "Terceira Variação",
        "sv": "Tredje variationen"
    },
    {
        "en": "<b>Follow Specific Pieces<\/b> - Want to focus on specific pieces? <br><br>The toolbar 'Options' will enable you to select the specific pieces you want to do work with",
        "es": "<b>Seguir Piezas Específicas<\/b> - ¿Quieres concentrarte en piezas específicas? <br><br>La barra de herramientas 'Opciones' te permitirá seleccionar las piezas específicas con las que quieras trabajar",
        "fr": "<b>Suivre des Pièces Spécifiques<\/b> - Vous voulez vous concentrer sur certaines pièces ? <br><br>La barre d’outils 'Options' vous permet de sélectionner les pièces spécifiques à travailler",
        "de": "<b>Bestimmte Figuren Folgen<\/b> - Willst du dich auf bestimmte Figuren konzentrieren? <br><br>Die Werkzeugleiste 'Optionen' ermöglicht dir, die Figuren auszuwählen, mit denen du arbeiten möchtest",
        "it": "<b>Segui Pezzi Specifici<\/b> - Vuoi concentrarti su pezzi specifici? <br><br>La barra degli strumenti 'Opzioni' ti permette di selezionare i pezzi specifici su cui lavorare",
        "pt": "<b>Seguir Peças Específicas<\/b> - Quer focar em peças específicas? <br><br>A barra de ferramentas 'Opções' permite selecionar as peças específicas com as quais deseja trabalhar",
        "sv": "<b>Följ specifika pjäser<\/b> — vill du fokusera på vissa pjäser? 'Inställningar' låter dig välja vilka."
    },
    {
        "en": "Will display the board just before the move sequence",
        "es": "Mostrará el tablero justo antes de la secuencia de movimientos",
        "fr": "Affichera le plateau juste avant la séquence de coups",
        "de": "Zeigt das Brett direkt vor der Zugfolge an",
        "it": "Mostrerà la scacchiera appena prima della sequenza di mosse",
        "pt": "Mostrará o tabuleiro pouco antes da sequência de movimentos",
        "sv": "Visar brädet precis innan dragsekvensen"
    },
    {
        "en": "When you're ready, the 'Replicate' button will unlock the pieces ready for you to place them on the squares where they should be at the end of the move sequence.",
        "es": "Cuando estés listo, el botón 'Replicar' desbloqueará las piezas para que las coloques en las casillas donde deben estar al final de la secuencia de movimientos.",
        "fr": "Lorsque vous êtes prêt, le bouton 'Répliquer' débloquera les pièces pour que vous puissiez les placer sur les cases où elles doivent être à la fin de la séquence de coups.",
        "de": "Wenn du bereit bist, schaltet der 'Replizieren'-Button die Figuren frei, damit du sie auf die Felder setzen kannst, wo sie am Ende der Zugfolge stehen sollen.",
        "it": "Quando sei pronto, il pulsante 'Replica' sbloccherà i pezzi, pronti per essere posizionati sulle caselle dove dovrebbero trovarsi alla fine della sequenza di mosse.",
        "pt": "Quando estiver pronto, o botão 'Replicar' desbloqueará as peças, prontas para colocá-las nas casas onde devem estar ao final da sequência de movimentos.",
        "sv": "När du är redo låses pjäserna upp med 'Replikera' så du kan placera dem där de ska vara efter sekvensen."
    },
    {
        "en": "For all variations, you can select:<br><b>Number of Moves<\/b> - # of moves in the sequence<br><b>Announce Moves<\/b> - Want to hear the moves spoken?<br><b>Show 1 Move At a Time<\/b> - You can either see all the moves at once or just one at a time",
        "es": "Para todas las variaciones, puedes seleccionar:<br><b>Número de Movimientos<\/b> - # de movimientos en la secuencia<br><b>Anunciar Movimientos<\/b> - ¿Quieres escuchar los movimientos hablados?<br><b>Mostrar 1 Movimiento a la Vez<\/b> - Puedes ver todos los movimientos a la vez o uno a la vez",
        "fr": "Pour toutes les variations, vous pouvez sélectionner :<br><b>Nombre de Coups<\/b> - # de coups dans la séquence<br><b>Annoncer les Coups<\/b> - Voulez-vous entendre les coups prononcés ?<br><b>Afficher 1 Coup à la Fois<\/b> - Vous pouvez voir tous les coups en même temps ou un à la fois",
        "de": "Für alle Varianten kannst du auswählen:<br><b>Anzahl der Züge<\/b> - # der Züge in der Sequenz<br><b>Züge Ansagen<\/b> - Möchtest du die Züge angesagt bekommen?<br><b>1 Zug auf Einmal Anzeigen<\/b> - Du kannst alle Züge gleichzeitig oder einen nach dem anderen sehen",
        "it": "Per tutte le varianti, puoi selezionare:<br><b>Numero di Mosse<\/b> - # di mosse nella sequenza<br><b>Annunciare Mosse<\/b> - Vuoi ascoltare le mosse pronunciate?<br><b>Mostra 1 Mossa alla Volta<\/b> - Puoi vedere tutte le mosse insieme o una alla volta",
        "pt": "Para todas as variações, você pode selecionar:<br><b>Número de Movimentos<\/b> - # de movimentos na sequência<br><b>Anunciar Movimentos<\/b> - Quer ouvir os movimentos falados?<br><b>Mostrar 1 Movimento por Vez<\/b> - Você pode ver todos os movimentos de uma vez ou um por vez",
        "sv": "För alla varianter kan du välja:<br><b>Antal drag<\/b><br><b>Meddela drag<\/b> — vill du höra dem upplästa?<br><b>Visa ett drag i taget<\/b> — visa alla eller ett i taget."
    },
    {
        "en": "Random Locations",
        "es": "Ubicaciones Aleatorias",
        "fr": "Emplacements Aléatoires",
        "de": "Zufällige Positionen",
        "it": "Posizioni Casuali",
        "pt": "Localizações Aleatórias",
        "sv": "Slumpmässiga platser"
    },
    {
        "en": "For <b>Random Location<\/b> you select how many pieces you want to work with",
        "es": "Para <b>Ubicación Aleatoria<\/b> seleccionas cuántas piezas quieres usar",
        "fr": "Pour <b>Emplacement Aléatoire<\/b>, vous sélectionnez combien de pièces vous souhaitez utiliser",
        "de": "Für <b>Zufällige Position<\/b> wählst du, mit wie vielen Figuren du arbeiten möchtest",
        "it": "Per <b>Posizione Casuale<\/b> selezioni quanti pezzi vuoi usare",
        "pt": "Para <b>Localização Aleatória<\/b>, você seleciona quantas peças deseja usar",
        "sv": "För <b>Slumpmässig plats<\/b> väljer du hur många pjäser du vill jobba med"
    },
    {
        "en": "For <b>Specific Pieces<\/b> you select the combination of pieces you want to work with",
        "es": "Para <b>Piezas Específicas<\/b> seleccionas la combinación de piezas con las que quieres trabajar",
        "fr": "Pour <b>Pièces Spécifiques<\/b>, vous sélectionnez la combinaison de pièces avec laquelle vous souhaitez travailler",
        "de": "Für <b>Bestimmte Figuren<\/b> wählst du die Kombination von Figuren, mit denen du arbeiten möchtest",
        "it": "Per <b>Pezzi Specifici<\/b> selezioni la combinazione di pezzi su cui vuoi lavorare",
        "pt": "Para <b>Peças Específicas<\/b>, você seleciona a combinação de peças com as quais deseja trabalhar",
        "sv": "För <b>Specifika pjäser<\/b> väljer du vilka pjäs­kombinationer du vill öva på"
    },
    {
        "en": "Play the Computer",
        "es": "Jugar contra la Computadora",
        "fr": "Jouer contre l’Ordinateur",
        "de": "Gegen den Computer Spielen",
        "it": "Gioca contro il Computer",
        "pt": "Jogar contra o Computador",
        "sv": "Spela mot datorn"
    },
    {
        "en": "This is straight up - 'Play the Computer'.<br><br>The game will start by randomly selecting moves in the opening tree based on popularity. This gives a much more realistic start to the game than if the engine was used from move 1",
        "es": "Esto es directo: 'Jugar contra la Computadora'.<br><br>El juego comenzará seleccionando movimientos al azar en el árbol de aperturas según su popularidad. Esto da un inicio mucho más realista que si el motor se usara desde el primer movimiento.",
        "fr": "C’est simple : 'Jouer contre l’Ordinateur'.<br><br>La partie commence par la sélection aléatoire de coups dans l’arbre d’ouverture en fonction de leur popularité. Cela donne un départ beaucoup plus réaliste que si le moteur était utilisé dès le premier coup.",
        "de": "Ganz einfach: 'Gegen den Computer Spielen'.<br><br>Das Spiel beginnt, indem Züge im Eröffnungsbaum nach Beliebtheit zufällig ausgewählt werden. Das ergibt einen viel realistischeren Spielbeginn als wenn die Engine von Zug 1 an genutzt wird.",
        "it": "È semplice: 'Gioca contro il Computer'.<br><br>La partita inizia selezionando casualmente mosse nell’albero di apertura in base alla popolarità. Questo dà un inizio molto più realistico rispetto all’utilizzo del motore dal primo turno.",
        "pt": "Isto é direto: 'Jogar contra o Computador'.<br><br>O jogo começará selecionando movimentos aleatórios na árvore de aberturas com base na popularidade. Isso dá um início muito mais realista do que usar o motor desde o primeiro movimento.",
        "sv": "Det här är helt enkelt 'spela datorn'. Partiet startar med slumpmässigt valda öppningsdrag baserat på popularitet — ger en mer realistisk start än att motor sätts in från drag 1."
    },
    {
        "en": "This is straight up - 'Play the Computer'",
        "es": "Esto es directo: 'Jugar contra la Computadora'",
        "fr": "C’est simple : 'Jouer contre l’Ordinateur'",
        "de": "Ganz einfach: 'Gegen den Computer Spielen'",
        "it": "È semplice: 'Gioca contro il Computer'",
        "pt": "Isto é direto: 'Jogar contra o Computador'",
        "sv": "Det här är helt enkelt 'Spela datorn'"
    },
    {
        "en": "Chessvis has many features to help ease your way into 'Blindfold Chess'.<br><br>There are four graduated blindfold 'Stepping Stones', two engines and 21 engine skill levels",
        "es": "Chessvis tiene muchas funciones para facilitar tu entrada en el 'Ajedrez a Ciegas'.<br><br>Hay cuatro 'Escalones' graduados para ajedrez a ciegas, dos motores y 21 niveles de habilidad del motor.",
        "fr": "Chessvis propose de nombreuses fonctionnalités pour faciliter l’accès aux 'Échecs à l’Aveugle'.<br><br>Il y a quatre 'marches' graduées pour les échecs à l’aveugle, deux moteurs et 21 niveaux de compétence.",
        "de": "Chessvis bietet viele Funktionen, um den Einstieg in Blindschach zu erleichtern.<br><br>Es gibt vier abgestufte Blindschach-'Stufen', zwei Engines und 21 Engine-Schwierigkeitsgrade.",
        "it": "Chessvis offre molte funzioni per facilitare l’accesso agli 'Scacchi alla Cieca'.<br><br>Ci sono quattro 'Gradini' graduati per gli scacchi alla cieca, due motori e 21 livelli di abilità del motore.",
        "pt": "O Chessvis possui muitas funções para facilitar sua entrada no 'Xadrez às Cegas'.<br><br>Existem quatro 'Degraus' graduados, dois motores e 21 níveis de habilidade do motor.",
        "sv": "Chessvis har många funktioner för att göra blindfold-spel enklare: fyra stegstenar, två motorer och 21 nivåer."
    },
    {
        "en": "You can select from the 4 graduated blindfold levels:<br><br>- One shared piece color<br>- White and black disks<br>- One shared disk color<br>- No visible pieces at all",
        "es": "Puedes seleccionar entre los 4 niveles graduados de ajedrez a ciegas:<br><br>- Un color compartido para todas las piezas<br>- Discos blancos y negros<br>- Un color compartido en los discos<br>- Ninguna pieza visible",
        "fr": "Vous pouvez choisir parmi les 4 niveaux gradués pour les échecs à l’aveugle :<br><br>- Une couleur unique pour toutes les pièces<br>- Disques blancs et noirs<br>- Une couleur partagée sur les disques<br>- Aucune pièce visible",
        "de": "Du kannst aus 4 abgestuften Blindschach-Leveln wählen:<br><br>- Eine gemeinsame Farbe für alle Figuren<br>- Weiße und schwarze Scheiben<br>- Eine gemeinsame Scheibenfarbe<br>- Keine sichtbaren Figuren",
        "it": "Puoi selezionare tra i 4 livelli graduati di scacchi alla cieca:<br><br>- Un colore condiviso per tutti i pezzi<br>- Dischi bianchi e neri<br>- Un colore condiviso nei dischi<br>- Nessun pezzo visibile",
        "pt": "Você pode selecionar entre 4 níveis graduados de xadrez às cegas:<br><br>- Uma cor compartilhada para todas as peças<br>- Discos brancos e pretos<br>- Uma cor compartilhada nos discos<br>- Nenhuma peça visível",
        "sv": "Välj bland fyra blindfold-nivåer:<br>- En gemensam pjäsfärg<br>- Vita och svarta brickor<br>- En gemensam färg på brickor<br>- Inga synliga pjäser"
    },
    {
        "en": "Engines",
        "es": "Motores",
        "fr": "Moteurs",
        "de": "Engines",
        "it": "Motori",
        "pt": "Motores",
        "sv": "Motorer"
    },
    {
        "en": "You can choose between the Komodo and Stockfish engines. Both are extremely strong at high skill levels. The Komodo simulates a much weaker player at the lower skill levels.",
        "es": "Puedes elegir entre los motores Komodo y Stockfish. Ambos son extremadamente fuertes a niveles altos de habilidad. Komodo simula un jugador mucho más débil en los niveles bajos.",
        "fr": "Vous pouvez choisir entre les moteurs Komodo et Stockfish. Les deux sont extrêmement forts à des niveaux élevés. Komodo simule un joueur beaucoup plus faible aux niveaux faibles.",
        "de": "Du kannst zwischen den Engines Komodo und Stockfish wählen. Beide sind auf hohen Levels extrem stark. Komodo simuliert auf niedrigen Levels einen viel schwächeren Spieler.",
        "it": "Puoi scegliere tra i motori Komodo e Stockfish. Entrambi sono estremamente forti ad alti livelli di abilità. Komodo simula un giocatore molto più debole ai livelli bassi.",
        "pt": "Você pode escolher entre os motores Komodo e Stockfish. Ambos são extremamente fortes em níveis altos. O Komodo simula um jogador muito mais fraco nos níveis baixos.",
        "sv": "Välj mellan Komodo och Stockfish. Båda är mycket starka på höga nivåer. Komodo simulerar en svagare spelare på lägre nivåer."
    },
    {
        "en": "The free version of Chessvis lets you give blindfold chess a try with two of the 4 'stepping stones'",
        "es": "La versión gratuita de Chessvis te permite probar ajedrez a ciegas con dos de los 4 'escalones'",
        "fr": "La version gratuite de Chessvis vous permet d’essayer les échecs à l’aveugle avec deux des 4 'marches'",
        "de": "Die kostenlose Version von Chessvis ermöglicht dir Blindschach mit zwei der vier 'Stufen' auszuprobieren",
        "it": "La versione gratuita di Chessvis ti permette di provare gli scacchi alla cieca con due dei 4 'gradini'",
        "pt": "A versão gratuita do Chessvis permite experimentar xadrez às cegas com dois dos 4 'degraus'",
        "sv": "Gratisversionen låter dig prova blindfold med två av fyra stegstenar"
    },
    {
        "en": "Choose between all the pieces being the same color. I.e., you know what the piece is but need to remember if it yours or your opponent's.<br><br>Or two color disks - you know the color of the pieces but you need to remember what the piece is",
        "es": "Elige entre todas las piezas del mismo color. Es decir, sabes qué pieza es pero debes recordar si es tuya o de tu oponente.<br><br>O discos de dos colores: sabes el color de las piezas pero debes recordar cuál es cada pieza",
        "fr": "Choisissez entre toutes les pièces de la même couleur. C’est-à-dire que vous savez quelle pièce est laquelle, mais devez vous rappeler si elle vous appartient ou à votre adversaire.<br><br>Ou disques bicolores - vous connaissez la couleur des pièces mais devez retenir quelle pièce est laquelle",
        "de": "Wähle zwischen allen Figuren derselben Farbe. Du weißt, welche Figur es ist, musst aber merken, ob sie dir oder deinem Gegner gehört.<br><br>Oder zwei Farbplatten - du kennst die Farbe der Figuren, musst aber die Art der Figur merken",
        "it": "Scegli se tutte le pezzi hanno lo stesso colore. Cioè, sai che pezzo è, ma devi ricordare se è tuo o dell’avversario.<br><br>Oppure dischi di due colori - conosci il colore dei pezzi ma devi ricordare quale pezzo è",
        "pt": "Escolha entre todas as peças sendo da mesma cor. Ou seja, você sabe qual peça é, mas precisa lembrar se é sua ou do oponente.<br><br>Ou discos de duas cores - você sabe a cor das peças, mas precisa lembrar qual peça é",
        "sv": "Välj mellan alla pjäser i samma färg (du vet pjäs men inte vem som äger den) eller tvåfärgade brickor (du vet färg men måste komma ihåg pjäsens typ)."
    },
    {
        "en": "Spaced Reveals",
        "es": "Revelaciones Espaciadas",
        "fr": "Révélations Espacées",
        "de": "Gestaffelte Enthüllungen",
        "it": "Rivelazioni a Distanza",
        "pt": "Revelações Espaçadas",
        "sv": "Upplägg med mellanliggande avslöjanden"
    },
    {
        "en": "The 'Blindfold King' recommends to start that you think about the game as a series of several move sequences.<br><br>Focus on remembering the pieces from one reveal to another. Is there another program that offers this?",
        "es": "El 'Rey a Ciegas' recomienda empezar pensando en la partida como una serie de secuencias de movimientos.<br><br>Concéntrate en recordar las piezas de una revelación a otra. ¿Existe otro programa que ofrezca esto?",
        "fr": "Le 'Roi à l’Aveugle' recommande de commencer en pensant au jeu comme une série de séquences de coups.<br><br>Concentrez-vous sur le fait de mémoriser les pièces d’une révélation à l’autre. Y a-t-il un autre programme qui propose cela ?",
        "de": "Der 'Blindfold King' empfiehlt, das Spiel als eine Serie mehrerer Zugfolgen zu betrachten.<br><br>Konzentriere dich darauf, die Figuren von einer Enthüllung zur nächsten zu merken. Gibt es ein anderes Programm, das das anbietet?",
        "it": "Il 'Re Blindfold' consiglia di iniziare pensando alla partita come una serie di sequenze di mosse.<br><br>Concentrati nel ricordare i pezzi da una rivelazione all’altra. Esiste un altro programma che offre questo?",
        "pt": "O 'Rei às Cegas' recomenda começar pensando no jogo como uma série de sequências de movimentos.<br><br>Concentre-se em lembrar as peças de uma revelação para outra. Existe outro programa que oferece isso?",
        "sv": "Blindfold-experter rekommenderar att se spelet som flera dragsekvenser. Fokusera på att minnas pjäserna mellan avslöjanden — finns det annat program som erbjuder detta?"
    },
    {
        "en": "Playing the Engine",
        "es": "Jugar contra el Motor",
        "fr": "Jouer contre le Moteur",
        "de": "Gegen die Engine Spielen",
        "it": "Giocare contro il Motore",
        "pt": "Jogando contra o Motor",
        "sv": "Spela mot motorn"
    },
    {
        "en": "You'll be playing against the Komodo engine at its basic skill level.<br><br>Unique to Chessvis is that opening moves come from the database and are randomly selected based on popularity. This gives a much better start then just the engine alone.",
        "es": "Jugarás contra el motor Komodo en su nivel básico.<br><br>Lo único de Chessvis es que los movimientos de apertura provienen de la base de datos y se seleccionan al azar según su popularidad. Esto da un inicio mucho mejor que solo el motor.",
        "fr": "Vous jouerez contre le moteur Komodo à son niveau de compétence de base.<br><br>Unique à Chessvis : les coups d’ouverture proviennent de la base de données et sont sélectionnés au hasard selon leur popularité. Cela donne un meilleur départ que le moteur seul.",
        "de": "Du spielst gegen die Komodo-Engine auf ihrem Basislevel.<br><br>Einzigartig bei Chessvis ist, dass die Eröffnungszüge aus der Datenbank stammen und nach Beliebtheit zufällig ausgewählt werden. Das ergibt einen viel besseren Start als nur die Engine allein.",
        "it": "Giocherai contro il motore Komodo al livello di abilità base.<br><br>Unico di Chessvis è che le mosse di apertura provengono dal database e sono selezionate casualmente in base alla popolarità. Questo offre un inizio molto migliore rispetto al solo motore.",
        "pt": "Você jogará contra o motor Komodo no nível básico.<br><br>Único no Chessvis é que os lances de abertura vêm do banco de dados e são selecionados aleatoriamente com base na popularidade. Isso dá um início muito melhor do que apenas o motor.",
        "sv": "Du spelar mot Komodo på grundnivå. Unikt för Chessvis är att öppningsdrag hämtas från databasen och väljs slumpmässigt efter popularitet — ger bättre start än bara motorn."
    },
    {
        "en": "Subscribers get 'Stockfish' as a 2nd chess engine and can play either one at any strength level.<br><br>Please consider subscribing and supporting my work.",
        "es": "Los suscriptores obtienen 'Stockfish' como segundo motor de ajedrez y pueden jugar con cualquiera de los dos a cualquier nivel de habilidad.<br><br>Por favor, considera suscribirte y apoyar mi trabajo.",
        "fr": "Les abonnés obtiennent 'Stockfish' comme deuxième moteur et peuvent jouer avec l’un ou l’autre à n’importe quel niveau.<br><br>Veuillez envisager de vous abonner et de soutenir mon travail.",
        "de": "Abonnenten erhalten 'Stockfish' als zweite Engine und können mit jeder auf beliebigem Niveau spielen.<br><br>Bitte erwäge ein Abonnement und unterstütze meine Arbeit.",
        "it": "Gli abbonati ottengono 'Stockfish' come secondo motore di scacchi e possono giocare con uno o l’altro a qualsiasi livello.<br><br>Si prega di considerare l’abbonamento e supportare il mio lavoro.",
        "pt": "Assinantes recebem 'Stockfish' como segundo motor de xadrez e podem jogar com qualquer um em qualquer nível de força.<br><br>Por favor, considere assinar e apoiar meu trabalho.",
        "sv": "Prenumeranter får Stockfish som andra motor och kan spela med valfri styrka. Överväg gärna att prenumerera och stödja mitt arbete."
    },
    {
        "en": "Subscriber Benefits",
        "es": "Beneficios para Suscriptores",
        "fr": "Avantages pour les Abonnés",
        "de": "Abonnenten Vorteile",
        "it": "Vantaggi per gli Abbonati",
        "pt": "Benefícios para Assinantes",
        "sv": "Fördelar för prenumeranter"
    },
    {
        "en": "Subscribers get two additional 'stepping stones' including: one color disks and the empty board.",
        "es": "Los suscriptores obtienen dos 'escalones' adicionales, incluyendo: discos de un color y el tablero vacío.",
        "fr": "Les abonnés obtiennent deux 'marches' supplémentaires, y compris : des disques d’une couleur et le plateau vide.",
        "de": "Abonnenten erhalten zwei zusätzliche 'Stufen', einschließlich: Einfarbige Scheiben und das leere Brett.",
        "it": "Gli abbonati ottengono due 'gradini' aggiuntivi, inclusi: dischi di un colore e la scacchiera vuota.",
        "pt": "Assinantes recebem dois 'degraus' adicionais, incluindo: discos de uma cor e o tabuleiro vazio.",
        "sv": "Prenumeranter får två extra stegstenar: en-färgs brickor och tomt bräde."
    },
    {
        "en": "Subscribers also get 'Stockfish' as a 2nd chess engine and can play either one at any strength level.<br><br>Please consider subscribing and supporting my work.",
        "es": "Los suscriptores también obtienen 'Stockfish' como segundo motor de ajedrez y pueden jugar con cualquiera de los dos a cualquier nivel de habilidad.<br><br>Por favor, considera suscribirte y apoyar mi trabajo.",
        "fr": "Les abonnés obtiennent également 'Stockfish' comme deuxième moteur et peuvent jouer avec l’un ou l’autre à n’importe quel niveau.<br><br>Merci de considérer l’abonnement et de soutenir mon travail.",
        "de": "Abonnenten erhalten auch 'Stockfish' als zweite Engine und können mit jeder auf jedem Schwierigkeitsgrad spielen.<br><br>Bitte erwägen Sie ein Abonnement und unterstützen Sie meine Arbeit.",
        "it": "Gli abbonati ottengono anche 'Stockfish' come secondo motore e possono giocare con uno o l’altro a qualsiasi livello di abilità.<br><br>Si prega di considerare l’abbonamento e supportare il mio lavoro.",
        "pt": "Assinantes também recebem 'Stockfish' como segundo motor de xadrez e podem jogar com qualquer um em qualquer nível de força.<br><br>Por favor, considere assinar e apoiar meu trabalho.",
        "sv": "Prenumeranter får även Stockfish som andra motor och kan spela på valfri nivå. Överväg att prenumerera och stödja mitt arbete."
    },
    {
        "en": "Game Review",
        "es": "Revisión de Partidas",
        "fr": "Revue de Partie",
        "de": "Partie Überprüfung",
        "it": "Revisione della Partita",
        "pt": "Revisão de Partida",
        "sv": "Partigranskning"
    },
    {
        "en": "Games are stored on the server and can be reviewed immediately or later.",
        "es": "Las partidas se almacenan en el servidor y se pueden revisar inmediatamente o más tarde.",
        "fr": "Les parties sont stockées sur le serveur et peuvent être consultées immédiatement ou plus tard.",
        "de": "Spiele werden auf dem Server gespeichert und können sofort oder später überprüft werden.",
        "it": "Le partite sono archiviate sul server e possono essere revisionate immediatamente o in seguito.",
        "pt": "As partidas são armazenadas no servidor e podem ser revisadas imediatamente ou mais tarde.",
        "sv": "Partier sparas på servern och kan granskas direkt eller senare."
    },
    {
        "en": "Start Game - Toolbar",
        "es": "Iniciar Partida - Barra de Herramientas",
        "fr": "Démarrer la Partie - Barre d’Outils",
        "de": "Spiel Starten - Werkzeugleiste",
        "it": "Inizia Partita - Barra degli Strumenti",
        "pt": "Iniciar Jogo - Barra de Ferramentas",
        "sv": "Starta parti - Verktygsfält"
    },
    {
        "en": "Start and End Game with this button",
        "es": "Inicia y termina la partida con este botón",
        "fr": "Commencez et Terminez la partie avec ce bouton",
        "de": "Spiel starten und beenden mit diesem Button",
        "it": "Avvia e termina la partita con questo pulsante",
        "pt": "Inicie e termine o jogo com este botão",
        "sv": "Starta och avsluta parti med denna knapp"
    },
    {
        "en": "Takeback - Toolbar",
        "es": "Deshacer Movimiento - Barra de Herramientas",
        "fr": "Annuler Coup - Barre d’Outils",
        "de": "Rücknahme - Werkzeugleiste",
        "it": "Riprendi Mossa - Barra degli Strumenti",
        "pt": "Desfazer Jogada - Barra de Ferramentas",
        "sv": "Återtag - Verktygsfält"
    },
    {
        "en": "You can set the 'delay' before the opponent's move is shown. If you made a wrong move, you have that amount of time to 'take it back'.",
        "es": "Puedes establecer el 'retraso' antes de que se muestre el movimiento del oponente. Si cometiste un error, tienes ese tiempo para 'deshacerlo'.",
        "fr": "Vous pouvez définir le 'délai' avant que le coup de l’adversaire ne soit affiché. Si vous faites une erreur, vous avez ce temps pour 'revenir en arrière'.",
        "de": "Du kannst die 'Verzögerung' einstellen, bevor der Zug des Gegners angezeigt wird. Wenn du einen Fehler machst, hast du diese Zeit, um ihn 'zurückzunehmen'.",
        "it": "Puoi impostare il 'ritardo' prima che venga mostrata la mossa dell’avversario. Se fai una mossa sbagliata, hai quel tempo per 'riprenderla'.",
        "pt": "Você pode definir o 'atraso' antes que o movimento do oponente seja mostrado. Se você errou, tem esse tempo para 'desfazer'.",
        "sv": "Ställ in fördröjning innan motståndarens drag visas. Gjorde du fel har du den tiden på dig att ta tillbaka draget."
    },
    {
        "en": "Review - Toolbar",
        "es": "Revisar - Barra de Herramientas",
        "fr": "Revue - Barre d’Outils",
        "de": "Überprüfung - Werkzeugleiste",
        "it": "Revisione - Barra degli Strumenti",
        "pt": "Revisão - Barra de Ferramentas",
        "sv": "Granska - Verktygsfält"
    },
    {
        "en": "Once the game is ended, you can immediately switch to the 'Review' screen.<br><br>Games are stored and can be reviewed at anytime off the 'Game History' screen.",
        "es": "Una vez que la partida termina, puedes cambiar inmediatamente a la pantalla de 'Revisión'.<br><br>Las partidas se almacenan y pueden revisarse en cualquier momento desde la pantalla de 'Historial de Partidas'.",
        "fr": "Une fois la partie terminée, vous pouvez passer immédiatement à l’écran de 'Revue'.<br><br>Les parties sont stockées et peuvent être consultées à tout moment depuis l’écran 'Historique des Parties'.",
        "de": "Sobald das Spiel beendet ist, kannst du sofort zum 'Überprüfen'-Bildschirm wechseln.<br><br>Spiele werden gespeichert und können jederzeit über den 'Spielverlauf'-Bildschirm überprüft werden.",
        "it": "Una volta terminata la partita, puoi passare immediatamente allo schermo di 'Revisione'.<br><br>Le partite sono archiviate e possono essere revisionate in qualsiasi momento dallo schermo 'Cronologia Partite'.",
        "pt": "Quando o jogo terminar, você pode mudar imediatamente para a tela de 'Revisão'.<br><br>As partidas são armazenadas e podem ser revisadas a qualquer momento na tela de 'Histórico de Jogos'.",
        "sv": "När partiet är slut kan du direkt gå till 'Granska'. Partier sparas och kan ses senare via 'Partihistorik'."
    },
    {
        "en": "As an alternative to the '<i>Reveal Every So Many Moves<\/i>', you can reveal the board on demand.",
        "es": "Como alternativa a '<i>Revelar cada cierta cantidad de movimientos<\/i>', puedes revelar el tablero cuando quieras.",
        "fr": "Comme alternative à '<i>Révéler tous les X coups<\/i>', vous pouvez révéler le plateau à la demande.",
        "de": "Als Alternative zu '<i>Alle X Züge aufdecken<\/i>' kannst du das Brett nach Bedarf aufdecken.",
        "it": "Come alternativa a '<i>Rivelare ogni tot mosse<\/i>', puoi rivelare la scacchiera su richiesta.",
        "pt": "Como alternativa a '<i>Revelar a cada X movimentos<\/i>', você pode revelar o tabuleiro sob demanda.",
        "sv": "Som alternativ till 'Visa varannan gång' kan du avslöja brädet på begäran."
    },
    {
        "en": "Blindfold Level Option - Toolbar",
        "es": "Opción de Nivel Ciegas - Barra de Herramientas",
        "fr": "Option Niveau Aveugle - Barre d’Outils",
        "de": "Blindschach-Level Option - Werkzeugleiste",
        "it": "Opzione Livello Scacchi alla Cieca - Barra degli Strumenti",
        "pt": "Opção de Nível Cegas - Barra de Ferramentas",
        "sv": "Blindfold-nivå - Verktygsfält"
    },
    {
        "en": "The free version enables you to try blindfold chess at two levels.<br><br><b>One Color Pieces<\/b> - Both sides will show as white<br><br><b>Two Color Disks<\/b> - All pieces will be white or black disks",
        "es": "La versión gratuita te permite probar ajedrez a ciegas en dos niveles.<br><br><b>Piezas de un color<\/b> - Ambos bandos se mostrarán en blanco<br><br><b>Discos de dos colores<\/b> - Todas las piezas serán discos blancos o negros",
        "fr": "La version gratuite vous permet d’essayer les échecs à l’aveugle à deux niveaux.<br><br><b>Pièces d’une couleur<\/b> - Les deux côtés apparaîtront en blanc<br><br><b>Disques de deux couleurs<\/b> - Toutes les pièces seront des disques blancs ou noirs",
        "de": "Die kostenlose Version ermöglicht es dir, Blindschach auf zwei Levels auszuprobieren.<br><br><b>Einfarbige Figuren<\/b> - Beide Seiten werden weiß angezeigt<br><br><b>Zweifarbige Scheiben<\/b> - Alle Figuren sind weiße oder schwarze Scheiben",
        "it": "La versione gratuita ti permette di provare gli scacchi alla cieca a due livelli.<br><br><b>Pezzi di un colore<\/b> - Entrambi i lati saranno mostrati in bianco<br><br><b>Dischi di due colori<\/b> - Tutti i pezzi saranno dischi bianchi o neri",
        "pt": "A versão gratuita permite experimentar xadrez às cegas em dois níveis.<br><br><b>Peças de uma cor<\/b> - Ambos os lados serão brancos<br><br><b>Discos de duas cores<\/b> - Todas as peças serão discos brancos ou pretos",
        "sv": "Gratisversionen låter dig prova blindfold på två nivåer: <b>Enfärgade pjäser<\/b> — båda sidor visas som vita. <b>Tvåfärgade brickor<\/b> — alla pjäser visas som vita eller svarta brickor."
    },
    {
        "en": "Select among the four blindfold stepping stones.",
        "es": "Selecciona entre los cuatro escalones de ajedrez a ciegas.",
        "fr": "Sélectionnez parmi les quatre marches pour les échecs à l’aveugle.",
        "de": "Wähle aus den vier Blindschach-Stufen.",
        "it": "Seleziona tra i quattro gradini di scacchi alla cieca.",
        "pt": "Selecione entre os quatro degraus de xadrez às cegas.",
        "sv": "Välj bland de fyra blindfold-stegstenarna."
    },
    {
        "en": "Engine & SKill Options - Toolbar",
        "es": "Opciones de Motor y Habilidad - Barra de Herramientas",
        "fr": "Options Moteur et Compétence - Barre d’Outils",
        "de": "Engine & Skill Optionen - Werkzeugleiste",
        "it": "Opzioni Motore e Abilità - Barra degli Strumenti",
        "pt": "Opções de Motor e Habilidade - Barra de Ferramentas",
        "sv": "Motor & nivå - Verktygsfält"
    },
    {
        "en": "Choose between the Komodo and Stockfish computer engines. Note: the Stockfish engine even at level 0 is still playing real chess.<br><br>Komodo at level 0 makes random moves and is a good place to start with the blindfold on.",
        "es": "Elige entre los motores Komodo y Stockfish. Nota: el motor Stockfish incluso en nivel 0 sigue jugando ajedrez real.<br><br>Komodo en nivel 0 hace movimientos aleatorios y es un buen lugar para empezar con el ajedrez a ciegas.",
        "fr": "Choisissez entre les moteurs Komodo et Stockfish. Note : le moteur Stockfish, même au niveau 0, joue encore aux vrais échecs.<br><br>Komodo au niveau 0 effectue des coups aléatoires et est un bon point de départ pour l’aveugle.",
        "de": "Wähle zwischen den Engines Komodo und Stockfish. Hinweis: Die Stockfish-Engine spielt selbst auf Level 0 noch echtes Schach.<br><br>Komodo auf Level 0 macht zufällige Züge und ist ein guter Startpunkt für Blindschach.",
        "it": "Scegli tra i motori Komodo e Stockfish. Nota: il motore Stockfish anche a livello 0 gioca ancora a scacchi reali.<br><br>Komodo a livello 0 fa mosse casuali ed è un buon punto di partenza con gli scacchi alla cieca.",
        "pt": "Escolha entre os motores Komodo e Stockfish. Nota: o motor Stockfish mesmo no nível 0 ainda joga xadrez real.<br><br>Komodo no nível 0 faz movimentos aleatórios e é um bom ponto de partida para o xadrez às cegas.",
        "sv": "Välj Komodo eller Stockfish. Obs: Stockfish på nivå 0 spelar fortfarande riktig schack. Komodo nivå 0 gör slumpmässiga drag och är bra att börja med blindfold."
    },
    {
        "en": "Choose between the Komodo and Stockfish computer engines at skill levels 0 to 20.<br><br>Note: the Stockfish engine even at level 0 is still playing real chess. (At least to me!)<br><br>Komodo at level 0 makes random moves.",
        "es": "Elige entre los motores Komodo y Stockfish en niveles de habilidad del 0 al 20.<br><br>Nota: el motor Stockfish incluso en nivel 0 sigue jugando ajedrez real. (¡Al menos para mí!)<br><br>Komodo en nivel 0 hace movimientos aleatorios.",
        "fr": "Choisissez entre les moteurs Komodo et Stockfish aux niveaux de compétence de 0 à 20.<br><br>Note : le moteur Stockfish, même au niveau 0, joue encore aux vrais échecs. (Du moins pour moi !)<br><br>Komodo au niveau 0 effectue des coups aléatoires.",
        "de": "Wähle zwischen den Engines Komodo und Stockfish auf den Schwierigkeitsstufen 0 bis 20.<br><br>Hinweis: Die Stockfish-Engine spielt selbst auf Level 0 noch echtes Schach. (Zumindest für mich!)<br><br>Komodo auf Level 0 macht zufällige Züge.",
        "it": "Scegli tra i motori Komodo e Stockfish ai livelli di abilità da 0 a 20.<br><br>Nota: il motore Stockfish anche a livello 0 gioca ancora a scacchi reali. (Almeno per me!)<br><br>Komodo a livello 0 fa mosse casuali.",
        "pt": "Escolha entre os motores Komodo e Stockfish nos níveis de habilidade de 0 a 20.<br><br>Nota: o motor Stockfish mesmo no nível 0 ainda joga xadrez real. (Pelo menos para mim!)<br><br>Komodo no nível 0 faz movimentos aleatórios.",
        "sv": "Välj Komodo eller Stockfish på nivå 0–20. Obs: Stockfish nivå 0 spelar fortfarande 'riktig' schack. Komodo nivå 0 gör slumpdrag."
    },
    {
        "en": "A scrollable list of the last 99 games you've played against the computer or blindfold.<br><br>Clicking on a game takes you to the 'Review' screen.",
        "es": "Una lista desplazable de las últimas 99 partidas que has jugado contra la computadora o a ciegas.<br><br>Hacer clic en una partida te lleva a la pantalla de 'Revisión'.",
        "fr": "Une liste déroulante des 99 dernières parties jouées contre l’ordinateur ou à l’aveugle.<br><br>Cliquez sur une partie pour accéder à l’écran de 'Revue'.",
        "de": "Eine scrollbare Liste der letzten 99 Spiele, die du gegen den Computer oder blind gespielt hast.<br><br>Ein Klick auf ein Spiel führt dich zum 'Überprüfen'-Bildschirm.",
        "it": "Una lista scorrevole delle ultime 99 partite giocate contro il computer o a scacchi alla cieca.<br><br>Cliccando su una partita accederai alla schermata di 'Revisione'.",
        "pt": "Uma lista rolável dos últimos 99 jogos que você jogou contra o computador ou às cegas.<br><br>Clicar em um jogo leva você à tela de 'Revisão'.",
        "sv": "En scrollbar lista med de senaste 99 partierna mot datorn eller blindfold. Klicka på ett parti för att granska det."
    },
    {
        "en": "Download - Toolbar",
        "es": "Descargar - Barra de Herramientas",
        "fr": "Télécharger - Barre d’Outils",
        "de": "Herunterladen - Werkzeugleiste",
        "it": "Scarica - Barra degli Strumenti",
        "pt": "Baixar - Barra de Ferramentas",
        "sv": "Ladda ner - Verktygsfält"
    },
    {
        "en": "Builds a PGN file of all the games you've played. You can import this into another game review program",
        "es": "Genera un archivo PGN de todas las partidas que has jugado. Puedes importarlo en otro programa de revisión de partidas.",
        "fr": "Crée un fichier PGN de toutes les parties jouées. Vous pouvez l’importer dans un autre programme de revue de parties.",
        "de": "Erstellt eine PGN-Datei aller Spiele, die du gespielt hast. Du kannst sie in ein anderes Analyseprogramm importieren.",
        "it": "Crea un file PGN di tutte le partite che hai giocato. Puoi importarlo in un altro programma di revisione partite.",
        "pt": "Cria um arquivo PGN de todas as partidas que você jogou. Você pode importá-lo em outro programa de revisão de jogos.",
        "sv": "Skapar en PGN-fil med alla dina partier som du kan importera i annat gransk­ningsprogram"
    },
    {
        "en": "With this opening explorer, you can evaluate win\/loss percentages for various moves in the tree.<br><br>Chessvis gives you multiple ways to filter the games.",
        "es": "Con este explorador de aperturas, puedes evaluar los porcentajes de victorias y derrotas para varios movimientos en el árbol.<br><br>Chessvis te ofrece múltiples formas de filtrar las partidas.",
        "fr": "Avec cet explorateur d’ouvertures, vous pouvez évaluer les pourcentages de victoires et de défaites pour divers coups dans l’arbre.<br><br>Chessvis vous offre plusieurs façons de filtrer les parties.",
        "de": "Mit diesem Eröffnungs-Explorer kannst du die Gewinn-\/Verlustprozentsätze für verschiedene Züge im Baum auswerten.<br><br>Chessvis bietet dir mehrere Möglichkeiten, die Partien zu filtern.",
        "it": "Con questo esploratore di aperture puoi valutare le percentuali di vittorie e sconfitte per le varie mosse nell’albero.<br><br>Chessvis ti offre diversi modi per filtrare le partite.",
        "pt": "Com este explorador de aberturas, você pode avaliar as porcentagens de vitórias e derrotas para vários lances na árvore.<br><br>O Chessvis oferece várias maneiras de filtrar as partidas.",
        "sv": "Med öppningsutforskaren kan du utvärdera vinst\/förlust-procent för olika drag i trädet. Chessvis erbjuder flera filtermöjligheter."
    },
    {
        "en": "The Game Universe",
        "es": "El Universo de Partidas",
        "fr": "L’Univers des Parties",
        "de": "Das Spieluniversum",
        "it": "L’Universo delle Partite",
        "pt": "O Universo de Partidas",
        "sv": "Spel-universumet"
    },
    {
        "en": "The Lichess 'rapid' games were used to build the tree.<br><br>Note: the tree is still being filled out. It has 200M games now and will have 600M in a couple of months. After that about 16M games will be added every month.",
        "es": "Las partidas 'rápidas' de Lichess se usaron para construir el árbol.<br><br>Nota: el árbol aún se está completando. Actualmente tiene 200 millones de partidas y tendrá 600 millones en un par de meses. Después de eso se agregarán unas 16 millones de partidas por mes.",
        "fr": "Les parties 'rapides' de Lichess ont été utilisées pour construire l’arbre.<br><br>Remarque : l’arbre est encore en cours de remplissage. Il contient actuellement 200 millions de parties et atteindra 600 millions dans quelques mois. Ensuite, environ 16 millions de parties seront ajoutées chaque mois.",
        "de": "Die 'Rapid'-Partien von Lichess wurden verwendet, um den Baum aufzubauen.<br><br>Hinweis: Der Baum wird noch erweitert. Er enthält derzeit 200 Millionen Partien und wird in ein paar Monaten 600 Millionen haben. Danach werden etwa 16 Millionen Partien pro Monat hinzugefügt.",
        "it": "Le partite 'rapide' di Lichess sono state utilizzate per costruire l’albero.<br><br>Nota: l’albero è ancora in fase di completamento. Attualmente contiene 200 milioni di partite e raggiungerà 600 milioni tra un paio di mesi. Successivamente verranno aggiunte circa 16 milioni di partite al mese.",
        "pt": "As partidas 'rápidas' do Lichess foram usadas para construir a árvore.<br><br>Observação: a árvore ainda está sendo preenchida. Atualmente possui 200 milhões de partidas e terá 600 milhões em alguns meses. Depois disso, cerca de 16 milhões de partidas serão adicionadas por mês.",
        "sv": "Lichess 'rapid'-partier användes för att bygga trädet. Trädet fylls fortfarande på: 200M partier nu, 600M inom några månader, och därefter ~16M per månad."
    },
    {
        "en": "Focus on Rating brackets",
        "es": "Enfócate en los rangos de puntuación",
        "fr": "Concentrez-vous sur les tranches de classement",
        "de": "Fokus auf Wertungsbereiche",
        "it": "Concentrati sulle fasce di punteggio",
        "pt": "Foque nas faixas de pontuação",
        "sv": "Fokusera på ratingintervaller"
    },
    {
        "en": "A detailed analysis of the game universe shows that it is important to focus on games around your rating.<br><br>Even a 50 point difference statistically outweighes even the best 'move' you can find.",
        "es": "Un análisis detallado del universo de partidas muestra que es importante centrarse en partidas cercanas a tu puntuación.<br><br>Incluso una diferencia de 50 puntos estadísticamente pesa más que la mejor 'jugada' que puedas encontrar.",
        "fr": "Une analyse détaillée de l’univers des parties montre qu’il est important de se concentrer sur les parties proches de votre classement.<br><br>Une différence de 50 points pèse statistiquement plus que le meilleur 'coup' que vous puissiez trouver.",
        "de": "Eine detaillierte Analyse des Spieluniversums zeigt, dass es wichtig ist, sich auf Partien in deinem Wertungsbereich zu konzentrieren.<br><br>Sogar ein Unterschied von 50 Punkten überwiegt statistisch selbst den besten 'Zug', den du finden kannst.",
        "it": "Un’analisi dettagliata dell’universo delle partite mostra che è importante concentrarsi su quelle intorno al proprio punteggio.<br><br>Anche una differenza di 50 punti pesa statisticamente più della migliore 'mossa' che puoi trovare.",
        "pt": "Uma análise detalhada do universo de partidas mostra que é importante focar em jogos próximos à sua pontuação.<br><br>Mesmo uma diferença de 50 pontos pesa estatisticamente mais do que o melhor 'lance' que você possa encontrar.",
        "sv": "Analys visar att det är viktigt att fokusera på partier runt ditt rating. Även 50 poäng skillnad påverkar mer än ett 'bäst' drag."
    },
    {
        "en": "Making Moves Two Ways",
        "es": "Dos maneras de realizar movimientos",
        "fr": "Deux façons de jouer un coup",
        "de": "Züge auf zwei Arten ausführen",
        "it": "Due modi per fare le mosse",
        "pt": "Duas maneiras de fazer lances",
        "sv": "Göra drag på två sätt"
    },
    {
        "en": "Moves can either be made on the board or by clicking on a move in the list",
        "es": "Los movimientos pueden hacerse en el tablero o haciendo clic en un movimiento de la lista.",
        "fr": "Les coups peuvent être joués sur l’échiquier ou en cliquant sur un coup dans la liste.",
        "de": "Züge können entweder auf dem Brett oder durch Klicken auf einen Zug in der Liste ausgeführt werden.",
        "it": "Le mosse possono essere fatte sulla scacchiera o cliccando su una mossa nell’elenco.",
        "pt": "Os lances podem ser feitos no tabuleiro ou clicando em um lance na lista.",
        "sv": "Drag kan göras på brädet eller genom att klicka i draglistan"
    },
    {
        "en": "The Move List",
        "es": "La Lista de Movimientos",
        "fr": "La Liste des Coups",
        "de": "Die Zugliste",
        "it": "L’Elenco delle Mosse",
        "pt": "A Lista de Lances",
        "sv": "Draglistan"
    },
    {
        "en": "The move choices are sorted in order of popularity. The moves above the 'blue' line make up 80% of the games. (This helps you identify the moves that matter.)<br><br>The stockfish engine score is shown at the right",
        "es": "Las opciones de movimiento se ordenan por popularidad. Los movimientos por encima de la línea 'azul' representan el 80% de las partidas. (Esto te ayuda a identificar los movimientos importantes).<br><br>La puntuación del motor Stockfish se muestra a la derecha.",
        "fr": "Les coups sont classés par ordre de popularité. Les coups au-dessus de la ligne 'bleue' représentent 80% des parties. (Cela vous aide à identifier les coups importants.)<br><br>Le score du moteur Stockfish est affiché à droite.",
        "de": "Die Zugoptionen sind nach Beliebtheit sortiert. Die Züge oberhalb der 'blauen' Linie machen 80 % der Partien aus. (Das hilft dir, die wichtigen Züge zu erkennen.)<br><br>Die Stockfish-Bewertung wird rechts angezeigt.",
        "it": "Le mosse sono ordinate per popolarità. Le mosse sopra la linea 'blu' rappresentano l’80% delle partite. (Questo ti aiuta a individuare le mosse che contano.)<br><br>Il punteggio del motore Stockfish è mostrato a destra.",
        "pt": "As jogadas são classificadas por popularidade. As jogadas acima da linha 'azul' representam 80% das partidas. (Isso ajuda você a identificar as jogadas mais importantes.)<br><br>A pontuação do motor Stockfish é exibida à direita.",
        "sv": "Dragval sorteras efter popularitet. Drag ovanför den blå linjen utgör 80% av partierna — hjälper dig hitta de viktiga dragen. Stockfish-poäng visas till höger."
    },
    {
        "en": "Set The Range",
        "es": "Establecer el Rango",
        "fr": "Définir la Plage",
        "de": "Bereich Festlegen",
        "it": "Imposta l’Intervallo",
        "pt": "Definir o Intervalo",
        "sv": "Sätt intervallet"
    },
    {
        "en": "The slider lets you set both the minimum and maximum ratings of the games to be included in the list.",
        "es": "El control deslizante te permite establecer las puntuaciones mínima y máxima de las partidas que se incluirán en la lista.",
        "fr": "Le curseur vous permet de définir les classements minimum et maximum des parties à inclure dans la liste.",
        "de": "Der Schieberegler ermöglicht es dir, die minimale und maximale Wertung der in die Liste aufgenommenen Partien festzulegen.",
        "it": "Il cursore ti consente di impostare il punteggio minimo e massimo delle partite da includere nell’elenco.",
        "pt": "O controle deslizante permite definir as pontuações mínima e máxima das partidas a serem incluídas na lista.",
        "sv": "Reglaget låter dig ställa in min- och max-rating för partier som inkluderas."
    },
    {
        "en": "Subscribers can compare two different groups.<br><br>They can also pull in their own games from Lichess and Chess.com for analysis and comparison.",
        "es": "Los suscriptores pueden comparar dos grupos diferentes.<br><br>También pueden importar sus propias partidas desde Lichess y Chess.com para analizarlas y compararlas.",
        "fr": "Les abonnés peuvent comparer deux groupes différents.<br><br>Ils peuvent également importer leurs propres parties depuis Lichess et Chess.com pour analyse et comparaison.",
        "de": "Abonnenten können zwei verschiedene Gruppen vergleichen.<br><br>Sie können auch ihre eigenen Partien von Lichess und Chess.com zum Analysieren und Vergleichen importieren.",
        "it": "Gli abbonati possono confrontare due gruppi diversi.<br><br>Possono anche importare le proprie partite da Lichess e Chess.com per analizzarle e confrontarle.",
        "pt": "Os assinantes podem comparar dois grupos diferentes.<br><br>Também podem importar suas próprias partidas do Lichess e do Chess.com para análise e comparação.",
        "sv": "Prenumeranter kan jämföra två grupper och även hämta egna partier från Lichess\/Chess.com för analys."
    },
    {
        "en": "Main (Game Source) - Toolbar",
        "es": "Principal (Fuente de Partidas) - Barra de Herramientas",
        "fr": "Principal (Source des Parties) - Barre d’Outils",
        "de": "Hauptquelle (Spielquelle) - Werkzeugleiste",
        "it": "Principale (Fonte delle Partite) - Barra degli Strumenti",
        "pt": "Principal (Fonte de Jogos) - Barra de Ferramentas",
        "sv": "Huvudkälla (partier) - Verktygsfält"
    },
    {
        "en": "The main win\/loss list can come from the Lichess rapid games or the master game collection.<br><br>Subscribers can additionally select their own games.",
        "es": "La lista principal de victorias\/derrotas puede provenir de las partidas rápidas de Lichess o de la colección de partidas maestras.<br><br>Los suscriptores también pueden seleccionar sus propias partidas.",
        "fr": "La liste principale des victoires\/défaites peut provenir des parties rapides de Lichess ou de la collection de parties de maîtres.<br><br>Les abonnés peuvent également sélectionner leurs propres parties.",
        "de": "Die Hauptliste der Siege\/Niederlagen kann aus den Lichess-Rapid-Partien oder der Meisterpartien-Sammlung stammen.<br><br>Abonnenten können zusätzlich ihre eigenen Partien auswählen.",
        "it": "L’elenco principale di vittorie\/sconfitte può provenire dalle partite rapide di Lichess o dalla collezione di partite dei maestri.<br><br>Gli abbonati possono anche selezionare le proprie partite.",
        "pt": "A lista principal de vitórias\/derrotas pode vir das partidas rápidas do Lichess ou da coleção de partidas de mestres.<br><br>Os assinantes também podem selecionar suas próprias partidas.",
        "sv": "Huvudlistan med vinster\/förluster kan komma från Lichess rapid eller master-samlingen. Prenumeranter kan även välja egna partier."
    },
    {
        "en": "Lichess Equal Rating - Toolbar",
        "es": "Lichess Igual Puntuación - Barra de Herramientas",
        "fr": "Lichess Classement Égal - Barre d’Outils",
        "de": "Lichess Gleiche Wertung - Werkzeugleiste",
        "it": "Lichess Punteggio Uguale - Barra degli Strumenti",
        "pt": "Lichess Classificação Igual - Barra de Ferramentas",
        "sv": "Lichess lika rating - Verktygsfält"
    },
    {
        "en": "Lichess games are brackets two ways:<br><br><b>Equal Rating<\/b> - only games where both the white and black players ratings fall within the same 50 point rating bracket. View this as 'head-to-head' competition.",
        "es": "Las partidas de Lichess se agrupan de dos formas:<br><br><b>Igual Puntuación<\/b> - solo partidas donde las puntuaciones de los jugadores blanco y negro estén dentro del mismo rango de 50 puntos. Considéralo como una competencia 'cara a cara'.",
        "fr": "Les parties Lichess sont regroupées de deux manières :<br><br><b>Classement Égal<\/b> - uniquement les parties où les classements des joueurs blanc et noir se situent dans la même tranche de 50 points. Considérez cela comme une compétition 'en tête-à-tête'.",
        "de": "Lichess-Partien werden auf zwei Arten gruppiert:<br><br><b>Gleiche Wertung<\/b> – nur Partien, in denen die Bewertungen beider Spieler innerhalb derselben 50-Punkte-Spanne liegen. Betrachte dies als 'direkten Vergleich'.",
        "it": "Le partite Lichess sono raggruppate in due modi:<br><br><b>Punteggio Uguale<\/b> - solo partite in cui i punteggi dei giocatori bianco e nero rientrano nella stessa fascia di 50 punti. Consideralo una competizione 'uno contro uno'.",
        "pt": "As partidas do Lichess são agrupadas de duas formas:<br><br><b>Classificação Igual<\/b> - apenas partidas em que as classificações dos jogadores branco e preto estão dentro da mesma faixa de 50 pontos. Veja isso como uma competição 'cara a cara'.",
        "sv": "Lichess-partier sorteras på två sätt: <b>Lika rating<\/b> — bara partier där både vit och svart ligger i samma 50-punktsintervall (head-to-head)."
    },
    {
        "en": "Lichess Average Rating - Toolbar",
        "es": "Lichess Promedio de Puntuación - Barra de Herramientas",
        "fr": "Lichess Classement Moyen - Barre d’Outils",
        "de": "Lichess Durchschnittswertung - Werkzeugleiste",
        "it": "Lichess Punteggio Medio - Barra degli Strumenti",
        "pt": "Lichess Classificação Média - Barra de Ferramentas",
        "sv": "Lichess genomsnittsrating - Verktygsfält"
    },
    {
        "en": "The other approach to Lichess game brackets is:<br><br><b>Average Rating<\/b> - the white and black player ratings are averaged and put into 100 point buckets.",
        "es": "El otro método para agrupar las partidas de Lichess es:<br><br><b>Promedio de Puntuación<\/b> - las puntuaciones de los jugadores blanco y negro se promedian y se agrupan en intervalos de 100 puntos.",
        "fr": "L’autre approche des groupes de parties Lichess est :<br><br><b>Classement Moyen<\/b> - les classements des joueurs blanc et noir sont moyennés et regroupés par tranches de 100 points.",
        "de": "Der andere Ansatz für Lichess-Spielgruppen ist:<br><br><b>Durchschnittswertung<\/b> – die Bewertungen der weißen und schwarzen Spieler werden gemittelt und in 100-Punkte-Bereiche eingeordnet.",
        "it": "L’altro approccio per raggruppare le partite di Lichess è:<br><br><b>Punteggio Medio<\/b> - i punteggi dei giocatori bianco e nero vengono mediati e suddivisi in fasce di 100 punti.",
        "pt": "A outra abordagem para os grupos de partidas do Lichess é:<br><br><b>Classificação Média<\/b> - as classificações dos jogadores branco e preto são calculadas pela média e colocadas em faixas de 100 pontos.",
        "sv": "Den andra metoden: <b>Genomsnittsbetyg<\/b> — vit och svart betygs genomsnitt hamnar i 100-punktskorgar."
    },
    {
        "en": "Compare (Game Source) - Toolbar",
        "es": "Comparar (Fuente de Partidas) - Barra de Herramientas",
        "fr": "Comparer (Source des Parties) - Barre d’Outils",
        "de": "Vergleichen (Spielquelle) - Werkzeugleiste",
        "it": "Confronta (Fonte delle Partite) - Barra degli Strumenti",
        "pt": "Comparar (Fonte de Jogos) - Barra de Ferramentas",
        "sv": "Jämför (partikälla) - Verktygsfält"
    },
    {
        "en": "For subscribers, a second set of win\/loss bars can be displayed for comparison.",
        "es": "Para los suscriptores, se puede mostrar un segundo conjunto de barras de victorias\/derrotas para comparación.",
        "fr": "Pour les abonnés, un deuxième ensemble de barres de victoires\/défaites peut être affiché pour la comparaison.",
        "de": "Für Abonnenten kann ein zweites Set von Gewinn-\/Verlustbalken zum Vergleich angezeigt werden.",
        "it": "Per gli abbonati può essere visualizzato un secondo set di barre di vittorie\/sconfitte per il confronto.",
        "pt": "Para os assinantes, um segundo conjunto de barras de vitórias\/derrotas pode ser exibido para comparação.",
        "sv": "För prenumeranter kan en andra uppsättning vinst\/förlust-staplar visas för jämförelse."
    },
    {
        "en": "Opening Explorer - Slice and Dice",
        "es": "Explorador de Aperturas - Analiza y Divide",
        "fr": "Explorateur d’Ouvertures - Analyser et Découper",
        "de": "Eröffnungs-Explorer - Analysieren und Aufschlüsseln",
        "it": "Esploratore di Aperture - Analizza e Suddividi",
        "pt": "Explorador de Aberturas - Analisar e Dividir",
        "sv": "Öppningsutforskare - analysera detaljerat"
    },
    {
        "en": "Why are we choosing the first moves of a game based on how games end 40 to 60 moves later?<br><br>Seems to me, an unfair burden to place on the beginning moves of the game.",
        "es": "¿Por qué elegimos los primeros movimientos de una partida basándonos en cómo terminan las partidas 40 o 60 jugadas después?<br><br>Me parece una carga injusta para los movimientos iniciales del juego.",
        "fr": "Pourquoi choisissons-nous les premiers coups d’une partie en fonction de la façon dont elle se termine 40 à 60 coups plus tard ?<br><br>Il me semble que c’est un fardeau injuste à imposer aux coups d’ouverture.",
        "de": "Warum wählen wir die ersten Züge einer Partie basierend darauf, wie sie 40 bis 60 Züge später endet?<br><br>Das scheint mir eine ungerechte Belastung für die Eröffnungszüge zu sein.",
        "it": "Perché scegliamo le prime mosse di una partita basandoci su come finiscono 40 o 60 mosse più tardi?<br><br>Mi sembra un peso ingiusto da mettere sulle mosse iniziali.",
        "pt": "Por que escolhemos os primeiros lances de uma partida com base em como ela termina 40 ou 60 lances depois?<br><br>Parece-me um fardo injusto para os lances iniciais do jogo."
    },
    {
        "en": "Is There A Better Way?",
        "es": "¿Hay una Mejor Manera?",
        "fr": "Y a-t-il une Meilleure Façon ?",
        "de": "Gibt es Einen Besseren Weg?",
        "it": "C’è un Modo Migliore?",
        "pt": "Existe uma Maneira Melhor?",
        "sv": "Finns ett bättre sätt?"
    },
    {
        "en": "How about if we could see how games are going at the middle game?<br><br>I propose using the Stockfish engine score as a measure of how well games are going. The higher the score, the better white is doing. The lower the score, the better black is doing.",
        "es": "¿Y si pudiéramos ver cómo van las partidas a mitad del juego?<br><br>Propongo usar la puntuación del motor Stockfish como medida de qué tan bien van las partidas. Cuanto mayor sea la puntuación, mejor para las blancas; cuanto menor, mejor para las negras.",
        "fr": "Et si nous pouvions voir comment se déroulent les parties au milieu du jeu ?<br><br>Je propose d’utiliser le score du moteur Stockfish comme mesure de la qualité du jeu. Plus le score est élevé, mieux les blancs se portent ; plus il est bas, mieux les noirs se portent.",
        "de": "Wie wäre es, wenn wir sehen könnten, wie die Partien im Mittelspiel verlaufen?<br><br>Ich schlage vor, die Stockfish-Bewertung als Maßstab zu verwenden. Je höher der Wert, desto besser steht Weiß; je niedriger, desto besser steht Schwarz.",
        "it": "E se potessimo vedere come stanno andando le partite nel mediogioco?<br><br>Propongo di usare il punteggio del motore Stockfish come misura di come vanno le partite. Più alto è il punteggio, meglio stanno i bianchi; più basso, meglio stanno i neri.",
        "pt": "E se pudéssemos ver como as partidas estão indo no meio-jogo?<br><br>Proponho usar a pontuação do motor Stockfish como medida do andamento das partidas. Quanto maior a pontuação, melhor para as brancas; quanto menor, melhor para as pretas.",
        "sv": "Tänk om vi kunde se hur partier utvecklas i mittspelet? Jag föreslår att använda Stockfish-poäng för att mäta hur partier går: högre = vit bättre, lägre = svart bättre."
    },
    {
        "en": "Seeing into the Middle Game",
        "es": "Viendo el Medio Juego",
        "fr": "Voir dans le Milieu de Partie",
        "de": "Einblick ins Mittelspiel",
        "it": "Vedere nel Mediogioco",
        "pt": "Vendo o Meio-Jogo",
        "sv": "Se in i mittspelet"
    },
    {
        "en": "Chessvis has calculated the Stockfish engine scores at moves 9, 12, 15, 18 and 21 for every game in the game collection.",
        "es": "Chessvis ha calculado las puntuaciones del motor Stockfish en las jugadas 9, 12, 15, 18 y 21 para cada partida de la colección.",
        "fr": "Chessvis a calculé les scores du moteur Stockfish aux coups 9, 12, 15, 18 et 21 pour chaque partie de la collection.",
        "de": "Chessvis hat die Stockfish-Bewertungen bei den Zügen 9, 12, 15, 18 und 21 für jede Partie in der Sammlung berechnet.",
        "it": "Chessvis ha calcolato i punteggi del motore Stockfish alle mosse 9, 12, 15, 18 e 21 per ogni partita della collezione.",
        "pt": "O Chessvis calculou as pontuações do motor Stockfish nos lances 9, 12, 15, 18 e 21 para cada partida da coleção.",
        "sv": "Chessvis har beräknat Stockfish-poängen på drag 9, 12, 15, 18 och 21 för varje parti i samlingen."
    },
    {
        "en": "The Game Collection",
        "es": "La Colección de Partidas",
        "fr": "La Collection de Parties",
        "de": "Die Partiensammlung",
        "it": "La Collezione di Partite",
        "pt": "A Coleção de Partidas",
        "sv": "Partisamlingen"
    },
    {
        "en": "That's A Lot of Scoring",
        "es": "Eso Es Mucha Puntuación",
        "fr": "Ça Fait Beaucoup de Scores",
        "de": "Das Ist Eine Menge Auswertungen",
        "it": "È Un Sacco di Punteggi",
        "pt": "Isso É Muita Pontuação",
        "sv": "Det är mycket poängsättning"
    },
    {
        "en": "At 5 moves per game, that's a lot of scoring being done.<br><br>But that's necessary to get meaningful game counts outside of the most popular moves",
        "es": "Con 5 jugadas por partida, se están haciendo muchas evaluaciones.<br><br>Pero es necesario para obtener recuentos de partidas significativos fuera de los movimientos más populares.",
        "fr": "Avec 5 coups par partie, cela fait beaucoup de calculs.<br><br>Mais c’est nécessaire pour obtenir des statistiques significatives en dehors des coups les plus populaires.",
        "de": "Mit 5 Zügen pro Partie wird viel bewertet.<br><br>Aber das ist notwendig, um aussagekräftige Spielzahlen außerhalb der beliebtesten Züge zu erhalten.",
        "it": "Con 5 mosse per partita, è un sacco di valutazioni.<br><br>Ma è necessario per ottenere conteggi significativi al di fuori delle mosse più popolari.",
        "pt": "Com 5 lances por partida, há muita pontuação sendo calculada.<br><br>Mas isso é necessário para obter contagens significativas fora dos lances mais populares.",
        "sv": "Med 5 drag per parti blir det mycket beräkningar — men nödvändigt för meningsfulla counts utanför de mest populära dragen."
    },
    {
        "en": "The move choices are sorted in order of popularity. The moves above the 'blue' line make up 80% of the games.",
        "es": "Las opciones de movimiento se ordenan por popularidad. Los movimientos por encima de la línea 'azul' representan el 80% de las partidas.",
        "fr": "Les coups sont classés par ordre de popularité. Les coups au-dessus de la ligne 'bleue' représentent 80% des parties.",
        "de": "Die Zugoptionen sind nach Beliebtheit sortiert. Die Züge oberhalb der 'blauen' Linie machen 80 % der Partien aus.",
        "it": "Le mosse sono ordinate per popolarità. Le mosse sopra la linea 'blu' rappresentano l’80% delle partite.",
        "pt": "As jogadas são classificadas por popularidade. As jogadas acima da linha 'azul' representam 80% das partidas.",
        "sv": "Dragval sorteras efter popularitet. De ovanför 'blå' linjen utgör 80% av partierna."
    },
    {
        "en": "Selecting Moves",
        "es": "Seleccionando Movimientos",
        "fr": "Sélectionner les Coups",
        "de": "Züge Auswählen",
        "it": "Selezionare le Mosse",
        "pt": "Selecionando os Lances",
        "sv": "Välja drag"
    },
    {
        "en": "Clicking the move or checking the box, will add the move to the chart.<br><br>Next to the # of games is a weighted average of the Stockfish scores. Positive is good for white and negative is good for black.",
        "es": "Al hacer clic en el movimiento o marcar la casilla, se agregará el movimiento al gráfico.<br><br>Junto al número de partidas hay un promedio ponderado de las puntuaciones de Stockfish. Positivo es bueno para las blancas y negativo para las negras.",
        "fr": "Cliquer sur le coup ou cocher la case ajoutera le coup au graphique.<br><br>À côté du nombre de parties se trouve une moyenne pondérée des scores de Stockfish. Positif est bon pour les blancs et négatif est bon pour les noirs.",
        "de": "Durch Klicken auf den Zug oder Ankreuzen des Feldes wird der Zug dem Diagramm hinzugefügt.<br><br>Neben der Anzahl der Partien steht ein gewichteter Durchschnitt der Stockfish-Bewertungen. Positiv ist gut für Weiß, negativ für Schwarz.",
        "it": "Facendo clic sulla mossa o selezionando la casella, la mossa verrà aggiunta al grafico.<br><br>Accanto al numero di partite c’è una media ponderata dei punteggi di Stockfish. Positivo è buono per i bianchi, negativo per i neri.",
        "pt": "Clicar no lance ou marcar a caixa adicionará o lance ao gráfico.<br><br>Ao lado do número de partidas há uma média ponderada das pontuações do Stockfish. Positivo é bom para as brancas e negativo para as pretas.",
        "sv": "Klicka på ett drag eller markera rutan för att lägga till det i diagrammet. Bredvid antalet partier visas ett viktat medelvärde av Stockfish-poängen: positivt = för vit, negativt = för svart."
    },
    {
        "en": "Comparing Groups",
        "es": "Comparando Grupos",
        "fr": "Comparer les Groupes",
        "de": "Gruppen Vergleichen",
        "it": "Confrontando i Gruppi",
        "pt": "Comparando Grupos",
        "sv": "Jämföra grupper"
    },
    {
        "en": "You can add a comparison group. That can be your games, master games or a different rating section of the Lichess games.",
        "es": "Puedes agregar un grupo de comparación. Puede ser tus propias partidas, partidas maestras o una sección de puntuación diferente de las partidas de Lichess.",
        "fr": "Vous pouvez ajouter un groupe de comparaison. Cela peut être vos propres parties, des parties de maîtres ou une section de classement différente des parties Lichess.",
        "de": "Du kannst eine Vergleichsgruppe hinzufügen. Das können deine eigenen Partien, Meisterpartien oder eine andere Wertungssektion der Lichess-Partien sein.",
        "it": "Puoi aggiungere un gruppo di confronto. Può essere le tue partite, partite di maestri o una sezione di punteggio diversa delle partite di Lichess.",
        "pt": "Você pode adicionar um grupo de comparação. Pode ser suas próprias partidas, partidas de mestres ou uma seção de classificação diferente das partidas do Lichess.",
        "sv": "Du kan lägga till en jämförelsegrupp — dina partier, stormästares partier eller ett annat ratingintervall."
    },
    {
        "en": "Selecting the Move Number",
        "es": "Seleccionando el Número de Jugada",
        "fr": "Sélection du Numéro de Coup",
        "de": "Zugnummer Auswählen",
        "it": "Selezionando il Numero di Mossa",
        "pt": "Selecionando o Número do Lance",
        "sv": "Välj dragnummer"
    },
    {
        "en": "The important slider is the <b>Move Number<\/b>. That is the <i>future<\/i> move that will be used for the bar chart.<br><br>The available future moves are: 9, 12, 15, 18, and 21.",
        "es": "El control deslizante importante es el <b>Número de Jugada<\/b>. Esa es la jugada <i>futura<\/i> que se usará para el gráfico de barras.<br><br>Las jugadas futuras disponibles son: 9, 12, 15, 18 y 21.",
        "fr": "Le curseur important est le <b>Numéro de Coup<\/b>. C’est le coup <i>futur<\/i> qui sera utilisé pour le graphique en barres.<br><br>Les coups futurs disponibles sont : 9, 12, 15, 18 et 21.",
        "de": "Der wichtige Schieberegler ist die <b>Zugnummer<\/b>. Das ist der <i>zukünftige<\/i> Zug, der für das Balkendiagramm verwendet wird.<br><br>Die verfügbaren zukünftigen Züge sind: 9, 12, 15, 18 und 21.",
        "it": "Il cursore importante è il <b>Numero di Mossa<\/b>. È la mossa <i>futura<\/i> che verrà utilizzata per il grafico a barre.<br><br>Le mosse future disponibili sono: 9, 12, 15, 18 e 21.",
        "pt": "O controle deslizante importante é o <b>Número do Lance<\/b>. Esse é o lance <i>futuro<\/i> que será usado no gráfico de barras.<br><br>Os lances futuros disponíveis são: 9, 12, 15, 18 e 21.",
        "sv": "Viktigt reglage är <b>Dragnummer<\/b> — framtida drag som används i stapeldiagrammet. Tillgängliga framtida drag: 9, 12, 15, 18 och 21."
    },
    {
        "en": "The Graph",
        "es": "El Gráfico",
        "fr": "Le Graphique",
        "de": "Das Diagramm",
        "it": "Il Grafico",
        "pt": "O Gráfico",
        "sv": "Grafen"
    },
    {
        "en": "The graph shows the distribution of the Stockfish engine scores for games where the checked move was made.<br><br>For example, if '1.e4' is checked and the slider is at move 15 then the graph shows how well players who played 'e4' are doing in their games at move 15.",
        "es": "El gráfico muestra la distribución de las puntuaciones del motor Stockfish para las partidas en las que se realizó el movimiento marcado.<br><br>Por ejemplo, si se marca '1.e4' y el control deslizante está en el movimiento 15, el gráfico muestra cómo les va a los jugadores que jugaron 'e4' en sus partidas en ese momento.",
        "fr": "Le graphique montre la répartition des scores du moteur Stockfish pour les parties où le coup coché a été joué.<br><br>Par exemple, si '1.e4' est coché et que le curseur est au coup 15, le graphique montre comment se débrouillent les joueurs ayant joué 'e4' à ce stade de la partie.",
        "de": "Das Diagramm zeigt die Verteilung der Stockfish-Bewertungen für Partien, in denen der ausgewählte Zug gespielt wurde.<br><br>Wenn zum Beispiel '1.e4' ausgewählt ist und der Schieberegler auf Zug 15 steht, zeigt das Diagramm, wie gut Spieler, die 'e4' gespielt haben, bei Zug 15 abschneiden.",
        "it": "Il grafico mostra la distribuzione dei punteggi del motore Stockfish per le partite in cui è stata giocata la mossa selezionata.<br><br>Ad esempio, se è selezionata '1.e4' e il cursore è sulla mossa 15, il grafico mostra come stanno andando i giocatori che hanno giocato 'e4' alla mossa 15.",
        "pt": "O gráfico mostra a distribuição das pontuações do motor Stockfish para as partidas em que o lance marcado foi jogado.<br><br>Por exemplo, se '1.e4' estiver marcado e o controle estiver no lance 15, o gráfico mostra como estão se saindo os jogadores que jogaram 'e4' nesse ponto.",
        "sv": "Grafen visar fördelningen av Stockfish-poäng för partier där det valda draget spelades. Ex: om '1.e4' valts och reglaget är på drag 15 visar grafen hur de som spelade e4 klarar sig vid drag 15."
    },
    {
        "en": "The Bars",
        "es": "Las Barras",
        "fr": "Les Barres",
        "de": "Die Balken",
        "it": "Le Barre",
        "pt": "As Barras",
        "sv": "Staplarna"
    },
    {
        "en": "The bars show the percentage of games in each bucket. The buckets start on the left with black having already won the game by the future move number. Next to that is the percentage of games where black has a 'huge' advantage",
        "es": "Las barras muestran el porcentaje de partidas en cada grupo. Los grupos comienzan a la izquierda con las partidas donde las negras ya han ganado. A continuación se muestra el porcentaje de partidas en las que las negras tienen una gran ventaja.",
        "fr": "Les barres montrent le pourcentage de parties dans chaque catégorie. Les catégories commencent à gauche avec les parties déjà gagnées par les noirs. À côté se trouve le pourcentage de parties où les noirs ont un grand avantage.",
        "de": "Die Balken zeigen den Prozentsatz der Partien in jeder Kategorie. Die Kategorien beginnen links mit Partien, die Schwarz bereits gewonnen hat. Daneben der Prozentsatz der Partien, in denen Schwarz einen großen Vorteil hat.",
        "it": "Le barre mostrano la percentuale di partite in ogni categoria. Le categorie iniziano a sinistra con le partite già vinte dal nero. Accanto, la percentuale di partite dove il nero ha un grande vantaggio.",
        "pt": "As barras mostram a porcentagem de partidas em cada categoria. As categorias começam à esquerda com as partidas já vencidas pelas pretas. Ao lado está a porcentagem de partidas em que as pretas têm uma grande vantagem.",
        "sv": "Staplarna visar procentandel partier i varje spann. Spannen börjar till vänster med partier där svart redan vunnit vid framtida draget, därefter partier där svart har 'stor' fördel."
    },
    {
        "en": "The Point Bars",
        "es": "Las Barras de Puntos",
        "fr": "Les Barres de Points",
        "de": "Die Punktebalken",
        "it": "Le Barre dei Punti",
        "pt": "As Barras de Pontos",
        "sv": "Poäng-staplarna"
    },
    {
        "en": "The next several bars break the stockfish engine scores into one point buckets.<br><br><i>(The 3 point bucket represents being up a bishop and the 1 point bucket represents being up by a pawn.)<\/i>",
        "es": "Las siguientes barras dividen las puntuaciones de Stockfish en intervalos de un punto.<br><br><i>(El grupo de 3 puntos representa una ventaja de un alfil y el de 1 punto representa una ventaja de un peón.)<\/i>",
        "fr": "Les barres suivantes divisent les scores du moteur Stockfish en tranches d’un point.<br><br><i>(La tranche de 3 points correspond à un avantage d’un fou et celle de 1 point à un pion.)<\/i>",
        "de": "Die nächsten Balken teilen die Stockfish-Bewertungen in Ein-Punkt-Bereiche.<br><br><i>(Der 3-Punkte-Bereich entspricht einem Läufervorsprung und der 1-Punkte-Bereich einem Bauernvorsprung.)<\/i>",
        "it": "Le barre successive dividono i punteggi Stockfish in intervalli di un punto.<br><br><i>(L’intervallo di 3 punti rappresenta un vantaggio di un alfiere e quello di 1 punto rappresenta un vantaggio di un pedone.)<\/i>",
        "pt": "As próximas barras dividem as pontuações do Stockfish em intervalos de um ponto.<br><br><i>(O intervalo de 3 pontos representa uma vantagem de bispo e o de 1 ponto uma vantagem de peão.)<\/i>",
        "sv": "De följande staplarna delar Stockfish-poäng i ettpoängsspann. (3-poängsspannet motsvarar en löpare i mer, 1-poäng = bonde i mer.)"
    },
    {
        "en": "The Middle and White's Bars",
        "es": "Las Barras del Medio y de las Blancas",
        "fr": "Les Barres du Milieu et des Blancs",
        "de": "Mittlere und Weiße Balken",
        "it": "Le Barre Centrali e del Bianco",
        "pt": "As Barras do Meio e das Brancas",
        "sv": "Mitten och Vits staplar"
    },
    {
        "en": "The center bar shows the percentage of games that are about even.<br><br>The bars to the right are white's mirroring the black buckets from 1 point through already won games.",
        "es": "La barra central muestra el porcentaje de partidas que están aproximadamente igualadas.<br><br>Las barras de la derecha son las de las blancas, reflejando los grupos de las negras desde 1 punto hasta las partidas ya ganadas.",
        "fr": "La barre centrale montre le pourcentage de parties à peu près égales.<br><br>Les barres à droite représentent les avantages des blancs, miroir des catégories des noirs.",
        "de": "Der mittlere Balken zeigt den Prozentsatz der etwa ausgeglichenen Partien.<br><br>Die rechten Balken spiegeln die Vorteile der Weißen wider, entsprechend den schwarzen Bereichen von 1 Punkt bis zu bereits gewonnenen Partien.",
        "it": "La barra centrale mostra le partite equilibrate.<br><br>Le barre a destra rappresentano i vantaggi del bianco, speculari a quelli del nero.",
        "pt": "A barra central mostra a porcentagem de partidas equilibradas.<br><br>As barras à direita representam as brancas, espelhando as pretas de 1 ponto até as partidas já vencidas.",
        "sv": "Mittstapeln visar andelen jämt ställda partier. Staplarna till höger speglar vit: 1-poängsspann upp till redan vunna partier."
    },
    {
        "en": "The main list can come from the Lichess rapid games, the master game collection or your own downloaded games.",
        "es": "La lista principal puede provenir de las partidas rápidas de Lichess, de la colección de partidas maestras o de tus propias partidas descargadas.",
        "fr": "La liste principale peut provenir des parties rapides de Lichess, de la collection de maîtres ou de vos propres parties téléchargées.",
        "de": "Die Hauptliste kann aus Lichess-Schnellpartien, der Meisterpartien-Sammlung oder deinen eigenen heruntergeladenen Partien stammen.",
        "it": "L’elenco principale può provenire dalle partite rapide di Lichess, dalla raccolta di maestri o dalle tue partite scaricate.",
        "pt": "A lista principal pode vir das partidas rápidas do Lichess, da coleção de mestres ou das suas próprias partidas baixadas.",
        "sv": "Huvudlistan kan komma från Lichess rapid, master-samlingen eller dina nedladdade partier."
    },
    {
        "en": "A second set of win\/loss bars can be displayed for comparison.",
        "es": "Se puede mostrar un segundo conjunto de barras de victorias\/derrotas para comparación.",
        "fr": "Un deuxième ensemble de barres victoires\/défaites peut être affiché pour comparaison.",
        "de": "Ein zweites Set von Gewinn\/Verlust-Balken kann zum Vergleich angezeigt werden.",
        "it": "Un secondo set di barre vittorie\/sconfitte può essere visualizzato per confronto.",
        "pt": "Um segundo conjunto de barras de vitórias\/derrotas pode ser exibido para comparação.",
        "sv": "En andra uppsättning vinst\/förlust-staplar kan visas för jämförelse."
    },
    {
        "en": "Show White +  - Toolbar",
        "es": "Mostrar Blancas +  - Barra de herramientas",
        "fr": "Afficher Blanc +  - Barre d'outils",
        "de": "Weiß anzeigen +  - Symbolleiste",
        "it": "Mostra Bianco +  - Barra degli strumenti",
        "pt": "Mostrar Brancas +  - Barra de ferramentas",
        "sv": "Visa 'Vit +' - Verktygsfält"
    },
    {
        "en": "Obviously, for whatever color you're playing, you want moves where your bars are 'higher'. When you find yourself looking back and forth between the equivalent white and black bars, this button will show you the difference between the corresponding bars",
        "es": "Obviamente, para el color que estés jugando, quieres movimientos donde tus barras estén 'más altas'. Cuando te encuentres mirando de un lado a otro entre las barras equivalentes de blancas y negras, este botón te mostrará la diferencia entre las barras correspondientes.",
        "fr": "Évidemment, pour la couleur que vous jouez, vous voulez des coups où vos barres sont 'plus hautes'. Lorsque vous vous retrouvez à regarder d'avant en arrière entre les barres blanches et noires équivalentes, ce bouton vous montrera la différence entre les barres correspondantes.",
        "de": "Offensichtlich, für welche Farbe Sie auch spielen, möchten Sie Züge, bei denen Ihre Balken 'höher' sind. Wenn Sie zwischen den entsprechenden weißen und schwarzen Balken hin und her schauen, zeigt Ihnen diese Schaltfläche den Unterschied zwischen den entsprechenden Balken.",
        "it": "Ovviamente, per il colore con cui stai giocando, vuoi mosse dove le tue barre siano 'più alte'. Quando ti ritrovi a guardare avanti e indietro tra le barre bianche e nere equivalenti, questo pulsante ti mostrerà la differenza tra le barre corrispondenti.",
        "pt": "Obviamente, para a cor que você está jogando, você quer movimentos onde suas barras estejam 'mais altas'. Quando você se pega olhando de um lado para o outro entre as barras equivalentes de brancas e pretas, este botão mostrará a diferença entre as barras correspondentes.",
        "sv": "Självklart vill du ha drag där dina staplar är högre. När du växlar mellan vita och svarta staplar visar den här knappen skillnaden mellan motsvarande staplar."
    },
    {
        "en": "More Show White +  - Toolbar",
        "es": "Más Mostrar Blancas +  - Barra de herramientas",
        "fr": "Plus Afficher Blanc +  - Barre d'outils",
        "de": "Mehr Weiß anzeigen +  - Symbolleiste",
        "it": "Altro Mostra Bianco +  - Barra degli strumenti",
        "pt": "Mais Mostrar Brancas +  - Barra de ferramentas",
        "sv": "Mer: Visa 'Vit +' - Verktygsfält"
    },
    {
        "en": "In 'White+' mode, each bar shows the percentage advantage that white has over black.<br><br>For black then shorter bars are better.",
        "es": "En el modo 'Blancas+', cada barra muestra la ventaja porcentual que tienen las blancas sobre las negras.<br><br>Para las negras, entonces, las barras más cortas son mejores.",
        "fr": "En mode 'Blanc+', chaque barre montre l'avantage en pourcentage des blancs sur les noirs.<br><br>Pour les noirs, des barres plus courtes sont meilleures.",
        "de": "Im 'Weiß+'-Modus zeigt jeder Balken den prozentualen Vorteil, den Weiß gegenüber Schwarz hat.<br><br>Für Schwarz sind dann kürzere Balken besser.",
        "it": "In modalità 'Bianco+', ogni barra mostra il vantaggio percentuale del bianco sul nero.<br><br>Per il nero, barre più corte sono migliori.",
        "pt": "No modo 'Brancas+', cada barra mostra a vantagem percentual que as brancas têm sobre as pretas.<br><br>Para as pretas, barras mais curtas são melhores.",
        "sv": "I 'Vit+'-läge visar varje stapel vita fördel över svart. För svart är kortare staplar bättre."
    },
    {
        "en": "A subscription is not required to use Chessvis. A perpetual subscription is a",
        "es": "No se requiere suscripción para usar Chessvis. Una suscripción perpetua es un",
        "fr": "Un abonnement n'est pas nécessaire pour utiliser Chessvis. Un abonnement perpétuel est un",
        "de": "Für die Nutzung von Chessvis ist kein Abonnement erforderlich. Ein unbefristetes Abonnement ist ein",
        "it": "Non è richiesta un'iscrizione per usare Chessvis. Un abbonamento perpetuo è un",
        "pt": "Não é necessário assinar para usar o Chessvis. Uma assinatura perpétua é um",
        "sv": "Prenumeration krävs inte för att använda Chessvis. En evig licens är en"
    },
    {
        "en": "Subscribing adds so much more!",
        "es": "¡Suscribirse añade mucho más!",
        "fr": "S'abonner apporte beaucoup plus !",
        "de": "Ein Abonnement fügt noch viel mehr hinzu!",
        "it": "Abbonarsi aggiunge molto di più!",
        "pt": "Assinar adiciona muito mais!",
        "sv": "Prenumeration ger mycket mer!"
    },
    {
        "en": "Lots of Chessvis is free",
        "es": "Mucho de Chessvis es gratis",
        "fr": "Beaucoup de Chessvis est gratuit",
        "de": "Viel von Chessvis ist kostenlos",
        "it": "Molto di Chessvis è gratuito",
        "pt": "Muito do Chessvis é gratuito",
        "sv": "Mycket i Chessvis är gratis"
    },
    {
        "en": "Most of the visualization tools within Chessvis, including regular and visualized puzzles, who's guarding whom, move following and static boards",
        "es": "La mayoría de las herramientas de visualización dentro de Chessvis, incluyendo los rompecabezas regulares y visualizados, quién protege a quién, seguimiento de movimientos y tableros estáticos",
        "fr": "La plupart des outils de visualisation dans Chessvis, y compris les puzzles réguliers et visualisés, qui protège qui, le suivi des coups et les échiquiers statiques",
        "de": "Die meisten Visualisierungswerkzeuge in Chessvis, einschließlich regulärer und visualisierter Rätsel, wer wen schützt, Zugverfolgung und statische Bretter",
        "it": "La maggior parte degli strumenti di visualizzazione all'interno di Chessvis, inclusi puzzle normali e visualizzati, chi protegge chi, il tracciamento delle mosse e le scacchiere statiche",
        "pt": "A maioria das ferramentas de visualização dentro do Chessvis, incluindo puzzles normais e visualizados, quem protege quem, acompanhamento de movimentos e tabuleiros estáticos",
        "sv": "Majoriteten av visualiseringsverktygen — vanliga och visualiserade pussel, 'vem bevakar vem', följa drag och statiska bräden — är tillgängliga"
    },
    {
        "en": "The 'Opening Explorer' with its 200 million 'equal rating' Lichess rapid game collection is free.",
        "es": "El 'Explorador de Aperturas' con su colección de 200 millones de partidas rápidas de Lichess de 'clasificación igual' es gratis.",
        "fr": "L''Opening Explorer' avec sa collection de 200 millions de parties rapides 'égalité de classement' de Lichess est gratuit.",
        "de": "Der 'Opening Explorer' mit seiner Sammlung von 200 Millionen 'gleichwertiger' Lichess-Rapid-Spiele ist kostenlos.",
        "it": "L''Opening Explorer' con la sua collezione di 200 milioni di partite rapide 'pari rating' di Lichess è gratuito.",
        "pt": "O 'Opening Explorer' com sua coleção de 200 milhões de partidas rápidas de 'classificação igual' do Lichess é gratuito.",
        "sv": "Öppningsutforskaren med 200M 'lika rating' Lichess rapid-partier är gratis."
    },
    {
        "en": "This unique collection only includes games where both players are in the same 50 point rating bracket.",
        "es": "Esta colección única solo incluye partidas donde ambos jugadores están en el mismo rango de 50 puntos de clasificación.",
        "fr": "Cette collection unique inclut uniquement des parties où les deux joueurs sont dans la même tranche de classement de 50 points.",
        "de": "Diese einzigartige Sammlung enthält nur Spiele, bei denen beide Spieler im gleichen 50-Punkte-Ratingbereich liegen.",
        "it": "Questa collezione unica include solo partite in cui entrambi i giocatori sono nella stessa fascia di rating di 50 punti.",
        "pt": "Esta coleção única inclui apenas jogos em que ambos os jogadores estão na mesma faixa de classificação de 50 pontos.",
        "sv": "Denna unika samling innehåller bara partier där båda spelare ligger i samma 50-punktsintervall."
    },
    {
        "en": "Plus, all can experience blindfold chess at the easiest setting. No other program has the 'reveal' features of Chessvis enabling you to focus on just a few moves at a time to build up that 'visualization' muscle.",
        "es": "Además, todos pueden experimentar el ajedrez a ciegas en el nivel más fácil. Ningún otro programa tiene las funciones de 'revelar' de Chessvis, que te permiten concentrarte en solo unos pocos movimientos a la vez para desarrollar ese 'músculo de visualización'.",
        "fr": "De plus, tout le monde peut expérimenter les échecs à l'aveugle au niveau le plus facile. Aucun autre programme ne possède les fonctionnalités de 'révélation' de Chessvis, vous permettant de vous concentrer sur quelques coups à la fois pour développer ce 'muscle de visualisation'.",
        "de": "Außerdem können alle Blindschach auf der einfachsten Stufe erleben. Kein anderes Programm hat die 'Reveal'-Funktionen von Chessvis, die es ermöglichen, sich auf nur wenige Züge gleichzeitig zu konzentrieren, um diesen 'Visualisierungsmuskel' aufzubauen.",
        "it": "Inoltre, tutti possono sperimentare gli scacchi alla cieca al livello più facile. Nessun altro programma ha le funzioni di 'rivelazione' di Chessvis, che ti permettono di concentrarti su pochi movimenti alla volta per sviluppare quel 'muscolo della visualizzazione'.",
        "pt": "Além disso, todos podem experimentar xadrez às cegas na configuração mais fácil. Nenhum outro programa possui os recursos de 'revelação' do Chessvis, permitindo que você se concentre em apenas alguns movimentos de cada vez para desenvolver esse 'músculo de visualização'.",
        "sv": "Dessutom kan alla prova blindfold på lättaste nivå. Ingen annan app har Chessvis avslöjande-funktioner som låter dig fokusera på få drag åt gången för att bygga visualiseringsmuskeln."
    },
    {
        "en": "And challenge players from around the world on Lichess.org",
        "es": "Y desafía a jugadores de todo el mundo en Lichess.org",
        "fr": "Et défiez des joueurs du monde entier sur Lichess.org",
        "de": "Und fordere Spieler aus der ganzen Welt auf Lichess.org heraus",
        "it": "E sfida giocatori da tutto il mondo su Lichess.org",
        "pt": "E desafie jogadores de todo o mundo no Lichess.org"
    },
    {
        "en": "advanced puzzles",
        "es": "puzles avanzados",
        "fr": "puzzles avancés",
        "de": "fortgeschrittene Rätsel",
        "it": "puzzle avanzati",
        "pt": "quebra-cabeças avançados",
        "sv": "avancerade pussel"
    },
    {
        "en": "opening preparation with repertoires",
        "es": "preparación de aperturas con repertorios",
        "fr": "préparation d'ouvertures avec des répertoires",
        "de": "Eröffnungsvorbereitung mit Repertoires",
        "it": "preparazione delle aperture con repertori",
        "pt": "preparação de abertura com repertórios",
        "sv": "öppningsförberedelse med repertoarer"
    },
    {
        "en": "analyze your games",
        "es": "analiza tus partidas",
        "fr": "analysez vos parties",
        "de": "analysiere deine Spiele",
        "it": "analizza le tue partite",
        "pt": "analise seus jogos",
        "sv": "analysera dina partier"
    },
    {
        "en": "advanced blindfold chess",
        "es": "ajedrez a ciegas avanzado",
        "fr": "échecs à l'aveugle avancés",
        "de": "fortgeschrittenes Blindschach",
        "it": "scacchi alla cieca avanzati",
        "pt": "xadrez às cegas avançado",
        "sv": "avancerat blindfold-schack"
    },
    {
        "en": "advanced play against the computer.",
        "es": "juego avanzado contra la computadora.",
        "fr": "jeu avancé contre l'ordinateur.",
        "de": "fortgeschrittenes Spiel gegen den Computer.",
        "it": "gioco avanzato contro il computer.",
        "pt": "jogo avançado contra o computador.",
        "sv": "avancerat spel mot datorn."
    },
    {
        "en": "Advanced puzzle benefits for Subscribers:",
        "es": "Beneficios avanzados de los puzles para suscriptores:",
        "fr": "Avantages avancés des puzzles pour les abonnés :",
        "de": "Fortgeschrittene Puzzle-Vorteile für Abonnenten:",
        "it": "Vantaggi avanzati dei puzzle per gli abbonati:",
        "pt": "Benefícios avançados de quebra-cabeças para assinantes:",
        "sv": "Fördelar med avancerade pussel för prenumeranter:"
    },
    {
        "en": "Timed puzzles. Focus on 'puzzle pattern recognition' instead of long fancy problems. When you play faster games, what you need is fast puzzle recognition.",
        "es": "Puzles cronometrados. Concéntrate en el 'reconocimiento de patrones de puzles' en lugar de problemas largos y complejos. Cuando juegas partidas rápidas, lo que necesitas es reconocimiento rápido de puzles.",
        "fr": "Puzzles chronométrés. Concentrez-vous sur la 'reconnaissance des motifs de puzzle' au lieu de longs problèmes compliqués. Lorsque vous jouez à des parties rapides, ce dont vous avez besoin est une reconnaissance rapide des puzzles.",
        "de": "Zeitgesteuerte Rätsel. Konzentriere dich auf 'Rätsel-Mustererkennung' statt auf lange komplizierte Probleme. Wenn du schnellere Spiele spielst, brauchst du schnelle Rätselerkennung.",
        "it": "Puzzle cronometrati. Concentrati sul 'riconoscimento dei modelli di puzzle' invece di problemi lunghi e complessi. Quando giochi partite veloci, ciò di cui hai bisogno è il riconoscimento rapido dei puzzle.",
        "pt": "Quebra-cabeças cronometrados. Concentre-se no 'reconhecimento de padrões de quebra-cabeças' em vez de problemas longos e complexos. Quando você joga partidas rápidas, o que você precisa é de reconhecimento rápido de quebra-cabeças.",
        "sv": "Tidsstyrda pussel. Träna på mönsterigenkänning istället för långa komplicerade varianter — i snabbare spel behöver du snabbigenkänning."
    },
    {
        "en": "Blindfold puzzles. All the 'stepping stone' blindfold levels are available in puzzle form.",
        "es": "Puzles a ciegas. Todos los niveles de 'stepping stone' a ciegas están disponibles en forma de puzle.",
        "fr": "Puzzles à l'aveugle. Tous les niveaux de 'stepping stone' à l'aveugle sont disponibles sous forme de puzzle.",
        "de": "Blindschach-Rätsel. Alle 'Stepping Stone'-Blindschach-Level sind in Puzzleform verfügbar.",
        "it": "Puzzle alla cieca. Tutti i livelli 'stepping stone' alla cieca sono disponibili in forma di puzzle.",
        "pt": "Quebra-cabeças às cegas. Todos os níveis 'stepping stone' às cegas estão disponíveis em forma de quebra-cabeça.",
        "sv": "Blindfold-pussel. Alla stegstenar finns som pussel."
    },
    {
        "en": "Off-line puzzles. Going on a trip or the subway? Take 500 regular and visualization puzzles with you. Then download the results when you've got internet access.",
        "es": "Puzles sin conexión. ¿Vas de viaje o en el metro? Lleva contigo 500 puzles regulares y de visualización. Luego descarga los resultados cuando tengas acceso a internet.",
        "fr": "Puzzles hors ligne. Vous partez en voyage ou prenez le métro ? Prenez 500 puzzles réguliers et de visualisation avec vous. Ensuite, téléchargez les résultats lorsque vous aurez accès à Internet.",
        "de": "Offline-Rätsel. Auf Reisen oder in der U-Bahn? Nimm 500 reguläre und visualisierte Rätsel mit. Lade die Ergebnisse dann herunter, wenn du Internetzugang hast.",
        "it": "Puzzle offline. In viaggio o in metropolitana? Porta con te 500 puzzle regolari e di visualizzazione. Poi scarica i risultati quando hai accesso a internet.",
        "pt": "Quebra-cabeças offline. Indo viajar ou no metrô? Leve 500 quebra-cabeças regulares e de visualização com você. Depois, baixe os resultados quando tiver acesso à internet.",
        "sv": "Offline-pussel. Reser du? Ta med 500 vanliga och visualiserade pussel och synka resultaten senare."
    },
    {
        "en": "Opening Mastery for Subscribers:",
        "es": "Dominio de aperturas para suscriptores:",
        "fr": "Maîtrise des ouvertures pour les abonnés :",
        "de": "Eröffnungsmeisterschaft für Abonnenten:",
        "it": "Maestria nelle aperture per gli abbonati:",
        "pt": "Domínio de aberturas para assinantes:",
        "sv": "Öppningsmastery för prenumeranter:"
    },
    {
        "en": "Subscribers can build their repertoire library. The unique focus here is on the moves that you'll actually see and less focus on long move sequences that are rarely seen. Have you seen the videos?",
        "es": "Los suscriptores pueden construir su biblioteca de repertorios. El enfoque único aquí está en los movimientos que realmente verás y menos en las secuencias largas que rara vez se ven. ¿Has visto los videos?",
        "fr": "Les abonnés peuvent construire leur bibliothèque de répertoires. L'accent unique ici est mis sur les coups que vous verrez réellement et moins sur les longues séquences rarement vues. Avez-vous vu les vidéos ?",
        "de": "Abonnenten können ihre Repertoire-Bibliothek aufbauen. Der besondere Fokus liegt hier auf den Zügen, die Sie tatsächlich sehen werden, und weniger auf langen Zugfolgen, die selten vorkommen. Hast du die Videos gesehen?",
        "it": "Gli abbonati possono costruire la loro libreria di repertori. L'attenzione unica qui è sui mosse che vedrai effettivamente e meno sulle lunghe sequenze di mosse che si vedono raramente. Hai visto i video?",
        "pt": "Assinantes podem construir sua biblioteca de repertório. O foco único aqui está nos lances que você realmente verá e menos nas sequências longas que raramente aparecem. Você já viu os vídeos?",
        "sv": "Prenumeranter kan bygga repertoarbibliotek. Fokus ligger på drag du faktiskt möter, inte långa sällsynta varianter. Har du sett videorna?"
    },
    {
        "en": "Interactive repertoire builder",
        "es": "Constructor de repertorio interactivo",
        "fr": "Constructeur de répertoire interactif",
        "de": "Interaktiver Repertoire-Builder",
        "it": "Costruttore di repertorio interattivo",
        "pt": "Construtor de repertório interativo",
        "sv": "Interaktiv repertoarbyggare"
    },
    {
        "en": "Tree View - lets you see the entire repertoire branching",
        "es": "Vista de árbol: te permite ver todas las ramificaciones del repertorio",
        "fr": "Vue en arbre - vous permet de voir toutes les branches du répertoire",
        "de": "Baumansicht - zeigt Ihnen alle Verzweigungen des Repertoires",
        "it": "Vista ad albero - ti permette di vedere tutti i rami del repertorio",
        "pt": "Visualização em árvore - permite ver todos os ramos do repertório",
        "sv": "Trädvy — se hela repertoarens förgreningar"
    },
    {
        "en": "Drill - daily spaced repetition of the moves in your repertoire",
        "es": "Ejercicio - repetición espaciada diaria de los movimientos en tu repertorio",
        "fr": "Exercice - répétition espacée quotidienne des coups de votre répertoire",
        "de": "Übung - tägliche verteilte Wiederholung der Züge in Ihrem Repertoire",
        "it": "Esercizio - ripetizione giornaliera dei movimenti nel tuo repertorio",
        "pt": "Exercício - repetição espaçada diária dos lances no seu repertório",
        "sv": "Drill — daglig upprepad träning av drag i din repertoar"
    },
    {
        "en": "Practice - extends your play into the middle game to find the tree branches that leave you thinking 'What Do I Do Now???'",
        "es": "Práctica: extiende tu juego hasta el medio juego para encontrar las ramas del árbol que te hagan pensar '¿Qué hago ahora?'",
        "fr": "Pratique - étend votre jeu jusqu'au milieu de partie pour trouver les branches qui vous font penser 'Que faire maintenant ???'",
        "de": "Praxis - erweitert Ihr Spiel ins Mittelspiel, um die Zweige zu finden, die Sie denken lassen: 'Was mache ich jetzt???'",
        "it": "Pratica - estende il tuo gioco nel mediogioco per trovare i rami dell'albero che ti fanno pensare 'Cosa faccio ora???'",
        "pt": "Prática - estende seu jogo para o meio-jogo para encontrar os ramos que fazem você pensar 'O que eu faço agora???'",
        "sv": "Practice — för du in i mittspelet för att hitta de grenar som lämnar dig fundersam: 'Vad gör jag nu?'"
    },
    {
        "en": "Analyze My Game benefits for Subscribers",
        "es": "Beneficios de 'Analizar mi partida' para suscriptores",
        "fr": "Avantages de 'Analyser ma partie' pour les abonnés",
        "de": "'Meine Partie analysieren'-Vorteile für Abonnenten",
        "it": "Vantaggi di 'Analizza la mia partita' per gli abbonati",
        "pt": "Benefícios de 'Analisar meu jogo' para assinantes",
        "sv": "Fördelar med 'Analysera mitt parti' för prenumeranter"
    },
    {
        "en": "Download all your games from chess.com and\/or lichess.org",
        "es": "Descarga todas tus partidas de chess.com y\/o lichess.org",
        "fr": "Téléchargez toutes vos parties de chess.com et\/ou lichess.org",
        "de": "Lade alle deine Spiele von chess.com und\/oder lichess.org herunter",
        "it": "Scarica tutte le tue partite da chess.com e\/o lichess.org",
        "pt": "Baixe todos os seus jogos do chess.com e\/ou lichess.org",
        "sv": "Ladda ner alla dina partier från chess.com och\/eller lichess.org"
    },
    {
        "en": "Blindfold Chess benefits for Subscribers",
        "es": "Beneficios del ajedrez a ciegas para suscriptores",
        "fr": "Avantages des échecs à l'aveugle pour les abonnés",
        "de": "Vorteile von Blindschach für Abonnenten",
        "it": "Vantaggi degli scacchi a occhi chiusi per gli abbonati",
        "pt": "Benefícios do xadrez às cegas para assinantes",
        "sv": "Blindfold-fördelar för prenumeranter"
    },
    {
        "en": "Blindfold chess against the Stockfish and Komodo engines at all levels and all 'stepping stones'.",
        "es": "Ajedrez a ciegas contra los motores Stockfish y Komodo en todos los niveles y todos los 'stepping stones'.",
        "fr": "Échecs à l'aveugle contre les moteurs Stockfish et Komodo à tous les niveaux et tous les 'stepping stones'.",
        "de": "Blindschach gegen die Stockfish- und Komodo-Engines auf allen Levels und allen 'Stepping Stones'.",
        "it": "Scacchi a occhi chiusi contro i motori Stockfish e Komodo a tutti i livelli e tutti i 'stepping stones'.",
        "pt": "Xadrez às cegas contra os motores Stockfish e Komodo em todos os níveis e todos os 'stepping stones'.",
        "sv": "Blindfold mot Stockfish och Komodo på alla nivåer och alla stegstenar."
    },
    {
        "en": "Blindfold puzzles - not only can you play 'chess' with a blindfold, you also take that to your puzzle practice",
        "es": "Puzles a ciegas: no solo puedes jugar 'ajedrez' con los ojos vendados, también aplicas esto a tu práctica de puzles",
        "fr": "Puzzles à l'aveugle - vous pouvez non seulement jouer aux 'échecs' les yeux bandés, mais aussi appliquer cela à vos exercices de puzzles",
        "de": "Blindschach-Rätsel - Sie können nicht nur 'Schach' mit verbundenen Augen spielen, sondern übertragen dies auch auf Ihre Rätselpraxis",
        "it": "Puzzle a occhi chiusi - non solo puoi giocare a 'scacchi' bendato, ma puoi anche applicarlo alla tua pratica dei puzzle",
        "pt": "Quebra-cabeças às cegas - você não só pode jogar 'xadrez' vendado, como também aplicar isso à prática de quebra-cabeças",
        "sv": "Blindfold-pussel — spela blindfold och ta tekniken in i pusselträningen"
    },
    {
        "en": "Many subscribers appreciate the many unique features within Chessvis and they just want to encourage me to keep working! I won't argue with that. Lots of hours and equipment is involved in building the programs and databases. So thank you.",
        "es": "Muchos suscriptores aprecian las muchas características únicas dentro de Chessvis y solo quieren animarme a seguir trabajando. ¡No voy a discutir eso! Se requieren muchas horas y equipos para construir los programas y bases de datos. Así que gracias.",
        "fr": "De nombreux abonnés apprécient les nombreuses fonctionnalités uniques de Chessvis et veulent simplement m'encourager à continuer de travailler ! Je ne vais pas discuter cela. Beaucoup d'heures et de matériel sont nécessaires pour construire les programmes et les bases de données. Donc merci.",
        "de": "Viele Abonnenten schätzen die vielen einzigartigen Funktionen von Chessvis und möchten mich einfach ermutigen, weiterzuarbeiten! Dagegen kann ich nichts sagen. Es sind viele Stunden und Ausrüstung nötig, um die Programme und Datenbanken zu erstellen. Also danke.",
        "it": "Molti abbonati apprezzano le molte caratteristiche uniche di Chessvis e vogliono solo incoraggiarmi a continuare a lavorare! Non discuterò su questo. Ci vogliono molte ore e attrezzature per costruire i programmi e i database. Quindi grazie.",
        "pt": "Muitos assinantes apreciam os muitos recursos únicos do Chessvis e só querem me incentivar a continuar trabalhando! Não vou discutir isso. Muitas horas e equipamentos são necessários para construir os programas e bancos de dados. Então, obrigado.",
        "sv": "Många prenumeranter uppskattar Chessvis unika funktioner och vill uppmuntra mig att fortsätta! Det kräver många timmar och utrustning att bygga allt — tack!"
    },
    {
        "en": "All that for only",
        "es": "Todo eso por solo",
        "fr": "Tout cela pour seulement",
        "de": "All das für nur",
        "it": "Tutto questo per solo",
        "pt": "Tudo isso por apenas",
        "sv": "Allt det för bara"
    },
    {
        "en": "year",
        "es": "año",
        "fr": "an",
        "de": "Jahr",
        "it": "anno",
        "pt": "ano",
        "sv": "år"
    },
    {
        "en": "month",
        "es": "mes",
        "fr": "mois",
        "de": "Monat",
        "it": "mese",
        "pt": "mês",
        "sv": "månad"
    },
    {
        "en": "or a",
        "es": "o un",
        "fr": "ou un",
        "de": "oder ein",
        "it": "o un",
        "pt": "ou um",
        "sv": "eller en"
    },
    {
        "en": "one-time fee",
        "es": "pago único",
        "fr": "frais unique",
        "de": "einmalige Gebühr",
        "it": "pagamento una tantum",
        "pt": "taxa única",
        "sv": "engångsavgift"
    },
    {
        "en": "Perpetual one-time fee at a cost of",
        "es": "Pago único perpetuo a un costo de",
        "fr": "Frais unique perpétuel au coût de",
        "de": "Einmalige, dauerhafte Gebühr in Höhe von",
        "it": "Pagamento perpetuo una tantum al costo di",
        "pt": "Taxa única perpétua ao custo de",
        "sv": "Perpetual (engångsavgift) till priset"
    },
    {
        "en": "Never see a recurring charge again!",
        "es": "¡Nunca más verás un cargo recurrente!",
        "fr": "Ne plus jamais voir de frais récurrents !",
        "de": "Nie wieder wiederkehrende Gebühren!",
        "it": "Non vedrai mai più addebiti ricorrenti!",
        "pt": "Nunca mais verá uma cobrança recorrente!",
        "sv": "Betala aldrig löpande avgift igen!"
    },
    {
        "en": "Annual auto-renewing subscription at a current cost of",
        "es": "Suscripción anual con renovación automática al costo actual de",
        "fr": "Abonnement annuel à renouvellement automatique au coût actuel de",
        "de": "Jährliches Abo mit automatischer Verlängerung zu den aktuellen Kosten von",
        "it": "Abbonamento annuale a rinnovo automatico al costo attuale di",
        "pt": "Assinatura anual com renovação automática ao custo atual de",
        "sv": "Årlig automatisk prenumeration till priset"
    },
    {
        "en": "per year. This will last 12 months.",
        "es": "por año. Esto durará 12 meses.",
        "fr": "par an. Cela durera 12 mois.",
        "de": "pro Jahr. Dies dauert 12 Monate.",
        "it": "all'anno. Questo durerà 12 mesi.",
        "pt": "por ano. Isso durará 12 meses.",
        "sv": "per år. Gäller i 12 månader."
    },
    {
        "en": "Monthly auto-renewing subscription at a current cost of",
        "es": "Suscripción mensual con renovación automática al costo actual de",
        "fr": "Abonnement mensuel à renouvellement automatique au coût actuel de",
        "de": "Monatliches Abonnement mit automatischer Verlängerung zu den aktuellen Kosten von",
        "it": "Abbonamento mensile a rinnovo automatico al costo attuale di",
        "pt": "Assinatura mensal com renovação automática ao custo atual de",
        "sv": "Månatlig automatisk prenumeration till priset"
    },
    {
        "en": "per month. This will last 1 month.",
        "es": "por mes. Esto durará 1 mes.",
        "fr": "par mois. Cela durera 1 mois.",
        "de": "pro Monat. Dies dauert 1 Monat.",
        "it": "al mese. Questo durerà 1 mese.",
        "pt": "por mês. Isso durará 1 mês.",
        "sv": "per månad. Gäller 1 månad."
    },
    {
        "en": "Note: If you cancel an annual or monthly subscription, you will not receive a refund for the current billing period, but will continue to receive your subscription content for the remainder of the current billing period, regardless of the cancellation date. Your cancellation goes into effect after the current billing period has passed. 'Cancelling' a subscription will stop renews. You will enjoy the benefits described above until the current period ends. No pro-rated refund will occur. If you are unsure as to the benefit of subscribing, please evaluate with the free version and consider starting with a month subscription. The 'Terms of Service' including our privacy policy can be found under the 'Support' main menu entry.",
        "es": "Nota: Si cancela una suscripción anual o mensual, no recibirá un reembolso por el período de facturación actual, pero continuará recibiendo el contenido de su suscripción durante el resto del período de facturación, independientemente de la fecha de cancelación. Su cancelación surtirá efecto después de que finalice el período de facturación actual. Cancelar una suscripción detendrá las renovaciones. Disfrutará de los beneficios descritos hasta el final del período actual. No se realizará ningún reembolso prorrateado. Si no está seguro del beneficio de suscribirse, por favor evalúe la versión gratuita y considere comenzar con una suscripción mensual. Los 'Términos de Servicio', incluida nuestra política de privacidad, se pueden encontrar en el menú principal 'Soporte'.",
        "fr": "Remarque : Si vous annulez un abonnement annuel ou mensuel, vous ne recevrez pas de remboursement pour la période de facturation en cours, mais continuerez à recevoir le contenu de votre abonnement jusqu'à la fin de cette période, quelle que soit la date d'annulation. Votre annulation prendra effet après la fin de la période de facturation en cours. L'annulation d'un abonnement arrêtera les renouvellements. Vous bénéficierez des avantages décrits ci-dessus jusqu'à la fin de la période en cours. Aucun remboursement au prorata ne sera effectué. Si vous n'êtes pas sûr des avantages de l'abonnement, veuillez évaluer la version gratuite et envisager de commencer avec un abonnement mensuel. Les 'Conditions de service', y compris notre politique de confidentialité, sont disponibles dans le menu principal 'Support'.",
        "de": "Hinweis: Wenn Sie ein Jahres- oder Monatsabonnement kündigen, erhalten Sie keine Rückerstattung für den aktuellen Abrechnungszeitraum, erhalten jedoch weiterhin Ihre Abonnementinhalte für den Rest des aktuellen Abrechnungszeitraums, unabhängig vom Kündigungsdatum. Ihre Kündigung tritt nach Ablauf des aktuellen Abrechnungszeitraums in Kraft. Das 'Kündigen' eines Abonnements stoppt die Verlängerungen. Sie genießen die oben beschriebenen Vorteile bis zum Ende des aktuellen Zeitraums. Es erfolgt keine anteilige Rückerstattung. Wenn Sie sich über den Nutzen eines Abonnements unsicher sind, testen Sie bitte die kostenlose Version und ziehen Sie ein Monatsabonnement in Betracht. Die 'Nutzungsbedingungen', einschließlich unserer Datenschutzrichtlinie, finden Sie im Hauptmenüeintrag 'Support'.",
        "it": "Nota: Se annulli un abbonamento annuale o mensile, non riceverà un rimborso per il periodo di fatturazione corrente, ma continuerà a ricevere i contenuti dell'abbonamento per il resto del periodo di fatturazione, indipendentemente dalla data di cancellazione. La cancellazione avrà effetto dopo la fine del periodo corrente. La cancellazione di un abbonamento interromperà i rinnovi. Godrà dei vantaggi descritti fino alla fine del periodo corrente. Non verrà effettuato alcun rimborso proporzionale. Se non è sicuro dei vantaggi dell'abbonamento, valuti la versione gratuita e consideri di iniziare con un abbonamento mensile. I 'Termini di servizio', inclusa la nostra politica sulla privacy, sono disponibili nel menu principale 'Supporto'.",
        "pt": "Nota: Se você cancelar uma assinatura anual ou mensal, não receberá reembolso pelo período de cobrança atual, mas continuará a receber o conteúdo da assinatura pelo restante do período, independentemente da data de cancelamento. Seu cancelamento entrará em vigor após o término do período atual. Cancelar uma assinatura interromperá as renovações. Você desfrutará dos benefícios descritos acima até o final do período atual. Nenhum reembolso proporcional será feito. Se você não tiver certeza sobre os benefícios da assinatura, avalie a versão gratuita e considere começar com uma assinatura mensal. Os 'Termos de Serviço', incluindo nossa política de privacidade, podem ser encontrados no menu principal 'Suporte'.",
        "sv": "Obs: Avbokning av årsmässig eller månadsprenumeration ger ingen återbetalning för innevarande period, men du behåller åtkomst till innehållet fram till periodens slut. Avbokningen träder i kraft efter den aktuella perioden. Ingen proportionell återbetalning. Är du osäker, prova gratisversionen eller börja med en månadsprenumeration. Villkor och sekretess finns under 'Support'."
    },
    {
        "en": "After clicking one of the following buttons, the device's subscription system will be appear.",
        "es": "Después de hacer clic en uno de los siguientes botones, aparecerá el sistema de suscripción del dispositivo.",
        "fr": "Après avoir cliqué sur l'un des boutons suivants, le système d'abonnement de l'appareil apparaîtra.",
        "de": "Nachdem Sie auf eine der folgenden Schaltflächen geklickt haben, wird das Abonnement-System des Geräts angezeigt.",
        "it": "Dopo aver cliccato uno dei pulsanti seguenti, apparirà il sistema di abbonamento del dispositivo.",
        "pt": "Após clicar em um dos botões a seguir, o sistema de assinatura do dispositivo aparecerá.",
        "sv": "När du klickar en av knapparna öppnas enhetens prenumerationssystem."
    },
    {
        "en": "After clicking one of the following buttons, you'll be taken to the secure 'Stripe.com' website. (This might take a couple of seconds.) When you're done with that page, you should automatically be back in Chessvis.",
        "es": "Después de hacer clic en uno de los siguientes botones, se le llevará al sitio web seguro 'Stripe.com'. (Esto puede tardar unos segundos). Cuando haya terminado en esa página, debería volver automáticamente a Chessvis.",
        "fr": "Après avoir cliqué sur l'un des boutons suivants, vous serez dirigé vers le site sécurisé 'Stripe.com'. (Cela peut prendre quelques secondes.) Une fois la page terminée, vous devriez revenir automatiquement dans Chessvis.",
        "de": "Nachdem Sie auf eine der folgenden Schaltflächen geklickt haben, werden Sie zur sicheren 'Stripe.com'-Website weitergeleitet. (Dies kann ein paar Sekunden dauern.) Nach Abschluss dieser Seite sollten Sie automatisch zu Chessvis zurückkehren.",
        "it": "Dopo aver cliccato uno dei pulsanti seguenti, verrai portato al sito sicuro 'Stripe.com'. (Questo potrebbe richiedere qualche secondo.) Quando avrai finito con quella pagina, dovresti tornare automaticamente in Chessvis.",
        "pt": "Após clicar em um dos botões a seguir, você será levado ao site seguro 'Stripe.com'. (Isso pode levar alguns segundos.) Quando terminar nessa página, você deverá retornar automaticamente ao Chessvis.",
        "sv": "Efter klick tas du till den säkra Stripe-webbplatsen (några sekunder). När du är klar kommer du tillbaka till Chessvis automatiskt."
    },
    {
        "en": "Perpetual, Lifetime Subscription",
        "es": "Suscripción perpetua de por vida",
        "fr": "Abonnement perpétuel à vie",
        "de": "Dauerabonnement \/ Lebenslanges Abonnement",
        "it": "Abbonamento perpetuo a vita",
        "pt": "Assinatura vitalícia perpétua",
        "sv": "Perpetual \/ livstidsprenumeration"
    },
    {
        "en": "Annual Subscription",
        "es": "Suscripción anual",
        "fr": "Abonnement annuel",
        "de": "Jahresabonnement",
        "it": "Abbonamento annuale",
        "pt": "Assinatura anual",
        "sv": "Årsprenumeration"
    },
    {
        "en": "Monthly Subscription",
        "es": "Suscripción mensual",
        "fr": "Abonnement mensuel",
        "de": "Monatsabonnement",
        "it": "Abbonamento mensile",
        "pt": "Assinatura mensal",
        "sv": "Månadsprenumeration"
    },
    {
        "en": "Show Terms of Service and Privacy Policy",
        "es": "Mostrar términos de servicio y política de privacidad",
        "fr": "Afficher les conditions d'utilisation et la politique de confidentialité",
        "de": "Nutzungsbedingungen und Datenschutzrichtlinie anzeigen",
        "it": "Mostra termini di servizio e politica sulla privacy",
        "pt": "Mostrar Termos de Serviço e Política de Privacidade",
        "sv": "Visa användarvillkor & sekretesspolicy"
    },
    {
        "en": "Restore Subscription",
        "es": "Restaurar suscripción",
        "fr": "Restaurer l'abonnement",
        "de": "Abonnement wiederherstellen",
        "it": "Ripristina abbonamento",
        "pt": "Restaurar assinatura",
        "sv": "Återställ prenumeration"
    },
    {
        "en": "Show Subscription Options",
        "es": "Mostrar opciones de suscripción",
        "fr": "Afficher les options d'abonnement",
        "de": "Abonnementoptionen anzeigen",
        "it": "Mostra opzioni di abbonamento",
        "pt": "Mostrar opções de assinatura",
        "sv": "Visa prenumerationsalternativ"
    },
    {
        "en": "The subscriber benefit areas are",
        "es": "Las áreas de beneficios para suscriptores son",
        "fr": "Les zones d'avantages pour les abonnés sont",
        "de": "Die Vorteile für Abonnenten sind",
        "it": "Le aree dei vantaggi per gli abbonati sono",
        "pt": "As áreas de benefícios para assinantes são",
        "sv": "Prenumerantförmånerna är"
    },
    {
        "en": "Analyze your games in the opening explorer",
        "es": "Analiza tus partidas en el explorador de aperturas",
        "fr": "Analysez vos parties dans l'explorateur d'ouvertures",
        "de": "Analysiere deine Spiele im Eröffnungs-Explorer",
        "it": "Analizza le tue partite nell'esploratore delle aperture",
        "pt": "Analise seus jogos no explorador de aberturas",
        "sv": "Analysera dina partier i öppningsutforskaren"
    },
    {
        "en": "Ever wonder which top players play your favorite opening?",
        "es": "¿Alguna vez te has preguntado qué jugadores top juegan tu apertura favorita?",
        "fr": "Vous êtes-vous déjà demandé quels grands joueurs jouent votre ouverture préférée ?",
        "de": "Hast du dich jemals gefragt, welche Top-Spieler deine Lieblings-Eröffnung spielen?",
        "it": "Ti sei mai chiesto quali giocatori top giocano la tua apertura preferita?",
        "pt": "Já se perguntou quais jogadores de topo jogam sua abertura favorita?",
        "sv": "Undrat vilka toppspelare som spelar din favoritöppning?"
    },
    {
        "en": "Check the box next to a move and the player list below will be updated to show the players who play that move.",
        "es": "Marca la casilla junto a un movimiento y la lista de jugadores abajo se actualizará para mostrar quiénes juegan ese movimiento.",
        "fr": "Cochez la case à côté d'un coup et la liste des joueurs ci-dessous sera mise à jour pour montrer qui joue ce coup.",
        "de": "Markiere das Kästchen neben einem Zug und die Spielerliste unten wird aktualisiert, um die Spieler zu zeigen, die diesen Zug spielen.",
        "it": "Seleziona la casella accanto a una mossa e la lista dei giocatori sottostante si aggiornerà mostrando chi gioca quella mossa.",
        "pt": "Marque a caixa ao lado de um lance e a lista de jogadores abaixo será atualizada para mostrar quem joga esse lance.",
        "sv": "Markera rutan vid ett drag så uppdateras spelarlistan med de som spelar det draget."
    },
    {
        "en": "The Player List",
        "es": "La Lista de Jugadores",
        "fr": "La Liste des Joueurs",
        "de": "Die Spielerliste",
        "it": "La Lista dei Giocatori",
        "pt": "A Lista de Jogadores",
        "sv": "Spelarlistan"
    },
    {
        "en": "Check the box next to the player's name and the move list above will be updated to reflect what that player plays.",
        "es": "Marca la casilla junto al nombre del jugador y la lista de movimientos arriba se actualizará para reflejar lo que juega ese jugador.",
        "fr": "Cochez la case à côté du nom du joueur et la liste des coups ci-dessus sera mise à jour pour refléter ce que joue ce joueur.",
        "de": "Markiere das Kästchen neben dem Namen des Spielers und die Zugliste oben wird aktualisiert, um zu zeigen, was dieser Spieler spielt.",
        "it": "Seleziona la casella accanto al nome del giocatore e la lista delle mosse sopra si aggiornerà per riflettere ciò che gioca quel giocatore.",
        "pt": "Marque a caixa ao lado do nome do jogador e a lista de jogadas acima será atualizada para refletir o que esse jogador joga.",
        "sv": "Markera rutan vid en spelares namn så uppdateras draglistan ovan med vad spelaren spelar."
    },
    {
        "en": "Player List Filters",
        "es": "Filtros de la Lista de Jugadores",
        "fr": "Filtres de la Liste des Joueurs",
        "de": "Filter für die Spielerliste",
        "it": "Filtri della Lista dei Giocatori",
        "pt": "Filtros da Lista de Jogadores",
        "sv": "Filter i spelarlistan"
    },
    {
        "en": "Clicking on a column heading will sort it. Clicking on the 3 bars next to the name will enable you to filter the list.",
        "es": "Hacer clic en el encabezado de una columna la ordenará. Hacer clic en las 3 barras junto al nombre te permitirá filtrar la lista.",
        "fr": "Cliquer sur l'en-tête d'une colonne la triera. Cliquer sur les 3 barres à côté du nom vous permettra de filtrer la liste.",
        "de": "Ein Klick auf die Spaltenüberschrift sortiert diese. Ein Klick auf die 3 Balken neben dem Namen ermöglicht es dir, die Liste zu filtern.",
        "it": "Cliccando sull'intestazione di una colonna la ordinerai. Cliccando sulle 3 barre accanto al nome potrai filtrare la lista.",
        "pt": "Clicar no cabeçalho de uma coluna irá ordená-la. Clicar nas 3 barras ao lado do nome permitirá filtrar a lista.",
        "sv": "Klicka på kolumnrubrik för att sortera. Klicka på de tre strecken vid namn för att filtrera listan."
    },
    {
        "en": "Game List - Toolbar",
        "es": "Lista de Partidas - Barra de Herramientas",
        "fr": "Liste des Parties - Barre d'Outils",
        "de": "Spielerliste - Symbolleiste",
        "it": "Lista Partite - Barra degli Strumenti",
        "pt": "Lista de Jogos - Barra de Ferramentas",
        "sv": "Partilista - Verktygsfält"
    },
    {
        "en": "If you select a player, this option will bring up a secondary screen where you see a list of the games. There you can review a game or download them.",
        "es": "Si seleccionas un jugador, esta opción abrirá una pantalla secundaria donde verás la lista de partidas. Allí puedes revisar una partida o descargarlas.",
        "fr": "Si vous sélectionnez un joueur, cette option affichera un écran secondaire où vous verrez la liste des parties. Vous pourrez y revoir une partie ou les télécharger.",
        "de": "Wenn du einen Spieler auswählst, öffnet diese Option einen sekundären Bildschirm, auf dem du eine Liste der Spiele siehst. Dort kannst du ein Spiel überprüfen oder herunterladen.",
        "it": "Se selezioni un giocatore, questa opzione aprirà una schermata secondaria dove vedrai l'elenco delle partite. Lì puoi rivedere una partita o scaricarle.",
        "pt": "Se você selecionar um jogador, esta opção abrirá uma tela secundária onde verá a lista de jogos. Lá você pode revisar uma partida ou baixá-las.",
        "sv": "Väljer du en spelare öppnas en sekundär skärm med den spelarens partier — där kan du granska eller ladda ner dem."
    },
    {
        "en": "Repertoire Tree Viewer",
        "es": "Visor de Árbol de Repertorio",
        "fr": "Visionneuse de l'Arbre de Répertoire",
        "de": "Repertoire-Baum-Viewer",
        "it": "Visualizzatore dell'Albero del Repertorio",
        "pt": "Visualizador da Árvore de Repertório",
        "sv": "Repertoarträdvisare"
    },
    {
        "en": "This is a '<i>Bird's Eye View<\/i>' of your repertoire'.<br><br>As you navigate around the tree, the board will be updated to reflect the moves to that point.<br><br>The video is for the entire set of repertoire routines.",
        "es": "Esta es una '<i>Vista de Pájaro<\/i>' de tu repertorio.<br><br>Al navegar por el árbol, el tablero se actualizará para reflejar los movimientos hasta ese punto.<br><br>El video abarca todo el conjunto de rutinas del repertorio.",
        "fr": "Ceci est une '<i>Vue d'ensemble<\/i>' de votre répertoire.<br><br>En naviguant dans l'arbre, l'échiquier sera mis à jour pour refléter les coups jusqu'à ce point.<br><br>La vidéo couvre l'ensemble des routines du répertoire.",
        "de": "Dies ist eine '<i>Vogelperspektive<\/i>' deines Repertoires.<br><br>Beim Navigieren im Baum wird das Brett aktualisiert, um die Züge bis zu diesem Punkt anzuzeigen.<br><br>Das Video behandelt alle Repertoire-Routinen.",
        "it": "Questa è una '<i>Vista a Volo d'Uccello<\/i>' del tuo repertorio.<br><br>Man mano che navighi nell'albero, la scacchiera si aggiornerà per riflettere le mosse fino a quel punto.<br><br>Il video riguarda l'intero insieme delle routine del repertorio.",
        "pt": "Esta é uma '<i>Visão de Pássaro<\/i>' do seu repertório.<br><br>Ao navegar pela árvore, o tabuleiro será atualizado para refletir os lances até aquele ponto.<br><br>O vídeo cobre todo o conjunto de rotinas do repertório.",
        "sv": "Detta är en 'fågelperspektiv' över din repertoar. När du navigerar i trädet uppdateras brädet för att visa ställningen vid den punkten. Videon visar hela repertoarrutinen."
    },
    {
        "en": "The Tree",
        "es": "El Árbol",
        "fr": "L'Arbre",
        "de": "Der Baum",
        "it": "L'Albero",
        "pt": "A Árvore",
        "sv": "Trädet"
    },
    {
        "en": "Moves that have a <b>(+)<\/b> after them represent places where there are multiple move choices. Tapping the <b>(+)<\/b> will open up the branches and highlight the choices on the board and in the tree.",
        "es": "Los movimientos que tienen un <b>(+)<\/b> después representan lugares donde hay múltiples opciones de movimiento. Tocar el <b>(+)<\/b> abrirá las ramas y resaltará las opciones en el tablero y en el árbol.",
        "fr": "Les coups suivis d'un <b>(+)<\/b> représentent des endroits où plusieurs choix de coup sont possibles. Cliquer sur le <b>(+)<\/b> ouvrira les branches et mettra en évidence les choix sur l'échiquier et dans l'arbre.",
        "de": "Züge, die ein <b>(+)<\/b> dahinter haben, zeigen Stellen mit mehreren Zugoptionen. Ein Tippen auf das <b>(+)<\/b> öffnet die Zweige und hebt die Optionen auf dem Brett und im Baum hervor.",
        "it": "Le mosse che hanno un <b>(+)<\/b> dopo rappresentano punti con più opzioni di mossa. Toccare il <b>(+)<\/b> aprirà i rami e evidenzierà le scelte sulla scacchiera e nell'albero.",
        "pt": "Os lances que têm um <b>(+)<\/b> depois representam lugares com múltiplas opções de lance. Tocar no <b>(+)<\/b> abrirá os ramos e destacará as escolhas no tabuleiro e na árvore.",
        "sv": "Drag med <b>(+)<\/b> efter visar flervalsställen. Tryck <b>(+)<\/b> för att öppna grenar och markera val på brädet och i trädet."
    },
    {
        "en": "Move Comments",
        "es": "Comentarios de Movimiento",
        "fr": "Commentaires sur le Coup",
        "de": "Zugkommentare",
        "it": "Commenti sulla Mossa",
        "pt": "Comentários do Lance",
        "sv": "Kommentarer till drag"
    },
    {
        "en": "If there is a comment associated with the move, it will be displayed here.",
        "es": "Si hay un comentario asociado con el movimiento, se mostrará aquí.",
        "fr": "S'il y a un commentaire associé au coup, il sera affiché ici.",
        "de": "Wenn ein Kommentar mit dem Zug verbunden ist, wird er hier angezeigt.",
        "it": "Se c'è un commento associato alla mossa, verrà mostrato qui.",
        "pt": "Se houver um comentário associado ao lance, ele será exibido aqui.",
        "sv": "Eventuell kommentar till draget visas här."
    },
    {
        "en": "Hide Comments - Toolbar",
        "es": "Ocultar Comentarios - Barra de Herramientas",
        "fr": "Masquer les Commentaires - Barre d'Outils",
        "de": "Kommentare Ausblenden - Symbolleiste",
        "it": "Nascondi Commenti - Barra degli Strumenti",
        "pt": "Ocultar Comentários - Barra de Ferramentas",
        "sv": "Dölj kommentarer - Verktygsfält"
    },
    {
        "en": "By default, comments are shown within the tree text.<br><br>If you find that distracting, or want a more compact 'tree' then this will toggle the comments out of and back into view.",
        "es": "Por defecto, los comentarios se muestran dentro del texto del árbol.<br><br>Si lo encuentras distractor o quieres un árbol más compacto, esto ocultará y mostrará los comentarios.",
        "fr": "Par défaut, les commentaires sont affichés dans le texte de l'arbre.<br><br>Si cela vous distrait ou si vous voulez un arbre plus compact, ceci basculera les commentaires hors et dans la vue.",
        "de": "Standardmäßig werden Kommentare im Baumtext angezeigt.<br><br>Wenn Sie dies ablenkend finden oder einen kompakteren Baum möchten, blendet dies die Kommentare ein- und aus.",
        "it": "Per impostazione predefinita, i commenti sono mostrati nel testo dell'albero.<br><br>Se lo trovi distraente o vuoi un albero più compatto, questo commuta i commenti dentro e fuori dalla visualizzazione.",
        "pt": "Por padrão, os comentários são exibidos no texto da árvore.<br><br>Se achar isso distrativo ou quiser uma árvore mais compacta, isto alternará os comentários para fora e para dentro da visualização.",
        "sv": "Som standard visas kommentarer i trädtexten. Om det distraherar eller du vill ha ett kompakt träd kan du växla kommentarer av\/på."
    },
    {
        "en": "Repertoire - Toolbar",
        "es": "Repertorio - Barra de Herramientas",
        "fr": "Répertoire - Barre d'Outils",
        "de": "Repertoire - Symbolleiste",
        "it": "Repertorio - Barra degli Strumenti",
        "pt": "Repertório - Barra de Ferramentas",
        "sv": "Repertoar - Verktygsfält"
    },
    {
        "en": "This will bring up the list of repertoires so you can select a different one.",
        "es": "Esto mostrará la lista de repertorios para que puedas seleccionar uno diferente.",
        "fr": "Cela fera apparaître la liste des répertoires afin que vous puissiez en sélectionner un autre.",
        "de": "Dies zeigt die Liste der Repertoires an, damit Sie ein anderes auswählen können.",
        "it": "Questo mostrerà l'elenco dei repertori in modo da poter selezionare uno diverso.",
        "pt": "Isto mostrará a lista de repertórios para que você possa selecionar outro diferente.",
        "sv": "Visar listan över repertoarer så du kan välja en annan."
    },
    {
        "en": "What good is defining a repertoire if you can't learn it? Can't practice it?<br><br><i>Note: the video is for the entire set of repertoire routines.<\/i>",
        "es": "¿De qué sirve definir un repertorio si no puedes aprenderlo? ¿No puedes practicarlo?<br><br><i>Nota: el video abarca todo el conjunto de rutinas del repertorio.<\/i>",
        "fr": "À quoi bon définir un répertoire si vous ne pouvez pas l'apprendre ? Impossible de le pratiquer ?<br><br><i>Remarque : la vidéo couvre l'ensemble des routines du répertoire.<\/i>",
        "de": "Was nützt es, ein Repertoire zu definieren, wenn man es nicht lernen kann? Kannst du es nicht üben?<br><br><i>Hinweis: Das Video zeigt alle Repertoire-Routinen.<\/i>",
        "it": "A che serve definire un repertorio se non puoi impararlo? Non puoi praticarlo?<br><br><i>Nota: il video riguarda l'intero insieme delle routine del repertorio.<\/i>",
        "pt": "De que adianta definir um repertório se você não pode aprendê-lo? Não pode praticá-lo?<br><br><i>Nota: o vídeo cobre todo o conjunto de rotinas do repertório.<\/i>",
        "sv": "Vad hjälper det att definiera en repertoar om du inte kan lära eller träna den? (Videon visar hela repertoarrutinen.)"
    },
    {
        "en": "Not 'Drill and Kill'",
        "es": "No es 'Repetir y Memorizar'",
        "fr": "Pas de 'Répéter et Mémoriser'",
        "de": "Nicht 'Drill und Tötung'",
        "it": "Non 'Ripeti e Memorizza'",
        "pt": "Não é 'Treinar e Decorar'",
        "sv": "Inte 'drill and kill'"
    },
    {
        "en": "I've been in many plays where I've had parts with hundreds of lines to deliver on stage from memory. The trick is to <i>learn<\/i> the lines, not <i>memorize<\/i> them. Internalize them.<br><br>Early rehersals start with <i>script in hand<\/i>. Why should learning a repertoire be any different?",
        "es": "He participado en muchas obras donde tenía partes con cientos de líneas que debía recitar de memoria. El truco es <i>aprender<\/i> las líneas, no <i>memorizarlas<\/i>. Internalízalas.<br><br>Los ensayos iniciales comienzan con el <i>guion en mano<\/i>. ¿Por qué aprender un repertorio debería ser diferente?",
        "fr": "J'ai joué dans de nombreuses pièces où j'avais des rôles avec des centaines de répliques à réciter par cœur. L'astuce est d'<i>apprendre<\/i> les répliques, pas de les <i>mémoriser<\/i>. Intériorisez-les.<br><br>Les premières répétitions commencent avec le <i>script en main<\/i>. Pourquoi apprendre un répertoire serait-il différent ?",
        "de": "Ich habe in vielen Stücken mitgespielt, in denen ich Hunderte von Zeilen auswendig auf der Bühne vortragen musste. Der Trick ist, die Zeilen zu <i>lernen<\/i>, nicht <i>auswendig zu lernen<\/i>. Internalisieren.<br><br>Frühe Proben beginnen mit dem <i>Drehbuch in der Hand<\/i>. Warum sollte das Erlernen eines Repertoires anders sein?",
        "it": "Ho recitato in molte opere dove avevo parti con centinaia di battute da recitare a memoria. Il trucco è <i>imparare<\/i> le battute, non <i>memorizzarle<\/i>. Internalizzale.<br><br>Le prime prove iniziano con il <i>copione in mano<\/i>. Perché imparare un repertorio dovrebbe essere diverso?",
        "pt": "Participei de muitas peças em que tinha partes com centenas de falas para apresentar de cor no palco. O truque é <i>aprender<\/i> as falas, não <i>decorá-las<\/i>. Internalize-as.<br><br>Os ensaios iniciais começam com o <i>roteiro na mão<\/i>. Por que aprender um repertório seria diferente?",
        "sv": "Jag har stått på scen med hundratals repliker — tricket är att lära, inte bara memorera. Tidiga repetitionerna har manus i handen — varför skulle repertoarlärande vara annorlunda?"
    },
    {
        "en": "Follow Along Tree View",
        "es": "Sigue el Árbol",
        "fr": "Suivre la Vue Arbre",
        "de": "Dem Baum folgen",
        "it": "Segui la Vista ad Albero",
        "pt": "Acompanhar a Visualização da Árvore",
        "sv": "Följ med i trädvyn"
    },
    {
        "en": "The <i>tree<\/i> is your <i>script<\/i>.<br><br>With Chessvis, you can display the tree while you practice.",
        "es": "El <i>árbol<\/i> es tu <i>guion<\/i>.<br><br>Con Chessvis, puedes mostrar el árbol mientras practicas.",
        "fr": "L'<i>arbre<\/i> est votre <i>script<\/i>.<br><br>Avec Chessvis, vous pouvez afficher l'arbre pendant votre pratique.",
        "de": "Der <i>Baum<\/i> ist dein <i>Drehbuch<\/i>.<br><br>Mit Chessvis kannst du den Baum während der Übung anzeigen.",
        "it": "L'<i>albero<\/i> è il tuo <i>copione<\/i>.<br><br>Con Chessvis, puoi visualizzare l'albero mentre pratichi.",
        "pt": "A <i>árvore<\/i> é o seu <i>roteiro<\/i>.<br><br>Com o Chessvis, você pode exibir a árvore enquanto pratica.",
        "sv": "Trädet är ditt manus. I Chessvis kan du visa trädet medan du övar."
    },
    {
        "en": "Build Specialized Repertoires",
        "es": "Construye Repertorios Especializados",
        "fr": "Construire des Répertoires Spécialisés",
        "de": "Spezialisierte Repertoires erstellen",
        "it": "Costruisci Repertori Specializzati",
        "pt": "Construir Repertórios Especializados",
        "sv": "Bygg specialiserade repertoarer"
    },
    {
        "en": "Repertoires are best built as focused answers to a particular set of opponent moves.<br><br>Maybe you have a repertoire that answers the Sicilian, another for the French, Caro-Kahn and so on.",
        "es": "Los repertorios se construyen mejor como respuestas enfocadas a un conjunto específico de movimientos del oponente.<br><br>Quizás tengas un repertorio que responda a la Siciliana, otro para la Francesa, Caro-Kahn, etc.",
        "fr": "Les répertoires se construisent mieux comme des réponses ciblées à un ensemble particulier de coups de l'adversaire.<br><br>Peut-être avez-vous un répertoire pour répondre à la Sicilienne, un autre pour la Française, Caro-Kann, etc.",
        "de": "Repertoires werden am besten als gezielte Antworten auf eine bestimmte Reihe von Gegnerzügen aufgebaut.<br><br>Vielleicht hast du ein Repertoire für die Sizilianische Verteidigung, ein anderes für Französisch, Caro-Kann usw.",
        "it": "I repertori si costruiscono meglio come risposte mirate a un insieme particolare di mosse dell'avversario.<br><br>Forse hai un repertorio per rispondere alla Siciliana, un altro per la Francese, Caro-Kahn e così via.",
        "pt": "Os repertórios são melhor construídos como respostas focadas a um conjunto específico de lances do oponente.<br><br>Talvez você tenha um repertório que responde à Siciliana, outro para a Francesa, Caro-Kahn, e assim por diante.",
        "sv": "Repertoarer byggs bäst som målade svar mot specifika motståndardrag — t.ex. en mot Sicilianskt, en mot Fransk, Caro–Kann osv."
    },
    {
        "en": "Practice Together",
        "es": "Practicar Juntos",
        "fr": "Pratiquer Ensemble",
        "de": "Gemeinsam Üben",
        "it": "Pratica Insieme",
        "pt": "Praticar Juntos",
        "sv": "Öva tillsammans"
    },
    {
        "en": "Chessvis can bring any number of repertoires together so you can practice them as though they one big repertoire.",
        "es": "Chessvis puede combinar cualquier número de repertorios para que los practiques como si fueran un solo gran repertorio.",
        "fr": "Chessvis peut regrouper n'importe quel nombre de répertoires afin que vous puissiez les pratiquer comme un grand répertoire unique.",
        "de": "Chessvis kann beliebig viele Repertoires zusammenbringen, sodass du sie wie ein großes Repertoire üben kannst.",
        "it": "Chessvis può combinare qualsiasi numero di repertori in modo da poterli praticare come se fossero un unico grande repertorio.",
        "pt": "O Chessvis pode juntar qualquer número de repertórios para que você os pratique como se fossem um grande repertório.",
        "sv": "Chessvis kan slå ihop flera repertoarer så du övar dem som en stor repertoar."
    },
    {
        "en": "Randoming the Lines",
        "es": "Aleatorizando las Líneas",
        "fr": "Aléatoire des Lignes",
        "de": "Zufällige Linien",
        "it": "Randomizzazione delle Linee",
        "pt": "Aleatorizando as Linhas",
        "sv": "Slumpa linjerna"
    },
    {
        "en": "Before starting, Chessvis builds all the different 'lines'.<br><br>After each of your moves, if there are multiple opponent moves, you will experience them in random order.",
        "es": "Antes de empezar, Chessvis construye todas las diferentes 'líneas'.<br><br>Después de cada uno de tus movimientos, si hay múltiples movimientos del oponente, los experimentarás en orden aleatorio.",
        "fr": "Avant de commencer, Chessvis construit toutes les 'lignes' différentes.<br><br>Après chacun de vos coups, s'il y a plusieurs coups de l'adversaire, vous les expérimenterez dans un ordre aléatoire.",
        "de": "Vor Beginn erstellt Chessvis alle verschiedenen 'Linien'.<br><br>Nach jedem deiner Züge, wenn es mehrere Züge des Gegners gibt, wirst du sie in zufälliger Reihenfolge erleben.",
        "it": "Prima di iniziare, Chessvis costruisce tutte le diverse 'linee'.<br><br>Dopo ciascuna delle tue mosse, se ci sono più mosse dell'avversario, le vivrai in ordine casuale.",
        "pt": "Antes de começar, o Chessvis constrói todas as diferentes 'linhas'.<br><br>Após cada um dos seus lances, se houver múltiplos lances do oponente, você os experimentará em ordem aleatória.",
        "sv": "Innan start bygger Chessvis alla varianter. Efter varje av dina drag slumpas motståndarens val om det finns flera."
    },
    {
        "en": "'Hint' is always here to help you remember what move comes next in your repertoire. And if there are multiple choices left, it will step through those.",
        "es": "'Pista' siempre está aquí para ayudarte a recordar cuál es el siguiente movimiento en tu repertorio. Y si quedan múltiples opciones, te guiará a través de ellas.",
        "fr": "L'«Indice» est toujours là pour vous aider à vous rappeler quel coup vient ensuite dans votre répertoire. Et s'il reste plusieurs choix, il vous les présentera un par un.",
        "de": "'Hinweis' ist immer hier, um dir zu helfen, den nächsten Zug in deinem Repertoire zu erinnern. Und wenn mehrere Optionen übrig sind, führt er dich durch diese.",
        "it": "'Suggerimento' è sempre qui per aiutarti a ricordare quale mossa viene dopo nel tuo repertorio. E se ci sono più scelte rimanenti, ti guiderà attraverso di esse.",
        "pt": "'Dica' está sempre aqui para ajudá-lo a lembrar qual é o próximo lance no seu repertório. E se houver várias opções restantes, ela passará por elas.",
        "sv": "'Tips' hjälper dig komma ihåg nästa drag i repertoaren och går igenom flera val om det finns."
    },
    {
        "en": "Plays all the moves in the current line.<br><br>Note: this option is only available after the current line is played far enough to be uniquely identified.",
        "es": "Reproduce todos los movimientos de la línea actual.<br><br>Nota: esta opción solo está disponible después de que la línea actual se juegue lo suficiente para ser identificada de manera única.",
        "fr": "Joue tous les coups de la ligne actuelle.<br><br>Remarque : cette option n'est disponible qu'après que la ligne actuelle a été jouée suffisamment pour être identifiée de manière unique.",
        "de": "Spielt alle Züge in der aktuellen Linie.<br><br>Hinweis: Diese Option ist nur verfügbar, nachdem die aktuelle Linie weit genug gespielt wurde, um eindeutig identifiziert zu werden.",
        "it": "Esegue tutte le mosse nella linea corrente.<br><br>Nota: questa opzione è disponibile solo dopo che la linea corrente è stata giocata abbastanza da essere identificata in modo univoco.",
        "pt": "Executa todos os lances na linha atual.<br><br>Nota: esta opção só está disponível depois que a linha atual foi jogada o suficiente para ser identificada de forma única.",
        "sv": "Spelar alla drag i aktuell linje. Obs: tillgänglig först när linjen kan identifieras entydigt."
    },
    {
        "en": "Again - Toolbar",
        "es": "De Nuevo - Barra de Herramientas",
        "fr": "Encore - Barre d'Outils",
        "de": "Nochmals - Symbolleiste",
        "it": "Di Nuovo - Barra degli Strumenti",
        "pt": "Novamente - Barra de Ferramentas",
        "sv": "Igen - Verktygsfält"
    },
    {
        "en": "Want to run this line again? This option resets to be beginning of the current line.<br><br>Note: this option is only available after the current line is played far enough to be uniquely identified.",
        "es": "¿Quieres ejecutar esta línea de nuevo? Esta opción reinicia al inicio de la línea actual.<br><br>Nota: esta opción solo está disponible después de que la línea actual se juegue lo suficiente para ser identificada de manera única.",
        "fr": "Vous voulez rejouer cette ligne ? Cette option réinitialise au début de la ligne actuelle.<br><br>Remarque : cette option n'est disponible qu'après que la ligne actuelle a été jouée suffisamment pour être identifiée de manière unique.",
        "de": "Möchten Sie diese Linie erneut ausführen? Diese Option setzt auf den Beginn der aktuellen Linie zurück.<br><br>Hinweis: Diese Option ist nur verfügbar, nachdem die aktuelle Linie weit genug gespielt wurde, um eindeutig identifiziert zu werden.",
        "it": "Vuoi eseguire di nuovo questa linea? Questa opzione reimposta all'inizio della linea corrente.<br><br>Nota: questa opzione è disponibile solo dopo che la linea corrente è stata giocata abbastanza da essere identificata in modo univoco.",
        "pt": "Quer executar esta linha novamente? Esta opção reinicia para o início da linha atual.<br><br>Nota: esta opção só está disponível depois que a linha atual foi jogada o suficiente para ser identificada de forma única.",
        "sv": "Vill du köra linjen igen? Återställ till början av aktuell linje. Obs: kräver att linjen identifierats."
    },
    {
        "en": "Next - Toolbar",
        "es": "Siguiente - Barra de Herramientas",
        "fr": "Suivant - Barre d'Outils",
        "de": "Nächste - Symbolleiste",
        "it": "Successiva - Barra degli Strumenti",
        "pt": "Próxima - Barra de Ferramentas",
        "sv": "Nästa - Verktygsfält"
    },
    {
        "en": "Brings up the next random line.<br><br>Note: this option is only available after the current line is played far enough to be uniquely identified.",
        "es": "Muestra la siguiente línea aleatoria.<br><br>Nota: esta opción solo está disponible después de que la línea actual se juegue lo suficiente para ser identificada de manera única.",
        "fr": "Affiche la ligne aléatoire suivante.<br><br>Remarque : cette option n'est disponible qu'après que la ligne actuelle a été jouée suffisamment pour être identifiée de manière unique.",
        "de": "Zeigt die nächste zufällige Linie an.<br><br>Hinweis: Diese Option ist nur verfügbar, nachdem die aktuelle Linie weit genug gespielt wurde, um eindeutig identifiziert zu werden.",
        "it": "Mostra la prossima linea casuale.<br><br>Nota: questa opzione è disponibile solo dopo che la linea corrente è stata giocata abbastanza da essere identificata in modo univoco.",
        "pt": "Exibe a próxima linha aleatória.<br><br>Nota: esta opção só está disponível depois que a linha atual foi jogada o suficiente para ser identificada de forma única.",
        "sv": "Visar nästa slumpade linje. Obs: kräver att aktuell linje identifierats."
    },
    {
        "en": "Tree - Toolbar",
        "es": "Árbol - Barra de Herramientas",
        "fr": "Arbre - Barre d'Outils",
        "de": "Baum - Symbolleiste",
        "it": "Albero - Barra degli Strumenti",
        "pt": "Árvore - Barra de Ferramentas",
        "sv": "Träd - Verktygsfält"
    },
    {
        "en": "This is the equivalent of learning your lines with '<i>script in hand<\/i>'.<br><br>You have a choice between a static display of the tree or a '<i>real-time<\/i>' tree that keeps up with your moves.",
        "es": "Esto es equivalente a aprender tus líneas con '<i>guion en mano<\/i>'.<br><br>Puedes elegir entre una visualización estática del árbol o un árbol '<i>en tiempo real<\/i>' que sigue tus movimientos.",
        "fr": "Ceci équivaut à apprendre vos lignes avec '<i>script en main<\/i>'.<br><br>Vous pouvez choisir entre un affichage statique de l'arbre ou un arbre '<i>en temps réel<\/i>' qui suit vos coups.",
        "de": "Dies entspricht dem Lernen deiner Linien mit '<i>Drehbuch in der Hand<\/i>'.<br><br>Du kannst zwischen einer statischen Darstellung des Baums oder einem '<i>Echtzeit<\/i>'-Baum wählen, der mit deinen Zügen Schritt hält.",
        "it": "Questo equivale a imparare le tue linee con '<i>copione in mano<\/i>'.<br><br>Puoi scegliere tra una visualizzazione statica dell'albero o un albero '<i>in tempo reale<\/i>' che segue le tue mosse.",
        "pt": "Isto equivale a aprender suas linhas com '<i>roteiro na mão<\/i>'.<br><br>Você pode escolher entre uma exibição estática da árvore ou uma árvore '<i>em tempo real<\/i>' que acompanha seus lances.",
        "sv": "Detta motsvarar att lära sig med 'manus i hand'. Välj mellan en statisk trädvy eller en realtidsvy som följer dina drag."
    },
    {
        "en": "Select any number of repertoires to practice. If you select more than one, they will be merged together for you to practice as a whole.<br><br>Note: practice is one color at a time.",
        "es": "Selecciona cualquier número de repertorios para practicar. Si seleccionas más de uno, se combinarán para que los practiques como un todo.<br><br>Nota: la práctica es de un color a la vez.",
        "fr": "Sélectionnez n'importe quel nombre de répertoires à pratiquer. Si vous en sélectionnez plusieurs, ils seront fusionnés pour que vous puissiez les pratiquer comme un tout.<br><br>Remarque : la pratique se fait d'une couleur à la fois.",
        "de": "Wähle beliebig viele Repertoires zum Üben aus. Wenn du mehr als eines auswählst, werden sie zusammengeführt, damit du sie als Ganzes üben kannst.<br><br>Hinweis: Das Üben erfolgt immer mit einer Farbe gleichzeitig.",
        "it": "Seleziona qualsiasi numero di repertori da praticare. Se ne selezioni più di uno, verranno uniti per essere praticati come un tutto.<br><br>Nota: la pratica è di un colore alla volta.",
        "pt": "Selecione qualquer número de repertórios para praticar. Se você selecionar mais de um, eles serão mesclados para que você pratique como um todo.<br><br>Nota: a prática é de uma cor por vez.",
        "sv": "Välj valfritt antal repertoarer att öva. Väljer du flera slås de ihop — övning sker en färg i taget."
    },
    {
        "en": "With Chessvis, building a repertoire is as easy as making moves.<br><br>Note: the video is for the entire set of repertoire routines.",
        "es": "Con Chessvis, construir un repertorio es tan fácil como hacer movimientos.<br><br>Nota: el video es para todo el conjunto de rutinas de repertorio.",
        "fr": "Avec Chessvis, construire un répertoire est aussi simple que de jouer des coups.<br><br>Remarque : la vidéo concerne l'ensemble des routines de répertoire.",
        "de": "Mit Chessvis ist das Erstellen eines Repertoires so einfach wie das Ziehen von Zügen.<br><br>Hinweis: Das Video zeigt das gesamte Repertoire an Routinen.",
        "it": "Con Chessvis, costruire un repertorio è facile quanto fare mosse.<br><br>Nota: il video riguarda l'intero set di routine del repertorio.",
        "pt": "Com o Chessvis, construir um repertório é tão fácil quanto fazer movimentos.<br><br>Nota: o vídeo é para todo o conjunto de rotinas de repertório.",
        "sv": "I Chessvis är det lika enkelt att bygga repertoar som att göra drag. (Videon visar hela repertoarrutinen.)"
    },
    {
        "en": "All of the possible moves are listed.<br><br>Moves that have been played with any regularity are in the 'tree' and will show the game count and white win\/loss percentages.",
        "es": "Todos los movimientos posibles están listados.<br><br>Los movimientos que se han jugado con regularidad están en el 'árbol' y mostrarán el número de partidas y los porcentajes de victorias\/derrotas de las blancas.",
        "fr": "Tous les coups possibles sont listés.<br><br>Les coups joués régulièrement se trouvent dans l'arbre et afficheront le nombre de parties et les pourcentages de victoires\/défaites des blancs.",
        "de": "Alle möglichen Züge sind aufgelistet.<br><br>Züge, die regelmäßig gespielt wurden, sind im 'Baum' und zeigen die Anzahl der Spiele sowie die Gewinn\/Verlust-Prozente der weißen Seite.",
        "it": "Tutte le mosse possibili sono elencate.<br><br>Le mosse giocate con una certa regolarità sono nell' 'albero' e mostreranno il numero di partite e le percentuali di vittorie\/sconfitte del bianco.",
        "pt": "Todos os movimentos possíveis estão listados.<br><br>Os movimentos jogados com alguma regularidade estão na 'árvore' e mostrarão a contagem de partidas e as porcentagens de vitórias\/derrotas das brancas.",
        "sv": "Alla möjliga drag listas. Drag som spelats med viss frekvens finns i 'trädet' och visar antal partier samt vit vinst\/förlust-procent."
    },
    {
        "en": "More about the Move List",
        "es": "Más sobre la Lista de Movimientos",
        "fr": "Plus sur la Liste des Coups",
        "de": "Mehr über die Zugliste",
        "it": "Di Più sulla Lista delle Mosse",
        "pt": "Mais sobre a Lista de Jogadas",
        "sv": "Mer om draglistan"
    },
    {
        "en": "Moves that aren't in the tree are listed last.<br><br>They don't have the win\/loss percentages.",
        "es": "Los movimientos que no están en el árbol se listan al final.<br><br>No tienen los porcentajes de victorias\/derrotas.",
        "fr": "Les coups qui ne sont pas dans l'arbre sont listés en dernier.<br><br>Ils n'ont pas les pourcentages de victoires\/défaites.",
        "de": "Züge, die nicht im Baum sind, werden zuletzt aufgelistet.<br><br>Sie haben keine Gewinn\/Verlust-Prozente.",
        "it": "Le mosse che non sono nell'albero sono elencate per ultime.<br><br>Non hanno le percentuali di vittorie\/sconfitte.",
        "pt": "Os movimentos que não estão na árvore são listados por último.<br><br>Não possuem as porcentagens de vitórias\/derrotas.",
        "sv": "Drag som inte finns i trädet listas sist. De har inga vinst\/förlust-procent."
    },
    {
        "en": "Building the Repertoire",
        "es": "Construyendo el Repertorio",
        "fr": "Construction du Répertoire",
        "de": "Aufbau des Repertoires",
        "it": "Costruire il Repertorio",
        "pt": "Construindo o Repertório",
        "sv": "Bygga repertoar"
    },
    {
        "en": "As you make moves on the board or by selecting them on the move list they are added to the repertoire.<br><br>Toggling the checkboxes will add and remove moves from the repertoire.",
        "es": "A medida que realizas movimientos en el tablero o los seleccionas en la lista de movimientos, se añaden al repertorio.<br><br>Marcar o desmarcar las casillas añadirá o quitará movimientos del repertorio.",
        "fr": "Au fur et à mesure que vous effectuez des coups sur l'échiquier ou en les sélectionnant dans la liste des coups, ils sont ajoutés au répertoire.<br><br>Basculer les cases à cocher ajoutera ou supprimera des coups du répertoire.",
        "de": "Wenn du Züge auf dem Brett machst oder sie in der Zugliste auswählst, werden sie dem Repertoire hinzugefügt.<br><br>Das Umschalten der Kontrollkästchen fügt Züge hinzu oder entfernt sie aus dem Repertoire.",
        "it": "Mentre fai mosse sulla scacchiera o le selezioni nella lista delle mosse, vengono aggiunte al repertorio.<br><br>Selezionando o deselezionando le caselle si aggiungono o rimuovono mosse dal repertorio.",
        "pt": "À medida que você faz movimentos no tabuleiro ou os seleciona na lista de jogadas, eles são adicionados ao repertório.<br><br>Alternar as caixas de seleção adicionará ou removerá movimentos do repertório.",
        "sv": "När du gör drag på brädet eller väljer dem i listan läggs de till repertoaren. Bocka av för att lägga till eller ta bort drag."
    },
    {
        "en": "Chessvis can also show display the move tree while you're building the repertoire.<br><br>There are 3 levels of tree display.",
        "es": "Chessvis también puede mostrar el árbol de movimientos mientras construyes el repertorio.<br><br>Hay 3 niveles de visualización del árbol.",
        "fr": "Chessvis peut également afficher l'arbre des coups pendant que vous construisez le répertoire.<br><br>Il existe 3 niveaux d'affichage de l'arbre.",
        "de": "Chessvis kann während des Aufbaus des Repertoires auch den Zugbaum anzeigen.<br><br>Es gibt 3 Anzeigeebenen des Baums.",
        "it": "Chessvis può anche mostrare l'albero delle mosse mentre costruisci il repertorio.<br><br>Ci sono 3 livelli di visualizzazione dell'albero.",
        "pt": "O Chessvis também pode exibir a árvore de jogadas enquanto você constrói o repertório.<br><br>Existem 3 níveis de exibição da árvore.",
        "sv": "Chessvis kan visa trädvyn medan du bygger repertoaren — tre displaynivåer finns."
    },
    {
        "en": "Tree Display Levels - Toolbar",
        "es": "Niveles de Visualización del Árbol - Barra de Herramientas",
        "fr": "Niveaux d'Affichage de l'Arbre - Barre d'Outils",
        "de": "Baumanzeige-Ebenen - Symbolleiste",
        "it": "Livelli di Visualizzazione dell'Albero - Barra degli Strumenti",
        "pt": "Níveis de Exibição da Árvore - Barra de Ferramentas",
        "sv": "Trädvisningsnivåer - Verktygsfält"
    },
    {
        "en": "<b>Display<\/b> - Static Tree<br><br><b>Follow Along<\/b> - the tree will be updated as you add moves.<br><br><b>Bidirectional<\/b> - selecting moves on the tree will cause the move list to jump to that location.",
        "es": "<b>Mostrar<\/b> - Árbol Estático<br><br><b>Seguir<\/b> - el árbol se actualizará a medida que agregues movimientos.<br><br><b>Bidireccional<\/b> - seleccionar movimientos en el árbol hará que la lista de movimientos salte a esa ubicación.",
        "fr": "<b>Affichage<\/b> - Arbre Statique<br><br><b>Suivre<\/b> - l'arbre sera mis à jour au fur et à mesure que vous ajoutez des coups.<br><br><b>Bidirectionnel<\/b> - sélectionner des coups dans l'arbre fera que la liste des coups se positionnera à cet endroit.",
        "de": "<b>Anzeigen<\/b> - Statischer Baum<br><br><b>Mitverfolgen<\/b> - Der Baum wird aktualisiert, während du Züge hinzufügst.<br><br><b>Bidirektional<\/b> - Züge im Baum auszuwählen, lässt die Zugliste zu dieser Stelle springen.",
        "it": "<b>Visualizza<\/b> - Albero Statico<br><br><b>Segui<\/b> - l'albero sarà aggiornato man mano che aggiungi mosse.<br><br><b>Bidirezionale<\/b> - selezionare mosse sull'albero farà saltare la lista delle mosse a quella posizione.",
        "pt": "<b>Exibir<\/b> - Árvore Estática<br><br><b>Acompanhar<\/b> - a árvore será atualizada à medida que você adiciona movimentos.<br><br><b>Bidirecional<\/b> - selecionar movimentos na árvore fará a lista de jogadas ir para essa posição.",
        "sv": "<b>Visa<\/b> — statiskt träd. <b>Följ med<\/b> — trädet uppdateras när du lägger till drag. <b>Bidirektionell<\/b> — välj drag i trädet för att hoppa i draglistan."
    },
    {
        "en": "Rating Filter - Toolbar",
        "es": "Filtro de Rating - Barra de Herramientas",
        "fr": "Filtre de Cote - Barre d'Outils",
        "de": "Bewertungsfilter - Symbolleiste",
        "it": "Filtro di Valutazione - Barra degli Strumenti",
        "pt": "Filtro de Rating - Barra de Ferramentas",
        "sv": "Betygsfilter - Verktygsfält"
    },
    {
        "en": "Different levels of players make different moves. It's important to filter the move tree to the bracket that you play in.",
        "es": "Diferentes niveles de jugadores realizan diferentes movimientos. Es importante filtrar el árbol de movimientos al rango en el que juegas.",
        "fr": "Différents niveaux de joueurs effectuent différents coups. Il est important de filtrer l'arbre des coups selon la catégorie dans laquelle vous jouez.",
        "de": "Spieler verschiedener Stärken machen unterschiedliche Züge. Es ist wichtig, den Zugbaum auf die Spielklasse zu filtern, in der du spielst.",
        "it": "Giocatori di livelli diversi fanno mosse diverse. È importante filtrare l'albero delle mosse nella fascia in cui giochi.",
        "pt": "Jogadores de diferentes níveis fazem movimentos diferentes. É importante filtrar a árvore de jogadas para a faixa em que você joga.",
        "sv": "Spelare på olika nivå gör olika drag — filtrera trädet till ditt betygsintervall."
    },
    {
        "en": "Comment - Toolbar",
        "es": "Comentario - Barra de Herramientas",
        "fr": "Commentaire - Barre d'Outils",
        "de": "Kommentar - Symbolleiste",
        "it": "Commento - Barra degli Strumenti",
        "pt": "Comentário - Barra de Ferramentas",
        "sv": "Kommentar - Verktygsfält"
    },
    {
        "en": "Add and\/or edit a comment associated with the board.<br><br><i>The 'tree' toolbar item can also toggle showing comments within the tree",
        "es": "Agregar y\/o editar un comentario asociado al tablero.<br><br><i>El elemento 'árbol' de la barra de herramientas también puede alternar la visualización de comentarios dentro del árbol.",
        "fr": "Ajouter et\/ou modifier un commentaire associé à l'échiquier.<br><br><i>L'élément 'arbre' de la barre d'outils peut également basculer l'affichage des commentaires dans l'arbre.",
        "de": "Einen Kommentar hinzufügen und\/oder bearbeiten, der mit dem Brett verknüpft ist.<br><br><i>Das 'Baum'-Symbol in der Symbolleiste kann ebenfalls die Anzeige von Kommentaren im Baum ein- oder ausschalten.<\/i>",
        "it": "Aggiungi e\/o modifica un commento associato alla scacchiera.<br><br><i>L'elemento 'albero' della barra degli strumenti può anche alternare la visualizzazione dei commenti nell'albero.<\/i>",
        "pt": "Adicionar e\/ou editar um comentário associado ao tabuleiro.<br><br><i>O item 'árvore' da barra de ferramentas também pode alternar a exibição de comentários na árvore.<\/i>",
        "sv": "Lägg till eller redigera kommentar för ställningen. (Trädverktyget kan även växla kommentarer i trädet.)"
    },
    {
        "en": "Videos - In English",
        "es": "Videos - En Inglés",
        "fr": "Vidéos - En Anglais",
        "de": "Videos - Auf Englisch",
        "it": "Video - In Inglese",
        "pt": "Vídeos - Em Inglês",
        "sv": "Videor - på engelska"
    },
    {
        "en": "Opening - Find Opponent Moves",
        "es": "Apertura - Encuentra los Movimientos del Oponente",
        "fr": "Ouverture - Trouver les Coups de l'Adversaire",
        "de": "Eröffnung - Finde die Züge des Gegners",
        "it": "Apertura - Trova le Mosse dell'Avversario",
        "pt": "Abertura - Encontre os Movimentos do Oponente",
        "sv": "Öppning - hitta motståndarens drag"
    },
    {
        "en": "Opening - Find Your Best Moves",
        "es": "Apertura - Encuentra Tus Mejores Movimientos",
        "fr": "Ouverture - Trouver Vos Meilleurs Coups",
        "de": "Eröffnung - Finde Deine Besten Züge",
        "it": "Apertura - Trova le Tue Migliori Mosse",
        "pt": "Abertura - Encontre Seus Melhores Movimentos",
        "sv": "Öppning - hitta dina bästa drag"
    },
    {
        "en": "Repertoires!",
        "es": "¡Repertorios!",
        "fr": "Répertoires !",
        "de": "Repertoires!",
        "it": "Repertori!",
        "pt": "Repertórios!",
        "sv": "Repertoarer!"
    },
    {
        "en": "Legacy - Repertoires",
        "es": "Legado - Repertorios",
        "fr": "Héritage - Répertoires",
        "de": "Legacy - Repertoires",
        "it": "Eredità - Repertori",
        "pt": "Legado - Repertórios",
        "sv": "Legacy - Repertoarer"
    },
    {
        "en": "Legacy - Master Player Games",
        "es": "Legado - Partidas de Maestros",
        "fr": "Héritage - Parties de Maîtres",
        "de": "Legacy - Meisterspieler-Partien",
        "it": "Eredità - Partite di Maestri",
        "pt": "Legado - Partidas de Mestres",
        "sv": "Legacy - stormästarpartier"
    },
    {
        "en": "Legacy - Play Game Collection",
        "es": "Legado - Colección de Partidas Jugadas",
        "fr": "Héritage - Collection de Parties Jouées",
        "de": "Legacy - Spielesammlung",
        "it": "Eredità - Collezione di Partite Giocate",
        "pt": "Legado - Coleção de Partidas Jogadas",
        "sv": "Legacy - spela partisamling"
    },
    {
        "en": "Do You Coach or Get Coached?",
        "es": "¿Das Clases o Recibes Clases?",
        "fr": "Enseignez-vous ou Recevez-vous des Cours ?",
        "de": "Gibst du Training oder wirst du trainiert?",
        "it": "Insegni o Veni Allenato?",
        "pt": "Você Dá Aulas ou Recebe Aulas?",
        "sv": "Coachar du eller blir du coachad?"
    },
    {
        "en": "Learn",
        "es": "Aprender",
        "fr": "Apprendre",
        "de": "Lernen",
        "it": "Imparare",
        "pt": "Aprender",
        "sv": "Lär dig"
    },
    {
        "en": "Learn With Coach",
        "es": "Aprender con un Entrenador",
        "fr": "Apprendre avec un Coach",
        "de": "Lernen mit einem Trainer",
        "it": "Imparare con un Allenatore",
        "pt": "Aprender com um Treinador",
        "sv": "Lär med coach"
    },
    {
        "en": "Welcome Back!",
        "es": "¡Bienvenido de Nuevo!",
        "fr": "Bon Retour !",
        "de": "Willkommen Zurück!",
        "it": "Bentornato!",
        "pt": "Bem-vindo de Volta!",
        "sv": "Välkommen tillbaka!"
    },
    {
        "en": "Scroll Up",
        "es": "Desplazar arriba",
        "fr": "Faire défiler vers le haut",
        "de": "Nach oben scrollen",
        "it": "Scorri su",
        "pt": "Rolar para cima",
        "sv": "Skrolla upp"
    },
    {
        "en": "Scroll Down",
        "es": "Desplazar abajo",
        "fr": "Faire défiler vers le bas",
        "de": "Nach unten scrollen",
        "it": "Scorri giù",
        "pt": "Rolar para baixo",
        "sv": "Skrolla ner"
    },
    {
        "en": "Big Buttons & EyeGaze",
        "es": "Botones Grandes y Seguimiento Ocular",
        "fr": "Gros Boutons & Suivi Oculaire",
        "de": "Große Tasten & Blickverfolgung",
        "it": "Pulsanti Grandi e EyeGaze",
        "pt": "Botões Grandes & Rastreamento Ocular",
        "sv": "Stora knappar & EyeGaze"
    },
    {
        "en": "Big Button Main Menu",
        "es": "Menú Principal de Botones Grandes",
        "fr": "Menu Principal de Gros Boutons",
        "de": "Hauptmenü mit Großen Tasten",
        "it": "Menu Principale con Pulsanti Grandi",
        "pt": "Menu Principal com Botões Grandes",
        "sv": "Huvudmeny med stora knappar"
    },
    {
        "en": "Big Button & EyeGaze Preferences",
        "es": "Preferencias de Botón Grande y Seguimiento Ocular",
        "fr": "Préférences des Grands Boutons et du Suivi Oculaire",
        "de": "Einstellungen für Große Schaltflächen und Blicksteuerung",
        "it": "Preferenze Pulsante Grande e EyeGaze",
        "pt": "Preferências de Botão Grande e Rastreamento Ocular",
        "sv": "Inställningar för stora knappar & EyeGaze"
    },
    {
        "en": "Board & Language Preferences",
        "es": "Preferencias de Tablero e Idioma",
        "fr": "Préférences de Plateau et de Langue",
        "de": "Brett- und Spracheinstellungen",
        "it": "Preferenze di Scacchiera e Lingua",
        "pt": "Preferências de Tabuleiro e Idioma",
        "sv": "Bräd- & språkinställningar"
    },
    {
        "en": "Show Big Buttons",
        "es": "Mostrar Botones Grandes",
        "fr": "Afficher les Grands Boutons",
        "de": "Große Schaltflächen Anzeigen",
        "it": "Mostra Pulsanti Grandi",
        "pt": "Mostrar Botões Grandes",
        "sv": "Visa stora knappar"
    },
    {
        "en": "EyeGaze Tracking for Board Play",
        "es": "Seguimiento Ocular para Jugar en el Tablero",
        "fr": "Suivi du Regard pour Jouer sur l’Échiquier",
        "de": "Blicksteuerung für das Spielbrett",
        "it": "Tracciamento Oculare per il Gioco sulla Scacchiera",
        "pt": "Rastreamento Ocular para Jogar no Tabuleiro",
        "sv": "EyeGaze-spårning för brädspel"
    },
    {
        "en": "Button Height Scaling Factor",
        "es": "Factor de Escala de Altura del Botón",
        "fr": "Facteur d’Échelle de la Hauteur des Boutons",
        "de": "Höhenskalierungsfaktor der Schaltfläche",
        "it": "Fattore di Scala dell’Altezza del Pulsante",
        "pt": "Fator de Escala da Altura do Botão",
        "sv": "Knapphöjdsskalfaktor"
    },
    {
        "en": "Free",
        "es": "Gratis",
        "fr": "Gratuit",
        "de": "Kostenlos",
        "it": "Gratis",
        "pt": "Grátis",
        "sv": "Gratis"
    },
    {
        "en": "Show Big Buttons - Everywhere",
        "es": "Mostrar botones grandes - en todas partes",
        "fr": "Afficher les grands boutons - partout",
        "de": "Große Schaltflächen anzeigen - überall",
        "it": "Mostra pulsanti grandi - ovunque",
        "pt": "Mostrar botões grandes - em todo lugar",
        "sv": "Visa stora knappar överallt"
    },
    {
        "en": "Opening Audio Book",
        "es": "Libro de audio de aperturas",
        "fr": "Livre audio des ouvertures",
        "de": "Eröffnungs-Hörbuch",
        "it": "Audiolibro delle aperture",
        "pt": "Audiolivro de aberturas",
        "sv": "Öppningsljudbok"
    },
    {
        "en": "Establish Connection",
        "es": "Establecer conexión",
        "fr": "Établir la connexion",
        "de": "Verbindung herstellen",
        "it": "Stabilire connessione",
        "pt": "Estabelecer conexão",
        "sv": "Etablera anslutning"
    },
    {
        "en": "Order Cancelled",
        "es": "Pedido cancelado",
        "fr": "Commande annulée",
        "de": "Bestellung storniert",
        "it": "Ordine annullato",
        "pt": "Pedido cancelado",
        "sv": "Beställning avbruten"
    },
    {
        "en": "Order Successful",
        "es": "Pedido realizado con éxito",
        "fr": "Commande réussie",
        "de": "Bestellung erfolgreich",
        "it": "Ordine riuscito",
        "pt": "Pedido realizado com sucesso",
        "sv": "Beställning lyckades"
    },
    {
        "en": "Password Reset",
        "es": "Restablecer contraseña",
        "fr": "Réinitialisation du mot de passe",
        "de": "Passwort zurückgesetzt",
        "it": "Reimpostazione della password",
        "pt": "Redefinição de senha",
        "sv": "Återställ lösenord"
    },
    {
        "en": "Unsubscribe",
        "es": "Darse de baja",
        "fr": "Se désabonner",
        "de": "Abmelden",
        "it": "Annulla iscrizione",
        "pt": "Cancelar inscrição",
        "sv": "Avsluta prenumeration"
    },
    {
        "en": "Password Reset Request",
        "es": "Solicitud de restablecimiento de contraseña",
        "fr": "Demande de réinitialisation du mot de passe",
        "de": "Anfrage zum Zurücksetzen des Passworts",
        "it": "Richiesta di reimpostazione della password",
        "pt": "Solicitação de redefinição de senha",
        "sv": "Begäran om återställning av lösenord"
    },
    {
        "en": "User",
        "es": "Usuario",
        "fr": "Utilisateur",
        "de": "Benutzer",
        "it": "Utente",
        "pt": "Usuário",
        "sv": "Användare"
    },
    {
        "en": "Hi",
        "es": "Hola",
        "fr": "Salut",
        "de": "Hallo",
        "it": "Ciao",
        "pt": "Olá",
        "sv": "Hej"
    },
    {
        "en": "To reset your password within the 'Chessvis' website, either click on the link below or copy it into your browser and it will take you to a password reset page.",
        "es": "Para restablecer tu contraseña en el sitio web de 'Chessvis', haz clic en el enlace a continuación o cópialo en tu navegador y te llevará a una página para restablecer la contraseña.",
        "fr": "Pour réinitialiser votre mot de passe sur le site 'Chessvis', cliquez sur le lien ci-dessous ou copiez-le dans votre navigateur pour accéder à la page de réinitialisation du mot de passe.",
        "de": "Um Ihr Passwort auf der 'Chessvis'-Website zurückzusetzen, klicken Sie auf den untenstehenden Link oder kopieren Sie ihn in Ihren Browser. Sie werden zur Seite zum Zurücksetzen des Passworts weitergeleitet.",
        "it": "Per reimpostare la tua password sul sito 'Chessvis', fai clic sul link qui sotto o copialo nel tuo browser per accedere alla pagina di reimpostazione della password.",
        "pt": "Para redefinir sua senha no site 'Chessvis', clique no link abaixo ou copie-o no seu navegador para acessar a página de redefinição de senha.",
        "sv": "För att återställa ditt Chessvis-lösenord, klicka på länken nedan eller klistra in den i din webbläsare för att komma till återställningssidan."
    },
    {
        "en": "If you have any questions, please email me at",
        "es": "Si tienes alguna pregunta, por favor envíame un correo a",
        "fr": "Si vous avez des questions, veuillez m'envoyer un e-mail à",
        "de": "Wenn Sie Fragen haben, senden Sie mir bitte eine E-Mail an",
        "it": "Se hai domande, scrivimi pure a",
        "pt": "Se tiver alguma dúvida, envie-me um e-mail para",
        "sv": "Om du har frågor, mejla mig på"
    },
    {
        "en": "no email associated with account",
        "es": "ningún correo asociado con la cuenta",
        "fr": "aucun e-mail associé au compte",
        "de": "kein E-Mail-Konto verbunden",
        "it": "nessuna email associata all'account",
        "pt": "nenhum email associado à conta",
        "sv": "ingen e-post kopplad till kontot"
    },
    {
        "en": "verification email sent",
        "es": "correo de verificación enviado",
        "fr": "e-mail de vérification envoyé",
        "de": "Verifizierungs-E-Mail gesendet",
        "it": "email di verifica inviata",
        "pt": "email de verificação enviado",
        "sv": "verifieringsmejl skickat"
    },
    {
        "en": "Email Verification Request",
        "es": "Solicitud de verificación de correo electrónico",
        "fr": "Demande de vérification de courriel",
        "de": "E-Mail-Bestätigungsanfrage",
        "it": "Richiesta di verifica e-mail",
        "pt": "Solicitação de verificação de e-mail",
        "sv": "Begäran om e-postverifiering"
    },
    {
        "en": "To verify your email address with the Chessvis website, either click on the link below or copy it into your browser. It will bring up a webpage that will register your verification.",
        "es": "Para verificar tu dirección de correo electrónico en el sitio web de Chessvis, haz clic en el enlace a continuación o cópialo en tu navegador. Se abrirá una página que registrará tu verificación.",
        "fr": "Pour vérifier votre adresse e-mail sur le site Chessvis, cliquez sur le lien ci-dessous ou copiez-le dans votre navigateur. Une page s’ouvrira pour enregistrer votre vérification.",
        "de": "Um Ihre E-Mail-Adresse auf der Chessvis-Website zu bestätigen, klicken Sie auf den untenstehenden Link oder kopieren Sie ihn in Ihren Browser. Eine Webseite wird geöffnet, um Ihre Bestätigung zu registrieren.",
        "it": "Per verificare il tuo indirizzo e-mail sul sito Chessvis, fai clic sul link qui sotto o copialo nel tuo browser. Si aprirà una pagina web che registrerà la tua verifica.",
        "pt": "Para verificar seu endereço de e-mail no site Chessvis, clique no link abaixo ou copie-o no seu navegador. Uma página será aberta para registrar sua verificação.",
        "sv": "För att verifiera din e-post med Chessvis, klicka på länken nedan eller klistra in den i din webbläsare för att registrera verifieringen."
    },
    {
        "en": "Information on how to 'Cancel Subscription' under 'Account' menu.",
        "es": "Información sobre cómo 'Cancelar suscripción' en el menú 'Cuenta'.",
        "fr": "Informations sur la façon d’'annuler l’abonnement' dans le menu 'Compte'.",
        "de": "Informationen zum 'Abonnement kündigen' im Menü 'Konto'.",
        "it": "Informazioni su come 'Annullare l'abbonamento' nel menu 'Account'.",
        "pt": "Informações sobre como 'Cancelar assinatura' no menu 'Conta'.",
        "sv": "Info om hur du 'Avslutar prenumeration' finns i 'Konto'-menyn."
    },
    {
        "en": "'Repertoire Import' under 'Legacy Repertoires' is working. (Since it is drag&drop, this will only be available on the Web version but once a repertoire is imported, it can be used anywhere.)",
        "es": "La opción 'Importar repertorio' bajo 'Repertorios heredados' está funcionando. (Como es de tipo arrastrar y soltar, solo estará disponible en la versión web, pero una vez importado el repertorio, se puede usar en cualquier lugar.)",
        "fr": "L'option 'Importer un répertoire' sous 'Répertoires hérités' fonctionne. (Comme il s'agit d'un glisser-déposer, elle n'est disponible que sur la version Web, mais une fois le répertoire importé, il peut être utilisé partout.)",
        "de": "'Repertoire-Import' unter 'Alte Repertoires' funktioniert. (Da es Drag & Drop ist, ist es nur in der Webversion verfügbar, aber sobald ein Repertoire importiert wurde, kann es überall verwendet werden.)",
        "it": "La funzione 'Importa repertorio' sotto 'Repertori legacy' funziona. (Poiché utilizza il trascinamento, è disponibile solo nella versione web, ma una volta importato il repertorio può essere usato ovunque.)",
        "pt": "A função 'Importar repertório' em 'Repertórios legados' está funcionando. (Como é arrastar e soltar, só está disponível na versão Web, mas uma vez importado o repertório, ele pode ser usado em qualquer lugar.)",
        "sv": "'Repertoarimport' under 'Legacy Repertoarer' fungerar (drag & drop kräver webbversion, men efter import kan repertoaren användas överallt)."
    },
    {
        "en": "'Puzzle Rating' selection is improved. Now you can specify a range of any size. Plus the screen got a 'facelift' with the long list of checkboxes replaced by sliders. Also, on 'Puzzle Visualization' if you click on the wrong 'from' square, clicking on that same square again will just clear the 'from' selection.",
        "es": "La selección de 'Calificación de rompecabezas' ha mejorado. Ahora puedes especificar un rango de cualquier tamaño. Además, la pantalla recibió un 'lavado de cara' reemplazando la larga lista de casillas por deslizadores. También, en 'Visualización de rompecabezas', si haces clic en el cuadro 'de' equivocado, al hacer clic de nuevo en el mismo cuadro se borrará la selección.",
        "fr": "La sélection de la 'notation des puzzles' a été améliorée. Vous pouvez désormais spécifier une plage de n’importe quelle taille. De plus, l’écran a eu un 'rafraîchissement' : la longue liste de cases à cocher a été remplacée par des curseurs. Enfin, dans la 'visualisation de puzzle', si vous cliquez sur la mauvaise case de départ, un second clic sur la même case effacera simplement la sélection.",
        "de": "Die Auswahl der 'Puzzle-Bewertung' wurde verbessert. Jetzt können Sie einen beliebigen Bereich angeben. Außerdem hat der Bildschirm ein 'Facelift' erhalten – die lange Liste von Kontrollkästchen wurde durch Schieberegler ersetzt. Und in der 'Puzzle-Visualisierung' wird, wenn Sie auf das falsche 'Von'-Feld klicken, ein erneuter Klick darauf die Auswahl einfach löschen.",
        "it": "La selezione della 'Valutazione dei puzzle' è stata migliorata. Ora puoi specificare un intervallo di qualsiasi dimensione. Inoltre, lo schermo ha ricevuto un 'restyling', sostituendo la lunga lista di caselle con degli slider. Anche in 'Visualizzazione puzzle', se clicchi sulla casella 'da' sbagliata, cliccando di nuovo sulla stessa la selezione verrà cancellata.",
        "pt": "A seleção de 'Classificação de quebra-cabeça' foi aprimorada. Agora você pode especificar um intervalo de qualquer tamanho. Além disso, a tela ganhou um 'visual novo', substituindo a longa lista de caixas de seleção por controles deslizantes. E em 'Visualização de quebra-cabeça', se você clicar na casa 'de' errada, clicar novamente na mesma casa limpará a seleção.",
        "sv": "'Pusselbetyg' förbättrat — välj vilket intervall som helst. Långa checkbox-listor ersatta med reglage. I 'Pusselvisualisering' rensar ett nytt klick samma 'från'-ruta."
    },
    {
        "en": "Welcome to Chessvis Version",
        "es": "Bienvenido a Chessvis Versión",
        "fr": "Bienvenue dans Chessvis Version",
        "de": "Willkommen bei Chessvis Version",
        "it": "Benvenuto in Chessvis Versione",
        "pt": "Bem-vindo à versão Chessvis",
        "sv": "Välkommen till Chessvis version"
    },
      {
        "en": "Welcome to Chessvis",
        "es": "Bienvenido a Chessvis",
        "fr": "Bienvenue dans Chessvis",
        "de": "Willkommen bei Chessvis",
        "it": "Benvenuto in Chessvis",
        "pt": "Bem-vindo à Chessvis",
        "sv": "Välkommen till Chessvis"
    },
    {
        "en": "Chessvis speaks your language! Starting with: Spanish, French, Italian, German and Portuguese. Suggest others? Subscribers can pick their favorite puzzle categories! And 'Eye Gaze' gets reworked and embedded in Chessvis. With it, you can use an 'eye tracker' to play. And since it now works on phones, users who don't need an eye tracker might find the move selection easy using just 'two thumbs'. Find the toolbar buttons too small on your screen? Now you can enlarge them.",
        "es": "¡Chessvis habla tu idioma! Empezando con: español, francés, italiano, alemán y portugués. ¿Quieres sugerir otros? ¡Los suscriptores pueden elegir sus categorías de rompecabezas favoritas! Además, 'Eye Gaze' ha sido rediseñado e integrado en Chessvis. Con él, puedes usar un 'rastreador ocular' para jugar. Y como ahora también funciona en teléfonos, los usuarios que no lo necesiten pueden encontrar fácil seleccionar movimientos usando solo 'dos pulgares'. ¿Los botones de la barra de herramientas te parecen pequeños? Ahora puedes agrandarlos.",
        "fr": "Chessvis parle votre langue ! En commençant par : espagnol, français, italien, allemand et portugais. Vous en voulez d'autres ? Les abonnés peuvent choisir leurs catégories d’énigmes préférées ! Et la fonction « Eye Gaze » a été repensée et intégrée à Chessvis. Grâce à elle, vous pouvez jouer avec un « eye tracker ». Et comme cela fonctionne désormais sur les téléphones, ceux qui n’en ont pas besoin peuvent trouver la sélection de coups facile avec seulement « deux pouces ». Les boutons de la barre d’outils sont trop petits ? Vous pouvez maintenant les agrandir.",
        "de": "Chessvis spricht deine Sprache! Beginnend mit: Spanisch, Französisch, Italienisch, Deutsch und Portugiesisch. Weitere Vorschläge? Abonnenten können ihre Lieblingskategorien für Rätsel auswählen! Außerdem wurde 'Eye Gaze' überarbeitet und in Chessvis integriert. Damit kannst du mit einem 'Eye Tracker' spielen. Und da es jetzt auch auf Handys funktioniert, könnten Nutzer ohne Eye Tracker die Zugauswahl ganz einfach mit 'zwei Daumen' finden. Sind die Symbolleistenschaltflächen zu klein? Jetzt kannst du sie vergrößern.",
        "it": "Chessvis parla la tua lingua! A partire da: spagnolo, francese, italiano, tedesco e portoghese. Vuoi suggerirne altre? Gli abbonati possono scegliere le loro categorie di enigmi preferite! Inoltre, 'Eye Gaze' è stato rinnovato e integrato in Chessvis. Con esso puoi usare un 'eye tracker' per giocare. E poiché ora funziona anche sui telefoni, chi non ne ha bisogno potrebbe trovare facile selezionare le mosse usando solo 'due pollici'. Trovi i pulsanti della barra degli strumenti troppo piccoli? Ora puoi ingrandirli.",
        "pt": "O Chessvis fala o seu idioma! Começando por: espanhol, francês, italiano, alemão e português. Quer sugerir outros? Os assinantes podem escolher as suas categorias de quebra-cabeças favoritas! Além disso, o 'Eye Gaze' foi reformulado e incorporado no Chessvis. Com ele, você pode jogar usando um 'rastreador ocular'. E como agora funciona em telemóveis, os utilizadores que não precisarem de um rastreador ocular podem achar fácil selecionar movimentos usando apenas 'dois polegares'. Os botões da barra de ferramentas parecem pequenos? Agora você pode aumentá-los.",
        "sv": "Chessvis talar ditt språk! Börjar med spanska, franska, italienska, tyska och portugisiska. Tips på fler? Prenumeranter väljer favoritkategorier! EyeGaze är omarbetat och inbyggt — använd en ögontracker eller två tummeval. För små verktygsknappar? Förstora dem."
    },
    {
        "en": "SOLVED",
        "es": "RESUELTO",
        "fr": "RÉSOLU",
        "de": "GELÖST",
        "it": "RISOLTO",
        "pt": "RESOLVIDO",
        "sv": "LÖST"
    },
    {
        "en": "Note: your device might be off-line",
        "es": "Nota: tu dispositivo podría estar sin conexión",
        "fr": "Remarque : votre appareil est peut-être hors ligne",
        "de": "Hinweis: Ihr Gerät ist möglicherweise offline",
        "it": "Nota: il tuo dispositivo potrebbe essere offline",
        "pt": "Observação: seu dispositivo pode estar offline",
        "sv": "Obs: din enhet kan vara offline"
    },
    {
        "en": "Chessvis had the following error while communicating with its on-line server",
        "es": "Chessvis tuvo el siguiente error al comunicarse con su servidor en línea",
        "fr": "Chessvis a rencontré l'erreur suivante lors de la communication avec son serveur en ligne",
        "de": "Chessvis hat den folgenden Fehler bei der Kommunikation mit dem Online-Server festgestellt",
        "it": "Chessvis ha riscontrato il seguente errore durante la comunicazione con il suo server online",
        "pt": "O Chessvis encontrou o seguinte erro ao se comunicar com o servidor online",
        "sv": "Chessvis upplevde följande fel vid kommunikation med servern"
    },
    {
        "en": "If this persists and is not associated with your connectivity, please let us know at: support@chessvis.com",
        "es": "Si esto persiste y no está relacionado con tu conexión, por favor avísanos en: support@chessvis.com",
        "fr": "Si cela persiste et n'est pas lié à votre connexion, veuillez nous en informer à : support@chessvis.com",
        "de": "Wenn das Problem weiterhin besteht und nicht mit Ihrer Verbindung zusammenhängt, lassen Sie es uns bitte wissen unter: support@chessvis.com",
        "it": "Se il problema persiste e non è legato alla tua connessione, per favore informaci a: support@chessvis.com",
        "pt": "Se isso persistir e não estiver relacionado à sua conexão, por favor nos avise em: support@chessvis.com",
        "sv": "Om det fortsätter och inte beror på din uppkoppling, kontakta oss på: support@chessvis.com"
    },
    {
        "en": "Loading Game",
        "es": "Cargando partida",
        "fr": "Chargement de la partie",
        "de": "Spiel wird geladen",
        "it": "Caricamento della partita",
        "pt": "Carregando jogo",
        "sv": "Läser in parti"
    },
    {
        "en": "Up",
        "es": "Arriba",
        "fr": "Haut",
        "de": "Hoch",
        "it": "Su",
        "pt": "Cima",
        "sv": "Upp"
    },
    {
        "en": "Down",
        "es": "Abajo",
        "fr": "Bas",
        "de": "Runter",
        "it": "Giù",
        "pt": "Baixo",
        "sv": "Ner"
    },
    {
        "en": "You have now left",
        "es": "Ahora has salido",
        "fr": "Vous avez maintenant quitté",
        "de": "Du hast jetzt verlassen",
        "it": "Hai appena lasciato",
        "pt": "Você saiu agora",
        "sv": "Du har nu lämnat"
    },
    {
        "en": "Please note it's possible you had not joined that tournament. No indication is available to this app",
        "es": "Ten en cuenta que es posible que no te hayas unido a ese torneo. Esta aplicación no tiene forma de saberlo",
        "fr": "Notez qu’il est possible que vous ne vous soyez pas inscrit à ce tournoi. Cette application ne peut pas le vérifier",
        "de": "Bitte beachte, dass du diesem Turnier möglicherweise nicht beigetreten bist. Diese App kann das nicht feststellen",
        "it": "Tieni presente che potresti non esserti iscritto a quel torneo. L'app non può verificarlo",
        "pt": "Observe que é possível que você não tenha entrado nesse torneio. O aplicativo não tem como saber disso",
        "sv": "Observera att du kanske inte anmält dig till turneringen — appen har ingen indikation på det"
    },
    {
        "en": "Pairings sometimes take a little while to show up so use the 'Refresh' button on that screen every so often",
        "es": "Los emparejamientos a veces tardan un poco en aparecer, así que usa el botón 'Actualizar' en esa pantalla de vez en cuando",
        "fr": "Les appariements mettent parfois un peu de temps à apparaître, alors utilisez le bouton 'Actualiser' de temps en temps",
        "de": "Die Paarungen brauchen manchmal etwas Zeit, um angezeigt zu werden, also nutze ab und zu die Schaltfläche 'Aktualisieren'",
        "it": "Gli abbinamenti a volte impiegano un po' a comparire, quindi usa di tanto in tanto il pulsante 'Aggiorna' su quella schermata",
        "pt": "Os emparelhamentos às vezes demoram um pouco para aparecer, então use o botão 'Atualizar' nessa tela de vez em quando",
        "sv": "Parningar kan dröja — använd 'Uppdatera' då och då"
    },
    {
        "en": "At that time, go to the 'Open Games List' on the 'Lichess Menu' to get your pairing.",
        "es": "En ese momento, ve a la 'Lista de Partidas Abiertas' en el 'Menú de Lichess' para ver tu emparejamiento.",
        "fr": "À ce moment-là, allez dans la 'Liste des parties ouvertes' du 'Menu Lichess' pour obtenir votre appariement.",
        "de": "Gehe dann zur 'Liste offener Spiele' im 'Lichess-Menü', um dein Paarungsspiel zu sehen.",
        "it": "A quel punto, vai su 'Elenco Partite Aperte' nel 'Menu di Lichess' per ottenere il tuo abbinamento.",
        "pt": "Nesse momento, vá até a 'Lista de Jogos Abertos' no 'Menu Lichess' para ver seu emparelhamento.",
        "sv": "Gå då till 'Öppna partier' i Lichess-menyn för att hitta din parning."
    },
    {
        "en": "Will start in",
        "es": "Comenzará en",
        "fr": "Commencera dans",
        "de": "Beginnt in",
        "it": "Inizia tra",
        "pt": "Começa em",
        "sv": "Startar om"
    },
    {
        "en": "Has already started.",
        "es": "Ya ha comenzado.",
        "fr": "A déjà commencé.",
        "de": "Hat bereits begonnen.",
        "it": "È già iniziato.",
        "pt": "Já começou.",
        "sv": "Har redan startat."
    },
    {
        "en": "Go to the 'Open Games List' on the 'Lichess Menu' now to see your pairing.",
        "es": "Ve ahora a la 'Lista de Partidas Abiertas' en el 'Menú de Lichess' para ver tu emparejamiento.",
        "fr": "Allez maintenant dans la 'Liste des parties ouvertes' du 'Menu Lichess' pour voir votre appariement.",
        "de": "Gehe jetzt zur 'Liste offener Spiele' im 'Lichess-Menü', um deine Paarung zu sehen.",
        "it": "Vai ora su 'Elenco Partite Aperte' nel 'Menu di Lichess' per vedere il tuo abbinamento.",
        "pt": "Vá agora até a 'Lista de Jogos Abertos' no 'Menu Lichess' para ver seu emparelhamento.",
        "sv": "Gå nu till 'Öppna partier' i Lichess-menyn för att se din parning."
    },
    {
        "en": "Returned Error",
        "es": "Error devuelto",
        "fr": "Erreur renvoyée",
        "de": "Fehler zurückgegeben",
        "it": "Errore restituito",
        "pt": "Erro retornado",
        "sv": "Fel returnerat"
    },
    {
        "en": "Failed. You're probably not eligible",
        "es": "Error. Probablemente no eres elegible",
        "fr": "Échec. Vous n’êtes probablement pas éligible",
        "de": "Fehlgeschlagen. Du bist wahrscheinlich nicht berechtigt",
        "it": "Operazione fallita. Probabilmente non sei idoneo",
        "pt": "Falhou. Provavelmente você não é elegível",
        "sv": "Misslyckades. Du är förmodligen inte behörig"
    },
    {
        "en": "Now for",
        "es": "Ahora para",
        "fr": "Maintenant pour",
        "de": "Jetzt für",
        "it": "Ora per",
        "pt": "Agora para",
        "sv": "Nu för"
    },
    {
        "en": "Now",
        "es": "Ahora",
        "fr": "Maintenant",
        "de": "Jetzt",
        "it": "Adesso",
        "pt": "Agora",
        "sv": "Nu"
    },
    {
        "en": "In",
        "es": "En",
        "fr": "Dans",
        "de": "In",
        "it": "Tra",
        "pt": "Em",
        "sv": "I"
    },
    {
        "en": "for",
        "es": "durante",
        "fr": "pendant",
        "de": "für",
        "it": "per",
        "pt": "por",
        "sv": "för"
    },
    {
        "en": "mins",
        "es": "min",
        "fr": "min",
        "de": "Min",
        "it": "min",
        "pt": "min",
        "sv": "min"
    },
    {
        "en": "Casual",
        "es": "Amistosa",
        "fr": "Amicale",
        "de": "Locker",
        "it": "Amichevole",
        "pt": "Casual",
        "sv": "Vänskapligt"
    },
    {
        "en": "Players",
        "es": "Jugadores",
        "fr": "Joueurs",
        "de": "Spieler",
        "it": "Giocatori",
        "pt": "Jogadores",
        "sv": "Spelare"
    },
    {
        "en": "Attempt to join",
        "es": "Intentar unirse",
        "fr": "Tenter de rejoindre",
        "de": "Versuchen beizutreten",
        "it": "Tentare di unirsi",
        "pt": "Tentar entrar",
        "sv": "Försök att gå med"
    },
    {
        "en": "day",
        "es": "día",
        "fr": "jour",
        "de": "Tag",
        "it": "giorno",
        "pt": "dia",
        "sv": "dag"
    },
    {
        "en": "No Online Friends",
        "es": "Sin amigos en línea",
        "fr": "Aucun ami en ligne",
        "de": "Keine Freunde online",
        "it": "Nessun amico online",
        "pt": "Nenhum amigo online",
        "sv": "Inga vänner online"
    },
    {
        "en": "Lichess Menu",
        "es": "Menú de Lichess",
        "fr": "Menu Lichess",
        "de": "Lichess-Menü",
        "it": "Menu Lichess",
        "pt": "Menu Lichess",
        "sv": "Lichess-menyn"
    },
    {
        "en": "Account Menu",
        "es": "Menú de cuenta",
        "fr": "Menu du compte",
        "de": "Kontomenü",
        "it": "Menu account",
        "pt": "Menu da conta",
        "sv": "Konto-menyn"
    },
    {
        "en": "Web Only",
        "es": "Solo en la web",
        "fr": "Web uniquement",
        "de": "Nur im Web",
        "it": "Solo web",
        "pt": "Somente na web",
        "sv": "Endast webb"
    },
    {
        "en": "Big Button Menu",
        "es": "Menú de botones grandes",
        "fr": "Menu à gros boutons",
        "de": "Großes Tastenmenü",
        "it": "Menu con pulsanti grandi",
        "pt": "Menu de botões grandes",
        "sv": "Meny med stora knappar"
    },
    {
        "en": "Do First",
        "es": "Haz esto primero",
        "fr": "À faire en premier",
        "de": "Zuerst tun",
        "it": "Fai prima questo",
        "pt": "Fazer primeiro",
        "sv": "Gör först"
    },
    {
        "en": "Main Menu",
        "es": "Menú principal",
        "fr": "Menu principal",
        "de": "Hauptmenü",
        "it": "Menu principale",
        "pt": "Menu principal",
        "sv": "Huvudmeny"
    },
    {
        "en": "Return to Big Button Menu",
        "es": "Volver al menú de botones grandes",
        "fr": "Retour au menu des grands boutons",
        "de": "Zurück zum Großtastenmenü",
        "it": "Torna al menu dei pulsanti grandi",
        "pt": "Voltar ao menu de botões grandes",
        "sv": "Åter till meny med stora knappar"
    },
    {
        "en": "Using EyeGaze Buttons",
        "es": "Usando los botones de seguimiento ocular",
        "fr": "Utiliser les boutons EyeGaze",
        "de": "Verwendung der EyeGaze-Tasten",
        "it": "Utilizzo dei pulsanti EyeGaze",
        "pt": "Usando os botões EyeGaze",
        "sv": "Använd EyeGaze-knappar"
    },
    {
        "en": "Run 'Verbal Chess' right inside 'Chessvis'! Access the new Cloud AI Voices and multiple languages. (It's on the right-hand menu.)",
        "es": "¡Ejecuta 'Verbal Chess' directamente dentro de 'Chessvis'! Accede a las nuevas voces de IA en la nube y a varios idiomas. (Está en el menú de la derecha).",
        "fr": "Lancez « Verbal Chess » directement dans « Chessvis » ! Accédez aux nouvelles voix IA dans le cloud et à plusieurs langues. (C’est dans le menu de droite.)",
        "de": "Starte „Verbal Chess“ direkt in „Chessvis“! Nutze die neuen Cloud-KI-Stimmen und mehrere Sprachen. (Du findest es im Menü auf der rechten Seite.)",
        "it": "Esegui 'Verbal Chess' direttamente dentro 'Chessvis'! Accedi alle nuove voci IA nel cloud e a più lingue. (Si trova nel menu a destra.)",
        "pt": "Execute o 'Verbal Chess' diretamente dentro do 'Chessvis'! Acesse as novas vozes de IA na nuvem e vários idiomas. (Está no menu à direita.)",
        "sv": "Kör 'Verbal Chess' direkt i Chessvis! Använd nya molnbaserade AI-röster och flera språk. (Finns i högermenyn.)"
    },
    {
        "en": "Run 'Verbal Chess' right inside 'Chessvis'! Access the new Cloud AI Voices and multiple languages. (It's on the left-hand menu.)",
        "es": "¡Ejecuta 'Verbal Chess' directamente dentro de 'Chessvis'! Accede a las nuevas voces de IA en la nube y a varios idiomas. (Está en el menú de la izquierda.)",
        "fr": "Lancez « Verbal Chess » directement dans « Chessvis » ! Accédez aux nouvelles voix IA dans le cloud et à plusieurs langues. (C’est dans le menu de gauche.)",
        "de": "Starte „Verbal Chess“ direkt in „Chessvis“! Nutze die neuen Cloud-KI-Stimmen und mehrere Sprachen. (Du findest es im Menü auf der linken Seite.)",
        "it": "Esegui 'Verbal Chess' direttamente dentro 'Chessvis'! Accedi alle nuove voci IA nel cloud e a più lingue. (Si trova nel menu a sinistra.)",
        "pt": "Execute o 'Verbal Chess' diretamente dentro do 'Chessvis'! Acesse as novas vozes de IA na nuvem e vários idiomas. (Está no menu à esquerda.)",
        "sv": "Kör 'Verbal Chess' direkt i Chessvis! Använd nya molnbaserade AI-röster och flera språk. (Finns i vänstermenyn.)"
    },
    {
    "en": "Swedish",
    "es": "Sueco",
    "it": "Svedese",
    "de": "Schwedisch",
    "fr": "Suédois",
    "pt": "Sueco",
    "sv": "Svenska"
  },
  {
    "en": "Train smarter. Prepare deeper. Play better.",
    "es": "Entrena mejor. Prepárate a fondo. Juega mejor.",
    "fr": "Entraînez-vous plus intelligemment. Préparez-vous plus en profondeur. Jouez mieux.",
    "de": "Trainiere klüger. Bereite dich gründlicher vor. Spiele besser.",
    "it": "Allenati meglio. Preparati più a fondo. Gioca meglio.",
    "pt": "Treine com inteligência. Prepare-se mais a fundo. Jogue melhor.",
    "sv": "Träna smartare. Förbered dig bättre. Spela bättre."
  },
  {
    "en": "The only chess app built around visualization training and data-driven opening preparation — with an AI coach to close the loop on your games.",
    "es": "La única app de ajedrez creada para entrenar la visualización y preparar aperturas con datos, con un entrenador de IA que te ayuda a aprender de cada partida.",
    "fr": "La seule application d'échecs conçue autour de l'entraînement à la visualisation et de la préparation des ouvertures basée sur les données, avec un coach IA pour tirer des leçons de chacune de vos parties.",
    "de": "Die einzige Schach-App mit Fokus auf Visualisierungstraining und datenbasierter Eröffnungsvorbereitung – mit einem KI-Coach, der dir hilft, aus deinen Partien zu lernen.",
    "it": "L'unica app di scacchi progettata attorno all'allenamento della visualizzazione e alla preparazione delle aperture basata sui dati, con un coach IA che ti aiuta a imparare da ogni partita.",
    "pt": "O único app de xadrez criado para treinar visualização e preparação de aberturas baseada em dados, com um treinador de IA que ajuda você a aprender com cada partida.",
    "sv": "Den enda schackappen byggd kring visualiseringsträning och databaserade öppningsförberedelser – med en AI-coach som hjälper dig att lära dig av dina partier."
  },
  {
    "en": "Start Free — No Account Needed",
    "es": "Empieza gratis — Sin crear cuenta",
    "fr": "Commencez gratuitement — Sans créer de compte",
    "de": "Kostenlos starten – Kein Konto erforderlich",
    "it": "Inizia gratis — Nessun account richiesto",
    "pt": "Comece grátis — Sem precisar de conta",
    "sv": "Kom igång gratis – Inget konto behövs"
  },
  {
    "en": "ChessVis started as a visualization app — it's in the name. While other apps were adding more puzzles, we were asking a harder question: <em>what does it actually take to see the board better?</em> That obsession never went away. It just grew into something bigger.",
    "es": "ChessVis empezó como una app de visualización; el nombre lo dice todo. Mientras otras apps añadían más problemas, nosotros nos hacíamos una pregunta más difícil: <em>¿qué hace falta realmente para ver mejor el tablero?</em> Esa obsesión nunca desapareció. Solo se convirtió en algo mucho más grande.",
    "fr": "ChessVis a commencé comme une application de visualisation — le nom le dit. Pendant que d'autres ajoutaient toujours plus de puzzles, nous nous posions une question plus difficile : <em>que faut-il vraiment pour mieux voir l'échiquier ?</em> Cette obsession ne nous a jamais quittés. Elle est simplement devenue quelque chose de plus grand.",
    "de": "ChessVis begann als App für Visualisierung – der Name sagt es schon. Während andere Apps immer mehr Aufgaben hinzufügten, stellten wir uns eine schwierigere Frage: <em>Was braucht es wirklich, um das Brett besser zu sehen?</em> Diese Leidenschaft hat uns nie losgelassen. Sie ist einfach zu etwas Größerem geworden.",
    "it": "ChessVis è nata come app per la visualizzazione: lo dice il nome. Mentre altre app aggiungevano sempre più puzzle, noi ci facevamo una domanda più difficile: <em>cosa serve davvero per vedere meglio la scacchiera?</em> Quell'ossessione non è mai sparita. È semplicemente diventata qualcosa di più grande.",
    "pt": "O ChessVis começou como um app de visualização — o nome já diz isso. Enquanto outros apps adicionavam mais quebra-cabeças, nós fazíamos uma pergunta mais difícil: <em>o que realmente é preciso para enxergar melhor o tabuleiro?</em> Essa obsessão nunca foi embora. Apenas cresceu e virou algo maior.",
    "sv": "ChessVis började som en app för visualisering – det hörs på namnet. Medan andra appar lade till fler schackproblem ställde vi en svårare fråga: <em>vad krävs egentligen för att se brädet bättre?</em> Den besattheten försvann aldrig. Den växte bara till något större."
  },
  {
    "en": "One app. A complete training loop.",
    "es": "Una sola app. Un entrenamiento completo.",
    "fr": "Une seule application. Un entraînement complet.",
    "de": "Eine App. Ein kompletter Trainingskreislauf.",
    "it": "Un'unica app. Un percorso di allenamento completo.",
    "pt": "Um só app. Um ciclo completo de treinamento.",
    "sv": "En app. Ett komplett träningsflöde."
  },
  {
    "en": "Step 1 · Puzzles & Visualization - Always Free",
    "es": "Paso 1 · Problemas y visualización — Siempre gratis",
    "fr": "Étape 1 · Puzzles et visualisation — Toujours gratuit",
    "de": "Schritt 1 · Aufgaben & Visualisierung – Immer kostenlos",
    "it": "Fase 1 · Puzzle e visualizzazione — Sempre gratis",
    "pt": "Etapa 1 · Quebra-cabeças e visualização — Sempre grátis",
    "sv": "Steg 1 · Schackproblem och visualisering – Alltid gratis"
  },
  {
    "en": "Train in the Tactics Gym",
    "es": "Entrena en el Gimnasio de Táctica",
    "fr": "Entraînez-vous dans la Salle de tactique",
    "de": "Trainiere im Taktik-Gym",
    "it": "Allenati nella Palestra Tattica",
    "pt": "Treine na Academia de Tática",
    "sv": "Träna i Taktikgymmet"
  },
  {
    "en": "Come for the puzzles and visualization. 4.5 million rated puzzles, unique visualized puzzle training, blindfold chess with stepping stones, and board visualization tools no other app has built. The kind of training that makes patterns click.",
    "es": "Ven por los problemas y la visualización. Disfruta de 4,5 millones de problemas con puntuación, entrenamiento único de visualización, ajedrez a ciegas con pasos intermedios y herramientas para visualizar el tablero que ninguna otra app ofrece. Un entrenamiento que hace que los patrones se queden contigo.",
    "fr": "Venez pour les puzzles et la visualisation. Profitez de 4,5 millions de puzzles classés, d'un entraînement unique à la visualisation, des échecs à l'aveugle avec étapes progressives et d'outils de visualisation de l'échiquier qu'aucune autre application ne propose. Un entraînement qui fait vraiment comprendre les schémas.",
    "de": "Komm wegen der Aufgaben und des Visualisierungstrainings. Mit 4,5 Millionen bewerteten Aufgaben, einzigartigem Visualisierungstraining, Blindschach mit Zwischenschritten und Werkzeugen zur Brettvisualisierung, die es sonst nirgends gibt. Ein Training, bei dem Muster wirklich hängen bleiben.",
    "it": "Vieni per i puzzle e la visualizzazione. Troverai 4,5 milioni di puzzle classificati, un allenamento unico alla visualizzazione, scacchi alla cieca con passaggi guidati e strumenti per visualizzare la scacchiera che nessun'altra app offre. Un allenamento che ti fa riconoscere davvero gli schemi.",
    "pt": "Venha pelos quebra-cabeças e pela visualização. São 4,5 milhões de quebra-cabeças ranqueados, treinamento exclusivo de visualização, xadrez às cegas com etapas guiadas e ferramentas de visualização do tabuleiro que nenhum outro app oferece. Um treinamento que faz os padrões ficarem naturais.",
    "sv": "Kom för schackproblemen och visualiseringsträningen. Här finns 4,5 miljoner rankade problem, unik visualiseringsträning, blindschack med stegvis hjälp och verktyg för brädvisualisering som ingen annan app erbjuder. Träning som får mönstren att verkligen fastna."
  },
  {
    "en": "4.5M+ puzzles, never repeated",
    "es": "Más de 4,5 millones de problemas, sin repetir",
    "fr": "Plus de 4,5 millions de puzzles, sans répétition",
    "de": "Über 4,5 Mio. Aufgaben – keine Wiederholungen",
    "it": "Oltre 4,5 milioni di puzzle, mai ripetuti",
    "pt": "Mais de 4,5 milhões de quebra-cabeças, sem repetição",
    "sv": "Över 4,5 miljoner schackproblem – aldrig samma två gånger"
  },
  {
    "en": "Visualized puzzles — unique to ChessVis",
    "es": "Problemas visualizados — solo en ChessVis",
    "fr": "Puzzles visualisés — exclusifs à ChessVis",
    "de": "Visualisierte Aufgaben – nur bei ChessVis",
    "it": "Puzzle visualizzati — esclusivi di ChessVis",
    "pt": "Quebra-cabeças visualizados — exclusivos do ChessVis",
    "sv": "Visualiserade schackproblem – unikt för ChessVis"
  },
  {
    "en": "Blindfold chess with stepping-stone onboarding",
    "es": "Ajedrez a ciegas con aprendizaje paso a paso",
    "fr": "Échecs à l'aveugle avec apprentissage progressif",
    "de": "Blindschach mit schrittweiser Einführung",
    "it": "Scacchi alla cieca con apprendimento graduale",
    "pt": "Xadrez às cegas com aprendizado passo a passo",
    "sv": "Blindschack med stegvis introduktion"
  },
  {
    "en": "Who's Guarding Whom — unique to ChessVis",
    "es": "¿Quién protege a quién? — solo en ChessVis",
    "fr": "Qui protège qui ? — exclusif à ChessVis",
    "de": "Wer deckt wen? – nur bei ChessVis",
    "it": "Chi difende chi? — esclusivo di ChessVis",
    "pt": "Quem protege quem? — exclusivo do ChessVis",
    "sv": "Vem skyddar vem? – unikt för ChessVis"
  },
  {
    "en": "Explore Tactics Gym",
    "es": "Explora el Gimnasio de Táctica",
    "fr": "Découvrir la Salle de tactique",
    "de": "Taktik-Gym entdecken",
    "it": "Scopri la Palestra Tattica",
    "pt": "Explore a Academia de Tática",
    "sv": "Utforska Taktikgymmet"
  },
  {
    "en": "Step 2 · Studio",
    "es": "Paso 2 · Estudio",
    "fr": "Étape 2 · Studio",
    "de": "Schritt 2 · Studio",
    "it": "Fase 2 · Studio",
    "pt": "Etapa 2 · Estúdio",
    "sv": "Steg 2 · Studio"
  },
  {
    "en": "Stay for the Opening Preparation",
    "es": "Quédate por la preparación de aperturas",
    "fr": "Restez pour la préparation des ouvertures",
    "de": "Bleib für die Eröffnungsvorbereitung",
    "it": "Resta per la preparazione delle aperture",
    "pt": "Fique pela preparação de aberturas",
    "sv": "Stanna för öppningsförberedelserna"
  },
  {
    "en": "Most players study openings wrong — memorizing long lines they'll rarely see, against players who don't play like them. ChessVis Opening Mastery is built on 200+ million real games at your rating level, filtered to head-to-head peers. Study the moves that actually matter.",
    "es": "La mayoría estudia las aperturas de la forma equivocada: memorizando variantes largas que casi nunca verá, contra rivales que ni siquiera juegan así. ChessVis Opening Mastery se basa en más de 200 millones de partidas reales de jugadores de tu nivel, filtradas para enfrentamientos entre jugadores como tú. Estudia los movimientos que de verdad importan.",
    "fr": "La plupart des joueurs étudient mal les ouvertures : ils mémorisent de longues variantes qu'ils verront rarement contre des adversaires qui ne jouent même pas ainsi. ChessVis Opening Mastery s'appuie sur plus de 200 millions de parties réelles de joueurs de votre niveau, filtrées pour ne garder que des affrontements entre joueurs comparables. Étudiez les coups qui comptent vraiment.",
    "de": "Die meisten lernen Eröffnungen falsch – sie pauken lange Varianten, die sie kaum jemals aufs Brett bekommen, und das gegen Gegner, die ganz anders spielen. ChessVis Opening Mastery basiert auf über 200 Millionen echten Partien von Spielern deiner Spielstärke, gefiltert nach direkten Duellen zwischen gleichstarken Spielern. Lerne die Züge, die wirklich zählen.",
    "it": "La maggior parte dei giocatori studia le aperture nel modo sbagliato: memorizza lunghe varianti che vedrà di rado contro avversari che non giocano nemmeno così. ChessVis Opening Mastery si basa su oltre 200 milioni di partite reali del tuo livello, filtrate per mostrare solo gli scontri tra giocatori simili a te. Studia le mosse che contano davvero.",
    "pt": "A maioria dos jogadores estuda aberturas do jeito errado: decorando longas variantes que quase nunca verá contra adversários que nem jogam assim. O ChessVis Opening Mastery é baseado em mais de 200 milhões de partidas reais do seu nível, filtradas para mostrar apenas confrontos entre jogadores como você. Estude os lances que realmente importam.",
    "sv": "De flesta pluggar öppningar på fel sätt – de memorerar långa varianter som de nästan aldrig får på brädet, mot spelare som inte ens spelar så. ChessVis Opening Mastery bygger på över 200 miljoner riktiga partier på din nivå, filtrerade till möten mellan jämnstarka spelare. Studera de drag som verkligen spelar roll."
  },
  {
    "en": "Peer-level games — study players like you",
    "es": "Partidas de jugadores de tu nivel",
    "fr": "Parties de joueurs de votre niveau",
    "de": "Partien von Spielern auf deinem Niveau",
    "it": "Partite di giocatori del tuo livello",
    "pt": "Partidas de jogadores do seu nível",
    "sv": "Partier från spelare på din nivå"
  },
  {
    "en": "Middle game impact — unique to ChessVis",
    "es": "Impacto en el medio juego — solo en ChessVis",
    "fr": "Impact sur le milieu de partie — exclusif à ChessVis",
    "de": "Auswirkungen aufs Mittelspiel – nur bei ChessVis",
    "it": "Impatto sul mediogioco — esclusivo di ChessVis",
    "pt": "Impacto no meio-jogo — exclusivo do ChessVis",
    "sv": "Påverkan i mittspelet – unikt för ChessVis"
  },
  {
    "en": "Repertoire builder with spaced repetition drill",
    "es": "Creador de repertorios con repaso espaciado",
    "fr": "Créateur de répertoire avec révision espacée",
    "de": "Repertoire-Builder mit verteilter Wiederholung",
    "it": "Costruttore di repertorio con ripetizione dilazionata",
    "pt": "Construtor de repertório com repetição espaçada",
    "sv": "Repertoarbyggare med utspridd repetition"
  },
  {
    "en": "Practice into the middle game — find your weak branches",
    "es": "Practica hasta el medio juego y descubre tus variantes débiles",
    "fr": "Entraînez-vous jusqu'au milieu de partie et repérez vos variantes faibles",
    "de": "Trainiere bis ins Mittelspiel und finde deine schwachen Varianten",
    "it": "Allenati fino al mediogioco e trova le tue varianti deboli",
    "pt": "Pratique até o meio-jogo e encontre suas linhas mais fracas",
    "sv": "Träna ända in i mittspelet och hitta dina svaga varianter"
  },
  {
    "en": "Explore Studio",
    "es": "Explora Studio",
    "fr": "Découvrir Studio",
    "de": "Studio entdecken",
    "it": "Scopri Studio",
    "pt": "Explore o Estúdio",
    "sv": "Utforska Studio"
  },
  {
    "en": "Step 3 · ChessVis AI",
    "es": "Paso 3 · ChessVis IA",
    "fr": "Étape 3 · ChessVis IA",
    "de": "Schritt 3 · ChessVis KI",
    "it": "Fase 3 · ChessVis IA",
    "pt": "Etapa 3 · ChessVis IA",
    "sv": "Steg 3 · ChessVis AI"
  },
  {
    "en": "Review Your Games with an AI Coach",
    "es": "Analiza tus partidas con un entrenador de IA",
    "fr": "Analysez vos parties avec un coach IA",
    "de": "Analysiere deine Partien mit einem KI-Coach",
    "it": "Analizza le tue partite con un coach IA",
    "pt": "Analise suas partidas com um treinador de IA",
    "sv": "Analysera dina partier med en AI-coach"
  },
  {
    "en": "You've prepared your openings. You've played your games. Now, venture over to ChessVis AI and understand what actually happened. ChessVis AI closes the loop — analyzing your games in plain language, flagging where your preparation held up and where it broke down.",
    "es": "Ya preparaste tus aperturas. Ya jugaste tus partidas. Ahora entra en ChessVis AI y descubre qué pasó realmente. ChessVis AI cierra el ciclo: analiza tus partidas en lenguaje sencillo y te muestra dónde tu preparación funcionó y dónde falló.",
    "fr": "Vous avez préparé vos ouvertures. Vous avez joué vos parties. Passez maintenant à ChessVis AI pour comprendre ce qui s'est vraiment passé. ChessVis AI boucle la boucle en analysant vos parties dans un langage simple et en montrant où votre préparation a tenu… et où elle a échoué.",
    "de": "Du hast deine Eröffnungen vorbereitet. Du hast deine Partien gespielt. Jetzt geh zu ChessVis AI und finde heraus, was wirklich passiert ist. ChessVis AI schließt den Kreis: Es analysiert deine Partien in einfacher Sprache und zeigt dir, wo deine Vorbereitung funktioniert hat – und wo nicht.",
    "it": "Hai preparato le tue aperture. Hai giocato le tue partite. Ora passa a ChessVis AI e scopri cosa è successo davvero. ChessVis AI chiude il cerchio: analizza le tue partite con un linguaggio semplice e ti mostra dove la preparazione ha funzionato e dove è venuta meno.",
    "pt": "Você preparou suas aberturas. Jogou suas partidas. Agora vá para o ChessVis AI e descubra o que realmente aconteceu. O ChessVis AI fecha o ciclo, analisando suas partidas em linguagem simples e mostrando onde sua preparação funcionou e onde falhou.",
    "sv": "Du har förberett dina öppningar. Du har spelat dina partier. Gå nu till ChessVis AI och se vad som faktiskt hände. ChessVis AI sluter cirkeln genom att analysera dina partier på ett enkelt sätt och visa var dina förberedelser höll – och var de brast."
  },
  {
    "en": "Deep game analysis in plain language",
    "es": "Análisis profundo en lenguaje sencillo",
    "fr": "Analyse approfondie en langage clair",
    "de": "Tiefgehende Partienanalyse in einfacher Sprache",
    "it": "Analisi approfondita in linguaggio semplice",
    "pt": "Análise profunda em linguagem simples",
    "sv": "Djup partianalys på enkel svenska"
  },
  {
    "en": "Turning points and critical moments flagged",
    "es": "Momentos clave y puntos de inflexión destacados",
    "fr": "Moments clés et tournants mis en évidence",
    "de": "Schlüsselmomente und Wendepunkte hervorgehoben",
    "it": "Momenti chiave e punti di svolta evidenziati",
    "pt": "Momentos decisivos e pontos de virada destacados",
    "sv": "Avgörande ögonblick och vändpunkter markeras"
  },
  {
    "en": "Monthly credits included with subscription",
    "es": "Créditos mensuales incluidos con la suscripción",
    "fr": "Crédits mensuels inclus avec l'abonnement",
    "de": "Monatliche Guthaben im Abo enthalten",
    "it": "Crediti mensili inclusi nell'abbonamento",
    "pt": "Créditos mensais incluídos na assinatura",
    "sv": "Månadskrediter ingår i abonnemanget"
  },
  {
    "en": "Analyzed for pennies per game",
    "es": "Análisis por solo unos céntimos por partida",
    "fr": "Analyse pour quelques centimes par partie",
    "de": "Analyse für nur wenige Cent pro Partie",
    "it": "Analisi a pochi centesimi per partita",
    "pt": "Análise por apenas alguns centavos por partida",
    "sv": "Analys för bara några ören per parti"
  },
  {
    "en": "Access Chessvis AI while staying in this program",
    "es": "Accede a ChessVis AI sin salir de la aplicación",
    "fr": "Accédez à ChessVis AI sans quitter l'application",
    "de": "Nutze ChessVis AI, ohne diese App zu verlassen",
    "it": "Accedi a ChessVis AI senza uscire dall'app",
    "pt": "Acesse o ChessVis AI sem sair do aplicativo",
    "sv": "Öppna ChessVis AI utan att lämna appen"
  },
  {
    "en": "Why ChessVis?",
    "es": "¿Por qué ChessVis?",
    "fr": "Pourquoi ChessVis ?",
    "de": "Warum ChessVis?",
    "it": "Perché ChessVis?",
    "pt": "Por que ChessVis?",
    "sv": "Varför ChessVis?"
  },
  {
    "en": "Built different from the start",
    "es": "Diseñado de forma diferente desde el principio",
    "fr": "Conçu différemment dès le départ",
    "de": "Von Anfang an anders entwickelt",
    "it": "Progettato in modo diverso fin dall'inizio",
    "pt": "Criado de forma diferente desde o começo",
    "sv": "Byggt annorlunda från första början"
  },
  {
    "en": "ChessVis didn't start by copying other chess apps. It started by asking what visualization training should actually look like — and built the tools to answer that question. No other app has Visualized Puzzles or Who's Guarding Whom because no other app started from the same place.",
    "es": "ChessVis no nació copiando otras apps de ajedrez. Empezó preguntándose cómo debería ser realmente el entrenamiento de visualización y creó las herramientas para responder a esa pregunta. Ninguna otra app tiene Problemas Visualizados o ¿Quién protege a quién? porque ninguna empezó desde ese punto.",
    "fr": "ChessVis n'est pas né en copiant d'autres applications d'échecs. Tout est parti d'une question : à quoi devrait vraiment ressembler l'entraînement à la visualisation ? Puis nous avons créé les outils pour y répondre. Aucune autre application ne propose les Puzzles visualisés ou Qui protège qui ?, parce qu'aucune n'est partie de cette idée.",
    "de": "ChessVis entstand nicht, indem andere Schach-Apps kopiert wurden. Stattdessen begann alles mit der Frage, wie Visualisierungstraining wirklich aussehen sollte – und daraus entstanden die passenden Werkzeuge. Keine andere App bietet Visualisierte Aufgaben oder Wer deckt wen?, weil keine denselben Ausgangspunkt hatte.",
    "it": "ChessVis non è nato copiando altre app di scacchi. È nato chiedendosi come dovrebbe essere davvero l'allenamento della visualizzazione, creando gli strumenti per rispondere a questa domanda. Nessun'altra app offre Puzzle visualizzati o Chi difende chi?, perché nessun'altra è partita dalla stessa idea.",
    "pt": "O ChessVis não nasceu copiando outros apps de xadrez. Ele começou perguntando como deveria ser um verdadeiro treinamento de visualização e criou as ferramentas para responder a essa pergunta. Nenhum outro app tem Quebra-cabeças Visualizados ou Quem protege quem?, porque nenhum começou do mesmo lugar.",
    "sv": "ChessVis började inte med att kopiera andra schackappar. Allt började med frågan hur visualiseringsträning egentligen borde fungera – och sedan byggde vi verktygen för det. Ingen annan app har Visualiserade schackproblem eller Vem skyddar vem?, eftersom ingen annan började på samma sätt."
  },
  {
    "en": "Real data, real rating, real peers",
    "es": "Datos reales, Elo real, rivales reales",
    "fr": "De vraies données, votre vrai Elo, de vrais adversaires",
    "de": "Echte Daten, echte Wertung, echte Gegner",
    "it": "Dati reali, punteggio reale, avversari reali",
    "pt": "Dados reais, rating real, adversários reais",
    "sv": "Riktiga data, riktig rating, riktiga motståndare"
  },
  {
    "en": "Studying the masters is a nice theory. In reality, they don't play like us. ChessVis Opening Mastery is the only tool that filters opening data specifically to your rating bracket — head-to-head games against players within 50 points of you. That's the data that matters.",
    "es": "Estudiar a los maestros suena bien, pero la realidad es otra: ellos no juegan como nosotros. ChessVis Opening Mastery filtra las aperturas según tu nivel, usando partidas entre jugadores con una diferencia de solo 50 puntos de Elo. Esos son los datos que realmente importan.",
    "fr": "Étudier les grands maîtres est une bonne idée en théorie. En pratique, ils ne jouent pas comme nous. ChessVis Opening Mastery est le seul outil qui filtre les données d'ouverture selon votre niveau, à partir de parties entre joueurs à moins de 50 points Elo de vous. Voilà les données qui comptent.",
    "de": "Großmeister zu studieren klingt gut. In der Praxis spielen sie aber nicht wie wir. ChessVis Opening Mastery filtert Eröffnungsdaten speziell für deine Spielstärke – aus Partien gegen Spieler mit höchstens 50 Elo Unterschied. Genau diese Daten sind wichtig.",
    "it": "Studiare i grandi maestri è una bella teoria. Nella pratica, però, non giocano come noi. ChessVis Opening Mastery filtra i dati delle aperture in base al tuo livello, usando partite tra giocatori con meno di 50 punti Elo di differenza. Sono questi i dati che contano.",
    "pt": "Estudar os grandes mestres parece uma boa ideia. Na prática, eles não jogam como nós. O ChessVis Opening Mastery filtra dados de aberturas especificamente para o seu nível, usando partidas entre jogadores com até 50 pontos de diferença de rating. Esses são os dados que realmente importam.",
    "sv": "Att studera stormästare låter bra i teorin. I verkligheten spelar de inte som vi. ChessVis Opening Mastery filtrerar öppningsdata efter din rating, med partier mot spelare inom 50 ratingpoäng från dig. Det är den statistiken som verkligen betyder något."
  },
  {
    "en": "A complete loop, not a collection of features",
    "es": "Un entrenamiento completo, no solo un montón de funciones",
    "fr": "Un cycle complet, pas juste une liste de fonctionnalités",
    "de": "Ein kompletter Trainingskreislauf statt einzelner Funktionen",
    "it": "Un percorso completo, non solo una raccolta di funzioni",
    "pt": "Um ciclo completo, não apenas um monte de recursos",
    "sv": "Ett komplett träningsflöde, inte bara en samling funktioner"
  },
  {
    "en": "Train your pattern recognition in the Tactics Gym. Build your opening preparation in Studio. Review your actual games with the AI coach. Each part feeds the next. That's not an accident — it's the point.",
    "es": "Entrena tu reconocimiento de patrones en el Gimnasio de Táctica. Prepara tus aperturas en Studio. Analiza tus partidas con el entrenador de IA. Cada parte alimenta a la siguiente. No es casualidad: esa es la idea.",
    "fr": "Travaillez votre reconnaissance des schémas dans la Salle de tactique. Préparez vos ouvertures dans Studio. Analysez vos parties avec le coach IA. Chaque étape nourrit la suivante. C'est voulu.",
    "de": "Trainiere dein Stellungserkennen im Taktik-Gym. Bereite deine Eröffnungen im Studio vor. Analysiere deine Partien mit dem KI-Coach. Alles greift ineinander. Genau das ist der Plan.",
    "it": "Allena il riconoscimento degli schemi nella Palestra Tattica. Prepara le aperture in Studio. Analizza le tue partite con il coach IA. Ogni fase alimenta la successiva. È proprio questo il punto.",
    "pt": "Treine seu reconhecimento de padrões na Academia de Tática. Prepare suas aberturas no Estúdio. Analise suas partidas com o treinador de IA. Cada etapa alimenta a seguinte. Essa é a ideia.",
    "sv": "Träna ditt mönsterseende i Taktikgymmet. Bygg din öppningsrepertoar i Studio. Analysera dina partier med AI-coachen. Varje del leder vidare till nästa. Det är hela poängen."
  },
  {
    "en": "Start where you are.",
    "es": "Empieza desde donde estás.",
    "fr": "Commencez là où vous en êtes.",
    "de": "Starte dort, wo du gerade bist.",
    "it": "Inizia da dove sei.",
    "pt": "Comece de onde você está.",
    "sv": "Börja där du är."
  },
  {
    "en": "Tactics Gym puzzles & visualation exercises are completely free. No account, no commitment — just better chess training, right now.",
    "es": "Los problemas y ejercicios de visualización del Gimnasio de Táctica son totalmente gratis. Sin cuenta, sin compromiso: solo mejor entrenamiento de ajedrez, desde ya.",
    "fr": "Les puzzles et exercices de visualisation de la Salle de tactique sont entièrement gratuits. Pas de compte, aucun engagement : juste un meilleur entraînement, dès maintenant.",
    "de": "Die Aufgaben und Visualisierungsübungen im Taktik-Gym sind komplett kostenlos. Kein Konto, keine Verpflichtung – einfach besseres Schachtraining.",
    "it": "I puzzle e gli esercizi di visualizzazione della Palestra Tattica sono completamente gratuiti. Nessun account, nessun impegno: solo allenamento migliore, subito.",
    "pt": "Os quebra-cabeças e exercícios de visualização da Academia de Tática são totalmente grátis. Sem conta, sem compromisso: apenas um treinamento melhor, agora mesmo.",
    "sv": "Schackproblemen och visualiseringsövningarna i Taktikgymmet är helt gratis. Inget konto, inga krav – bara bättre schackträning direkt."
  },
  {
    "en": "Start Free",
    "es": "Empieza gratis",
    "fr": "Commencer gratuitement",
    "de": "Kostenlos starten",
    "it": "Inizia gratis",
    "pt": "Comece grátis",
    "sv": "Kom igång gratis"
  },
  {
    "en": "Home Menu",
    "es": "Menú principal",
    "fr": "Menu principal",
    "de": "Hauptmenü",
    "it": "Menu principale",
    "pt": "Menu inicial",
    "sv": "Huvudmeny"
  },
  {
    "en": "Tactics Gym",
    "es": "Gimnasio de Táctica",
    "fr": "Salle de tactique",
    "de": "Taktik-Gym",
    "it": "Palestra Tattica",
    "pt": "Academia de Tática",
    "sv": "Taktikgymmet"
  },
  {
    "en": "Studio",
    "es": "Studio",
    "fr": "Studio",
    "de": "Studio",
    "it": "Studio",
    "pt": "Estúdio",
    "sv": "Studio"
  },
  {
    "en": "Sign-In",
    "es": "Iniciar sesión",
    "fr": "Se connecter",
    "de": "Anmelden",
    "it": "Accedi",
    "pt": "Entrar",
    "sv": "Logga in"
  },
  {
    "en": "View Subscription Options",
    "es": "Ver opciones de suscripción",
    "fr": "Voir les abonnements",
    "de": "Abos ansehen",
    "it": "Vedi le opzioni di abbonamento",
    "pt": "Ver opções de assinatura",
    "sv": "Visa abonnemang"
  },
  {
    "en": "OK",
    "es": "Aceptar",
    "fr": "OK",
    "de": "OK",
    "it": "OK",
    "pt": "OK",
    "sv": "OK"
  },
  {
    "en": "Sign In",
    "es": "Iniciar sesión",
    "fr": "Se connecter",
    "de": "Anmelden",
    "it": "Accedi",
    "pt": "Entrar",
    "sv": "Logga in"
  },
  {
    "en": "Sign in to your ChessVis account",
    "es": "Inicia sesión en tu cuenta de ChessVis",
    "fr": "Connectez-vous à votre compte ChessVis",
    "de": "Melde dich bei deinem ChessVis-Konto an",
    "it": "Accedi al tuo account ChessVis",
    "pt": "Entre na sua conta ChessVis",
    "sv": "Logga in på ditt ChessVis-konto"
  },
  {
    "en": "Create a new ChessVis account",
    "es": "Crea una nueva cuenta de ChessVis",
    "fr": "Créer un compte ChessVis",
    "de": "Neues ChessVis-Konto erstellen",
    "it": "Crea un nuovo account ChessVis",
    "pt": "Crie uma nova conta ChessVis",
    "sv": "Skapa ett nytt ChessVis-konto"
  },
  {
    "en": "Sign Off",
    "es": "Cerrar sesión",
    "fr": "Se déconnecter",
    "de": "Abmelden",
    "it": "Esci",
    "pt": "Sair",
    "sv": "Logga ut"
  },
  {
    "en": "Sign off of your ChessVis account",
    "es": "Cerrar sesión de tu cuenta de ChessVis",
    "fr": "Se déconnecter de votre compte ChessVis",
    "de": "Von deinem ChessVis-Konto abmelden",
    "it": "Esci dal tuo account ChessVis",
    "pt": "Sair da sua conta ChessVis",
    "sv": "Logga ut från ditt ChessVis-konto"
  },
  {
    "en": "Verified address needed to subscribe",
    "es": "Necesitas verificar tu dirección de correo para suscribirte",
    "fr": "Une adresse e-mail vérifiée est requise pour s'abonner",
    "de": "Für ein Abo ist eine bestätigte E-Mail-Adresse erforderlich",
    "it": "Per abbonarti serve un indirizzo email verificato",
    "pt": "É necessário verificar seu e-mail para assinar",
    "sv": "Du behöver en verifierad e-postadress för att prenumerera"
  },
  {
    "en": "Email Address Verified",
    "es": "Correo electrónico verificado",
    "fr": "Adresse e-mail vérifiée",
    "de": "E-Mail-Adresse bestätigt",
    "it": "Indirizzo email verificato",
    "pt": "E-mail verificado",
    "sv": "E-postadressen är verifierad"
  },
  {
    "en": "Thanks for verifying your email address",
    "es": "Gracias por verificar tu correo electrónico",
    "fr": "Merci d'avoir vérifié votre adresse e-mail",
    "de": "Danke, dass du deine E-Mail-Adresse bestätigt hast",
    "it": "Grazie per aver verificato il tuo indirizzo email",
    "pt": "Obrigado por verificar seu e-mail",
    "sv": "Tack för att du verifierade din e-postadress"
  },
  {
    "en": "Access",
    "es": "Acceso",
    "fr": "Accès",
    "de": "Zugriff",
    "it": "Accesso",
    "pt": "Acesso",
    "sv": "Åtkomst"
  },
  {
    "en": "Subscription",
    "es": "Suscripción",
    "fr": "Abonnement",
    "de": "Abonnement",
    "it": "Abbonamento",
    "pt": "Assinatura",
    "sv": "Prenumeration"
  },
  {
    "en": "App settings, board style and language",
    "es": "Ajustes, estilo del tablero e idioma",
    "fr": "Paramètres, style de l'échiquier et langue",
    "de": "App-Einstellungen, Brettstil und Sprache",
    "it": "Impostazioni, stile della scacchiera e lingua",
    "pt": "Configurações, estilo do tabuleiro e idioma",
    "sv": "Inställningar, brädstil och språk"
  },
  {
    "en": "Leaving",
    "es": "Saliendo",
    "fr": "Vous quittez",
    "de": "Du verlässt",
    "it": "Uscita",
    "pt": "Saindo",
    "sv": "Lämnar"
  },
   {
    "en": "Permanently delete your account and data",
    "es": "Eliminar tu cuenta y tus datos para siempre",
    "fr": "Supprimer définitivement votre compte et vos données",
    "de": "Dein Konto und alle Daten dauerhaft löschen",
    "it": "Elimina definitivamente il tuo account e i tuoi dati",
    "pt": "Excluir permanentemente sua conta e seus dados",
    "sv": "Radera ditt konto och dina data permanent"
  },
  {
    "en": "Cancel renewal of your subscription",
    "es": "Cancelar la renovación de tu suscripción",
    "fr": "Annuler le renouvellement de votre abonnement",
    "de": "Automatische Verlängerung deines Abos kündigen",
    "it": "Annulla il rinnovo dell'abbonamento",
    "pt": "Cancelar a renovação da sua assinatura",
    "sv": "Avsluta förnyelsen av din prenumeration"
  },
  {
    "en": "Opening Mastery Videos",
    "es": "Videos de Opening Mastery",
    "fr": "Vidéos Opening Mastery",
    "de": "Opening-Mastery-Videos",
    "it": "Video di Opening Mastery",
    "pt": "Vídeos do Opening Mastery",
    "sv": "Opening Mastery-videor"
  },
  {
    "en": "Opening — Find Opponent Moves",
    "es": "Aperturas — Encuentra las jugadas de tus rivales",
    "fr": "Ouvertures — Trouver les coups de vos adversaires",
    "de": "Eröffnung – Gegnerzüge finden",
    "it": "Aperture — Trova le mosse degli avversari",
    "pt": "Aberturas — Encontre os lances dos adversários",
    "sv": "Öppningar – Hitta motståndarens drag"
  },
  {
    "en": "How to find the moves your opponents play",
    "es": "Cómo encontrar las jugadas que hacen tus rivales",
    "fr": "Comment trouver les coups joués par vos adversaires",
    "de": "So findest du die Züge deiner Gegner",
    "it": "Come trovare le mosse giocate dai tuoi avversari",
    "pt": "Como encontrar os lances que seus adversários jogam",
    "sv": "Så hittar du dragen som dina motståndare spelar"
  },
  {
    "en": "Opening — Find Your Best Moves",
    "es": "Aperturas — Encuentra tus mejores jugadas",
    "fr": "Ouvertures — Trouver vos meilleurs coups",
    "de": "Eröffnung – Deine besten Züge finden",
    "it": "Aperture — Trova le tue mosse migliori",
    "pt": "Aberturas — Encontre seus melhores lances",
    "sv": "Öppningar – Hitta dina bästa drag"
  },
  {
    "en": "How to find your strongest responses",
    "es": "Cómo encontrar tus respuestas más fuertes",
    "fr": "Comment trouver vos meilleures réponses",
    "de": "So findest du deine stärksten Antworten",
    "it": "Come trovare le tue risposte migliori",
    "pt": "Como encontrar suas melhores respostas",
    "sv": "Så hittar du dina starkaste svar"
  },
  {
    "en": "Building and drilling your repertoire",
    "es": "Crear y practicar tu repertorio",
    "fr": "Construire et travailler votre répertoire",
    "de": "Dein Repertoire aufbauen und trainieren",
    "it": "Creare e allenare il tuo repertorio",
    "pt": "Montando e treinando seu repertório",
    "sv": "Bygg och träna ditt repertoar"
  },
  {
    "en": "Tactics Gym Videos",
    "es": "Videos del Gimnasio de Táctica",
    "fr": "Vidéos de la Salle de tactique",
    "de": "Taktik-Gym-Videos",
    "it": "Video della Palestra Tattica",
    "pt": "Vídeos da Academia de Tática",
    "sv": "Videor om Taktikgymmet"
  },
  {
    "en": "How Puzzle Visualization works",
    "es": "Cómo funciona la visualización de problemas",
    "fr": "Comment fonctionne la visualisation des puzzles",
    "de": "So funktioniert die Aufgaben-Visualisierung",
    "it": "Come funziona la visualizzazione dei puzzle",
    "pt": "Como funciona a visualização dos quebra-cabeças",
    "sv": "Så fungerar visualisering av schackproblem"
  },
  {
    "en": "Introduction to the guarding exercise",
    "es": "Introducción al ejercicio de defensa",
    "fr": "Introduction à l'exercice Qui protège qui ?",
    "de": "Einführung in die Deckungsübung",
    "it": "Introduzione all'esercizio sulle difese",
    "pt": "Introdução ao exercício de proteção",
    "sv": "Introduktion till bevakningsövningen"
  },
  {
    "en": "Just - Whoo",
    "es": "Solo - ¡Uau!",
    "fr": "Juste - Wouah !",
    "de": "Einfach – Wow!",
    "it": "Solo - Wow!",
    "pt": "Só - Uau!",
    "sv": "Bara – Wow!"
  },
  {
    "en": "Legacy Videos",
    "es": "Videos clásicos",
    "fr": "Vidéos classiques",
    "de": "Ältere Videos",
    "it": "Video classici",
    "pt": "Vídeos clássicos",
    "sv": "Äldre videor"
  },
  {
    "en": "Legacy — Repertoires",
    "es": "Clásico — Repertorios",
    "fr": "Classique — Répertoires",
    "de": "Klassisch – Repertoires",
    "it": "Classico — Repertori",
    "pt": "Clássico — Repertórios",
    "sv": "Klassiskt – Repertoarer"
  },
  {
    "en": "Classic repertoire tools walkthrough",
    "es": "Guía de las herramientas clásicas de repertorio",
    "fr": "Présentation des outils classiques de répertoire",
    "de": "Einführung in die klassischen Repertoire-Werkzeuge",
    "it": "Guida agli strumenti classici per il repertorio",
    "pt": "Guia das ferramentas clássicas de repertório",
    "sv": "Genomgång av de klassiska repertoarverktygen"
  },
  {
    "en": "Legacy — Master Player Games",
    "es": "Clásico — Partidas de maestros",
    "fr": "Classique — Parties de grands maîtres",
    "de": "Klassisch – Meisterpartien",
    "it": "Classico — Partite dei maestri",
    "pt": "Clássico — Partidas de mestres",
    "sv": "Klassiskt – Mästarnas partier"
  },
  {
    "en": "Using the master player explorer",
    "es": "Cómo usar el explorador de maestros",
    "fr": "Utiliser l'explorateur de grands maîtres",
    "de": "Den Meisterspieler-Explorer verwenden",
    "it": "Come usare l'esploratore dei maestri",
    "pt": "Como usar o explorador de mestres",
    "sv": "Så använder du mästarutforskaren"
  },
  {
    "en": "Legacy — Play Game Collection",
    "es": "Clásico — Jugar una colección de partidas",
    "fr": "Classique — Jouer une collection de parties",
    "de": "Klassisch – Partiensammlung spielen",
    "it": "Classico — Gioca una raccolta di partite",
    "pt": "Clássico — Jogar coleção de partidas",
    "sv": "Klassiskt – Spela en partisamling"
  },
  {
    "en": "Playing against game collections",
    "es": "Jugar contra colecciones de partidas",
    "fr": "Jouer contre des collections de parties",
    "de": "Gegen Partiensammlungen spielen",
    "it": "Giocare contro raccolte di partite",
    "pt": "Jogar contra coleções de partidas",
    "sv": "Spela mot partisamlingar"
  },
   {
    "en": "Launch the large button navigation",
    "es": "Abrir la navegación con botones grandes",
    "fr": "Ouvrir la navigation à gros boutons",
    "de": "Navigation mit großen Schaltflächen starten",
    "it": "Apri la navigazione con pulsanti grandi",
    "pt": "Abrir a navegação com botões grandes",
    "sv": "Öppna navigering med stora knappar"
  },
  {
    "en": "Configure big button and eye gaze settings",
    "es": "Configurar los botones grandes y el control con la mirada",
    "fr": "Configurer les gros boutons et le suivi du regard",
    "de": "Große Schaltflächen und Blicksteuerung einrichten",
    "it": "Configura i pulsanti grandi e il controllo con lo sguardo",
    "pt": "Configurar botões grandes e controle pelo olhar",
    "sv": "Ställ in stora knappar och ögonstyrning"
  },
  {
    "en": "Introduction and overview of ChessVis",
    "es": "Introducción y presentación de ChessVis",
    "fr": "Présentation et vue d'ensemble de ChessVis",
    "de": "Einführung und Überblick über ChessVis",
    "it": "Introduzione e panoramica di ChessVis",
    "pt": "Introdução e visão geral do ChessVis",
    "sv": "Introduktion och översikt över ChessVis"
  },
  {
    "en": "Latest updates and improvements",
    "es": "Últimas novedades y mejoras",
    "fr": "Dernières nouveautés et améliorations",
    "de": "Neueste Updates und Verbesserungen",
    "it": "Ultimi aggiornamenti e miglioramenti",
    "pt": "Últimas atualizações e melhorias",
    "sv": "Senaste uppdateringarna och förbättringarna"
  },
  {
    "en": "Get in touch with support",
    "es": "Contactar con soporte",
    "fr": "Contacter l'assistance",
    "de": "Support kontaktieren",
    "it": "Contatta l'assistenza",
    "pt": "Fale com o suporte",
    "sv": "Kontakta supporten"
  },
  {
    "en": "ChessVis terms and privacy policy",
    "es": "Términos y política de privacidad de ChessVis",
    "fr": "Conditions d'utilisation et politique de confidentialité de ChessVis",
    "de": "Nutzungsbedingungen und Datenschutzerklärung von ChessVis",
    "it": "Termini e informativa sulla privacy di ChessVis",
    "pt": "Termos e política de privacidade do ChessVis",
    "sv": "ChessVis användarvillkor och integritetspolicy"
  },
  {
    "en": "Sign in, subscribe & prefs",
    "es": "Iniciar sesión, suscribirse y preferencias",
    "fr": "Connexion, abonnement et préférences",
    "de": "Anmelden, Abo und Einstellungen",
    "it": "Accesso, abbonamento e preferenze",
    "pt": "Entrar, assinatura e preferências",
    "sv": "Logga in, prenumeration och inställningar"
  },
  {
    "en": "Tutorials & feature guides",
    "es": "Tutoriales y guías de funciones",
    "fr": "Tutoriels et guides des fonctionnalités",
    "de": "Tutorials und Funktionsanleitungen",
    "it": "Tutorial e guide alle funzioni",
    "pt": "Tutoriais e guias de recursos",
    "sv": "Guider och genomgångar"
  },
  {
    "en": "Accessibility settings",
    "es": "Opciones de accesibilidad",
    "fr": "Paramètres d'accessibilité",
    "de": "Bedienungshilfen",
    "it": "Impostazioni di accessibilità",
    "pt": "Configurações de acessibilidade",
    "sv": "Tillgänglighetsinställningar"
  },
  {
    "en": "Help, contact & what's new",
    "es": "Ayuda, contacto y novedades",
    "fr": "Aide, contact et nouveautés",
    "de": "Hilfe, Kontakt und Neuigkeiten",
    "it": "Aiuto, contatti e novità",
    "pt": "Ajuda, contato e novidades",
    "sv": "Hjälp, kontakt och nyheter"
  },
  {
    "en": "Data-driven opening explorer — 200M+ peer-level games",
    "es": "Explorador de aperturas basado en datos — más de 200 millones de partidas de jugadores de tu nivel",
    "fr": "Explorateur d'ouvertures basé sur les données — plus de 200 millions de parties de joueurs de votre niveau",
    "de": "Datengestützter Eröffnungs-Explorer – über 200 Mio. Partien von Spielern deiner Spielstärke",
    "it": "Esploratore di aperture basato sui dati — oltre 200 milioni di partite di giocatori del tuo livello",
    "pt": "Explorador de aberturas baseado em dados — mais de 200 milhões de partidas de jogadores do seu nível",
    "sv": "Datadriven öppningsutforskare – över 200 miljoner partier från spelare på din nivå"
  },
  {
    "en": "Import your games from chess.com and lichess.org",
    "es": "Importa tus partidas de chess.com y lichess.org",
    "fr": "Importez vos parties depuis chess.com et lichess.org",
    "de": "Importiere deine Partien von chess.com und lichess.org",
    "it": "Importa le tue partite da chess.com e lichess.org",
    "pt": "Importe suas partidas do chess.com e lichess.org",
    "sv": "Importera dina partier från chess.com och lichess.org"
  },
  {
    "en": "Run your games through the Opening Explorer",
    "es": "Analiza tus partidas con el Explorador de Aperturas",
    "fr": "Analysez vos parties avec l'Explorateur d'ouvertures",
    "de": "Analysiere deine Partien mit dem Eröffnungs-Explorer",
    "it": "Analizza le tue partite con l'Esploratore delle aperture",
    "pt": "Analise suas partidas no Explorador de Aberturas",
    "sv": "Analysera dina partier med Öppningsutforskaren"
  },
  {
    "en": "Build",
    "es": "Crear",
    "fr": "Créer",
    "de": "Erstellen",
    "it": "Crea",
    "pt": "Criar",
    "sv": "Bygg"
  },
  {
    "en": "Create and manage your repertoire library",
    "es": "Crea y organiza tu biblioteca de repertorios",
    "fr": "Créez et gérez votre bibliothèque de répertoires",
    "de": "Erstelle und verwalte deine Repertoire-Bibliothek",
    "it": "Crea e gestisci la tua libreria di repertori",
    "pt": "Crie e gerencie sua biblioteca de repertórios",
    "sv": "Skapa och hantera ditt repertoarbibliotek"
  },
  {
    "en": "Build your opening lines move by move",
    "es": "Construye tus variantes apertura por apertura",
    "fr": "Construisez vos variantes coup par coup",
    "de": "Baue deine Eröffnungsvarianten Zug für Zug auf",
    "it": "Costruisci le tue varianti mossa dopo mossa",
    "pt": "Monte suas linhas de abertura lance a lance",
    "sv": "Bygg dina öppningsvarianter drag för drag"
  },
  {
    "en": "See your entire repertoire as a branching tree",
    "es": "Visualiza todo tu repertorio como un árbol de variantes",
    "fr": "Visualisez tout votre répertoire sous forme d'arborescence",
    "de": "Sieh dein gesamtes Repertoire als Variantenbaum",
    "it": "Visualizza tutto il tuo repertorio come un albero di varianti",
    "pt": "Veja todo o seu repertório como uma árvore de variantes",
    "sv": "Se hela ditt repertoar som ett förgreningsträd"
  },
  {
    "en": "Train",
    "es": "Entrenar",
    "fr": "S'entraîner",
    "de": "Trainieren",
    "it": "Allenati",
    "pt": "Treinar",
    "sv": "Träna"
  },
  {
    "en": "Daily spaced repetition of your repertoire moves",
    "es": "Repaso diario con repetición espaciada",
    "fr": "Révision quotidienne avec répétition espacée",
    "de": "Tägliches Training mit verteilter Wiederholung",
    "it": "Ripasso quotidiano con ripetizione dilazionata",
    "pt": "Revisão diária com repetição espaçada",
    "sv": "Daglig repetition med intervaller"
  },
  {
    "en": "Extend play into the middle game — find your weak branches",
    "es": "Juega hasta el medio juego y descubre tus variantes débiles",
    "fr": "Prolongez jusqu'au milieu de partie et repérez vos variantes faibles",
    "de": "Spiele bis ins Mittelspiel und finde deine schwachen Varianten",
    "it": "Prosegui fino al mediogioco e trova le tue varianti deboli",
    "pt": "Continue até o meio-jogo e descubra suas linhas mais fracas",
    "sv": "Spela vidare till mittspelet och hitta dina svaga varianter"
  },
  {
    "en": "Transfer",
    "es": "Exportar",
    "fr": "Exporter",
    "de": "Exportieren",
    "it": "Esporta",
    "pt": "Exportar",
    "sv": "Exportera"
  },
  {
    "en": "Export your repertoire for use in other tools",
    "es": "Exporta tu repertorio para usarlo en otras herramientas",
    "fr": "Exportez votre répertoire pour l'utiliser dans d'autres outils",
    "de": "Exportiere dein Repertoire für andere Programme",
    "it": "Esporta il tuo repertorio per usarlo in altri strumenti",
    "pt": "Exporte seu repertório para usar em outras ferramentas",
    "sv": "Exportera ditt repertoar för användning i andra verktyg"
  },
   {
    "en": "Opening Explorer — Win/Loss",
    "es": "Explorador de Aperturas — Victorias/Derrotas",
    "fr": "Explorateur d'ouvertures — Victoires/Défaites",
    "de": "Eröffnungs-Explorer – Sieg/Niederlage",
    "it": "Esploratore delle aperture — Vittorie/Sconfitte",
    "pt": "Explorador de Aberturas — Vitórias/Derrotas",
    "sv": "Öppningsutforskare – Vinster/Förluster"
  },
  {
    "en": "Classic win/loss opening statistics",
    "es": "Estadísticas clásicas de victorias y derrotas",
    "fr": "Statistiques classiques de victoires et défaites",
    "de": "Klassische Gewinn-/Verluststatistik",
    "it": "Statistiche classiche di vittorie e sconfitte",
    "pt": "Estatísticas clássicas de vitórias e derrotas",
    "sv": "Klassisk statistik över vinster och förluster"
  },
  {
    "en": "Play against moves from real game collections",
    "es": "Juega contra jugadas de partidas reales",
    "fr": "Jouez contre des coups issus de parties réelles",
    "de": "Spiele gegen Züge aus echten Partiensammlungen",
    "it": "Gioca contro mosse tratte da partite reali",
    "pt": "Jogue contra lances de partidas reais",
    "sv": "Spela mot drag från riktiga partisamlingar"
  },
  {
    "en": "Opening Explorer — Slice/Dice",
    "es": "Explorador de Aperturas — Filtros avanzados",
    "fr": "Explorateur d'ouvertures — Filtres avancés",
    "de": "Eröffnungs-Explorer – Erweiterte Filter",
    "it": "Esploratore delle aperture — Filtri avanzati",
    "pt": "Explorador de Aberturas — Filtros avançados",
    "sv": "Öppningsutforskare – Avancerade filter"
  },
  {
    "en": "Slice and dice opening data by filters",
    "es": "Filtra y analiza los datos de aperturas",
    "fr": "Filtrez et analysez les données d'ouverture",
    "de": "Filtere und analysiere Eröffnungsdaten",
    "it": "Filtra e analizza i dati delle aperture",
    "pt": "Filtre e analise os dados das aberturas",
    "sv": "Filtrera och analysera öppningsdata"
  },
  {
    "en": "Download games for legacy analysis",
    "es": "Descarga partidas para el análisis clásico",
    "fr": "Téléchargez des parties pour l'analyse classique",
    "de": "Partien für die klassische Analyse herunterladen",
    "it": "Scarica partite per l'analisi classica",
    "pt": "Baixe partidas para análise clássica",
    "sv": "Ladda ner partier för klassisk analys"
  },
  {
    "en": "Explore openings from master-level games",
    "es": "Explora aperturas de partidas de maestros",
    "fr": "Explorez les ouvertures des parties de grands maîtres",
    "de": "Eröffnungen aus Meisterpartien erkunden",
    "it": "Esplora le aperture delle partite dei maestri",
    "pt": "Explore aberturas de partidas de mestres",
    "sv": "Utforska öppningar från mästarpartier"
  },
  {
    "en": "Manage your classic repertoires",
    "es": "Gestiona tus repertorios clásicos",
    "fr": "Gérez vos répertoires classiques",
    "de": "Verwalte deine klassischen Repertoires",
    "it": "Gestisci i tuoi repertori classici",
    "pt": "Gerencie seus repertórios clássicos",
    "sv": "Hantera dina klassiska repertoarer"
  },
  {
    "en": "Classic repertoire building tool",
    "es": "Herramienta clásica para crear repertorios",
    "fr": "Outil classique de création de répertoires",
    "de": "Klassisches Werkzeug zum Erstellen von Repertoires",
    "it": "Strumento classico per creare repertori",
    "pt": "Ferramenta clássica para criar repertórios",
    "sv": "Klassiskt verktyg för att bygga repertoarer"
  },
  {
    "en": "Classic tree view of your repertoire",
    "es": "Vista en árbol de tu repertorio",
    "fr": "Vue en arbre de votre répertoire",
    "de": "Klassische Baumansicht deines Repertoires",
    "it": "Vista ad albero del tuo repertorio",
    "pt": "Visualização em árvore do seu repertório",
    "sv": "Klassisk trädvy över ditt repertoar"
  },
  {
    "en": "Classic repertoire practice mode",
    "es": "Modo clásico de práctica del repertorio",
    "fr": "Mode d'entraînement classique du répertoire",
    "de": "Klassischer Repertoire-Trainingsmodus",
    "it": "Modalità classica di allenamento del repertorio",
    "pt": "Modo clássico de treino do repertório",
    "sv": "Klassiskt träningsläge för repertoaren"
  },
  {
    "en": "Export your classic repertoire",
    "es": "Exporta tu repertorio clásico",
    "fr": "Exportez votre répertoire classique",
    "de": "Exportiere dein klassisches Repertoire",
    "it": "Esporta il tuo repertorio classico",
    "pt": "Exporte seu repertório clássico",
    "sv": "Exportera ditt klassiska repertoar"
  },
  {
    "en": "Import repertoires via web",
    "es": "Importa repertorios desde la web",
    "fr": "Importez des répertoires via le Web",
    "de": "Repertoires über das Web importieren",
    "it": "Importa repertori dal web",
    "pt": "Importe repertórios pela web",
    "sv": "Importera repertoarer via webben"
  },
  {
    "en": "Explorer free · Full access with subscription",
    "es": "Explorador gratis · Acceso completo con suscripción",
    "fr": "Explorateur gratuit · Accès complet avec abonnement",
    "de": "Explorer kostenlos · Voller Zugriff mit Abo",
    "it": "Esploratore gratuito · Accesso completo con abbonamento",
    "pt": "Explorador grátis · Acesso completo com assinatura",
    "sv": "Utforskaren är gratis · Full åtkomst med prenumeration"
  },
   {
    "en": "ChessVis Overview",
    "es": "Resumen de ChessVis",
    "fr": "Présentation de ChessVis",
    "de": "Überblick über ChessVis",
    "it": "Panoramica di ChessVis",
    "pt": "Visão geral do ChessVis",
    "sv": "Översikt över ChessVis"
  },
  {
    "en": "Puzzles, Visualization, Blindfold",
    "es": "Problemas, visualización y ajedrez a ciegas",
    "fr": "Puzzles, visualisation et échecs à l'aveugle",
    "de": "Aufgaben, Visualisierung und Blindschach",
    "it": "Puzzle, visualizzazione e scacchi alla cieca",
    "pt": "Quebra-cabeças, visualização e xadrez às cegas",
    "sv": "Schackproblem, visualisering och blindschack"
  },
  {
    "en": "Openings & Repertoire",
    "es": "Aperturas y repertorio",
    "fr": "Ouvertures et répertoire",
    "de": "Eröffnungen & Repertoire",
    "it": "Aperture e repertorio",
    "pt": "Aberturas e repertório",
    "sv": "Öppningar och repertoar"
  },
  {
    "en": "The Stable",
    "es": "El Establo",
    "fr": "L'Écurie",
    "de": "Der Stall",
    "it": "La Scuderia",
    "pt": "O Estábulo",
    "sv": "Stallet"
  },
  {
    "en": "Verbal Chess & AI",
    "es": "Ajedrez por voz e IA",
    "fr": "Échecs vocaux et IA",
    "de": "Sprachschach & KI",
    "it": "Scacchi vocali e IA",
    "pt": "Xadrez por voz e IA",
    "sv": "Röstschack och AI"
  },
  {
    "en": "Settings & preferences",
    "es": "Ajustes y preferencias",
    "fr": "Paramètres et préférences",
    "de": "Einstellungen und Präferenzen",
    "it": "Impostazioni e preferenze",
    "pt": "Configurações e preferências",
    "sv": "Inställningar och preferenser"
  },
  {
    "en": "All exercises here are free — no subscription needed.",
    "es": "Todos los ejercicios son gratis. No necesitas suscripción.",
    "fr": "Tous les exercices sont gratuits. Aucun abonnement n'est nécessaire.",
    "de": "Alle Übungen hier sind kostenlos – kein Abo erforderlich.",
    "it": "Tutti gli esercizi sono gratuiti. Nessun abbonamento richiesto.",
    "pt": "Todos os exercícios aqui são grátis. Não é preciso assinar.",
    "sv": "Alla övningar här är gratis – ingen prenumeration behövs."
  },
  {
    "en": "Thanks for being a Subscriber! -- You have access to both Komodo & Stockfish Engines at all skill levels. Plus All Blindfold Stepping Stones.",
    "es": "¡Gracias por suscribirte! Tienes acceso a los motores Komodo y Stockfish en todos los niveles, además de todos los niveles guiados de ajedrez a ciegas.",
    "fr": "Merci pour votre abonnement ! Vous avez accès aux moteurs Komodo et Stockfish à tous les niveaux, ainsi qu'à tous les niveaux progressifs des échecs à l'aveugle.",
    "de": "Danke für dein Abo! Du hast Zugriff auf Komodo und Stockfish in allen Spielstärken sowie auf alle Blindschach-Zwischenstufen.",
    "it": "Grazie per il tuo abbonamento! Hai accesso ai motori Komodo e Stockfish a tutti i livelli, oltre a tutti i livelli guidati degli scacchi alla cieca.",
    "pt": "Obrigado por assinar! Você tem acesso aos motores Komodo e Stockfish em todos os níveis, além de todos os níveis guiados de xadrez às cegas.",
    "sv": "Tack för att du prenumererar! Du har tillgång till både Komodo och Stockfish på alla nivåer samt alla stegvisa nivåer i blindschack."
  },
  {
    "en": "Your free account gives access to the Komodo Engine at its easiest setting only. For blindfold chess, you'll have two 'stepping stone' levels. See the 'Subscribe' screen for all the subscriber benefits",
    "es": "Con tu cuenta gratuita puedes usar el motor Komodo solo en el nivel más fácil. En ajedrez a ciegas tendrás acceso a dos niveles guiados. Consulta la pantalla «Suscribirse» para ver todas las ventajas.",
    "fr": "Avec votre compte gratuit, vous pouvez utiliser le moteur Komodo uniquement au niveau le plus facile. Pour les échecs à l'aveugle, vous disposez de deux niveaux progressifs. Consultez l'écran « Abonnement » pour découvrir tous les avantages.",
    "de": "Mit deinem kostenlosen Konto kannst du Komodo nur auf der leichtesten Stufe nutzen. Beim Blindschach stehen dir zwei Zwischenstufen zur Verfügung. Auf der Abo-Seite findest du alle Vorteile.",
    "it": "Con l'account gratuito puoi usare il motore Komodo solo al livello più facile. Negli scacchi alla cieca hai a disposizione due livelli guidati. Vai alla schermata «Abbonati» per vedere tutti i vantaggi.",
    "pt": "Sua conta gratuita dá acesso ao motor Komodo apenas no nível mais fácil. No xadrez às cegas, você terá dois níveis guiados. Veja a tela «Assinar» para conhecer todos os benefícios.",
    "sv": "Med ditt gratiskonto får du tillgång till Komodo på den lättaste nivån. I blindschack får du två stegvisa nivåer. Se sidan «Prenumerera» för alla förmåner."
  },
  {
    "en": "Pick up your game in progress",
    "es": "Continúa tu partida",
    "fr": "Reprendre votre partie",
    "de": "Setze deine Partie fort",
    "it": "Riprendi la tua partita",
    "pt": "Continue sua partida",
    "sv": "Fortsätt ditt pågående parti"
  },
  {
    "en": "Play a full game against the engine",
    "es": "Juega una partida completa contra el motor",
    "fr": "Jouez une partie complète contre le moteur",
    "de": "Spiele eine komplette Partie gegen die Engine",
    "it": "Gioca una partita completa contro il motore",
    "pt": "Jogue uma partida completa contra o motor",
    "sv": "Spela ett helt parti mot schackmotorn"
  },
  {
    "en": "Play with no board visible",
    "es": "Juega sin ver el tablero",
    "fr": "Jouez sans voir l'échiquier",
    "de": "Spiele ohne sichtbares Brett",
    "it": "Gioca senza vedere la scacchiera",
    "pt": "Jogue sem ver o tabuleiro",
    "sv": "Spela utan synligt bräde"
  },
  {
    "en": "Review your past blindfold games",
    "es": "Revisa tus partidas a ciegas",
    "fr": "Revoir vos parties à l'aveugle",
    "de": "Sieh dir deine Blindschach-Partien an",
    "it": "Rivedi le tue partite alla cieca",
    "pt": "Revise suas partidas às cegas",
    "sv": "Granska dina blindschackpartier"
  },
  {
    "en": "Solve puzzles without a visible board",
    "es": "Resuelve problemas sin ver el tablero",
    "fr": "Résolvez des puzzles sans voir l'échiquier",
    "de": "Löse Aufgaben ohne sichtbares Brett",
    "it": "Risolvi puzzle senza vedere la scacchiera",
    "pt": "Resolva quebra-cabeças sem ver o tabuleiro",
    "sv": "Lös schackproblem utan synligt bräde"
  },
  {
    "en": "Solve tactical puzzles",
    "es": "Resuelve problemas tácticos",
    "fr": "Résolvez des puzzles tactiques",
    "de": "Löse Taktikaufgaben",
    "it": "Risolvi puzzle tattici",
    "pt": "Resolva quebra-cabeças táticos",
    "sv": "Lös taktiska schackproblem"
  },
  {
    "en": "Solve the Puzzle. Visualized In Your Mind",
    "es": "Resuelve el problema. Visualízalo en tu mente.",
    "fr": "Résolvez le puzzle. Visualisez-le dans votre esprit.",
    "de": "Löse die Aufgabe. Stell sie dir im Kopf vor.",
    "it": "Risolvi il puzzle. Visualizzalo nella tua mente.",
    "pt": "Resolva o quebra-cabeça. Visualize-o na sua mente.",
    "sv": "Lös schackproblemet. Se det framför dig."
  },
  {
    "en": "Race the clock on tactical challenges",
    "es": "Pon a prueba tu velocidad con desafíos tácticos",
    "fr": "Affrontez le chrono avec des défis tactiques",
    "de": "Stelle dich Taktikaufgaben gegen die Uhr",
    "it": "Sfida il tempo con esercizi tattici",
    "pt": "Corra contra o relógio em desafios táticos",
    "sv": "Tävla mot klockan i taktikutmaningar"
  },
  {
    "en": "Visualization puzzles with a time limit",
    "es": "Problemas de visualización contrarreloj",
    "fr": "Puzzles de visualisation chronométrés",
    "de": "Visualisierungsaufgaben mit Zeitlimit",
    "it": "Puzzle di visualizzazione a tempo",
    "pt": "Quebra-cabeças de visualização com limite de tempo",
    "sv": "Visualiseringsproblem med tidsgräns"
  },
  {
    "en": "Save puzzles to play without a connection",
    "es": "Guarda problemas para jugar sin conexión",
    "fr": "Enregistrez des puzzles pour jouer hors ligne",
    "de": "Aufgaben zum Offline-Spielen speichern",
    "it": "Salva i puzzle per giocare offline",
    "pt": "Salve quebra-cabeças para jogar offline",
    "sv": "Spara schackproblem för att spela offline"
  },
  {
    "en": "Play from your downloaded collection",
    "es": "Juega desde tu colección descargada",
    "fr": "Jouez depuis votre collection téléchargée",
    "de": "Spiele aus deiner heruntergeladenen Sammlung",
    "it": "Gioca dalla tua raccolta scaricata",
    "pt": "Jogue da sua coleção baixada",
    "sv": "Spela från din nedladdade samling"
  },
  {
    "en": "Review and export your past puzzles",
    "es": "Revisa y exporta tus problemas anteriores",
    "fr": "Consultez et exportez vos anciens puzzles",
    "de": "Frühere Aufgaben ansehen und exportieren",
    "it": "Rivedi ed esporta i puzzle completati",
    "pt": "Revise e exporte seus quebra-cabeças anteriores",
    "sv": "Granska och exportera dina tidigare schackproblem"
  },
  {
    "en": "Identify piece relationships",
    "es": "Identifica las relaciones entre las piezas",
    "fr": "Identifiez les relations entre les pièces",
    "de": "Erkenne die Beziehungen zwischen den Figuren",
    "it": "Individua le relazioni tra i pezzi",
    "pt": "Identifique as relações entre as peças",
    "sv": "Identifiera relationerna mellan pjäserna"
  },
  {
    "en": "Study positions without moving pieces",
    "es": "Estudia posiciones sin mover las piezas",
    "fr": "Étudiez les positions sans déplacer les pièces",
    "de": "Stellungen studieren, ohne Figuren zu ziehen",
    "it": "Studia le posizioni senza muovere i pezzi",
    "pt": "Estude posições sem mover as peças",
    "sv": "Studera ställningar utan att flytta pjäser"
  },
  {
    "en": "Moves at Random Location",
    "es": "Movimientos desde una posición aleatoria",
    "fr": "Coups depuis une position aléatoire",
    "de": "Züge von einer zufälligen Stellung",
    "it": "Mosse da una posizione casuale",
    "pt": "Lances a partir de uma posição aleatória",
    "sv": "Drag från en slumpmässig position"
  },
  {
    "en": "Visualize moves from any board position",
    "es": "Visualiza jugadas desde cualquier posición",
    "fr": "Visualisez les coups depuis n'importe quelle position",
    "de": "Züge von jeder Brettstellung aus visualisieren",
    "it": "Visualizza le mosse da qualsiasi posizione",
    "pt": "Visualize lances de qualquer posição do tabuleiro",
    "sv": "Visualisera drag från valfri ställning"
  },
  {
    "en": "Moves from Game Beginning",
    "es": "Movimientos desde el inicio de la partida",
    "fr": "Coups depuis le début de la partie",
    "de": "Züge vom Partiebeginn",
    "it": "Mosse dall'inizio della partita",
    "pt": "Lances desde o início da partida",
    "sv": "Drag från partiets början"
  },
  {
    "en": "Trace moves from the opening",
    "es": "Sigue las jugadas desde la apertura",
    "fr": "Suivez les coups depuis l'ouverture",
    "de": "Verfolge die Züge von der Eröffnung an",
    "it": "Segui le mosse dall'apertura",
    "pt": "Acompanhe os lances desde a abertura",
    "sv": "Följ dragen från öppningen"
  },
  {
    "en": "Track individual pieces through a game",
    "es": "Sigue una pieza durante toda la partida",
    "fr": "Suivez une pièce tout au long de la partie",
    "de": "Verfolge eine einzelne Figur durch die Partie",
    "it": "Segui un singolo pezzo durante la partita",
    "pt": "Acompanhe uma peça durante toda a partida",
    "sv": "Följ en enskild pjäs genom hela partiet"
  },
  {
    "en": "Play chess using only your voice",
    "es": "Juega al ajedrez usando solo tu voz",
    "fr": "Joue aux échecs uniquement avec ta voix",
    "de": "Spiele Schach nur mit deiner Stimme",
    "it": "Gioca a scacchi usando solo la tua voce",
    "pt": "Jogue xadrez usando apenas a sua voz",
    "sv": "Spela schack med bara din röst"
  },
  {
    "en": "Your AI chess coach",
    "es": "Tu entrenador de ajedrez con IA",
    "fr": "Ton coach d'échecs IA",
    "de": "Dein KI-Schachtrainer",
    "it": "Il tuo allenatore di scacchi con IA",
    "pt": "Seu treinador de xadrez com IA",
    "sv": "Din AI-schacktränare"
  },
  {
    "en": "The sharpest chess training tools in one place — completely free.",
    "es": "Las mejores herramientas de entrenamiento de ajedrez en un solo lugar, totalmente gratis.",
    "fr": "Les meilleurs outils d'entraînement aux échecs réunis au même endroit, entièrement gratuits.",
    "de": "Die besten Schach-Trainingswerkzeuge an einem Ort – komplett kostenlos.",
    "it": "I migliori strumenti di allenamento per gli scacchi in un unico posto, completamente gratis.",
    "pt": "As melhores ferramentas de treinamento de xadrez em um só lugar — totalmente grátis.",
    "sv": "De bästa träningsverktygen för schack på ett ställe – helt gratis."
  },
  {
    "en": "Puzzles, board visualization, and blindfold chess. Train the skills that separate good players from great ones.",
    "es": "Problemas, visualización del tablero y ajedrez a ciegas. Entrena las habilidades que separan a los buenos jugadores de los grandes.",
    "fr": "Puzzles, visualisation de l'échiquier et jeu à l'aveugle. Développez les compétences qui distinguent les bons joueurs des excellents.",
    "de": "Taktikaufgaben, Brettvisualisierung und Blindschach. Trainiere die Fähigkeiten, die gute von starken Spielern unterscheiden.",
    "it": "Puzzle, visualizzazione della scacchiera e scacchi alla cieca. Allena le abilità che distinguono i buoni giocatori dai grandi giocatori.",
    "pt": "Quebra-cabeças, visualização do tabuleiro e xadrez às cegas. Treine as habilidades que separam bons jogadores dos grandes jogadores.",
    "sv": "Problem, brädvisualisering och blindschack. Träna färdigheterna som skiljer bra spelare från riktigt starka."
  },
  {
    "en": "4.5 Million Puzzles — and Counting",
    "es": "4,5 millones de problemas... y sumando.",
    "fr": "4,5 millions de puzzles... et ce n'est pas fini.",
    "de": "4,5 Millionen Aufgaben – und es werden mehr.",
    "it": "4,5 milioni di puzzle... e continuano ad aumentare.",
    "pt": "4,5 milhões de quebra-cabeças — e aumentando.",
    "sv": "4,5 miljoner problem – och fler tillkommer."
  },
  {
    "en": "ChessVis starts with the entire Lichess puzzle library — over 4.5 million categorized and rated puzzles — and builds on top of it with features you won't find anywhere else.",
    "es": "ChessVis incluye toda la biblioteca de problemas de Lichess, con más de 4,5 millones de problemas clasificados y valorados, y añade funciones exclusivas que no encontrarás en ningún otro sitio.",
    "fr": "ChessVis s'appuie sur toute la bibliothèque de puzzles de Lichess — plus de 4,5 millions de puzzles classés et notés — et y ajoute des fonctionnalités uniques introuvables ailleurs.",
    "de": "ChessVis nutzt die komplette Lichess-Aufgabensammlung mit über 4,5 Millionen kategorisierten und bewerteten Aufgaben und ergänzt sie um Funktionen, die es sonst nirgends gibt.",
    "it": "ChessVis parte dall'intera libreria di puzzle di Lichess — oltre 4,5 milioni di puzzle classificati e valutati — e aggiunge funzionalità che non troverai altrove.",
    "pt": "O ChessVis começa com toda a biblioteca de quebra-cabeças do Lichess — mais de 4,5 milhões de posições classificadas e avaliadas — e adiciona recursos exclusivos que você não encontra em outro lugar.",
    "sv": "ChessVis bygger på hela Lichess problembibliotek med över 4,5 miljoner kategoriserade och rankade problem, och lägger till funktioner som du inte hittar någon annanstans."
  },
  {
    "en": "Unique to ChessVis",
    "es": "Exclusivo de ChessVis",
    "fr": "Exclusif à ChessVis",
    "de": "Nur bei ChessVis",
    "it": "Esclusivo di ChessVis",
    "pt": "Exclusivo do ChessVis",
    "sv": "Unikt för ChessVis"
  },
  {
    "en": "Solve the Puzzle. Visualized In Your Mind.",
    "es": "Resuelve el problema. Visualízalo en tu mente.",
    "fr": "Résolvez le puzzle. Visualisez-le dans votre esprit.",
    "de": "Löse die Aufgabe. Sieh sie vor deinem inneren Auge.",
    "it": "Risolvi il puzzle. Visualizzalo nella tua mente.",
    "pt": "Resolva o problema. Visualize-o na sua mente.",
    "sv": "Lös problemet. Se det framför dig i huvudet."
  },
  {
    "en": "We show you a real game position, a few moves before the tactic strikes. Play it forward in your mind's eye. Can you see the board clearly enough to find the winning move?",
    "es": "Te mostramos una posición real unos movimientos antes de que aparezca la táctica. Reproduce las jugadas en tu mente. ¿Ves el tablero con suficiente claridad para encontrar la jugada ganadora?",
    "fr": "Nous vous montrons une position réelle quelques coups avant le coup tactique. Faites avancer la position dans votre tête. Voyez-vous l'échiquier assez clairement pour trouver le coup gagnant ?",
    "de": "Wir zeigen dir eine echte Partieposition wenige Züge vor der Taktik. Spiele die Stellung im Kopf weiter. Kannst du das Brett klar genug sehen, um den Gewinnzug zu finden?",
    "it": "Ti mostriamo una posizione reale poche mosse prima della combinazione tattica. Falla avanzare nella tua mente. Riesci a vedere la scacchiera abbastanza chiaramente da trovare la mossa vincente?",
    "pt": "Mostramos uma posição real alguns lances antes da tática acontecer. Jogue a sequência na sua mente. Você consegue visualizar o tabuleiro claramente o bastante para encontrar o lance vencedor?",
    "sv": "Vi visar en riktig ställning några drag innan taktiken slår till. Spela vidare i huvudet. Ser du brädet tillräckligt tydligt för att hitta vinstdraget?"
  },
  {
    "en": "You Control the Difficulty",
    "es": "Tú eliges la dificultad",
    "fr": "Vous choisissez la difficulté",
    "de": "Du bestimmst den Schwierigkeitsgrad",
    "it": "Scegli tu la difficoltà",
    "pt": "Você controla a dificuldade",
    "sv": "Du bestämmer svårighetsgraden"
  },
  {
    "en": "Set both the category and rating of every puzzle you face. Easy forks one day, hard multi-move mates the next. You'll never be locked into puzzles around some rating you've 'earned' — the full collection is always available.",
    "es": "Elige la categoría y el nivel de cada problema. Tenedores fáciles un día, mates complicados varios movimientos después al siguiente. Nunca estarás limitado a problemas de una puntuación determinada: toda la colección está siempre disponible.",
    "fr": "Choisissez la catégorie et le niveau de chaque puzzle. Fourchettes faciles un jour, mats complexes en plusieurs coups le lendemain. Vous ne serez jamais limité à un niveau précis : toute la collection reste accessible.",
    "de": "Lege Kategorie und Wertung jeder Aufgabe selbst fest. Heute einfache Gabeln, morgen schwierige Mattkombinationen über mehrere Züge. Du wirst nie auf Aufgaben eines bestimmten Ratings beschränkt – die gesamte Sammlung steht immer offen.",
    "it": "Scegli sia la categoria che il livello di ogni puzzle. Forchette facili un giorno, matti complessi in più mosse il giorno dopo. Non sarai mai limitato a un punteggio specifico: l'intera raccolta è sempre disponibile.",
    "pt": "Escolha a categoria e a classificação de cada problema. Garfos fáceis hoje, mates difíceis em vários lances amanhã. Você nunca ficará preso a problemas de um nível específico — toda a coleção está sempre disponível.",
    "sv": "Välj både kategori och rating för varje problem. Enkla gafflar ena dagen, svåra mattkombinationer flera drag fram nästa. Du låses aldrig till en viss nivå – hela samlingen finns alltid tillgänglig."
  },
  {
    "en": "The No-Repeat Pledge",
    "es": "Nuestra promesa: sin repeticiones",
    "fr": "Notre promesse : aucun doublon",
    "de": "Keine-Wiederholungen-Garantie",
    "it": "La promessa: nessuna ripetizione",
    "pt": "Compromisso sem repetições",
    "sv": "Löftet om inga upprepningar"
  },
  {
    "en": "With 4.5 million puzzles, you'll never see the same one twice. Work offline with up to 2,000 downloaded puzzles. Track your history, graph your results, and compare with others.",
    "es": "Con 4,5 millones de problemas, nunca verás el mismo dos veces. Entrena sin conexión con hasta 2.000 problemas descargados. Consulta tu historial, analiza tus resultados y compáralos con otros jugadores.",
    "fr": "Avec 4,5 millions de puzzles, vous ne reverrez jamais le même deux fois. Travaillez hors ligne avec jusqu'à 2 000 puzzles téléchargés. Suivez vos progrès, consultez vos statistiques et comparez-vous aux autres.",
    "de": "Mit 4,5 Millionen Aufgaben wirst du nie dieselbe zweimal sehen. Trainiere offline mit bis zu 2.000 heruntergeladenen Aufgaben. Verfolge deinen Verlauf, analysiere deine Ergebnisse und vergleiche dich mit anderen.",
    "it": "Con 4,5 milioni di puzzle non vedrai mai lo stesso due volte. Allenati offline con fino a 2.000 puzzle scaricati. Controlla la cronologia, visualizza i risultati e confrontati con gli altri.",
    "pt": "Com 4,5 milhões de problemas, você nunca verá o mesmo duas vezes. Treine offline com até 2.000 problemas baixados. Acompanhe seu histórico, veja seus resultados em gráficos e compare-se com outros jogadores.",
    "sv": "Med 4,5 miljoner problem kommer du aldrig att se samma problem två gånger. Träna offline med upp till 2 000 nedladdade problem. Följ din historik, se dina resultat i diagram och jämför dig med andra."
  },
  {
    "en": "ChessVis started as a visualization app — it's in the name. These tools train the mental seeing that strong players rely on.",
    "es": "ChessVis nació como una app de visualización; está en el nombre. Estas herramientas entrenan la capacidad de visualizar mentalmente en la que confían los jugadores fuertes.",
    "fr": "ChessVis est né comme une application de visualisation — le nom le dit. Ces outils développent la vision mentale sur laquelle s'appuient les joueurs forts.",
    "de": "ChessVis begann als Visualisierungs-App – der Name verrät es. Diese Werkzeuge trainieren das mentale Sehen, auf das starke Spieler vertrauen.",
    "it": "ChessVis è nato come app di visualizzazione, e il nome lo dice chiaramente. Questi strumenti allenano la visualizzazione mentale su cui fanno affidamento i giocatori forti.",
    "pt": "O ChessVis nasceu como um app de visualização — o nome já diz tudo. Essas ferramentas treinam a visão mental usada pelos jogadores mais fortes.",
    "sv": "ChessVis började som en visualiseringsapp – det hörs på namnet. De här verktygen tränar den mentala syn som starka spelare förlitar sig på."
  },
  {
    "en": "A deceptively simple exercise that forces you to mentally track piece movements and interactions. You won't find this anywhere else, and it's more powerful than it looks.",
    "es": "Un ejercicio aparentemente sencillo que te obliga a seguir mentalmente los movimientos y las interacciones de las piezas. No encontrarás nada parecido en otro lugar, y es más potente de lo que parece.",
    "fr": "Un exercice en apparence simple qui vous oblige à suivre mentalement les déplacements et interactions des pièces. Vous ne trouverez cela nulle part ailleurs, et c'est plus puissant qu'il n'y paraît.",
    "de": "Eine täuschend einfache Übung, bei der du Figurenzüge und Wechselwirkungen im Kopf verfolgen musst. So etwas findest du sonst nirgends, und es ist wirkungsvoller als es aussieht.",
    "it": "Un esercizio apparentemente semplice che ti costringe a seguire mentalmente movimenti e interazioni dei pezzi. Non troverai nulla di simile altrove ed è più efficace di quanto sembri.",
    "pt": "Um exercício aparentemente simples que obriga você a acompanhar mentalmente os movimentos e as interações das peças. Você não encontrará isso em nenhum outro lugar, e ele é mais poderoso do que parece.",
    "sv": "En till synes enkel övning som tvingar dig att följa pjäsernas rörelser och samspel i huvudet. Du hittar inget liknande någon annanstans, och den är kraftfullare än den verkar."
  },
  {
    "en": "Track a sequence of moves and update the board in your mind. Follow from the opening, from a random midgame position, or focus on specific pieces as they move across the board.",
    "es": "Sigue una secuencia de jugadas y actualiza el tablero en tu mente. Empieza desde la apertura, desde una posición aleatoria de medio juego o céntrate en piezas concretas mientras recorren el tablero.",
    "fr": "Suivez une séquence de coups et mettez l'échiquier à jour dans votre tête. Commencez depuis l'ouverture, une position aléatoire de milieu de partie ou concentrez-vous sur certaines pièces.",
    "de": "Verfolge eine Zugfolge und aktualisiere das Brett in deinem Kopf. Starte aus der Eröffnung, einer zufälligen Mittelspielstellung oder konzentriere dich auf bestimmte Figuren.",
    "it": "Segui una sequenza di mosse e aggiorna la scacchiera nella tua mente. Parti dall'apertura, da una posizione casuale di mediogioco o concentrati su pezzi specifici mentre si muovono.",
    "pt": "Acompanhe uma sequência de lances e atualize o tabuleiro na sua mente. Comece da abertura, de uma posição aleatória de meio-jogo ou concentre-se em peças específicas enquanto se movem.",
    "sv": "Följ en dragföljd och uppdatera brädet i huvudet. Börja från öppningen, en slumpmässig mittspelsställning eller fokusera på särskilda pjäser när de rör sig över brädet."
  },
  {
    "en": "Study a position, then recreate it from memory. Start simple — a few pieces — and work your way up. A quiet but effective way to sharpen your board sense.",
    "es": "Estudia una posición y luego reconstruyela de memoria. Empieza con pocas piezas y ve aumentando la dificultad. Una forma tranquila pero muy eficaz de mejorar tu visión del tablero.",
    "fr": "Étudiez une position puis recréez-la de mémoire. Commencez avec quelques pièces et progressez petit à petit. Une méthode discrète mais très efficace pour améliorer votre vision de l'échiquier.",
    "de": "Präge dir eine Stellung ein und stelle sie anschließend aus dem Gedächtnis nach. Beginne mit wenigen Figuren und steigere dich nach und nach. Eine ruhige, aber sehr effektive Trainingsmethode.",
    "it": "Studia una posizione e poi ricreala a memoria. Inizia con pochi pezzi e aumenta gradualmente la difficoltà. Un metodo semplice ma efficace per migliorare la percezione della scacchiera.",
    "pt": "Estude uma posição e depois recrie-a de memória. Comece com poucas peças e vá aumentando a dificuldade. Uma forma tranquila, mas muito eficaz, de melhorar sua percepção do tabuleiro.",
    "sv": "Studera en ställning och återskapa den sedan ur minnet. Börja enkelt med några få pjäser och bygg vidare därifrån. Ett lugnt men effektivt sätt att förbättra din brädkänsla."
  },
  {
    "en": "Play a full game against the computer without seeing the board. ChessVis makes this approachable with a gradual stepping-stone system.",
    "es": "Juega una partida completa contra el ordenador sin ver el tablero. ChessVis lo hace accesible gracias a un sistema progresivo paso a paso.",
    "fr": "Jouez une partie complète contre l'ordinateur sans voir l'échiquier. ChessVis rend cela accessible grâce à une progression graduelle.",
    "de": "Spiele eine komplette Partie gegen den Computer, ohne das Brett zu sehen. ChessVis macht den Einstieg mit einem schrittweisen Lernsystem leicht.",
    "it": "Gioca una partita completa contro il computer senza vedere la scacchiera. ChessVis rende tutto più accessibile con un percorso graduale.",
    "pt": "Jogue uma partida completa contra o computador sem ver o tabuleiro. O ChessVis torna isso acessível com um sistema gradual de aprendizado.",
    "sv": "Spela en hel parti mot datorn utan att se brädet. ChessVis gör det lättare med ett stegvis träningssystem."
  },
  {
    "en": "Smart onboarding",
    "es": "Inicio guiado e inteligente",
    "fr": "Prise en main intelligente",
    "de": "Intelligenter Einstieg",
    "it": "Introduzione guidata intelligente",
    "pt": "Introdução inteligente",
    "sv": "Smart introduktion"
  },
  {
    "en": "Start with all pieces sharing one color, then progress to two-color disks, a shared color disk, and finally a fully empty board. Each step builds the mental model you need for the next.",
    "es": "Empieza con todas las piezas del mismo color, luego pasa a discos de dos colores, después a discos de un solo color y finalmente a un tablero vacío. Cada paso desarrolla la habilidad mental necesaria para el siguiente.",
    "fr": "Commencez avec toutes les pièces de la même couleur, puis passez à des disques bicolores, à des disques d'une seule couleur et enfin à un échiquier totalement vide. Chaque étape prépare la suivante.",
    "de": "Beginne mit Figuren in einer einzigen Farbe, wechsle dann zu zweifarbigen Scheiben, anschließend zu einfarbigen Scheiben und schließlich zu einem komplett leeren Brett. Jeder Schritt baut die mentale Grundlage für den nächsten auf.",
    "it": "Inizia con tutti i pezzi dello stesso colore, poi passa a dischi bicolore, a dischi monocolore e infine a una scacchiera completamente vuota. Ogni fase sviluppa le capacità mentali necessarie per quella successiva.",
    "pt": "Comece com todas as peças da mesma cor, depois avance para discos de duas cores, discos de uma única cor e, por fim, um tabuleiro completamente vazio. Cada etapa desenvolve a habilidade mental necessária para a próxima.",
    "sv": "Börja med alla pjäser i samma färg, gå sedan vidare till tvåfärgade brickor, enfärgade brickor och till sist ett helt tomt bräde. Varje steg bygger upp den mentala modell du behöver för nästa nivå."
  },
  {
    "en": "Reveal When You Need It",
    "es": "Muéstralo cuando lo necesites",
    "fr": "Affichez-le quand vous en avez besoin",
    "de": "Zeige es an, wenn du es brauchst",
    "it": "Mostralo quando ne hai bisogno",
    "pt": "Mostre quando precisar",
    "sv": "Visa när du behöver det"
  },
  {
    "en": "Feeling lost? Reveal the board on demand, or set it to reveal automatically every few moves as a checkpoint. You're always in control of how hard you push.",
    "es": "¿Te has perdido? Muestra el tablero cuando quieras o configúralo para que aparezca automáticamente cada pocas jugadas como punto de control. Tú decides lo exigente que quieres que sea el entrenamiento.",
    "fr": "Vous êtes perdu ? Affichez l'échiquier à la demande ou faites-le apparaître automatiquement tous les quelques coups comme point de contrôle. Vous choisissez toujours le niveau de difficulté.",
    "de": "Verloren den Überblick? Blende das Brett jederzeit ein oder lasse es alle paar Züge automatisch als Kontrollpunkt anzeigen. Du entscheidest selbst, wie anspruchsvoll das Training sein soll.",
    "it": "Ti senti perso? Mostra la scacchiera quando vuoi oppure falla apparire automaticamente ogni poche mosse come punto di controllo. Sei sempre tu a decidere quanto metterti alla prova.",
    "pt": "Perdeu o fio da posição? Mostre o tabuleiro quando quiser ou configure-o para aparecer automaticamente a cada poucos lances como um ponto de verificação. Você decide o nível do desafio.",
    "sv": "Känner du dig vilse? Visa brädet när du vill eller låt det visas automatiskt efter några drag som en kontrollpunkt. Du bestämmer själv hur hårt du vill pressa dig."
  },
  {
    "en": "Puzzles & Visualization always free. And so is beginning blindfold chess. No account required to begin.",
    "es": "Los problemas y la visualización son siempre gratis. Y también lo es empezar con el ajedrez a ciegas. No necesitas crear una cuenta.",
    "fr": "Les puzzles et la visualisation sont toujours gratuits. Et les premiers pas dans le jeu à l'aveugle le sont aussi. Aucun compte n'est nécessaire.",
    "de": "Aufgaben und Visualisierung sind immer kostenlos. Das gilt auch für den Einstieg ins Blindschach. Kein Konto erforderlich.",
    "it": "Puzzle e visualizzazione sono sempre gratuiti. Anche iniziare con gli scacchi alla cieca non costa nulla. Nessun account richiesto.",
    "pt": "Problemas e visualização são sempre grátis. E começar no xadrez às cegas também. Não é preciso criar uma conta.",
    "sv": "Problem och visualisering är alltid gratis. Detsamma gäller att börja med blindschack. Inget konto behövs."
  },
  {
    "en": "Start Training",
    "es": "Empezar a entrenar",
    "fr": "Commencer l'entraînement",
    "de": "Training starten",
    "it": "Inizia ad allenarti",
    "pt": "Começar treino",
    "sv": "Börja träna"
  },
  {
    "en": "Where games are prepared and won.",
    "es": "Donde se preparan y se ganan las partidas.",
    "fr": "Là où les parties se préparent et se gagnent.",
    "de": "Hier werden Partien vorbereitet und gewonnen.",
    "it": "Dove le partite si preparano e si vincono.",
    "pt": "Onde as partidas são preparadas e vencidas.",
    "sv": "Där partier förbereds och vinns."
  },
  {
    "en": "Opening mastery, repertoire building, AI coaching, and game analysis — the tools serious players use to improve between games.",
    "es": "Dominio de aperturas, creación de repertorios, entrenamiento con IA y análisis de partidas: las herramientas que usan los jugadores serios para mejorar entre partida y partida.",
    "fr": "Maîtrise des ouvertures, création de répertoire, coaching IA et analyse de parties : les outils utilisés par les joueurs ambitieux pour progresser entre les parties.",
    "de": "Eröffnungsverständnis, Repertoireaufbau, KI-Coaching und Partienanalyse – die Werkzeuge, mit denen ernsthafte Spieler zwischen den Partien besser werden.",
    "it": "Padronanza delle aperture, costruzione del repertorio, coaching con IA e analisi delle partite: gli strumenti che i giocatori più seri usano per migliorare tra una partita e l'altra.",
    "pt": "Domínio das aberturas, construção de repertório, treinamento com IA e análise de partidas — as ferramentas que jogadores sérios usam para evoluir entre uma partida e outra.",
    "sv": "Öppningsmästerskap, repertoarbygge, AI-coachning och partianalys – verktygen som seriösa spelare använder för att bli bättre mellan partierna."
  },
  {
    "en": "Some features free",
    "es": "Algunas funciones gratis",
    "fr": "Certaines fonctionnalités gratuites",
    "de": "Einige Funktionen kostenlos",
    "it": "Alcune funzioni gratuite",
    "pt": "Alguns recursos grátis",
    "sv": "Vissa funktioner är gratis"
  },
  {
    "en": "Full access with subscription",
    "es": "Acceso completo con suscripción",
    "fr": "Accès complet avec abonnement",
    "de": "Voller Zugriff mit Abonnement",
    "it": "Accesso completo con abbonamento",
    "pt": "Acesso completo com assinatura",
    "sv": "Full tillgång med abonnemang"
  },
  {
    "en": "A different approach",
    "es": "Un enfoque diferente",
    "fr": "Une approche différente",
    "de": "Ein anderer Ansatz",
    "it": "Un approccio diverso",
    "pt": "Uma abordagem diferente",
    "sv": "Ett annorlunda sätt"
  },
  {
    "en": "Study the Moves You'll Actually See",
    "es": "Estudia las jugadas que realmente verás",
    "fr": "Étudiez les coups que vous verrez vraiment",
    "de": "Lerne die Züge, denen du wirklich begegnest",
    "it": "Studia le mosse che vedrai davvero",
    "pt": "Estude os lances que você realmente vai encontrar",
    "sv": "Studera dragen du faktiskt kommer att möta"
  },
  {
    "en": "Most opening tools show you everything — including long move sequences you'll almost never face. Opening Mastery focuses your study time on the moves that matter at your rating level, against players like you.",
    "es": "La mayoría de las herramientas de aperturas te muestran todo, incluidas largas variantes que casi nunca aparecerán en tus partidas. Opening Mastery centra tu tiempo de estudio en las jugadas que realmente importan a tu nivel y contra rivales como tú.",
    "fr": "La plupart des outils d'ouverture vous montrent tout, y compris de longues variantes que vous ne rencontrerez presque jamais. Opening Mastery concentre votre étude sur les coups qui comptent vraiment à votre niveau.",
    "de": "Die meisten Eröffnungstools zeigen dir alles – auch lange Varianten, die du fast nie aufs Brett bekommst. Opening Mastery konzentriert sich auf die Züge, die auf deinem Spielniveau wirklich wichtig sind.",
    "it": "La maggior parte degli strumenti per le aperture mostra tutto, comprese lunghe varianti che probabilmente non incontrerai mai. Opening Mastery concentra il tuo studio sulle mosse che contano davvero al tuo livello.",
    "pt": "A maioria das ferramentas de abertura mostra tudo, inclusive variantes longas que você quase nunca verá. O Opening Mastery concentra seu estudo nos lances que realmente importam para o seu nível.",
    "sv": "De flesta öppningsverktyg visar allt, även långa varianter som du nästan aldrig stöter på. Opening Mastery fokuserar på dragen som verkligen spelar roll på din nivå."
  },
  {
    "en": "200+ Million Real Games",
    "es": "Más de 200 millones de partidas reales",
    "fr": "Plus de 200 millions de parties réelles",
    "de": "Über 200 Millionen echte Partien",
    "it": "Oltre 200 milioni di partite reali",
    "pt": "Mais de 200 milhões de partidas reais",
    "sv": "Över 200 miljoner riktiga partier"
  },
  {
    "en": "Built on Lichess Rapid games — longer time controls where players actually think. Only head-to-head games within the same 50-point rating bracket are included. Why? Because even a 50-point rating difference skews how people play. You're studying your peers, not the masters.",
    "es": "Basado en partidas rápidas de Lichess, con controles de tiempo más largos donde los jugadores realmente piensan. Solo se incluyen partidas entre jugadores del mismo rango de 50 puntos Elo. ¿Por qué? Porque incluso una diferencia de 50 puntos cambia la forma de jugar. Estás estudiando a tus iguales, no a los maestros.",
    "fr": "Basé sur les parties rapides de Lichess, avec des cadences où les joueurs prennent réellement le temps de réfléchir. Seules les parties entre joueurs du même groupe de 50 points Elo sont incluses. Vous étudiez vos pairs, pas les maîtres.",
    "de": "Die Daten stammen aus Rapid-Partien auf Lichess, also aus Bedenkzeiten, bei denen wirklich nachgedacht wird. Berücksichtigt werden nur Partien zwischen Spielern innerhalb derselben 50-Punkte-Ratinggruppe. Du analysierst deine Spielstärke, nicht die der Großmeister.",
    "it": "Basato sulle partite Rapid di Lichess, dove i giocatori hanno davvero il tempo di riflettere. Sono incluse solo partite tra giocatori della stessa fascia di 50 punti Elo. Stai studiando avversari del tuo livello, non i maestri.",
    "pt": "Baseado em partidas rápidas do Lichess, com controles de tempo em que os jogadores realmente pensam. Apenas partidas entre jogadores da mesma faixa de 50 pontos de rating são incluídas. Você está estudando jogadores do seu nível, não mestres.",
    "sv": "Byggt på snabbschackspartier från Lichess, där spelarna faktiskt hinner tänka. Endast partier mellan spelare inom samma 50-poängs ratingintervall ingår. Du studerar spelare på din egen nivå, inte mästare."
  },
  {
    "en": "See Into the Middle Game",
    "es": "Mira dentro del medio juego",
    "fr": "Voyez ce qui se passe au milieu de partie",
    "de": "Sieh ins Mittelspiel",
    "it": "Guarda dentro il mediogioco",
    "pt": "Veja o que acontece no meio-jogo",
    "sv": "Se in i mittspelet"
  },
  {
    "en": "This is the only program that shows you how your opening moves affect the middle game. Move beyond win/loss percentages — why judge a first move by how a game ends 40 moves later? See what actually happens in the positions your openings create.",
    "es": "Este es el único programa que te muestra cómo tus jugadas de apertura influyen en el medio juego. Ve más allá de los porcentajes de victorias y derrotas. ¿Por qué juzgar una jugada inicial por cómo termina una partida 40 movimientos después? Mira qué ocurre realmente en las posiciones que crean tus aperturas.",
    "fr": "C'est le seul programme qui montre comment vos coups d'ouverture influencent le milieu de partie. Allez au-delà des pourcentages de victoire : voyez ce qui se passe réellement dans les positions créées par vos ouvertures.",
    "de": "Dies ist das einzige Programm, das zeigt, wie sich deine Eröffnungszüge auf das Mittelspiel auswirken. Statt nur Gewinnquoten zu betrachten, siehst du, was in den entstehenden Stellungen tatsächlich passiert.",
    "it": "È l'unico programma che mostra come le tue mosse d'apertura influenzano il mediogioco. Vai oltre le percentuali di vittoria e sconfitta e osserva cosa accade davvero nelle posizioni create dalle tue aperture.",
    "pt": "Este é o único programa que mostra como seus lances de abertura afetam o meio-jogo. Vá além das porcentagens de vitória e derrota e veja o que realmente acontece nas posições criadas pelas suas aberturas.",
    "sv": "Det här är det enda programmet som visar hur dina öppningsdrag påverkar mittspelet. Gå bortom vinstprocent och se vad som faktiskt händer i ställningarna som dina öppningar skapar."
  },
  {
    "en": "Spot and Avoid Traps",
    "es": "Detecta y evita trampas",
    "fr": "Repérez et évitez les pièges",
    "de": "Fallen erkennen und vermeiden",
    "it": "Individua ed evita le trappole",
    "pt": "Identifique e evite armadilhas",
    "sv": "Upptäck och undvik fällor"
  },
  {
    "en": "When you focus on the middle game, your opponent's trappy lines reveal themselves quickly — and show you exactly how to sidestep them.",
    "es": "Cuando te concentras en el medio juego, las variantes tramposas de tus rivales se vuelven evidentes rápidamente y te muestran exactamente cómo evitarlas.",
    "fr": "En vous concentrant sur le milieu de partie, les variantes piégeuses de vos adversaires deviennent rapidement évidentes et vous apprenez à les éviter.",
    "de": "Wenn du dich auf das Mittelspiel konzentrierst, erkennst du die Fallstricke deiner Gegner schnell und lernst, wie du ihnen ausweichst.",
    "it": "Concentrandoti sul mediogioco, le linee insidiose dei tuoi avversari diventano subito evidenti e ti mostrano come evitarle.",
    "pt": "Quando você se concentra no meio-jogo, as linhas cheias de armadilhas dos adversários aparecem rapidamente e mostram exatamente como evitá-las.",
    "sv": "När du fokuserar på mittspelet blir motståndarens fällor snabbt synliga och du ser exakt hur du undviker dem."
  },
  {
    "en": "Analyze Your Own Games",
    "es": "Analiza tus propias partidas",
    "fr": "Analysez vos propres parties",
    "de": "Analysiere deine eigenen Partien",
    "it": "Analizza le tue partite",
    "pt": "Analise suas próprias partidas",
    "sv": "Analysera dina egna partier"
  },
  {
    "en": "Download your games from chess.com and lichess.org and run them through the Opening Explorer. See where you're deviating from your plan and what the data says about the positions you're reaching.",
    "es": "Descarga tus partidas de chess.com y lichess.org y analízalas con el Explorador de Aperturas. Descubre dónde te desvías de tu plan y qué dicen los datos sobre las posiciones a las que llegas.",
    "fr": "Téléchargez vos parties depuis chess.com et lichess.org puis analysez-les avec l'Explorateur d'Ouvertures. Découvrez où vous vous écartez de votre plan et ce que révèlent les données.",
    "de": "Lade deine Partien von chess.com und lichess.org herunter und analysiere sie mit dem Eröffnungs-Explorer. Finde heraus, wo du von deinem Plan abweichst und was die Daten über deine Stellungen sagen.",
    "it": "Scarica le tue partite da chess.com e lichess.org e analizzale con l'Esploratore delle Aperture. Scopri dove ti allontani dal tuo piano e cosa dicono i dati sulle posizioni che raggiungi.",
    "pt": "Baixe suas partidas do chess.com e do lichess.org e analise-as no Explorador de Aberturas. Veja onde você se desvia do plano e o que os dados dizem sobre as posições que alcança.",
    "sv": "Ladda ner dina partier från chess.com och lichess.org och kör dem genom Öppningsutforskaren. Se var du avviker från din plan och vad statistiken säger om ställningarna du får."
  },
  {
    "en": "Build a repertoire grounded in what you'll actually see — not theoretical lines that disappear after move 10.",
    "es": "Construye un repertorio basado en lo que realmente verás sobre el tablero, no en variantes teóricas som försvinner después de la décima jugada.",
    "fr": "Construisez un répertoire basé sur ce que vous rencontrerez réellement, pas sur des variantes théoriques qui disparaissent après le 10e coup.",
    "de": "Baue ein Repertoire auf, das auf echten Partien basiert, nicht auf theoretischen Varianten, die nach dem 10. Zug verschwinden.",
    "it": "Costruisci un repertorio basato su ciò che vedrai davvero in partita, non su varianti teoriche che spariscono dopo la decima mossa.",
    "pt": "Monte um repertório baseado no que você realmente encontrará nas partidas, não em variantes teóricas que desaparecem depois do décimo lance.",
    "sv": "Bygg en repertoar baserad på det du faktiskt kommer att möta, inte på teoretiska varianter som försvinner efter drag 10."
  },
  {
    "en": "An interactive repertoire builder that lets you construct your opening lines move by move, informed by the Opening Mastery data you already have.",
    "es": "Un creador de repertorios interactivo que te permite construir tus variantes de apertura jugada a jugada, utilizando los datos de Opening Mastery.",
    "fr": "Un créateur de répertoire interactif qui vous permet de construire vos variantes coup par coup à partir des données d'Opening Mastery.",
    "de": "Ein interaktiver Repertoire-Builder, mit dem du deine Eröffnungsvarianten Zug für Zug anhand der Opening-Mastery-Daten aufbauen kannst.",
    "it": "Uno strumento interattivo per creare il tuo repertorio, costruendo le varianti mossa dopo mossa grazie ai dati di Opening Mastery.",
    "pt": "Um construtor de repertório interativo que permite criar suas variantes de abertura lance a lance usando os dados do Opening Mastery.",
    "sv": "Ett interaktivt repertoarverktyg där du bygger dina öppningsvarianter drag för drag med hjälp av data från Opening Mastery."
  },
  {
    "en": "Tree View",
    "es": "Vista en árbol",
    "fr": "Vue en arbre",
    "de": "Baumansicht",
    "it": "Vista ad albero",
    "pt": "Visualização em árvore",
    "sv": "Trädvy"
  },
  {
    "en": "See your entire repertoire as a branching tree. Understand where your lines diverge and how deep your preparation actually goes.",
    "es": "Ve todo tu repertorio como un árbol de variantes. Comprende dónde se separan tus líneas y hasta qué profundidad llega realmente tu preparación.",
    "fr": "Visualisez tout votre répertoire sous forme d'arbre de variantes. Comprenez où vos lignes se séparent et jusqu'où va réellement votre préparation.",
    "de": "Sieh dein gesamtes Repertoire als Variantenbaum. Erkenne, wo sich deine Linien verzweigen und wie tief deine Vorbereitung wirklich reicht.",
    "it": "Visualizza tutto il tuo repertorio come un albero di varianti. Scopri dove le linee si separano e quanto è profonda davvero la tua preparazione.",
    "pt": "Veja todo o seu repertório como uma árvore de variantes. Entenda onde suas linhas se dividem e até onde sua preparação realmente vai.",
    "sv": "Se hela din repertoar som ett förgrenat träd. Förstå var dina varianter delar sig och hur djupt dina förberedelser faktiskt går."
  },
  {
    "en": "How you actually learn it",
    "es": "Cómo aprenderlo de verdad",
    "fr": "Comment vraiment l'apprendre",
    "de": "So lernst du es wirklich",
    "it": "Come impararlo davvero",
    "pt": "Como realmente aprender",
    "sv": "Så lär du dig det på riktigt"
  },
  {
    "en": "Drill — Spaced Repetition",
    "es": "Entrenamiento — Repetición espaciada",
    "fr": "Entraînement — Répétition espacée",
    "de": "Training – Verteilte Wiederholung",
    "it": "Allenamento — Ripetizione dilazionata",
    "pt": "Treino — Repetição espaçada",
    "sv": "Träning – Spaced repetition"
  },
  {
    "en": "Daily drills using spaced repetition, so the moves you struggle with come back more often and the ones you know stay sharp with less effort.",
    "es": "Entrena cada día con repetición espaciada. Las jugadas que más te cuestan aparecerán con más frecuencia, mientras que las que ya conoces se mantendrán frescas con menos esfuerzo.",
    "fr": "Des exercices quotidiens basés sur la répétition espacée. Les coups qui vous posent problème reviennent plus souvent, tandis que ceux que vous maîtrisez restent bien ancrés avec moins d'effort.",
    "de": "Tägliche Übungen mit verteilter Wiederholung. Züge, die dir schwerfallen, tauchen häufiger auf, während bekannte Züge mit weniger Aufwand im Gedächtnis bleiben.",
    "it": "Allenamenti quotidiani con ripetizione dilazionata. Le mosse che trovi più difficili tornano più spesso, mentre quelle che conosci già restano ben memorizzate con meno sforzo.",
    "pt": "Treinos diários com repetição espaçada. Os lances que você tem mais dificuldade em lembrar aparecem com mais frequência, enquanto os que já conhece permanecem afiados com menos esforço.",
    "sv": "Dagliga övningar med spaced repetition. Dragen du har svårast för dyker upp oftare, medan de du redan kan hålls färska med mindre ansträngning."
  },
  {
    "en": "Where repertoires usually fail",
    "es": "Donde suelen fallar los repertorios",
    "fr": "Là où les répertoires échouent souvent",
    "de": "Wo Repertoires meist scheitern",
    "it": "Dove i repertori spesso falliscono",
    "pt": "Onde os repertórios costumam falhar",
    "sv": "Där repertoarer oftast fallerar"
  },
  {
    "en": "Practice Into the Middle Game",
    "es": "Practica más allá de la apertura",
    "fr": "Entraînez-vous jusqu'au milieu de partie",
    "de": "Training bis ins Mittelspiel",
    "it": "Allenati fino al mediogioco",
    "pt": "Pratique até o meio-jogo",
    "sv": "Träna vidare in i mittspelet"
  },
  {
    "en": "Your repertoire ends — but the game doesn't. Practice extends play beyond your prepared lines into the middle game, surfacing the positions that leave you thinking 'What do I do now?'' That's where real preparation happens.",
    "es": "Tu repertorio termina, pero la partida no. La práctica continúa más allá de tus variantes preparadas y te lleva al medio juego, donde aparecen esas posiciones que te hacen pensar: «¿Y ahora qué hago?». Ahí es donde empieza la preparación de verdad.",
    "fr": "Votre répertoire s'arrête, mais la partie continue. L'entraînement prolonge le jeu au-delà de vos variantes préparées jusqu'au milieu de partie, là où vous vous demandez : « Et maintenant, que faire ? ». C'est là que la vraie préparation commence.",
    "de": "Dein Repertoire endet – die Partie aber nicht. Das Training führt dich über deine vorbereiteten Varianten hinaus ins Mittelspiel und zeigt dir genau die Stellungen, in denen du denkst: „Was mache ich jetzt?“ Dort findet die eigentliche Vorbereitung statt.",
    "it": "Il tuo repertorio finisce, ma la partita continua. L'allenamento va oltre le varianti preparate e ti porta nel mediogioco, facendo emergere le posizioni che ti fanno pensare: «E adesso cosa faccio?». È lì che avviene la vera preparazione.",
    "pt": "Seu repertório termina, mas a partida não. O treino continua além das variantes preparadas e entra no meio-jogo, revelando aquelas posições em que você pensa: «O que faço agora?». É aí que a preparação de verdade acontece.",
    "sv": "Din repertoar tar slut – men partiet fortsätter. Träningen går vidare bortom dina förberedda varianter in i mittspelet och lyfter fram de ställningar där du tänker: ”Vad gör jag nu?”. Det är där den verkliga förberedelsen sker."
  },
  {
    "en": "Export & Import",
    "es": "Exportar e importar",
    "fr": "Exporter et importer",
    "de": "Importieren & Exportieren",
    "it": "Esporta e importa",
    "pt": "Exportar e importar",
    "sv": "Exportera och importera"
  },
  {
    "en": "Export your repertoire for use in other tools. Import existing repertoires to build on work you've already done.",
    "es": "Exporta tu repertorio para usarlo en otras herramientas. Importa repertorios existentes y sigue trabajando sobre lo que ya has creado.",
    "fr": "Exportez votre répertoire pour l'utiliser dans d'autres outils. Importez des répertoires existants pour continuer un travail déjà commencé.",
    "de": "Exportiere dein Repertoire für andere Programme. Importiere bestehende Repertoires und baue auf deiner bisherigen Arbeit auf.",
    "it": "Esporta il tuo repertorio per usarlo in altri strumenti. Importa repertori esistenti e continua il lavoro già svolto.",
    "pt": "Exporte seu repertório para usar em outras ferramentas. Importe repertórios existentes e continue o trabalho que já começou.",
    "sv": "Exportera din repertoar för användning i andra verktyg. Importera befintliga repertoarer och bygg vidare på det arbete du redan gjort."
  },
  {
    "en": "Legacy Tools",
    "es": "Herramientas clásicas",
    "fr": "Outils classiques",
    "de": "Klassische Werkzeuge",
    "it": "Strumenti classici",
    "pt": "Ferramentas clássicas",
    "sv": "Klassiska verktyg"
  },
  {
    "en": "Classic Opening & Repertoire Tools",
    "es": "Herramientas clásicas de aperturas y repertorios",
    "fr": "Outils classiques d'ouvertures et de répertoires",
    "de": "Klassische Eröffnungs- und Repertoire-Werkzeuge",
    "it": "Strumenti classici per aperture e repertori",
    "pt": "Ferramentas clássicas de aberturas e repertórios",
    "sv": "Klassiska verktyg för öppningar och repertoarer"
  },
  {
    "en": "The original ChessVis opening and repertoire tools are still here — including the Win/Loss Explorer, Slice/Dice analysis, Play Against Game Collection, and Master Player Explorer. If you prefer the classic approach, nothing has been taken away.",
    "es": "Las herramientas originales de aperturas y repertorios de ChessVis siguen aquí: Win/Loss Explorer, análisis Slice/Dice, Jugar contra la colección de partidas y Master Player Explorer. Si prefieres el enfoque clásico, no hemos quitado nada.",
    "fr": "Les outils originaux d'ouvertures et de répertoires de ChessVis sont toujours là : Win/Loss Explorer, analyse Slice/Dice, Jeu contre une collection de parties et Master Player Explorer. Si vous préférez l'approche classique, rien n'a disparu.",
    "de": "Die ursprünglichen Eröffnungs- und Repertoire-Werkzeuge von ChessVis sind weiterhin verfügbar, darunter Win/Loss Explorer, Slice/Dice-Analyse, Spielen gegen Partiensammlungen und Master Player Explorer. Wenn du den klassischen Ansatz bevorzugst, wurde nichts entfernt.",
    "it": "Gli strumenti originali di aperture e repertori di ChessVis sono ancora disponibili, inclusi Win/Loss Explorer, analisi Slice/Dice, Gioca contro una raccolta di partite e Master Player Explorer. Se preferisci l'approccio classico, non manca nulla.",
    "pt": "As ferramentas originais de aberturas e repertórios do ChessVis continuam aqui, incluindo Win/Loss Explorer, análise Slice/Dice, Jogar contra Coleção de Partidas e Master Player Explorer. Se você prefere a abordagem clássica, nada foi removido.",
    "sv": "De ursprungliga öppnings- och repertoarverktygen i ChessVis finns fortfarande kvar, inklusive Win/Loss Explorer, Slice/Dice-analys, Spela mot partisamling och Master Player Explorer. Om du föredrar det klassiska upplägget har inget tagits bort."
  },
  {
    "en": "Opening Mastery Explorer is free. Full access unlocks with a subscription.",
    "es": "Opening Mastery Explorer es gratis. El acceso completo se desbloquea con una suscripción.",
    "fr": "Opening Mastery Explorer est gratuit. L'accès complet est disponible avec un abonnement.",
    "de": "Opening Mastery Explorer ist kostenlos. Der volle Zugriff wird mit einem Abonnement freigeschaltet.",
    "it": "Opening Mastery Explorer è gratuito. L'accesso completo si sblocca con un abbonamento.",
    "pt": "O Opening Mastery Explorer é gratuito. O acesso completo é liberado com uma assinatura.",
    "sv": "Opening Mastery Explorer är gratis. Full tillgång låses upp med en prenumeration."
  },
  {
    "en": "Thank you for subscribing and supporting my work",
    "es": "Gracias por suscribirte y apoyar mi trabajo",
    "fr": "Merci de vous être abonné et de soutenir mon travail",
    "de": "Danke, dass du mein Abo abgeschlossen hast und meine Arbeit unterstützt",
    "it": "Grazie per esserti abbonato e per sostenere il mio lavoro",
    "pt": "Obrigado por assinar e apoiar o meu trabalho",
    "sv": "Tack för att du prenumererar och stöttar mitt arbete"
  },
  {
    "en": "Unlock Chessvis Studio, Blindfold and support my work",
    "es": "Desbloquea ChessVis Studio y Blindfold, y apoya mi trabajo",
    "fr": "Débloquez ChessVis Studio et Blindfold tout en soutenant mon travail",
    "de": "Schalte ChessVis Studio und Blindfold frei und unterstütze meine Arbeit",
    "it": "Sblocca ChessVis Studio e Blindfold e sostieni il mio lavoro",
    "pt": "Desbloqueie o ChessVis Studio e o Blindfold e apoie o meu trabalho",
    "sv": "Lås upp ChessVis Studio och Blindfold och stötta mitt arbete"
  },
  {
    "en": "Keep Me Programming!",
    "es": "¡Ayúdame a seguir programando!",
    "fr": "Aidez-moi à continuer à développer !",
    "de": "Hilf mir, weiterzuentwickeln!",
    "it": "Aiutami a continuare a programmare!",
    "pt": "Ajude-me a continuar programando!",
    "sv": "Hjälp mig att fortsätta utveckla!"
  },
  {
    "en": "Many subscribers appreciate the unique features within ChessVis and subscribe simply to encourage the work to continue. I won't argue with that — and I'm genuinely grateful.",
    "es": "Muchos suscriptores valoran las funciones únicas de ChessVis y se suscriben simplemente para apoyar que el proyecto siga adelante. No voy a discutirlo; estoy sinceramente agradecido.",
    "fr": "De nombreux abonnés apprécient les fonctionnalités uniques de ChessVis et s'abonnent simplement pour soutenir la poursuite du projet. Je leur en suis sincèrement reconnaissant.",
    "de": "Viele Abonnenten schätzen die einzigartigen Funktionen von ChessVis und abonnieren einfach, um die Weiterentwicklung zu unterstützen. Dafür bin ich wirklich dankbar.",
    "it": "Molti abbonati apprezzano le funzionalità uniche di ChessVis e si abbonano semplicemente per sostenere il progetto. Ne sono sinceramente grato.",
    "pt": "Muitos assinantes apreciam os recursos exclusivos do ChessVis e assinam simplesmente para ajudar o projeto a continuar. Sou sinceramente grato por isso.",
    "sv": "Många prenumeranter uppskattar ChessVis unika funktioner och prenumererar helt enkelt för att stödja fortsatt utveckling. Det är jag verkligen tacksam för."
  },
  {
    "en": "Running ChessVis involves real ongoing costs: production and development servers, database infrastructure, automated backups, email services, and the many other expenses that come with keeping a serious app running reliably with 99.99% uptime in the past 12 months. Your subscription directly funds all of it.",
    "es": "Mantener ChessVis tiene costes reales: servidores de producción y desarrollo, infraestructura de bases de datos, copias de seguridad automáticas, servicios de correo electrónico y muchos otros gastos necesarios para ofrecer una aplicación fiable con un 99,99 % de disponibilidad durante los últimos 12 meses. Tu suscripción ayuda directamente a cubrir todo eso.",
    "fr": "Faire fonctionner ChessVis entraîne de vrais coûts : serveurs de production et de développement, infrastructure de bases de données, sauvegardes automatiques, services de messagerie et bien d'autres dépenses nécessaires pour maintenir une application fiable avec 99,99 % de disponibilité sur les 12 derniers mois. Votre abonnement finance directement tout cela.",
    "de": "Der Betrieb von ChessVis verursacht laufende Kosten: Produktions- und Entwicklungsserver, Datenbankinfrastruktur, automatische Backups, E-Mail-Dienste und vieles mehr. Nur so konnten wir in den letzten 12 Monaten eine Verfügbarkeit von 99,99 % erreichen. Dein Abonnement finanziert all das direkt.",
    "it": "Gestire ChessVis comporta costi reali: server di produzione e sviluppo, infrastruttura database, backup automatici, servizi email e molte altre spese necessarie per mantenere un'app affidabile con il 99,99% di disponibilità negli ultimi 12 mesi. Il tuo abbonamento contribuisce direttamente a tutto questo.",
    "pt": "Manter o ChessVis funcionando gera custos reais: servidores de produção e desenvolvimento, infraestrutura de banco de dados, backups automáticos, serviços de e-mail e muitas outras despesas necessárias para manter um aplicativo confiável com 99,99% de disponibilidade nos últimos 12 meses. Sua assinatura ajuda diretamente a financiar tudo isso.",
    "sv": "Att driva ChessVis innebär verkliga kostnader: produktions- och utvecklingsservrar, databasinfrastruktur, automatiska säkerhetskopior, e-posttjänster och mycket annat. Det är så vi har kunnat hålla 99,99 % upptid under de senaste 12 månaderna. Din prenumeration hjälper direkt till att finansiera allt detta."
  },
  {
    "en": "So thank you. Every subscriber makes the next feature possible.",
    "es": "Así que gracias. Cada suscriptor ayuda a hacer posible la próxima función.",
    "fr": "Alors merci. Chaque abonné contribue à rendre la prochaine fonctionnalité possible.",
    "de": "Vielen Dank. Jeder Abonnent hilft dabei, die nächste Funktion möglich zu machen.",
    "it": "Quindi grazie. Ogni abbonato contribuisce a rendere possibile la prossima funzionalità.",
    "pt": "Por isso, obrigado. Cada assinante ajuda a tornar possível o próximo recurso.",
    "sv": "Så tack. Varje prenumerant hjälper till att göra nästa funktion möjlig."
  },
  {
    "en": "All that for only:",
    "es": "Todo eso por solo:",
    "fr": "Tout cela pour seulement :",
    "de": "All das für nur:",
    "it": "Tutto questo a soli:",
    "pt": "Tudo isso por apenas:",
    "sv": "Allt detta för bara:"
  },
  {
    "en": "Annual auto-renewing subscription. Best subscription value.",
    "es": "Suscripción anual con renovación automática. La mejor relación calidad-precio.",
    "fr": "Abonnement annuel avec renouvellement automatique. Le meilleur rapport qualité-prix.",
    "de": "Jahresabo mit automatischer Verlängerung. Das beste Preis-Leistungs-Verhältnis.",
    "it": "Abbonamento annuale con rinnovo automatico. Il miglior rapporto qualità-prezzo.",
    "pt": "Assinatura anual com renovação automática. O melhor custo-benefício.",
    "sv": "Årsprenumeration med automatisk förnyelse. Mest värde för pengarna."
  },
  {
    "en": "Monthly auto-renewing subscription. Try it for a month with no long-term commitment.",
    "es": "Suscripción mensual con renovación automática. Pruébala durante un mes sin compromiso a largo plazo.",
    "fr": "Abonnement mensuel avec renouvellement automatique. Essayez-le pendant un mois sans engagement à long terme.",
    "de": "Monatsabo mit automatischer Verlängerung. Einen Monat testen – ganz ohne langfristige Verpflichtung.",
    "it": "Abbonamento mensile con rinnovo automatico. Provalo per un mese senza impegni a lungo termine.",
    "pt": "Assinatura mensal com renovação automática. Experimente por um mês sem compromisso de longo prazo.",
    "sv": "Månadsprenumeration med automatisk förnyelse. Testa en månad utan långsiktigt åtagande."
  },
  {
    "en": "Perpetual one-time fee. Never see a recurring charge again.",
    "es": "Pago único de por vida. No volverás a ver un cargo recurrente.",
    "fr": "Paiement unique à vie. Plus jamais de frais récurrents.",
    "de": "Einmalzahlung für dauerhaften Zugriff. Nie wieder eine wiederkehrende Gebühr.",
    "it": "Pagamento unico a vita. Nessun addebito ricorrente in futuro.",
    "pt": "Pagamento único vitalício. Nunca mais veja uma cobrança recorrente.",
    "sv": "Engångsbetalning för alltid. Inga återkommande avgifter igen."
  },
  {
    "en": "Note: If you cancel an annual or monthly subscription, you will not receive a refund for the current billing period but will continue to receive subscriber benefits until the period ends. Cancelling stops renewal — no pro-rated refunds. If you are unsure, start with a monthly subscription and evaluate from there. Terms of Service and privacy policy are available under Support in the Account section.",
    "es": "Nota: Si cancelas una suscripción anual o mensual, no recibirás un reembolso por el período actual, pero seguirás disfrutando de las ventajas de suscriptor hasta que termine. Cancelar detiene la renovación; no hay reembolsos proporcionales. Si tienes dudas, empieza con la suscripción mensual y decide después. Los Términos del Servicio y la Política de Privacidad están disponibles en la sección Soporte de tu cuenta.",
    "fr": "Remarque : si vous annulez un abonnement mensuel ou annuel, aucun remboursement ne sera accordé pour la période en cours, mais vous conserverez les avantages jusqu'à son expiration. L'annulation empêche simplement le renouvellement. En cas d'hésitation, commencez par l'abonnement mensuel. Les Conditions d'utilisation et la Politique de confidentialité sont disponibles dans la section Assistance du compte.",
    "de": "Hinweis: Wenn du ein Monats- oder Jahresabo kündigst, erhältst du keine Rückerstattung für den aktuellen Abrechnungszeitraum. Die Vorteile bleiben jedoch bis zum Ende des Zeitraums bestehen. Die Kündigung verhindert lediglich die Verlängerung. Wenn du unsicher bist, beginne mit dem Monatsabo. Nutzungsbedingungen und Datenschutzerklärung findest du im Support-Bereich deines Kontos.",
    "it": "Nota: se annulli un abbonamento mensile o annuale, non riceverai alcun rimborso per il periodo in corso, ma continuerai a usufruire dei vantaggi fino alla scadenza. L'annullamento interrompe il rinnovo automatico; non sono previsti rimborsi proporzionali. Se hai dubbi, inizia con l'abbonamento mensile. Termini di servizio e informativa sulla privacy sono disponibili nella sezione Supporto dell'account.",
    "pt": "Observação: se você cancelar uma assinatura mensal ou anual, não receberá reembolso pelo período atual, mas continuará com os benefícios até o fim da vigência. O cancelamento apenas impede a renovação. Se estiver em dúvida, comece com a assinatura mensal. Os Termos de Serviço e a Política de Privacidade estão disponíveis na seção Suporte da sua conta.",
    "sv": "Obs: Om du säger upp en månads- eller årsprenumeration får du ingen återbetalning för den aktuella perioden, men du behåller alla förmåner tills perioden löper ut. Uppsägning stoppar endast förnyelsen. Om du är osäker, börja med månadsprenumerationen. Användarvillkor och integritetspolicy finns under Support i kontosektionen."
  },
  {
    "en": "A lot of ChessVis is free — and always will be. A subscription unlocks the deeper tools for serious improvement.",
    "es": "Gran parte de ChessVis es gratis, y siempre lo será. Una suscripción desbloquea las herramientas más avanzadas para quienes quieren mejorar de verdad.",
    "fr": "Une grande partie de ChessVis est gratuite, et le restera toujours. Un abonnement débloque les outils les plus avancés pour progresser sérieusement.",
    "de": "Ein großer Teil von ChessVis ist kostenlos – und wird es immer bleiben. Mit einem Abonnement erhältst du Zugriff auf die fortgeschritteneren Werkzeuge für ernsthafte Verbesserungen.",
    "it": "Gran parte di ChessVis è gratuita e lo sarà sempre. Un abbonamento sblocca gli strumenti più avanzati per chi vuole migliorare seriamente.",
    "pt": "Grande parte do ChessVis é grátis e sempre será. A assinatura libera as ferramentas mais avançadas para quem quer evoluir de verdade.",
    "sv": "En stor del av ChessVis är gratis – och kommer alltid att vara det. En prenumeration låser upp de mer avancerade verktygen för dig som vill förbättras på allvar."
  },
  {
    "en": "Lots of ChessVis is Free",
    "es": "Gran parte de ChessVis es gratis",
    "fr": "Une grande partie de ChessVis est gratuite",
    "de": "Vieles in ChessVis ist kostenlos",
    "it": "Gran parte di ChessVis è gratuita",
    "pt": "Grande parte do ChessVis é grátis",
    "sv": "Mycket i ChessVis är gratis"
  },
  {
    "en": "Tactics Gym — Puzzles and Visualization Exercises - Completely Free",
    "es": "Gimnasio Táctico — Problemas y ejercicios de visualización totalmente gratis",
    "fr": "Salle de tactique — Puzzles et exercices de visualisation entièrement gratuits",
    "de": "Taktik-Training – Aufgaben und Visualisierungsübungen komplett kostenlos",
    "it": "Palestra Tattica — Puzzle ed esercizi di visualizzazione completamente gratuiti",
    "pt": "Academia Tática — Problemas e exercícios de visualização totalmente grátis",
    "sv": "Taktikträning – Problem och visualiseringsövningar helt gratis"
  },
  {
    "en": "All puzzles including regular and visualized puzzles. Timed, offline and blindfold puzzles are now free. Who's Guarding Whom, Move Following, Static Boards and all visualization tools. Blindfold chess at the introductory stepping-stone level. No subscription needed for any of it.",
    "es": "Todos los problemas, incluidos los normales y los visualizados. Los problemas cronometrados, sin conexión y a ciegas ahora son gratis. Quién Defiende a Quién, Seguimiento de Jugadas, Tableros Estáticos y todas las herramientas de visualización. También el nivel inicial de ajedrez a ciegas. No necesitas suscripción para nada de esto.",
    "fr": "Tous les puzzles, y compris les puzzles classiques et visualisés. Les puzzles chronométrés, hors ligne et à l'aveugle sont désormais gratuits. Qui protège qui, Suivi des coups, Échiquiers statiques et tous les outils de visualisation. Le niveau d'introduction au jeu à l'aveugle est également gratuit. Aucun abonnement nécessaire.",
    "de": "Alle Aufgaben, einschließlich normaler und visualisierter Aufgaben. Zeitaufgaben, Offline-Aufgaben und Blindschach-Aufgaben sind jetzt kostenlos. Who's Guarding Whom, Zugverfolgung, Statische Bretter und alle Visualisierungstools. Auch die Einstiegsstufe ins Blindschach ist gratis. Dafür brauchst du kein Abonnement.",
    "it": "Tutti i puzzle, inclusi quelli normali e visualizzati. I puzzle a tempo, offline e alla cieca sono ora gratuiti. Chi Difende Chi, Segui le Mosse, Scacchiere Statiche e tutti gli strumenti di visualizzazione. Anche il livello introduttivo degli scacchi alla cieca è gratuito. Nessun abbonamento richiesto.",
    "pt": "Todos os problemas, incluindo os normais e os visualizados. Problemas com tempo, offline e às cegas agora são grátis. Quem Defende Quem, Acompanhamento de Lances, Tabuleiros Estáticos e todas as ferramentas de visualização. O nível introdutório de xadrez às cegas também é gratuito. Nenhuma assinatura é necessária.",
    "sv": "Alla problem, inklusive vanliga och visualiserade problem. Tidsbaserade, offline- och blindschacksproblem är nu gratis. Vem försvarar vem, Dragföljning, Statiska bräden och alla visualiseringsverktyg. Även nybörjarnivån för blindschack är gratis. Ingen prenumeration krävs."
  },
  {
    "en": "Opening Explorer — Free",
    "es": "Explorador de Aperturas — Gratis",
    "fr": "Explorateur d'Ouvertures — Gratuit",
    "de": "Eröffnungs-Explorer – Kostenlos",
    "it": "Esploratore delle Aperture — Gratuito",
    "pt": "Explorador de Aberturas — Grátis",
    "sv": "Öppningsutforskaren – Gratis"
  },
   {
    "en": "The Opening Explorer with its 200 million equal-rating Lichess Rapid game collection is free. This unique collection only includes games where both players are within the same 50-point rating bracket — so you're studying players who actually play like you.",
    "es": "El Explorador de Aperturas con su colección de 200 millones de partidas rápidas de Lichess entre jugadores de nivel similar es gratis. Esta colección única solo incluye partidas donde ambos jugadores están dentro del mismo rango de 50 puntos Elo, para que estudies jugadores que realmente juegan como tú.",
    "fr": "L'Explorateur d'Ouvertures et sa collection de 200 millions de parties rapides Lichess entre joueurs de même niveau sont gratuits. Cette collection unique ne contient que des parties où les deux joueurs sont dans la même tranche de 50 points Elo, afin que vous étudiiez des joueurs qui jouent réellement comme vous.",
    "de": "Der Eröffnungs-Explorer mit seiner Sammlung von 200 Millionen Lichess-Rapid-Partien zwischen Spielern gleicher Spielstärke ist kostenlos. Diese einzigartige Sammlung enthält nur Partien, bei denen beide Spieler innerhalb derselben 50-Punkte-Ratinggruppe liegen, sodass du Spieler studierst, die tatsächlich wie du spielen.",
    "it": "L'Esploratore delle Aperture con la sua raccolta di 200 milioni di partite Rapid di Lichess tra giocatori dello stesso livello è gratuito. Questa raccolta unica include solo partite in cui entrambi i giocatori appartengono alla stessa fascia di 50 punti Elo, così studi giocatori che giocano davvero come te.",
    "pt": "O Explorador de Aberturas com sua coleção de 200 milhões de partidas rápidas do Lichess entre jogadores de nível semelhante é gratuito. Essa coleção exclusiva inclui apenas partidas em que ambos os jogadores estão na mesma faixa de 50 pontos de rating, para que você estude jogadores que realmente jogam como você.",
    "sv": "Öppningsutforskaren med sin samling på 200 miljoner Lichess-snabbpartier mellan spelare på samma nivå är gratis. Samlingen innehåller bara partier där båda spelarna ligger inom samma ratingintervall på 50 poäng, så att du studerar spelare som faktiskt spelar som du."
  },
  {
    "en": "Opening preparation with repertoires",
    "es": "Preparación de aperturas con repertorios",
    "fr": "Préparation des ouvertures avec répertoires",
    "de": "Eröffnungsvorbereitung mit Repertoires",
    "it": "Preparazione delle aperture con repertori",
    "pt": "Preparação de aberturas com repertórios",
    "sv": "Öppningsförberedelser med repertoarer"
  },
  {
    "en": "Analyze your games",
    "es": "Analiza tus partidas",
    "fr": "Analysez vos parties",
    "de": "Analysiere deine Partien",
    "it": "Analizza le tue partite",
    "pt": "Analise suas partidas",
    "sv": "Analysera dina partier"
  },
  {
    "en": "Advanced blindfold chess",
    "es": "Ajedrez a ciegas avanzado",
    "fr": "Jeu à l'aveugle avancé",
    "de": "Fortgeschrittenes Blindschach",
    "it": "Scacchi alla cieca avanzati",
    "pt": "Xadrez às cegas avançado",
    "sv": "Avancerat blindschack"
  },
  {
    "en": "Build Your Repertoire",
    "es": "Construye tu repertorio",
    "fr": "Construisez votre répertoire",
    "de": "Baue dein Repertoire auf",
    "it": "Costruisci il tuo repertorio",
    "pt": "Monte seu repertório",
    "sv": "Bygg din repertoar"
  },
  {
    "en": "Subscribers can build their repertoire library. The unique focus here is on the moves you'll actually see — not long move sequences that are rarely played. Have you seen the videos in the Account section?",
    "es": "Los suscriptores pueden crear su biblioteca de repertorios. El enfoque aquí está en las jugadas que realmente verás en tus partidas, no en largas variantes que rara vez aparecen. ¿Ya viste los vídeos de la sección Cuenta?",
    "fr": "Les abonnés peuvent créer leur bibliothèque de répertoires. L'accent est mis sur les coups que vous rencontrerez réellement, pas sur de longues variantes rarement jouées. Avez-vous regardé les vidéos dans la section Compte ?",
    "de": "Abonnenten können ihre eigene Repertoire-Bibliothek aufbauen. Der Fokus liegt auf den Zügen, die du tatsächlich aufs Brett bekommst, nicht auf langen Varianten, die kaum gespielt werden. Hast du dir die Videos im Kontobereich angesehen?",
    "it": "Gli abbonati possono creare la propria libreria di repertori. L'attenzione è rivolta alle mosse che incontrerai davvero in partita, non a lunghe varianti che vengono giocate raramente. Hai già visto i video nella sezione Account?",
    "pt": "Os assinantes podem criar sua biblioteca de repertórios. O foco está nos lances que você realmente encontrará nas partidas, e não em variantes longas que quase nunca aparecem. Você já viu os vídeos na seção Conta?",
    "sv": "Prenumeranter kan bygga upp sitt eget repertoarbibliotek. Fokus ligger på dragen du faktiskt kommer att möta, inte på långa varianter som sällan spelas. Har du sett videorna i kontosektionen?"
  },
  {
    "en": "Interactive Repertoire Builder",
    "es": "Constructor interactivo de repertorios",
    "fr": "Créateur de répertoire interactif",
    "de": "Interaktiver Repertoire-Builder",
    "it": "Costruttore interattivo di repertori",
    "pt": "Construtor interativo de repertório",
    "sv": "Interaktiv repertoarbyggare"
  },
  {
    "en": "Build your opening lines move by move, informed by the Opening Explorer data you already have.",
    "es": "Construye tus variantes de apertura jugada a jugada utilizando los datos del Explorador de Aperturas.",
    "fr": "Construisez vos variantes d'ouverture coup par coup à partir des données de l'Explorateur d'Ouvertures.",
    "de": "Baue deine Eröffnungsvarianten Zug für Zug mithilfe der Daten aus dem Eröffnungs-Explorer auf.",
    "it": "Costruisci le tue varianti d'apertura mossa dopo mossa usando i dati dell'Esploratore delle Aperture.",
    "pt": "Construa suas variantes de abertura lance a lance usando os dados do Explorador de Aberturas.",
    "sv": "Bygg dina öppningsvarianter drag för drag med hjälp av data från Öppningsutforskaren."
  },
  {
    "en": "See your entire repertoire as a branching tree — understand where your lines diverge and how deep your preparation actually goes.",
    "es": "Ve todo tu repertorio como un árbol de variantes. Comprende dónde se separan tus líneas y hasta qué profundidad llega realmente tu preparación.",
    "fr": "Visualisez tout votre répertoire sous forme d'arbre de variantes. Comprenez où vos lignes se séparent et jusqu'où va réellement votre préparation.",
    "de": "Sieh dein gesamtes Repertoire als Variantenbaum. Erkenne, wo sich deine Linien verzweigen und wie tief deine Vorbereitung wirklich reicht.",
    "it": "Visualizza tutto il tuo repertorio come un albero di varianti. Scopri dove le linee si separano e quanto è profonda davvero la tua preparazione.",
    "pt": "Veja todo o seu repertório como uma árvore de variantes. Entenda onde suas linhas se dividem e até onde sua preparação realmente vai.",
    "sv": "Se hela din repertoar som ett förgrenat träd. Förstå var dina varianter delar sig och hur djupt dina förberedelser faktiskt går."
  },
  {
    "en": "Extends your play beyond your prepared lines into the middle game, surfacing the positions that leave you thinking 'What Do I Do Now???' That's where real preparation happens.",
    "es": "Lleva tu entrenamiento más allá de las variantes preparadas y hasta el medio juego, mostrando esas posiciones que te hacen pensar: «¿Y ahora qué hago?». Ahí es donde empieza la preparación de verdad.",
    "fr": "Prolonge votre entraînement au-delà de vos variantes préparées jusque dans le milieu de partie, en mettant en lumière les positions où vous vous dites : « Que faire maintenant ? ». C'est là que commence la vraie préparation.",
    "de": "Führt dein Training über deine vorbereiteten Varianten hinaus ins Mittelspiel und zeigt dir die Stellungen, in denen du denkst: „Was mache ich jetzt?“. Genau dort beginnt die echte Vorbereitung.",
    "it": "Porta il tuo allenamento oltre le varianti preparate e nel mediogioco, facendo emergere le posizioni che ti fanno pensare: «E adesso cosa faccio?». È lì che nasce la vera preparazione.",
    "pt": "Leva seu treinamento além das variantes preparadas e para o meio-jogo, revelando aquelas posições em que você pensa: «O que faço agora?». É aí que acontece a verdadeira preparação.",
    "sv": "Tar träningen bortom dina förberedda varianter och in i mittspelet, där de ställningar dyker upp som får dig att tänka: ”Vad gör jag nu?”. Det är där den verkliga förberedelsen sker."
  },
  {
    "en": "Analyze My Games",
    "es": "Analizar mis partidas",
    "fr": "Analyser mes parties",
    "de": "Meine Partien analysieren",
    "it": "Analizza le mie partite",
    "pt": "Analisar minhas partidas",
    "sv": "Analysera mina partier"
  },
  {
    "en": "Download & Analyze",
    "es": "Descargar y analizar",
    "fr": "Télécharger et analyser",
    "de": "Herunterladen & Analysieren",
    "it": "Scarica e analizza",
    "pt": "Baixar e analisar",
    "sv": "Ladda ner och analysera"
  },
  {
    "en": "Download all your games from chess.com and lichess.org and run them through the Opening Explorer. See exactly where you're deviating from your preparation and what the data says about the positions you're reaching.",
    "es": "Descarga todas tus partidas de chess.com y lichess.org y analízalas con el Explorador de Aperturas. Descubre exactamente dónde te desvías de tu preparación y qué dicen los datos sobre las posiciones que estás alcanzando.",
    "fr": "Téléchargez toutes vos parties depuis chess.com et lichess.org et analysez-les avec l'Explorateur d'Ouvertures. Voyez exactement où vous vous écartez de votre préparation et ce que disent les données sur les positions obtenues.",
    "de": "Lade alle deine Partien von chess.com und lichess.org herunter und analysiere sie mit dem Eröffnungs-Explorer. Finde genau heraus, wo du von deiner Vorbereitung abweichst und was die Daten über deine erreichten Stellungen sagen.",
    "it": "Scarica tutte le tue partite da chess.com e lichess.org e analizzale con l'Esploratore delle Aperture. Scopri esattamente dove ti allontani dalla tua preparazione e cosa dicono i dati sulle posizioni che raggiungi.",
    "pt": "Baixe todas as suas partidas do chess.com e do lichess.org e analise-as com o Explorador de Aberturas. Veja exatamente onde você se desvia da sua preparação e o que os dados dizem sobre as posições que alcança.",
    "sv": "Ladda ner alla dina partier från chess.com och lichess.org och analysera dem med Öppningsutforskaren. Se exakt var du avviker från dina förberedelser och vad statistiken säger om ställningarna du hamnar i."
  },
  {
    "en": "Advanced Blindfold Chess",
    "es": "Ajedrez a ciegas avanzado",
    "fr": "Jeu à l'aveugle avancé",
    "de": "Fortgeschrittenes Blindschach",
    "it": "Scacchi alla cieca avanzati",
    "pt": "Xadrez às cegas avançado",
    "sv": "Avancerat blindschack"
  },
  {
    "en": "Full Blindfold Play",
    "es": "Juego completo a ciegas",
    "fr": "Parties complètes à l'aveugle",
    "de": "Vollständiges Blindschach",
    "it": "Partite complete alla cieca",
    "pt": "Partidas completas às cegas",
    "sv": "Fullständigt blindschack"
  },
  {
    "en": "Blindfold chess against Stockfish and Komodo engines at all levels and all stepping stones. The introductory level is free — subscribers unlock the full progression.",
    "es": "Juega ajedrez a ciegas contra los motores Stockfish y Komodo en todos los niveles y etapas de aprendizaje. El nivel introductorio es gratuito; los suscriptores desbloquean toda la progresión.",
    "fr": "Jouez à l'aveugle contre les moteurs Stockfish et Komodo à tous les niveaux. Le niveau d'introduction est gratuit ; les abonnés débloquent toute la progression.",
    "de": "Spiele Blindschach gegen die Engines Stockfish und Komodo auf allen Schwierigkeitsstufen und Trainingsstufen. Die Einstiegsstufe ist kostenlos, Abonnenten erhalten Zugriff auf den gesamten Fortschrittspfad.",
    "it": "Gioca a scacchi alla cieca contro i motori Stockfish e Komodo a tutti i livelli. Il livello introduttivo è gratuito; gli abbonati sbloccano l'intero percorso di apprendimento.",
    "pt": "Jogue xadrez às cegas contra os motores Stockfish e Komodo em todos os níveis e etapas de aprendizado. O nível introdutório é gratuito; os assinantes desbloqueiam toda a progressão.",
    "sv": "Spela blindschack mot Stockfish och Komodo på alla nivåer och träningssteg. Introduktionsnivån är gratis, medan prenumeranter låser upp hela progressionen."
  },
   {
    "en": "Signed off",
    "es": "Desconectado",
    "fr": "Déconnecté",
    "de": "Abgemeldet",
    "it": "Disconnesso",
    "pt": "Desconectado",
    "sv": "Utloggad"
  },
  {
    "en": "Enter Reset Code",
    "es": "Introduce el código de restablecimiento",
    "fr": "Saisissez le code de réinitialisation",
    "de": "Rücksetzungscode eingeben",
    "it": "Inserisci il codice di reimpostazione",
    "pt": "Digite o código de redefinição",
    "sv": "Ange återställningskoden"
  },
  {
    "en": "Verify Reset Code",
    "es": "Verificar código de restablecimiento",
    "fr": "Vérifier le code de réinitialisation",
    "de": "Rücksetzungscode bestätigen",
    "it": "Verifica il codice di reimpostazione",
    "pt": "Verificar código de redefinição",
    "sv": "Verifiera återställningskoden"
  },
  {
    "en": "Reset Code",
    "es": "Código de restablecimiento",
    "fr": "Code de réinitialisation",
    "de": "Rücksetzungscode",
    "it": "Codice di reimpostazione",
    "pt": "Código de redefinição",
    "sv": "Återställningskod"
  },
  {
    "en": "Cancel any open sessions on other devices.",
    "es": "Cerrar cualquier sesión abierta en otros dispositivos.",
    "fr": "Fermer toutes les sessions ouvertes sur d'autres appareils.",
    "de": "Alle aktiven Sitzungen auf anderen Geräten beenden.",
    "it": "Chiudi tutte le sessioni aperte su altri dispositivi.",
    "pt": "Encerrar todas as sessões abertas em outros dispositivos.",
    "sv": "Logga ut från alla aktiva sessioner på andra enheter."
  },
  {
    "en": "Not needed if you only forgot your password",
    "es": "No es necesario si solo olvidaste tu contraseña",
    "fr": "Inutile si vous avez seulement oublié votre mot de passe",
    "de": "Nicht erforderlich, wenn du nur dein Passwort vergessen hast",
    "it": "Non necessario se hai solo dimenticato la password",
    "pt": "Não é necessário se você apenas esqueceu sua senha",
    "sv": "Behövs inte om du bara har glömt ditt lösenord"
  },
  {
    "en": "Password reset email containing code sent",
    "es": "Se ha enviado un correo con el código para restablecer la contraseña",
    "fr": "Un e-mail contenant le code de réinitialisation du mot de passe a été envoyé",
    "de": "E-Mail mit dem Passwort-Zurücksetzungscode wurde gesendet",
    "it": "È stata inviata un'e-mail con il codice per reimpostare la password",
    "pt": "E-mail com o código de redefinição de senha enviado",
    "sv": "E-post med kod för återställning av lösenord har skickats"
  },
  {
    "en": "Enter New Password",
    "es": "Introduce una nueva contraseña",
    "fr": "Saisissez un nouveau mot de passe",
    "de": "Neues Passwort eingeben",
    "it": "Inserisci una nuova password",
    "pt": "Digite uma nova senha",
    "sv": "Ange ett nytt lösenord"
  },
  {
    "en": "Password Reset. Please use the 'Sign in' screen with the new password.",
    "es": "Contraseña restablecida. Inicia sesión con tu nueva contraseña.",
    "fr": "Mot de passe réinitialisé. Connectez-vous avec votre nouveau mot de passe.",
    "de": "Passwort zurückgesetzt. Melde dich mit deinem neuen Passwort an.",
    "it": "Password reimpostata. Accedi con la tua nuova password.",
    "pt": "Senha redefinida. Entre usando sua nova senha.",
    "sv": "Lösenordet har återställts. Logga in med ditt nya lösenord."
  },
  {
    "en": "Code",
    "es": "Código",
    "fr": "Code",
    "de": "Code",
    "it": "Codice",
    "pt": "Código",
    "sv": "Kod"
  },
  {
    "en": "Enter code",
    "es": "Introduce el código",
    "fr": "Saisissez le code",
    "de": "Code eingeben",
    "it": "Inserisci il codice",
    "pt": "Digite o código",
    "sv": "Ange koden"
  },
  {
    "en": "To verify your email, click the send button below. You'll receive a 6 digit code to enter on the next line",
    "es": "Para verificar tu correo electrónico, pulsa el botón de envío de abajo. Recibirás un código de 6 dígitos que deberás introducir a continuación.",
    "fr": "Pour vérifier votre adresse e-mail, cliquez sur le bouton d'envoi ci-dessous. Vous recevrez un code à 6 chiffres à saisir dans le champ suivant.",
    "de": "Klicke auf die Schaltfläche unten, um deine E-Mail-Adresse zu bestätigen. Du erhältst einen 6-stelligen Code, den du anschließend eingeben musst.",
    "it": "Per verificare il tuo indirizzo e-mail, premi il pulsante qui sotto. Riceverai un codice di 6 cifre da inserire nel campo seguente.",
    "pt": "Para verificar seu e-mail, toque no botão abaixo. Você receberá um código de 6 dígitos para inserir no campo seguinte.",
    "sv": "För att verifiera din e-postadress, tryck på knappen nedan. Du får en 6-siffrig kod som du anger i nästa fält."
  },
  {
    "en": "Check Code",
    "es": "Verificar código",
    "fr": "Vérifier le code",
    "de": "Code prüfen",
    "it": "Verifica codice",
    "pt": "Verificar código",
    "sv": "Kontrollera kod"
  },
  {
    "en": "Email Verified.",
    "es": "Correo electrónico verificado.",
    "fr": "Adresse e-mail vérifiée.",
    "de": "E-Mail-Adresse bestätigt.",
    "it": "E-mail verificata.",
    "pt": "E-mail verificado.",
    "sv": "E-postadressen har verifierats."
  },
  {
    "en": "Code doesn't match. Please try again",
    "es": "El código no coincide. Inténtalo de nuevo.",
    "fr": "Le code ne correspond pas. Veuillez réessayer.",
    "de": "Der Code stimmt nicht überein. Bitte versuche es erneut.",
    "it": "Il codice non corrisponde. Riprova.",
    "pt": "O código não corresponde. Tente novamente.",
    "sv": "Koden stämmer inte. Försök igen."
  },
  {
    "en": "Email Verification email sent",
    "es": "Se ha enviado el correo de verificación",
    "fr": "E-mail de vérification envoyé",
    "de": "Bestätigungs-E-Mail wurde gesendet",
    "it": "E-mail di verifica inviata",
    "pt": "E-mail de verificação enviado",
    "sv": "Verifieringsmejl har skickats"
  },
  {
    "en": "Web (Stripe) Subscriber: cancellation is handled by you at the Stripe Customer Portal",
    "es": "Suscriptor web (Stripe): debes gestionar la cancelación tú mismo en el portal de clientes de Stripe.",
    "fr": "Abonné Web (Stripe) : vous devez gérer vous-même l'annulation depuis le portail client Stripe.",
    "de": "Web-Abonnent (Stripe): Die Kündigung verwaltest du selbst im Stripe-Kundenportal.",
    "it": "Abbonato Web (Stripe): la cancellazione deve essere gestita da te tramite il Portale Clienti Stripe.",
    "pt": "Assinante Web (Stripe): o cancelamento deve ser feito por você no Portal do Cliente Stripe.",
    "sv": "Webbprenumerant (Stripe): du hanterar själv uppsägningen i Stripes kundportal."
  },
  {
    "en": "Tuned to Lichess ratings",
    "es": "Ajustado a los ratings de Lichess",
    "fr": "Adapté aux classements Lichess",
    "de": "Auf Lichess-Wertungen abgestimmt",
    "it": "Ottimizzato per i rating di Lichess",
    "pt": "Ajustado aos ratings do Lichess",
    "sv": "Anpassat till Lichess-ratingar"
  },
  {
    "en": "Thanks for being a Subscriber! -- You have access to the Komodo, Stockfish and Maia Engines at all skill levels. Plus All Blindfold Stepping Stones.",
    "es": "¡Gracias por suscribirte! Tienes acceso a los motores Komodo, Stockfish y Maia en todos los niveles. Además, desbloqueas todas las etapas de entrenamiento de ajedrez a ciegas.",
    "fr": "Merci pour votre abonnement ! Vous avez accès aux moteurs Komodo, Stockfish et Maia à tous les niveaux. Vous débloquez également toutes les étapes de progression du jeu à l'aveugle.",
    "de": "Danke für dein Abonnement! Du hast Zugriff auf die Engines Komodo, Stockfish und Maia auf allen Spielstärken. Außerdem sind alle Blindschach-Trainingsstufen freigeschaltet.",
    "it": "Grazie per il tuo abbonamento! Hai accesso ai motori Komodo, Stockfish e Maia a tutti i livelli di difficoltà. Inoltre, hai accesso a tutte le fasi del percorso di allenamento per gli scacchi alla cieca.",
    "pt": "Obrigado por ser assinante! Você tem acesso aos motores Komodo, Stockfish e Maia em todos os níveis. Além disso, desbloqueia todas as etapas de treinamento de xadrez às cegas.",
    "sv": "Tack för att du är prenumerant! Du har tillgång till motorerna Komodo, Stockfish och Maia på alla nivåer. Dessutom får du tillgång till alla steg i blindschacksträningen."
  },
  {
    "en": "Blindfold chess against Stockfish, Komodo and Maia engines at all levels and all stepping stones. The introductory level is free — subscribers unlock the full progression.",
    "es": "Juega ajedrez a ciegas contra los motores Stockfish, Komodo y Maia en todos los niveles y etapas de aprendizaje. El nivel introductorio es gratuito; los suscriptores desbloquean toda la progresión.",
    "fr": "Jouez à l'aveugle contre les moteurs Stockfish, Komodo et Maia à tous les niveaux. Le niveau d'introduction est gratuit ; les abonnés débloquent toute la progression.",
    "de": "Spiele Blindschach gegen die Engines Stockfish, Komodo und Maia auf allen Schwierigkeits- und Trainingsstufen. Die Einstiegsstufe ist kostenlos, Abonnenten erhalten Zugriff auf den gesamten Fortschrittspfad.",
    "it": "Gioca a scacchi alla cieca contro i motori Stockfish, Komodo e Maia a tutti i livelli e in tutte le fasi del percorso di apprendimento. Il livello introduttivo è gratuito; gli abbonati sbloccano l'intera progressione.",
    "pt": "Jogue xadrez às cegas contra os motores Stockfish, Komodo e Maia em todos os níveis e etapas de aprendizado. O nível introdutório é gratuito; os assinantes desbloqueiam toda a progressão.",
    "sv": "Spela blindschack mot Stockfish-, Komodo- och Maia-motorerna på alla nivåer och träningssteg. Introduktionsnivån är gratis, medan prenumeranter låser upp hela progressionen."
  },
   {
    "en": "All Puzzles are Free! Total redo of the 'landing page'. And finally, a menu system that shows off what Chessvis has. AND for subscribers, the Maia chess engine is available!",
    "es": "¡Todos los problemas son gratis! Rediseño completo de la página de inicio. Y por fin, un sistema de menús que muestra todo lo que ofrece ChessVis. ¡Y además, los suscriptores ya tienen acceso al motor de ajedrez Maia!",
    "fr": "Tous les puzzles sont gratuits ! Refonte complète de la page d'accueil. Et enfin, un système de menus qui met en valeur tout ce que ChessVis propose. Et en plus, le moteur d'échecs Maia est désormais disponible pour les abonnés !",
    "de": "Alle Aufgaben sind kostenlos! Die Startseite wurde komplett überarbeitet. Und endlich gibt es ein Menüsystem, das zeigt, was ChessVis alles zu bieten hat. UND für Abonnenten ist jetzt auch die Schach-Engine Maia verfügbar!",
    "it": "Tutti i puzzle sono gratuiti! Restyling completo della schermata iniziale. E finalmente un sistema di menu che mette in mostra tutto ciò che ChessVis offre. E in più, per gli abbonati è ora disponibile il motore scacchistico Maia!",
    "pt": "Todos os problemas são grátis! Reformulação completa da página inicial. E finalmente um sistema de menus que mostra tudo o que o ChessVis oferece. E para os assinantes, o motor de xadrez Maia já está disponível!",
    "sv": "Alla problem är gratis! Helt ny design av startsidan. Och äntligen ett menysystem som visar allt ChessVis har att erbjuda. OCH för prenumeranter finns nu schackmotorn Maia tillgänglig!"
  },
  {
    "en": "You can choose between the Komodo, Stockfish and Maia engines. All are extremely strong at high skill levels. The Komodo simulates a much weaker player at the lower skill levels. Maia is tuned to Lichess players at the rating",
    "es": "Puedes elegir entre los motores Komodo, Stockfish y Maia. Todos son extremadamente fuertes en los niveles más altos. Komodo simula jugadores mucho más débiles en los niveles bajos. Maia está ajustado a jugadores de Lichess con ese rating.",
    "fr": "Vous pouvez choisir entre les moteurs Komodo, Stockfish et Maia. Tous sont extrêmement forts aux niveaux élevés. Komodo simule des joueurs beaucoup plus faibles aux niveaux inférieurs. Maia est calibré sur les joueurs Lichess de ce classement.",
    "de": "Du kannst zwischen den Engines Komodo, Stockfish und Maia wählen. Alle sind auf hohen Spielstärken extrem stark. Komodo simuliert auf niedrigeren Stufen deutlich schwächere Spieler. Maia ist auf Lichess-Spieler dieser Wertung abgestimmt.",
    "it": "Puoi scegliere tra i motori Komodo, Stockfish e Maia. Tutti sono estremamente forti ai livelli più alti. Komodo simula giocatori molto più deboli ai livelli inferiori. Maia è calibrato sui giocatori Lichess di quel rating.",
    "pt": "Você pode escolher entre os motores Komodo, Stockfish e Maia. Todos são extremamente fortes nos níveis mais altos. O Komodo simula jogadores muito mais fracos nos níveis inferiores. O Maia é ajustado para jogadores do Lichess com essa classificação.",
    "sv": "Du kan välja mellan motorerna Komodo, Stockfish och Maia. Alla är extremt starka på de högre nivåerna. Komodo simulerar betydligt svagare spelare på de lägre nivåerna. Maia är anpassad till Lichess-spelare på den aktuella ratingnivån."
  },
  {
    "en": "Subscribers get 'Stockfish' and 'Maia' as additional chess engines and can play all at any strength level.<br><br>Please consider subscribing and supporting my work.",
    "es": "Los suscriptores obtienen acceso a los motores Stockfish y Maia, además de Komodo, y pueden jugar con cualquiera de ellos en cualquier nivel.<br><br>Por favor, considera suscribirte y apoyar mi trabajo.",
    "fr": "Les abonnés ont accès aux moteurs Stockfish et Maia en plus de Komodo, et peuvent jouer à tous les niveaux de difficulté.<br><br>Merci d'envisager un abonnement pour soutenir mon travail.",
    "de": "Abonnenten erhalten zusätzlich Zugriff auf die Engines Stockfish und Maia und können alle Engines auf jeder Spielstärke nutzen.<br><br>Bitte unterstütze meine Arbeit mit einem Abonnement.",
    "it": "Gli abbonati hanno accesso ai motori Stockfish e Maia oltre a Komodo e possono usarli a qualsiasi livello di difficoltà.<br><br>Valuta la possibilità di abbonarti per sostenere il mio lavoro.",
    "pt": "Os assinantes têm acesso aos motores Stockfish e Maia, além do Komodo, e podem jogar em qualquer nível de força.<br><br>Considere assinar e apoiar o meu trabalho.",
    "sv": "Prenumeranter får tillgång till motorerna Stockfish och Maia utöver Komodo och kan spela mot alla på valfri styrkenivå.<br><br>Överväg gärna att prenumerera och stödja mitt arbete."
  },
  {
    "en": "Choose between the Komodo, Stockfish and Maia computer engines. Note: the Stockfish engine even at level 0 is still playing real chess.<br><br>Komodo at level 0 makes random moves and is a good place to start with the blindfold on.<br><br>Maia is tuned to Lichess players at the rating.",
    "es": "Elige entre los motores Komodo, Stockfish y Maia. Nota: incluso en el nivel 0, Stockfish sigue jugando ajedrez real.<br><br>Komodo en el nivel 0 hace movimientos aleatorios y es un buen punto de partida para practicar ajedrez a ciegas.<br><br>Maia está ajustado a jugadores de Lichess con ese rating.",
    "fr": "Choisissez entre les moteurs Komodo, Stockfish et Maia. Remarque : même au niveau 0, Stockfish joue toujours un véritable jeu d'échecs.<br><br>Au niveau 0, Komodo joue des coups aléatoires et constitue un bon point de départ pour le jeu à l'aveugle.<br><br>Maia est calibré sur les joueurs Lichess de ce classement.",
    "de": "Wähle zwischen den Engines Komodo, Stockfish und Maia. Hinweis: Selbst auf Stufe 0 spielt Stockfish noch echtes Schach.<br><br>Komodo macht auf Stufe 0 zufällige Züge und ist ein guter Einstieg ins Blindschach.<br><br>Maia ist auf Lichess-Spieler dieser Wertung abgestimmt.",
    "it": "Scegli tra i motori Komodo, Stockfish e Maia. Nota: anche al livello 0, Stockfish gioca ancora veri scacchi.<br><br>Komodo al livello 0 effettua mosse casuali ed è un buon punto di partenza per gli scacchi alla cieca.<br><br>Maia è calibrato sui giocatori Lichess di quel rating.",
    "pt": "Escolha entre os motores Komodo, Stockfish e Maia. Observação: mesmo no nível 0, o Stockfish continua jogando xadrez de verdade.<br><br>No nível 0, o Komodo faz lances aleatórios e é um bom ponto de partida para praticar xadrez às cegas.<br><br>O Maia é ajustado para jogadores do Lichess com essa classificação.",
    "sv": "Välj mellan motorerna Komodo, Stockfish och Maia. Obs: även på nivå 0 spelar Stockfish fortfarande riktig schack.<br><br>Komodo gör slumpmässiga drag på nivå 0 och är en bra startpunkt för blindschack.<br><br>Maia är anpassad till Lichess-spelare på den aktuella ratingnivån."
  },
  {
    "en": "Engine & Skill Options - Toolbar",
    "es": "Motores y nivel de juego - Barra de herramientas",
    "fr": "Moteurs et niveaux de jeu - Barre d'outils",
    "de": "Engine- und Spielstärkeoptionen - Symbolleiste",
    "it": "Motori e livelli di gioco - Barra degli strumenti",
    "pt": "Motores e níveis de habilidade - Barra de ferramentas",
    "sv": "Motor- och styrkeinställningar - Verktygsfält"
  },
  {
    "en": "Choose between the Komodo, Stockfish and Maia computer engines at skill levels 0 to 20.<br><br>Note: the Stockfish engine even at level 0 is still playing real chess. (At least to me!)<br><br>Komodo at level 0 makes random moves. Maia is turned to players at the rating.",
    "es": "Elige entre los motores Komodo, Stockfish y Maia en niveles de habilidad del 0 al 20.<br><br>Nota: incluso en el nivel 0, Stockfish sigue jugando ajedrez real (¡al menos para mí!).<br><br>Komodo hace movimientos aleatorios en el nivel 0. Maia está ajustado a jugadores de ese rating.",
    "fr": "Choisissez entre les moteurs Komodo, Stockfish et Maia aux niveaux de difficulté de 0 à 20.<br><br>Remarque : même au niveau 0, Stockfish joue toujours un véritable jeu d'échecs (du moins à mes yeux !).<br><br>Komodo joue des coups aléatoires au niveau 0. Maia est calibré sur les joueurs de ce classement.",
    "de": "Wähle zwischen den Engines Komodo, Stockfish und Maia auf den Spielstärken 0 bis 20.<br><br>Hinweis: Selbst auf Stufe 0 spielt Stockfish noch echtes Schach (zumindest meiner Meinung nach!).<br><br>Komodo macht auf Stufe 0 zufällige Züge. Maia ist auf Spieler dieser Wertung abgestimmt.",
    "it": "Scegli tra i motori Komodo, Stockfish e Maia ai livelli da 0 a 20.<br><br>Nota: anche al livello 0, Stockfish gioca ancora veri scacchi (almeno secondo me!).<br><br>Komodo al livello 0 effettua mosse casuali. Maia è calibrato sui giocatori di quel rating.",
    "pt": "Escolha entre os motores Komodo, Stockfish e Maia nos níveis de habilidade de 0 a 20.<br><br>Observação: mesmo no nível 0, o Stockfish continua jogando xadrez de verdade (pelo menos na minha opinião!).<br><br>O Komodo faz lances aleatórios no nível 0. O Maia é ajustado para jogadores dessa classificação.",
    "sv": "Välj mellan motorerna Komodo, Stockfish och Maia på nivåerna 0 till 20.<br><br>Obs: även på nivå 0 spelar Stockfish fortfarande riktig schack (åtminstone enligt mig!).<br><br>Komodo gör slumpmässiga drag på nivå 0. Maia är anpassad till spelare på den aktuella ratingnivån."
  },
  {
    "en": "Color You Play Option - Toolbar",
    "es": "Color de juego - Barra de herramientas",
    "fr": "Choix de couleur - Barre d'outils",
    "de": "Spielfarbe auswählen - Symbolleiste",
    "it": "Colore dei pezzi - Barra degli strumenti",
    "pt": "Cor das peças - Barra de ferramentas",
    "sv": "Val av färg - Verktygsfält"
  },
  {
    "en": "Play with the white or black pieces",
    "es": "Juega con las piezas blancas o negras",
    "fr": "Jouez avec les pièces blanches ou noires",
    "de": "Spiele mit den weißen oder schwarzen Figuren",
    "it": "Gioca con i pezzi bianchi o neri",
    "pt": "Jogue com as peças brancas ou pretas",
    "sv": "Spela med de vita eller svarta pjäserna"
  },
  {
    "en": "Reveal Board - Toolbar",
    "es": "Mostrar tablero - Barra de herramientas",
    "fr": "Afficher l'échiquier - Barre d'outils",
    "de": "Brett anzeigen - Symbolleiste",
    "it": "Mostra scacchiera - Barra degli strumenti",
    "pt": "Mostrar tabuleiro - Barra de ferramentas",
    "sv": "Visa brädet - Verktygsfält"
  },
  {
    "en": "The 'Blindfold Chess King' reccomends starting off revealing the board every # of moves.<br><br>This way you're not trying to remember the entire game but just so many moves. The idea is to increase this number as you get better.",
    "es": "El «Rey del Ajedrez a Ciegas» recomienda empezar mostrando el tablero cada cierto número de jugadas.<br><br>Así no tendrás que recordar toda la partida, solo una parte. La idea es aumentar ese número a medida que mejores.",
    "fr": "Le « Roi des échecs à l'aveugle » recommande de commencer en affichant l'échiquier tous les quelques coups.<br><br>Ainsi, vous n'avez pas à mémoriser toute la partie, seulement une portion. L'objectif est d'augmenter progressivement ce nombre à mesure que vous progressez.",
    "de": "Der „Blindschach-König“ empfiehlt, das Brett anfangs alle paar Züge einzublenden.<br><br>So musst du dir nicht die ganze Partie merken, sondern nur einen Abschnitt davon. Mit zunehmender Spielstärke kannst du dieses Intervall schrittweise erhöhen.",
    "it": "Il «Re degli Scacchi alla Cieca» consiglia di iniziare mostrando la scacchiera ogni certo numero di mosse.<br><br>In questo modo non devi ricordare l'intera partita, ma solo una parte. L'obiettivo è aumentare gradualmente questo numero man mano che migliori.",
    "pt": "O «Rei do Xadrez às Cegas» recomenda começar revelando o tabuleiro a cada certo número de lances.<br><br>Assim, você não precisa memorizar a partida inteira, apenas uma parte dela. A ideia é aumentar esse número à medida que melhorar.",
    "sv": "Blindschackskungen rekommenderar att du i början visar brädet efter ett visst antal drag.<br><br>På så sätt behöver du inte komma ihåg hela partiet, bara en del av det. Tanken är att gradvis öka antalet drag ju bättre du blir."
  },
    {
    "en": "Install APP",
    "es": "Instalar la app",
    "fr": "Installer l'appli",
    "de": "App installieren",
    "it": "Installa l'app",
    "pt": "Instalar o app",
    "sv": "Installera appen"
  },
  {
    "en": "Add ChessVis to your home screen",
    "es": "Añade ChessVis a tu pantalla de inicio",
    "fr": "Ajoutez ChessVis à votre écran d'accueil",
    "de": "Füge ChessVis deinem Startbildschirm hinzu",
    "it": "Aggiungi ChessVis alla schermata Home",
    "pt": "Adicione o ChessVis à sua tela inicial",
    "sv": "Lägg till ChessVis på hemskärmen"
  },
  {
    "en": "Also available on",
    "es": "También disponible en",
    "fr": "Également disponible sur",
    "de": "Auch verfügbar auf",
    "it": "Disponibile anche su",
    "pt": "Também disponível em",
    "sv": "Finns även på"
  },
  {
    "en": "Tip: Install as a web app anytime via Account → Support",
    "es": "Consejo: Instálala como aplicación web en cualquier momento desde Cuenta → Soporte",
    "fr": "Astuce : Installez-la comme application web à tout moment via Compte → Assistance",
    "de": "Tipp: Installiere sie jederzeit als Web-App über Konto → Support",
    "it": "Suggerimento: installala come app web in qualsiasi momento da Account → Supporto",
    "pt": "Dica: Instale como aplicativo web a qualquer momento em Conta → Suporte",
    "sv": "Tips: Installera den som webbapp när som helst via Konto → Support"
  },
  {
    "en": "Eye Gaze Landing Page",
    "es": "Página de inicio de Eye Gaze",
    "fr": "Page d'accueil Eye Gaze",
    "de": "Eye-Gaze-Startseite",
    "it": "Pagina iniziale di Eye Gaze",
    "pt": "Página inicial do Eye Gaze",
    "sv": "Eye Gaze-startsida"
  },
    {
    "en": "EyeGaze Overview",
    "es": "Resumen de EyeGaze",
    "fr": "Présentation d'EyeGaze",
    "de": "EyeGaze-Übersicht",
    "it": "Panoramica di EyeGaze",
    "pt": "Visão geral do EyeGaze",
    "sv": "Översikt över EyeGaze"
  },
  {
    "en": "Stripe Account Manager",
    "es": "Gestor de cuenta de Stripe",
    "fr": "Gestionnaire de compte Stripe",
    "de": "Stripe-Kontoverwaltung",
    "it": "Gestione account Stripe",
    "pt": "Gerenciador de conta do Stripe",
    "sv": "Stripe-kontohantering"
  },
  {
    "en": "Daily Puzzle Count Confetti",
    "es": "Confeti por el total diario de problemas",
    "fr": "Confettis pour le total quotidien de puzzles",
    "de": "Konfetti für die tägliche Puzzleanzahl",
    "it": "Coriandoli per il totale giornaliero di puzzle",
    "pt": "Confete pela contagem diária de quebra-cabeças",
    "sv": "Konfetti för dagens pusselantal"
  },
  {
    "en": "Lichess Play",
    "es": "Jugar en Lichess",
    "fr": "Jouer sur Lichess",
    "de": "Auf Lichess spielen",
    "it": "Gioca su Lichess",
    "pt": "Jogar no Lichess",
    "sv": "Spela på Lichess"
  },
  {
    "en": "Copy to Clipboard?",
    "es": "¿Copiar al portapapeles?",
    "fr": "Copier dans le presse-papiers ?",
    "de": "In die Zwischenablage kopieren?",
    "it": "Copiare negli appunti?",
    "pt": "Copiar para a área de transferência?",
    "sv": "Kopiera till urklipp?"
  },
  {
    "en": "Daily Puzzle Count Confetti",
    "es": "Confeti por el total diario de problemas",
    "fr": "Confettis pour le total quotidien de puzzles",
    "de": "Konfetti für die tägliche Puzzleanzahl",
    "it": "Coriandoli per il totale giornaliero di puzzle",
    "pt": "Confete pela contagem diária de quebra-cabeças",
    "sv": "Konfetti för dagens pusselantal"
  },
  {
    "en": "Data-driven opening explorer - with AI analysis",
    "es": "Explorador de aperturas basado en datos, con análisis de IA",
    "fr": "Explorateur d'ouvertures basé sur les données, avec analyse par IA",
    "de": "Datengestützter Eröffnungs-Explorer mit KI-Analyse",
    "it": "Esploratore di aperture basato sui dati, con analisi IA",
    "pt": "Explorador de aberturas baseado em dados, com análise por IA",
    "sv": "Datadriven öppningsutforskare med AI-analys"
  },
  {
    "en": "Persona",
    "es": "Perfil",
    "fr": "Profil",
    "de": "Profil",
    "it": "Profilo",
    "pt": "Perfil",
    "sv": "Profil"
  }
]

/* 

    Last string

  { "en": ""},


*/


export function setTranslationLanguage() {
  const connectionStore = useConnectionStore()

  // language. if user selected "system" -- empty, then grab the default -- unless not supported
  languageInUse = connectionStore.getLanguageIncludingSystem
  console.log("system lanaguage",languageInUse)
  if (languageInUse == "") {
    const userPreferredLanguage = navigator.language;
    const language2char = userPreferredLanguage.slice(0, 2)
    const systemLanguage = (language2char != "en" && language2char != "es" &&
                            language2char != "it" && language2char != "de" &&
                            language2char != "fr" && language2char != "pt" &&
                            language2char != "sv") 
                            ? "en" : language2char
    languageInUse = systemLanguage
  }
  console.log("******* language in use",languageInUse)
  connectionStore.setLanguageInUse(languageInUse)
}

var noTranslationArray = []

export function t(englishString) {

  // if first string, build map
  if (stringMap == null) {
    stringMap = new Map()
    for (var i=0; i < strings.length; i++) {
      const oneString = strings[i]
      if (stringMap.has(oneString.en))
        console.log("********** Translation duplicate",oneString.en)
      stringMap.set(oneString.en,oneString)
    }
  }

  if (englishString == "")
    return ("")

  const entry = stringMap.get(englishString)
  if (entry == null) {
    if (process.env.NODE_ENV !== 'production') {
        console.log("no translation",'"' + englishString + '",')
        noTranslationArray.push(englishString)
        console.log(noTranslationArray)
    }
    return ("*** " + englishString + " ***" )
  }
  if (languageInUse == "en") {
    return (englishString)
    //return (englishString.toUpperCase())
  }
  else {
    return (entry[languageInUse])
  }
}

export function replaceMultipleAll(str, replacements) {
  let newStr = str;
  for (let i = 0; i < replacements.length; i++) {
    const [search, replace] = replacements[i];
    newStr = newStr.replaceAll(search, replace);
  }
  return newStr;
}